/* ⛔ UN SIGNAL QUI ABANDONNE, SUR CHAQUE APPEL AU STUDIO (23/08/2026). Voir `global.js` : le
   Studio tombe, une balise de mesure a mis plus de trente secondes a rendre la main, et `load`
   avec elle. 2,5 s, puis elle abandonne. */
function afSignalCourt(ms) {
  try { return AbortSignal.timeout(ms || 2500); } catch (e) { return undefined; }
}
/* Murmure : product page logic (variant select, photo personalization, add to cart) */
(function () {
  "use strict";
  var variants = window.__pdpVariants || [];
  var optCount = window.__pdpOptionCount || 0;
  var $ = function (s) { return document.querySelector(s); };
  /* ⛔ LE CONTEXTE (2e argument) DOIT ETRE HONORE. Sept appels passent un conteneur ; quand
     $$ l'ignorait, $$("[data-value]", groupe) rendait TOUTES les pilules du document :
     formatGroupInfo prenait le groupe Type pour le groupe Taille et defaultNoFormat
     depressait les trois lignes d'options du panneau de mariage, premiere fiche a trois
     options (invisible sur les fiches a option unique, constate en production le 04/08/2026). */
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var T = window.MURMURE_I18N || {};
  /* Prefixe de langue et devise, lus sur l'objet Shopify de la page : ecrits en dur,
     ils renvoyaient le visiteur sur la version francaise et affichaient des euros a un
     acheteur facture en livres. Le fichier reste autonome, il ne depend pas de l'ordre
     de chargement des scripts. */
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  function murUrl(path) { return ROOT + String(path).replace(/^\//, ""); }
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
  var LOCALE = (window.Shopify && Shopify.locale) || "fr";
  /* ⛔ LE FORMAT DES PRIX VIENT DE LA BOUTIQUE, ET D'UN SEUL ENDROIT : theme.liquid le pose
     dans window.MURMURE_MONEY depuis shop.money_format. Il y avait deux formats concurrents,
     et c'est ce qui faisait sauter la ligne de prix : Liquid servait « dès €10,13 », ce
     formateur le reecrivait en « dès 10,13 € » au chargement, et le prix barre comme le badge
     partaient vers la droite avant de retomber en place (mesure le 06/08/2026).
     Le repli Intl ne sert que si le script d'entete n'a pas tourne. */
  var money = function (c) {
    if (typeof window.MURMURE_MONEY === "function") return window.MURMURE_MONEY(c);
    try { return new Intl.NumberFormat(LOCALE, { style: "currency", currency: CUR }).format(c / 100); }
    catch (e) { return (c / 100).toLocaleString(LOCALE, { minimumFractionDigits: 2 }) + " " + CUR; }
  };

  /* LE PARCOURS PROFESSIONNEL, LU UNE FOIS ET SUR <html>.
     ⛔ LA FICHE NE PEUT PAS FAIRE COMME LES CARTES. Ailleurs, Liquid rend les DEUX prix et
     `html[data-pro]` choisit ; ici le prix est entierement ecrit par ce script a chaque
     changement de taille, de quantite et d'accessoire. Un prix pro rendu par le serveur y
     serait perime au premier clic sur un format.
     ⛔ ET SANS TAUX CONNU, PAS DE HORS TAXES. Hors Union (Suisse, Norvege, Islande,
     Liechtenstein, Royaume-Uni) aucun taux ne s'applique : un montant « hors taxes » y serait
     un chiffre invente. On retombe alors sur l'affichage grand public, comme le snippet. */
  var PRO = document.documentElement.getAttribute("data-pro") === "1";
  var TVA = parseFloat(document.documentElement.getAttribute("data-tva") || "0") || 0;
  var PRO_HT = PRO && TVA > 0;
  var HT = document.documentElement.getAttribute("data-ht") || "";
  var moneyPro = function (c) { return money(Math.round(c / (1 + TVA / 100))); };

  /* ⛔ LE TARIF PRO PART DU PRIX PLEIN. Les promos de la boutique sont des BAISSES DE PRIX
     ecrites dans la variante : prendre le prix du jour ferait suivre au tarif professionnel
     chaque promo grand public, ce qu'Adrien a exclu le 22/08/2026. */
  var plein = function (prix, avant) { return avant > prix ? avant : prix; };

  /* Le meme montant, en TEXTE : pour les libelles composes (« · des 29,00 EUR (4) ») ou une
     balise ne peut pas entrer sans reecrire toute la phrase. */
  var montantTxt = function (c) { return PRO_HT ? moneyPro(c) + (HT ? " " + HT : "") : money(c); };

  /* Le seul endroit qui ecrit un montant dans un element : le suffixe « HT » ne peut pas
     passer par `textContent`, qui n'ecrit que du texte brut. */
  function ecrirePrix(el, cents, prefixe) {
    if (!el) return;
    el.textContent = "";
    if (prefixe) {
      var prefix = document.createElement('span');
      prefix.className = 'pdp-config-price-prefix';
      prefix.textContent = prefixe + ' ';
      el.appendChild(prefix);
    }
    el.appendChild(document.createTextNode(PRO_HT ? moneyPro(cents) : money(cents)));
    if (PRO_HT && HT) {
      var s = document.createElement("small");
      s.className = "pro-ht";
      s.textContent = HT;
      el.appendChild(s);
    }
  }

  // Couleurs de moulure par valeur de l'option Cadre. Les anciennes valeurs (Chêne,
  // Noir, Sans cadre) restent tolérées : un produit non migré ne casse pas.
  var FRAME_SWATCH = {
    "Blanc": "#F2EFE9", "Noir": "#1A1A1A", "Marron clair": "#C9A063", "Marron foncé": "#5C3B27",
    "Chêne": "#D0AE79", "Chêne clair": "#D0AE79", "Noyer": "#6B4A36", "Noir mat": "#1A2238"
  };
  var NO_FRAME = "Sans cadre";   // pas une couleur : la moulure disparaît
  /* ⛔ UNE COULEUR RECUE SE RAMENE A SA CLE FRANCAISE, ICI, UNE FOIS.
   *
   * `FRAME_SWATCH` est indexe en francais. Les pastilles, elles, portent la valeur de la
   * LANGUE SERVIE depuis le 10/08/2026 : sur /nl c'est « Zwart » et « Licht eiken ». La
   * recherche rendait donc `undefined`, `applyFramePreview` recevait une couleur vide et
   * AUCUN CADRE NE S'AFFICHAIT AUTOUR DE L'AFFICHE sur douze marches. Adrien l'a vu a l'ecran.
   *
   * ⚠️ LE RANG NE SE TRADUIT PAS : blanc, noir, chene clair, dans l'ordre des options du
   * produit cadre. C'est lui qui fait le pont, jamais le mot. */
  function cleCouleurFr(valeur) {
    if (!valeur) return "";
    if (FRAME_SWATCH[valeur] !== undefined) return valeur;      /* deja francais */
    var vues = [];
    (window.__pdpFrameVariants || []).forEach(function (v) {
      (v.options || []).forEach(function (o) {
        if (!/^\d+X\d+$/i.test(String(o)) && vues.indexOf(o) === -1) vues.push(o);
      });
    });
    var rang = vues.indexOf(valeur);
    return rang >= 0 ? (["Blanc", "Noir", "Chêne clair"][rang] || "") : "";
  }
  // Dimensions en cm [largeur, hauteur], affichées telles quelles. Tailles catalogue.
  /* ⛔ LA COTE EST CELLE DU PAPIER, LE CADRE NE COMPTE JAMAIS (Adrien, 06/08/2026 :
     « aligne sur la facon dont sont donnees les dimensions des autres formats »).
     C'est la regle de tout le catalogue et elle etait deja la : une 50 x 70 encadree reste
     annoncee 50 x 70, alors que ses baguettes lui ajoutent 3,6 cm dans chaque sens. Le
     polyptyque suit donc la meme regle : ses quatre feuilles et les ecarts entre elles, sans
     les baguettes ; affiche 100 x 140 depuis le 12/08/2026 (les feuilles, sans les ecarts).
     ⛔ CE QUI ETAIT FAUX N'ETAIT PAS LA GALERIE, C'ETAIT LA PASTILLE. Elle annoncait 108 x 148,
     l'encombrement AVEC cadres, pendant que le dessin annoncait la cote nue : deux tailles pour
     le meme produit sur le meme ecran, et dans l'etat par defaut, sans cadre.
     ⛔ ET LA COTE NE BOUGE PLUS AVEC LE CADRE. Elle en dependait, ce qui semblait plus exact ;
     c'etait en fait une exception a la regle du catalogue, et une exception qu'aucun autre
     format ne suivait. Le DESSIN, lui, continue de changer : on voit les baguettes et l'ecart
     s'elargir, exactement comme sur une affiche seule. */
  /* ⛔ « 50X35 » EST LE PREMIER FORMAT ECRIT EN PAYSAGE, et il n'a pas de jumeau portrait :
     le panneau voiture ne se vend QUE couche, 50 de large sur 35 de haut. Le retournement
     ci-dessous (`estPaysage`) sert aux affiches qui existent dans les deux sens ; ici les deux
     valeurs sont deja dans le bon ordre et il ne doit pas s'appliquer. Sans cette entree, la
     boucle des cotes passait son tour : le client voyait une plaque sans aucune mesure. */
  var A_CM = { "21X30": [21, 30], "30X40": [30, 40], "50X70": [50, 70], "70X100": [70, 100],
    "50X35": [50, 35],
    /* ⛔ LA COTE AFFICHEE DU POLYPTYQUE EST CELLE DES FEUILLES, SANS LES ECARTS (Adrien,
       12/08/2026 : « renomme-la juste 100x140cm sur les pages produit »). 2 x 50 sur 2 x 70 :
       100 x 140. L'ecart d'un centimetre avec l'encombrement reel est invisible dans les
       mises en situation, et c'est le libelle que lit le client qui prime.
       « Polyptyque 2x2 · 70x100 » n'existe plus : purge du 12/08/2026, 1584 fiches. */
    "Polyptyque 2x2 · 50x70": [100, 140] };
  // Taille de reference (la plus grande) pour l'echelle du mockup.
  var SIZE_REF = "70X100";
  // Échelle de la vue "affiche seule". On garde une compression légère ici pour que
  // les petits formats restent lisibles dans la galerie principale.
  var A_SCALE = { "21X30": 0.55, "30X40": 0.63, "50X70": 0.84, "70X100": 1, "50X35": 0.72,
    "Polyptyque 2x2 · 50x70": 1 };
  // Mise en situation à l'échelle réelle : le décor reste fixe et la largeur de
  // l'affiche suit strictement les dimensions ISO, en prenant A0 comme référence.
  // A4 vaut donc environ 25 % de A0, A3 35 %, A2 50 %, A1 71 %.
  var MOCK_BASE_A0_W = 39;
  var MOCK_W = Object.keys(A_CM).reduce(function (acc, key) {
    acc[key] = MOCK_BASE_A0_W * (A_CM[key][0] / A_CM[SIZE_REF][0]);
    return acc;
  }, {});
  // Passe-partout désactivé : l'affiche colle à la baguette dans les aperçus galerie.
  /* Passe-partout de la vue murale, en fraction de la LARGEUR DE L'AFFICHE.
   *
   * 0,022 : les mêmes chiffres que `salon_mockup.py`, donc la vue murale, la carte de
   * collection au survol et la mise en situation vendue montrent le même cadrage.
   *
   * ⚠️ Il vaut 0 depuis assez longtemps, et c'est ce qui rendait invisible tout réglage fait
   * dans le CSS : `positionMockup` écrit `padding` EN INLINE, ce qui bat n'importe quelle
   * feuille de style. Chercher la cause dans base.css ne pouvait rien donner.
   *
   * Pourquoi le JS s'en charge plutôt que le CSS : un `padding` en pourcentage se résout sur la
   * largeur du CONTENEUR, jamais sur celle de l'élément. Écrit dans le CSS, `padding:2.2%`
   * donnerait 2,2 % de la pièce entière, soit un carton énorme. Ici on multiplie par la largeur
   * réelle de l'affiche, elle-même en % du conteneur : le compte tombe juste. */
  var MAT_RATIO = 0.022;
  // Zoom RELATIF au « cover » (le fond juste rempli).
  var MOCK_ROOM_ZOOM = 1;
  /* Rapprochement du point de vue, par format.
   *
   * L'affiche est dimensionnée en pourcentage de la SCÈNE, à l'échelle réelle : un 21×30
   * occupe 11,7 % de la largeur, contre 39 % pour un 70×100. C'est juste, c'est bien le
   * rapport des deux formats sur un vrai mur, et c'est illisible : sur un téléphone, le
   * cadre fait deux centimètres et on ne voit ni la moulure ni l'image.
   *
   * On rapproche donc le point de vue sur les petits formats, en zoomant le décor ET
   * l'affiche du MÊME facteur. C'est un pas en avant dans la pièce, pas un agrandissement
   * de l'affiche : le rapport entre le cadre et le canapé reste exact, donc l'aperçu ne
   * ment pas sur la taille. Le 70×100 ne bouge pas, il remplit déjà le mur.
   *
   * ⚠️ Conséquence assumée, contraire à la règle d'avant : changer de format fait AVANCER
   * la pièce. La règle disait « le décor ne doit pas bouger, sinon l'aperçu paraît faux » :
   * mais un cadre de deux centimètres paraît faux bien plus sûrement, et il paraît faux
   * pour la seule raison qui compte, la lisibilité. */
  /* ⛔ LES POLYPTYQUES RESTENT A 1, ET RECULER SERAIT CONTRE-PRODUCTIF. On avait pose 0,85 et
     0,75 pour « prendre du recul » et loger un mur de 148 cm. Mesure faite a l'ecran le
     06/08/2026 : le fond du salon est cale en HAUT (background-position-y a 0 tant que le
     canape tient au-dessus de sa cible), donc dezoomer fait REMONTER le canape et RETRECIT le
     mur libre. Le recul enlevait donc de la place au lieu d'en donner, et il passait sous le
     cover, ce qui laissait une bande blanche sous le canape.
     La suite des formats simples reste ce qu'elle etait : 21 -> 1,60 ; 30 -> 1,42 ;
     50 -> 1,18 ; 70 -> 1,00, soit largeur^-0,39.
     ⚠️ CONSEQUENCE ASSUMEE, ET C'EST UNE LIMITE DE LA PHOTO, PAS DU CODE : le mur libre de ce
     salon est deja entierement occupe par une 70 x 100. Un polyptyque de 141 cm ne peut donc
     pas y paraitre plus grand qu'elle ; il s'y montre en quatre panneaux, a la taille que le
     mur autorise, et ce sont les cotes affichees qui portent l'information de taille. Le
     montrer a l'echelle vraie demande une photo de piece plus large, pas un reglage ici. */
  /* ⛔ LE POLYPTYQUE PASSE DE 1 A 1,10, ET CE N'EST PAS UN CHOIX ESTHETIQUE (Adrien : « sur le
     polyptyque l'affiche est toujours decalee par rapport aux traits, tu peux zoomer legerement
     a l'interieur »). Il avait raison sur la cause : a zoom 1, le fond est exactement au format
     de la scene, il n'y a AUCUN debordement, et `background-position` ne peut donc rien decaler.
     Le recentrage sur le panneau du mur, qui marche a tous les autres formats, restait sans
     effet sur celui-la.
     Il faut 0,0092 de largeur d'image pour amener le milieu du panneau au centre. La marge
     disponible vaut (S - 1) / 2S : il faut donc S ≥ 1,019 pour que le decalage soit seulement
     possible, et a cette valeur le fond serait colle contre un bord. 1,10 laisse 0,045 de
     marge, cinq fois ce qu'il faut.
     ⚠️ Zoomer le fond NE retrecit PAS l'affiche : `Zeff` suit le meme S, donc l'affiche avance
     avec la piece et garde sa taille relative aux meubles. C'est justement pour ca que ce
     tableau existe. */
  var ZOOM_FORMAT = { "21X30": 1.6, "30X40": 1.42, "50X70": 1.18, "70X100": 1, "50X35": 1.3,
    "Polyptyque 2x2 · 50x70": 1.1 };
  // Les tailles metal portent un prefixe : garder leur libelle pour les variantes,
  // mais enregistrer leurs dimensions pour le choix obligatoire et le controle DPI.
  if (window.__pdpPersoMetal) variants.forEach(function (v) {
    var key = v.option1 || v.options[0], cm = String(key).match(/(\d+)\s*[x×]\s*(\d+)/i);
    if (!cm) return;
    var w = Math.min(+cm[1], +cm[2]), h = Math.max(+cm[1], +cm[2]);
    A_CM[key] = [w, h];
    A_SCALE[key] = w <= 20 ? 0.55 : 0.63;
    ZOOM_FORMAT[key] = w <= 20 ? 1.6 : 1.42;
    MOCK_W[key] = MOCK_BASE_A0_W * w / A_CM[SIZE_REF][0];
  });
  /* ⛔ LES TABLES CI-DESSUS SONT INDEXEES PAR LE LIBELLE FRANCAIS DU POLYPTYQUE, et Markets
   * TRADUIT les valeurs d'option : sur /nl la taille s'appelle « Polyptiek 2x2 · 50x70 ».
   * Chaque lecture (`A_CM[v]`, `A_SCALE[v]`, `ZOOM_FORMAT[v]`, `MOCK_W[v]`) retombait donc sur
   * son defaut, et la mise en situation montrait un polyptyque a la mauvaise echelle sur les
   * douze marches non francophones.
   *
   * ⚠️ ON AJOUTE DES CLES, ON N'EN DEPLACE AUCUNE. Reecrire les huit sites de lecture aurait
   * touche le calcul d'echelle, qui est ce qu'il y a de plus delicat dans ce fichier ; ajouter
   * un alias ne change rien pour le francais et repare les autres. La correspondance se fait
   * par les NOMBRES du libelle, jamais par le mot : c'est la lecon du 10/08/2026.
   */
  function aliasTaillesTraduites() {
    var tables = [A_CM, A_SCALE, ZOOM_FORMAT, MOCK_W];
    var signature = function (s) {
      var g = String(s).match(/(\d)\s*[x\u00d7]\s*(\d)\D+(\d{2,3})\s*[x\u00d7]\s*(\d{2,3})/i);
      return g ? g[1] + 'x' + g[2] + '/' + Math.min(+g[3], +g[4]) + 'X' + Math.max(+g[3], +g[4]) : null;
    };
    var valeurs = [];
    try {
      document.querySelectorAll('.opt-pill[data-value]').forEach(function (b) {
        valeurs.push(b.getAttribute('data-value'));
      });
    } catch (e) { return; }
    valeurs.forEach(function (v) {
      var sig = signature(v);
      if (!sig) return;
      tables.forEach(function (tab) {
        if (tab[v] !== undefined) return;               /* deja connu : c'est le francais */
        Object.keys(tab).forEach(function (k) {
          if (signature(k) === sig) tab[v] = tab[k];    /* meme structure : meme valeur */
        });
      });
    });
  }

  /* ⛔ LE 21 x 30 AVANCE ENCORE SUR TELEPHONE, ET SEULEMENT LA (Adrien, 06/08/2026). La scene
     mobile est bien plus petite que celle du desktop : a zoom egal, le plus petit format y
     tombe sous la taille ou l'on distingue encore ce qui est imprime dessus, et un apercu ou
     l'on ne voit pas l'affiche ne vend rien. Sur desktop il est deja lisible, l'augmenter y
     ferait au contraire perdre le canape et les etageres qui donnent l'echelle.
     1,6 -> 1,85, soit 15 % de plus. Le fond ne peut pas depasser ce que le cadrage « cover »
     autorise : `positionMockup` borne le zoom par le bas mais pas par le haut, c'est donc a
     l'ecran que se verifie qu'on ne sort pas du mur, pas dans ce tableau. */
  var ZOOM_FORMAT_MOBILE = { "21X30": 1.85 };
  function zoomFormat(v) {
    if (window.matchMedia && window.matchMedia("(max-width:768px)").matches
        && ZOOM_FORMAT_MOBILE[v]) return ZOOM_FORMAT_MOBILE[v];
    return ZOOM_FORMAT[v] || 1;
  }
  // Géométrie de la pièce de fond (mockup-salon.png = 1108×1420).
  //  - MOCK_IMG_AR : ratio largeur/hauteur de la photo.
  //  - MOCK_IY_SOFA : où commence le canapé DANS la photo (fraction de hauteur).
  //  - MOCK_SOFA_TARGET : le canapé n'est JAMAIS poussé plus bas que ça dans la scène.
  //    Tant que le zoom le garde au-dessus, on cale le fond en haut ; sinon on fait
  //    descendre le point de vue (background-position-y) pour l'y maintenir → le canapé
  //    reste toujours visible, même aux petits formats très zoomés.
  //  - MOCK_TOP_MARGIN : marge de mur en haut ; l'affiche est centrée entre elle et le canapé.
  // Pièces de mise en situation. Chaque pièce porte sa propre géométrie :
  //  ar = largeur/hauteur de la photo ; iy = où commence le meuble (fraction de hauteur) ;
  //  target = le meuble n'est jamais poussé plus bas ; top = marge de mur en haut.
  //  Alimenté par window.__pdpRooms (Liquid) ; sinon fallback salon d'origine.
  var ROOMS = (window.__pdpRooms && window.__pdpRooms.length) ? window.__pdpRooms
            : [{ img: "", ar: 1108 / 1420, iy: 0.58, target: 0.76, top: 0.10 }];
  var curRoom = ROOMS[0];

  var selected = {};   // option index -> value
  var qty = 1, photo = null, photoFile = null, photoSourceFile = null, viewCustom = false, genTimer = null;
  // URL rendue par le depot ; elle part dans les proprietes de la ligne de panier.
  var persoUrl = null, persoPreview = null, persoSourceUrl = null, persoCadreeUrl = null, persoUploading = false;
  /* ⛔ LE CADRAGE PORTE UN ZOOM, ET IL DOIT FINIR DANS LE FICHIER IMPRIMÉ.
     Il n'avait que x et y, et surtout il ne servait qu'à l'écran : la composition envoyée au
     panier dessinait l'image ENTIÈRE. Le client déplaçait donc un cadrage qu'il ne recevait
     jamais, et son affiche partait à l'impression en « contain », avec des bandes blanches
     quand sa photo n'avait pas le ratio de l'affiche. Relevé le 01/08/2026 sur A1032 : une
     photo en 1053x2096 pour un 30x40. */
  var persoCrop = { x: 50, y: 50, z: 1 }, persoPrintKey = "";
  /* Le fichier envoyé porte-t-il le cadrage ? Faux tant qu'aucune composition n'a réussi. */
  var persoCropApplique = false;
  var PERSO_ZOOM_MAX = 3;
  // Zone de texte. photoSourceFile = photo d'origine (sans bande / passe-partout).
  var persoTextOn = false, persoFont = "classic";
  /* ⛔ UNE POLICE PAR TEXTE, EN CASCADE (Adrien, 20/08/2026 : « il manque le choix de police par
     texte »). Vide = ce texte suit la police de l'affiche ; le client qui ne touche a rien ne
     voit aucune difference, et recliquer la police posee la retire. Meme regle que l'encre. */
  var persoFontTitre = "", persoFontSous = "";
  function fontIdDe(cible) {
    var id = cible === "sous" ? persoFontSous : persoFontTitre;
    return (id && PERSO_FONTS[id]) ? id : persoFont;
  }
  var persoTextDesign = "design", persoTextColor = "blanc";
  /* Gabarit de bande choisi par ?look= (ceremonie, etat-civil, signature, fete).
     Vide = gabarit classique. Voyage au panier en _perso_gabarit : l'impression
     (catalogue/perso-tirage.js, table GABARITS) reproduit les memes reglages. */
  var persoGabarit = "";
  /* Etat civil : les virgules du sous-titre deviennent des points medians a l'AFFICHAGE
     (ecran, fichier panier, impression) ; la saisie du client reste telle quelle. */
  function sousAffiche(s) {
    return persoGabarit === "etat-civil" ? String(s || "").replace(/,\s+/g, " \u00b7 ") : s;
  }
  /* ⛔ MIROIR DE catalogue/perso-tirage.js (STYLES) : meme fichier de police, meme graisse,
     meme casse, meme interlettrage. C'est le seul moyen que la cliente imprime ce qu'elle a
     choisi. Jusqu'au 08/08/2026 quatre de ces huit entrees nommaient une police SYSTEME que
     le serveur n'a pas — Georgia, Arial, Palatino, Impact — et l'impression y repondait par
     Playfair, Montserrat, Playfair et Anton : le dessin de la lettre changeait entre l'ecran
     et la presse. Une police systeme n'est de toute facon pas la meme d'une machine cliente
     a l'autre.
     ⚠️ Six dessins pour huit options : classic et elegant partagent Playfair, distingues par
     la graisse et la casse. */
  var PERSO_FONTS = {
    classic: { family: '"Playfair Display", Georgia, serif', titleWeight: "700", titleTransform: "uppercase", titleTracking: 0.06 },
    modern:  { family: "Montserrat, Arial, sans-serif", titleWeight: "700", titleTransform: "uppercase", titleTracking: 0.08 },
    elegant: { family: '"Playfair Display", Georgia, serif', titleWeight: "500", titleTransform: "none", titleTracking: 0.02 },
    bold:    { family: 'Anton, Impact, sans-serif', titleWeight: "400", titleTransform: "uppercase", titleTracking: 0.04 },
    script:  { family: '"Great Vibes", "Apple Chancery", cursive', titleWeight: "400", titleTransform: "none", titleTracking: 0.01 },
    marcellus: { family: 'Marcellus, "Times New Roman", serif', titleWeight: "400", titleTransform: "none", titleTracking: 0.04 },
    garamond: { family: '"Cormorant Garamond", Garamond, Georgia, serif', titleWeight: "500", titleTransform: "none", titleTracking: 0.02 },
    cinzel:  { family: 'Cinzel, "Times New Roman", serif', titleWeight: "400", titleTransform: "uppercase", titleTracking: 0.10 }
  };
  /* ⛔ MIROIR de catalogue/perso-tirage.js (FONDS) : memes cles, memes hexas. */
  /* Couleur des DEUX textes choisie par la pastille : une cle de PERSO_MATS, ou vide
     pour l'automatique (l'encre suit alors le fond, et la pastille en voile). Voyage au
     panier en _perso_encre ; l'impression applique la meme regle. */
  var persoInkTitre = "", persoInkSous = "";
  /* ⛔ L'ENCRE DU VOILE SUIT LA PHOTO, PAS LE FOND : sur « Sur la photo » (voile,
     voile-bas), l'encre automatique se choisit par la luminance moyenne de la photo
     sous le texte, seuil 0.55 : photo claire -> sombre #1A2238 / #3A4054, photo
     sombre -> blanc #FFFFFF / #E8E4DC. MEMES seuil et couleurs dans le canvas panier
     (composePersoWithText) et l'impression (perso-tirage.js, composer). Une pastille
     d'encre explicite garde toujours le dernier mot. Avant : l'encre suivait le fond
     (blanc par defaut), illisible sur photo claire (02/08/2026). */
  var persoVoileAuto = null;
  var persoVoileAutoCle = "";
  var persoVoileAutoJeton = 0;
  function encresParLuminance(lum) {
    return lum > 0.55
      ? { ink: "#1A2238", muted: "#3A4054" }
      : { ink: "#FFFFFF", muted: "#E8E4DC" };
  }
  function encreEffective(mat, voile) {
    var auto = voile ? (persoVoileAuto || { ink: "#1A2238", muted: "#3A4054" }) : null;
    var ink = (persoInkTitre && PERSO_MATS[persoInkTitre]) ? PERSO_MATS[persoInkTitre].bg
      : (voile ? auto.ink : mat.ink);
    var muted = (persoInkSous && PERSO_MATS[persoInkSous]) ? PERSO_MATS[persoInkSous].bg
      : (voile ? auto.muted : mat.muted);
    return { bg: mat.bg, ink: ink, muted: muted };
  }
  var PERSO_MATS = {
    blanc:  { bg: "#FFFFFF", ink: "#1a2238", muted: "#3a4054" },
    creme:  { bg: "#F5EFE3", ink: "#1a2238", muted: "#4a453c" },
    sable:  { bg: "#E8DFD0", ink: "#1a2238", muted: "#4a453c" },
    sauge:  { bg: "#C9D2C0", ink: "#1a2238", muted: "#45503f" },
    poudre: { bg: "#E8D3CE", ink: "#1a2238", muted: "#5c4a46" },
    brume:  { bg: "#CBD5DC", ink: "#1a2238", muted: "#414c55" },
    terracotta: { bg: "#C67B5C", ink: "#1a2238", muted: "#5c3a2c" },
    ocre:   { bg: "#C8A96B", ink: "#1a2238", muted: "#6b5a36" },
    lilas:  { bg: "#D8D0E4", ink: "#1a2238", muted: "#544a63" },
    foret:  { bg: "#31473A", ink: "#FFFFFF", muted: "#C9D2C8" },
    marine: { bg: "#26334D", ink: "#FFFFFF", muted: "#C4CBD8" },
    noir:   { bg: "#1A1A1A", ink: "#FFFFFF", muted: "#C8C4BC" }
  };
  /* MEDIANE, pas moyenne : une region bimodale (eau claire + roche sombre) tirait la
     moyenne du mauvais cote de la matiere qui porte le texte. Meme regle que le
     canvas panier et le tirage (02/08/2026). */
  function luminanceMediane(d) {
    var lums = [];
    for (var i = 0; i < d.length; i += 4) lums.push(0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]);
    lums.sort(function (a, b) { return a - b; });
    return lums[Math.floor(lums.length / 2)] / 255;
  }
  function luminanceRegion(img, sx, sy, sw, sh) {
    var c = document.createElement("canvas");
    c.width = 48; c.height = 24;
    var cx = c.getContext("2d");
    cx.drawImage(img, sx, sy, Math.max(1, sw), Math.max(1, sh), 0, 0, 48, 24);
    return luminanceMediane(cx.getImageData(0, 0, 48, 24).data);
  }
  /* Recalcule l'encre automatique du voile pour la photo affichee (importee, sinon
     l'exemple du look). Async : a l'arrivee, les vars se reappliquent via sync. */
  function calculerEncreVoileAuto() {
    var voileActif = persoTextDesign === "voile" || persoTextDesign === "voile-bas";
    if (!voileActif) { persoVoileAuto = null; persoVoileAutoCle = ""; return; }
    var cle = [persoTextDesign, persoOrientation, persoUrl || photo || "exemple",
      window.__persoLook || "", persoCrop.x, persoCrop.y, persoCrop.z].join("|");
    if (cle === persoVoileAutoCle) return;
    persoVoileAutoCle = cle;
    var jeton = ++persoVoileAutoJeton;
    var g = persoGeometrie();
    var finir = function (img, rect) {
      if (jeton !== persoVoileAutoJeton) return;
      /* La region de la bande dans le repere de la photo (le voile est pleine feuille),
         restreinte aux 70 % centraux comme le tirage : le texte est centre, et les
         bords sombres d'une photo diluaient la moyenne. */
      var fx = (g.bande.x - g.img.x) / g.img.w + (g.bande.w / g.img.w) * 0.15;
      var fw = (g.bande.w / g.img.w) * 0.7;
      var fy = (g.bande.y - g.img.y) / g.img.h, fh = g.bande.h / g.img.h;
      var lum;
      try {
        lum = luminanceRegion(img,
          rect.sx + fx * rect.sw, rect.sy + fy * rect.sh, fw * rect.sw, fh * rect.sh);
      } catch (e) { return; } /* canvas souille : on garde le defaut sombre */
      persoVoileAuto = encresParLuminance(lum);
      /* ⛔ ET LES PASTILLES SUIVENT. L'encre automatique du voile se calcule sur la LUMINANCE de
         la photo, donc APRES son chargement et son analyse. Les pastilles, elles, etaient
         peintes une fois pour toutes au moment du clic : sur une photo sombre, l'apercu passait
         le texte en blanc pendant que la pastille gardait le bleu nuit du defaut. Adrien,
         20/08/2026 : « je ne sais meme pas si la cliente a vraiment voulu du noir, ou si elle a
         vu du blanc s'afficher ». Une pastille qui ment sur la couleur envoyee est pire qu'une
         pastille absente. */
      try { majPastillesPersoTexte(); } catch (e) {}
      syncPersoTextPreview();
    };
    loadPersoImage().then(function (img) {
      finir(img, rectangleSource(img));
    }).catch(function () {
      /* Etat exemple : la photo du look, cadree en couverture centree. */
      var ghost = document.querySelector("#pdp-placeholder .pdp-placeholder__ghost");
      var fond = ghost ? (getComputedStyle(ghost).backgroundImage || "") : "";
      var m = fond.match(/url\(["']?([^"')]+)/);
      if (!m) return;
      var img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = function () {
        var iw = img.naturalWidth, ih = img.naturalHeight;
        var R = (g.img.w / g.img.h) * g.R;
        var sw = iw, sh = iw / R;
        if (sh > ih) { sh = ih; sw = ih * R; }
        finir(img, { sx: (iw - sw) / 2, sy: (ih - sh) / 2, sw: sw, sh: sh });
      };
      img.src = m[1];
    });
  }
  function persoMatTheme() {
    return PERSO_MATS[persoTextColor] || PERSO_MATS.blanc;
  }
  function clampPct(v) {
    v = parseFloat(v);
    if (!isFinite(v)) return 50;
    return Math.max(0, Math.min(100, v));
  }
  function clampZoom(v) {
    v = parseFloat(v);
    if (!isFinite(v)) return 1;
    return Math.max(1, Math.min(PERSO_ZOOM_MAX, v));
  }
  function persoCropPosition() {
    return clampPct(persoCrop.x).toFixed(0) + "% " + clampPct(persoCrop.y).toFixed(0) + "%";
  }
  /* ⛔ LE RATIO DE LA FEUILLE EST CELUI DE L'IMPRESSION, PAS CELUI D'UNE IMAGE.
   *
   * 0,6923 : la zone imprimée de la famille de formats, celle que le Studio impose à toutes les
   * affiches générées (`idealGenerationRatio()` dans `print.js`). Une affiche personnalisée est
   * imprimée sur la même presse et sur le même papier : elle doit sortir au même ratio, sinon
   * elle prend des bandes blanches que les autres n'ont pas.
   *
   * Il se lisait dans `--art-ratio`, que le thème remplissait avec le ratio de l'IMAGE du
   * produit. Pour l'affiche personnalisée, cette image est la démonstration, un fjord en
   * 652x900, soit 0,7244 : la maquette et le fichier composé étaient donc réglés sur les
   * proportions d'une photo de catalogue (relevé le 01/08/2026).
   *
   * La valeur ne se déduit donc plus de rien, ni ici ni dans le thème : une affiche hors ratio
   * doit se voir rognée dans un cadre juste, jamais déformer le cadre pour se cacher. */
  var PERSO_RATIO_IMPRESSION = 0.6923;
  /* Paysage : la meme feuille, tournee a 90 degres. L'orientation est une PROPRIETE de la
     ligne (pas une variante) : memes tailles, memes prix, et l'atelier lit _perso_orient. */
  var persoOrientation = "portrait";
  function persoRatioPortrait() {
    if (!window.__pdpPersoMetal) return PERSO_RATIO_IMPRESSION;
    var v = currentVariant(), d = v && String(v.option1 || v.options[0]).match(/(\d+)\s*[x×]\s*(\d+)/i);
    return d ? Math.min(+d[1], +d[2]) / Math.max(+d[1], +d[2]) : 0.75;
  }
  function persoRatioFeuille() {
    var r = persoRatioPortrait();
    return persoOrientation === "paysage" ? 1 / r : r;
  }
  function peindrePersoOrientation() {
    $$("[data-perso-orient]").forEach(function (b) {
      var on = b.getAttribute("data-perso-orient") === persoOrientation;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
  function setPersoOrientation(id, formatChange) {
    if (id !== "portrait" && id !== "paysage") return;
    if (persoOrientation === id && !formatChange) { peindrePersoOrientation(); return; }
    persoOrientation = id;
    /* ⛔ LA GALERIE DE DEMOS S'EFFACE AU CHANGEMENT D'ORIENTATION (Adrien, 08/08/2026 : « le
       clic sur mode paysage n'a aucun effet sur l'image placeholder »). Ces rendus sont des
       JPEG figes, tous en portrait : ils ne peuvent pas suivre le ratio. Tant qu'ils couvrent
       le cadre, basculer en paysage ne change rien a ce qu'on voit, alors que le cadre en
       dessous a bien change de forme. Les autres reglages (mise en page, police, couleur)
       effacent deja la galerie pour la meme raison ; l'orientation manquait a la liste. */
    /* Changer d'orientation, c'est demander a revoir SON affiche : une vue fixe n'y survit
       pas, sinon la scene garde le rapport de la photo produit. */
    if (window.__pdpMontrerLAffiche) window.__pdpMontrerLAffiche();
    peindrePersoOrientation();
    /* --art-ratio pilote la scene, la maquette et les vignettes. Il est defini EN LIGNE
       sur la galerie et sur la maquette (section) : une valeur posee sur la racine serait
       battue par ces definitions plus proches. On met donc a jour chaque source inline. */
    var ratio = String(persoRatioFeuille());
    document.querySelectorAll('[style*="--art-ratio"]').forEach(function (el) {
      el.style.setProperty("--art-ratio", ratio);
    });
    var root = document.querySelector(".pdp--perso");
    if (root) {
      root.style.setProperty("--art-ratio", ratio);
      /* La classe porte les regles CSS propres au paysage (hauteur de scene). */
      root.classList.toggle("pdp--paysage", persoOrientation === "paysage");
    }
    /* La feuille change de proportions : le cadrage repart du centre, comme au changement
       de gabarit. L'auto ne rejoue qu'a l'import d'une photo ; le choix manuel reste maitre. */
    persoCrop = { x: 50, y: 50, z: 1 };
    persoPrintKey = "";
    if (typeof applyPersoCrop === "function") applyPersoCrop();
    if (typeof syncPersoTextPreview === "function") syncPersoTextPreview();
    /* La maquette murale se recale : en paysage l'affiche est plus LARGE au mur. */
    if (typeof positionMockup === "function") positionMockup(mockFmt);
    if (window.__pdpPersoMetal) updateFormatScale();
  }
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-perso-orient]");
    if (!b) return;
    setPersoOrientation(b.getAttribute("data-perso-orient"));
  });

  /* ⛔ UNE SEULE GÉOMÉTRIE POUR L'APERÇU ET POUR LE FICHIER.
   *
   * Elles étaient écrites deux fois : en CSS pour la maquette (marges à 5 %, zone de texte à
   * 26 %), en dur dans le canvas pour le fichier (marges à 6 % de la LARGEUR DE L'IMAGE, bande
   * à 22 % de sa hauteur). Rien ne les obligeait à se ressembler, et elles ne se ressemblaient
   * pas : la cliente voyait une affiche 30x40 avec sa photo en haut et son titre dessous, et
   * l'atelier recevait un fichier de 1053x2096, au ratio de sa photo à elle, marges comprises.
   * Relevé le 01/08/2026 sur A1032.
   *
   * Les fractions ci-dessous sont celles de `base.css`, à la virgule près. En changer une sans
   * changer l'autre ferait revenir l'écart, en silence : c'est pour ça qu'elles sont commentées
   * des deux côtés.
   */
  function persoGeometrie() {
    var R = persoRatioFeuille();
    /* ⛔ LA SAISIE, PAS LE MASQUAGE, ET C'EST LA PARITE ECRAN / IMPRESSION QUI L'EXIGE. Cette
       fonction donne les fractions du FICHIER imprime ; l'ecran, lui, reserve la place d'une
       ligne masquee (voir persoTextTitle). Lire ici la valeur masquee ferait imprimer une zone
       photo de 74 % la ou le client en a valide une de 72 % : le tirage ne serait pas ce qu'il
       a vu. Les glyphes, eux, restent masques a la peinture, dans composePersoWithText. */
    var avecTexte = !!(persoTextOn && persoTextTitleSaisi());
    var sub = avecTexte && !!persoTextSubSaisi();
    if (!avecTexte) return { R: R, img: { x: 0, y: 0, w: 1, h: 1 }, bande: null, passePartout: false };
    if (persoTextDesign === "design" || persoTextDesign === "editorial" || persoTextDesign === "arche") {
      /* base.css : #pdp-main { top:5%; left:5%; right:5%; bottom:26% (28% avec sous-titre) }
         et .pdp-textband { left:5%; right:5%; bottom:2.5%; height:20% (22% avec sous-titre) } */
      var bas = sub ? 0.28 : 0.26;
      var hb = sub ? 0.22 : 0.20;
      return {
        R: R, passePartout: true,
        img: { x: 0.05, y: 0.05, w: 0.90, h: 1 - 0.05 - bas },
        bande: { x: 0.05, y: 1 - 0.025 - hb, w: 0.90, h: hb }
      };
    }
    if (persoTextDesign === "voile-bas") {
      /* Le miroir du voile : bande nue en bas (4,5 % du bord), memes fractions que
         base.css et plan() (02/08/2026). */
      return {
        R: R, passePartout: false, voile: true,
        img: { x: 0, y: 0, w: 1, h: 1 },
        bande: { x: 0.05, y: 1 - 0.045 - (sub ? 0.20 : 0.16), w: 0.90, h: sub ? 0.20 : 0.16 }
      };
    }
    if (persoTextDesign === "musee") {
      /* Galerie : marges 12 % de cote, 10 % en haut, cartel a gauche en bas.
         Fractions partagees avec base.css et plan() (02/08/2026). */
      var hautBasM = sub ? 0.26 : 0.24;
      var hbM = sub ? 0.14 : 0.10;
      return {
        R: R, passePartout: true,
        img: { x: 0.12, y: 0.10, w: 0.76, h: 1 - 0.10 - hautBasM },
        bande: { x: 0.12, y: 1 - 0.055 - hbM, w: 0.76, h: hbM }
      };
    }
    if (persoTextDesign === "voile") {
      /* base.css : photo pleine feuille, .pdp-textband { top:4.5%; height:16% (20% avec
         sous-titre) } SANS fond : le texte se pose sur la photo (reference NOUS DEUX,
         validee le 02/08/2026). Le drapeau `voile` dit aux composeurs de ne pas peindre
         le fond de bande. */
      return {
        R: R, passePartout: false, voile: true,
        img: { x: 0, y: 0, w: 1, h: 1 },
        bande: { x: 0.05, y: 0.045, w: 0.90, h: sub ? 0.20 : 0.16 }
      };
    }
    if (persoTextDesign === "entete") {
      /* base.css : #pdp-main { top:26% (28% avec sous-titre); left/right:5%; bottom:5% }
         et .pdp-textband { left/right:5%; top:2.5%; height:20% (22% avec sous-titre) }.
         Le miroir vertical du passe-partout : le texte EN HAUT, la photo dessous
         (reference MR & MME, validee le 02/08/2026). */
      var haut = sub ? 0.28 : 0.26;
      var he = sub ? 0.22 : 0.20;
      return {
        R: R, passePartout: true,
        img: { x: 0.05, y: haut, w: 0.90, h: 1 - haut - 0.05 },
        bande: { x: 0.05, y: 0.025, w: 0.90, h: he }
      };
    }
    /* base.css : .pdp-textband { bottom:0; height:22% (26% avec sous-titre) }, photo plein cadre. */
    var hz = sub ? 0.26 : 0.22;
    return {
      R: R, passePartout: false,
      img: { x: 0, y: 0, w: 1, h: 1 },
      bande: { x: 0, y: 1 - hz, w: 1, h: hz }
    };
  }

  /* Ce que le cadrage doit remplir : la ZONE PHOTO, pas la feuille. Avec le passe-partout, elle
     est presque carrée alors que la feuille est en 0,75 ; croiser les deux couperait la photo
     autrement à l'écran et à l'impression. */
  function persoRatioCible() {
    var g = persoGeometrie();
    return (g.img.w / g.img.h) * g.R;
  }
  /* La taille de fond qui remplit le cadre (« cover »), multipliée par le zoom. En pourcentages
     du cadre, parce que `background-size: cover` ne se multiplie pas en CSS. */
  function persoCoverPct() {
    var z = clampZoom(persoCrop.z);
    var ri = persoPx.w && persoPx.h ? persoPx.w / persoPx.h : null;
    if (!ri) return { w: 100 * z, h: 100 * z, auto: true };
    var rc = persoRatioCible();
    /* Image plus large que le cadre : c'est la hauteur qui touche, la largeur déborde. */
    return ri > rc
      ? { w: (ri / rc) * 100 * z, h: 100 * z }
      : { w: 100 * z, h: (rc / ri) * 100 * z };
  }

  function currentVariant() {
    return variants.filter(function (v) {
      for (var i = 0; i < optCount; i++) { if (v.options[i] !== selected[i]) return false; }
      return true;
    })[0];
  }
  // Variante la moins chère (pour « dès X € » + son prix barré éventuel), PARMI celles qui
  // respectent les options deja choisies : sur le panneau de mariage, arriver sur la carte
  // « Plan de table » doit dire « dès 110 », pas le minimum du produit entier (60).
  /* ⛔⛔ LES COTES QUE L'ECRAN N'OFFRE PAS NE COMPTENT PAS DANS LE PRIX « dès » (Adrien,
     28/08/2026 : « le prix à partir de est faux quand on choisit displate »). Le support
     metallise masque les cotes papier — c'est un filtre d'ECRAN, pas une option Shopify — et
     `cheapestVariant` balayait quand meme TOUTES les variantes : la fiche annoncait « dès
     12,60 € », le prix d'un 21x30 papier, sous un choix ou la plus petite plaque vaut 20 €.
     ⛔ UN PRIX « dès » QUI DESIGNE UNE VARIANTE INATTEIGNABLE EST UN PRIX FAUX, et c'est la
     forme la plus couteuse : le client clique en confiance et decouvre l'ecart au panier.
     ⚠️ LA REGLE EST GENERALE, pas propre au metal : tout filtre d'ecran a venir en profitera,
     et aucun n'aura a se souvenir de retoucher le prix. */
  window.__pdpMajPrix = function () {
    try { updatePrice(); } catch (e) { /* jamais bloquer */ }
    /* ⚠️ LE TABLEAU DEGRESSIF SUIT LE PRIX, et il le fait DANS `updatePrice` : le brancher ici
       aussi le peindrait deux fois par changement, et laisserait croire que ce point d'entree
       est le seul chemin — ce qu'il n'a jamais ete. */
  };

  /* ⛔ LE PRIX DE LA VARIANTE CHOISIE, POUR QUI EN A BESOIN AILLEURS. Le tableau degressif du
     parcours pro doit dire ce que coute UNE affiche a chaque palier : sans ce point d'entree, il
     relirait le prix dans le DOM, c'est-a-dire une chaine deja formatee, deja convertie en hors
     taxes et deja traduite — trois occasions de se tromper pour retrouver un nombre qui est ici.
     ⚠️ IL REND `0` TANT QU'AUCUNE COTE N'EST CHOISIE : l'appelant montre alors la remise seule
     plutot qu'un prix invente sur la premiere variante venue. */
  window.__pdpPrixUnitaire = function () {
    try { var v = currentVariant(); return v ? v.price : 0; } catch (e) { return 0; }
  };

  /* ⛔⛔ LE TABLEAU DEGRESSIF DU PARCOURS PRO. Il dit, pour la cote choisie, ce que coute UNE
     affiche a chaque palier — c'est la question qu'un professionnel se pose devant un catalogue,
     et la seule reponse qui l'interesse.
     ⛔ LES PALIERS VIENNENT DE `window.__lotBareme`, pose par `lot-bareme.liquid`. Une liste
     ecrite ici serait une deuxieme source pour un bareme deja annonce a trois endroits, et c'est
     toujours celle qu'on ne relit pas qui garde l'ancien taux.
     ⚠️ LE PRIX SUIT LA COTE : il se refait a chaque changement de variante, sinon la colonne
     montre le tarif du format qu'on vient de quitter — le meme piege que le prix « des ».
     ⚠️ ET IL EST EN HORS TAXES COMME TOUTE LA PAGE EN MODE PRO : `montantTxt` porte deja la
     conversion et le suffixe. Le recalculer ici ferait deux arrondis pour un seul prix. */
  function peindreDegressif() {
    var boite = document.querySelector("[data-pdp-degressif]");
    if (!boite) return;
    var B = window.__lotBareme;
    var paliers = B && B.actif && B.paliers ? B.paliers : [];
    var prix = window.__pdpPrixUnitaire ? window.__pdpPrixUnitaire() : 0;
    if (!paliers.length) { boite.hidden = true; return; }
    var corps = boite.querySelector("[data-pdp-degressif-corps]");
    corps.innerHTML = paliers.map(function (t, i) {
      var suivant = paliers[i + 1];
      var plage = suivant ? t.n + " – " + (suivant.n - 1) : t.n + " +";
      /* ⚠️ SHOPIFY TRONQUE LA REMISE, IL NE L'ARRONDIT PAS : mesure du 28/08 sur des paniers
         reels. `Math.round` annoncerait ici un prix que la caisse ne rendrait pas. */
      var unit = prix ? prix - Math.floor(prix * t.pct / 100) : 0;
      return "<tr><td>" + plage + "</td><td><span class=\"pdp-degressif__r\">\u2212" + t.pct
        + " %</span></td><td>" + (unit ? montantTxt(unit) : "\u2014") + "</td></tr>";
    }).join("");
    boite.hidden = false;
  }
  window.__pdpDegressif = peindreDegressif;

  /* ⛔⛔ CHANGER DE SUPPORT EFFACE LA TAILLE, ET IL FAUT LE DIRE ICI (Adrien, 28/08/2026 : « le
     prix a partir de ne revient pas sur papier quand on reclique dessus apres avoir selectionne
     une taille de displate »).
     Le choix de support masque les cotes de l'autre support et retire leur `aria-pressed` : a
     l'ECRAN, plus rien n'est choisi. Mais `selected` est un etat de CE fichier, que personne ne
     touchait : `formatChosen()` restait vrai, et le prix continuait d'afficher les 20 € de la
     plaque sur une fiche revenue au papier — un prix qui ne designe plus aucune variante
     offerte.
     ⚠️ LE DOM N'EST PAS L'ETAT. Decocher un bouton ne desélectionne rien tant que la variable
     qui decide n'a pas bouge, et rien ne signale l'ecart : les deux se contredisent en silence.
     ⚠️ AUCUN LIBELLE DE PLAQUE N'EGALE UN LIBELLE DE PAPIER : un choix ne peut donc JAMAIS
     survivre a un changement de support. On oublie sans condition. */
  window.__pdpOublierLeFormat = function () {
    try {
      var fi = formatGroupInfo();
      if (!fi) return;
      delete selected[fi.idx];
      fi.pills.forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
      disengageScale();
      updatePrice();
      updateFrame();
    } catch (e) { /* jamais bloquer la fiche pour un prix */ }
  };

  function valeursMasquees() {
    var hors = {};
    var bloc = document.querySelector(".pdp-option");
    if (!bloc) return hors;
    var champs = bloc.querySelectorAll("[data-value]");
    for (var i = 0; i < champs.length; i++) {
      var e = champs[i];
      var tuile = (e.closest && (e.closest("label") || e.closest("button"))) || e;
      if (tuile.hidden) hors[e.getAttribute("data-value")] = 1;
    }
    return hors;
  }

  function cheapestVariant() {
    var best = null;
    var hors = valeursMasquees();
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available === false) continue;
      /* Une variante dont UNE valeur est masquee a l'ecran n'est pas achetable : elle ne peut
         donc pas porter le prix d'appel. */
      var offerte = true;
      for (var h = 0; h < variants[i].options.length; h++) {
        if (hors[variants[i].options[h]]) { offerte = false; break; }
      }
      if (!offerte) continue;
      var accord = true;
      for (var o = 0; o < optCount; o++) {
        if (selected[o] != null && variants[i].options[o] !== selected[o]) { accord = false; break; }
      }
      if (!accord) continue;
      if (!best || variants[i].price < best.price) best = variants[i];
    }
    return best || variants[0] || null;
  }
  function minVariantPrice() { var v = cheapestVariant(); return v ? v.price : 0; }
  // Repère le groupe d'options « Format » : celui dont une valeur est un format ISO (A0…A4).
  function formatGroupInfo() {
    var grps = $$(".pdp-option");
    for (var g = 0; g < grps.length; g++) {
      var pills = $$("[data-value]", grps[g]);
      for (var p = 0; p < pills.length; p++) {
        if (A_CM[pills[p].getAttribute("data-value")]) {
          return { grp: grps[g], idx: parseInt(grps[g].getAttribute("data-option-index"), 10), pills: pills };
        }
      }
    }
    return null;
  }
  // Un format a-t-il été choisi par l'acheteur ? (sinon : prix « dès », mockup A0)
  function formatChosen() {
    var fi = formatGroupInfo();
    return !fi || selected[fi.idx] != null;
  }
  /* ⛔ SUR UN ACCESSOIRE, LA COULEUR CHANGE L'IMAGE, PAS UNE TEINTE DE MOULURE DESSINÉE.
     La fiche « Cadre pour affiche » montrait sa couleur en TEIGNANT la baguette que le gabarit
     dessine autour de l'image, alors que le produit a une vraie photo par finition (cadre-blanc,
     cadre-noir, cadre-chene-clair) et que chaque variante la porte. D'où le cadre dans un cadre,
     et un sélecteur qui n'avait plus rien à teindre une fois la baguette retirée : « Blanc »
     s'affichait pressé au-dessus de la photo chêne clair (Adrien, 05/08/2026).
     Le produit dit ce qu'il est : quand la variante porte une image, c'est elle qu'on montre. */
  function imageDeVariante() {
    var w = $(".pdp-gallery__wrap");
    if (!w || w.getAttribute("data-framed") !== "false") return;
    /* ⚠️ PAS `currentVariant()` : elle exige que TOUTES les options soient choisies, or sur un
       cadre la couleur se choisit avant la dimension et l'image ne dépend que de la couleur.
       On prend donc la première variante compatible avec ce qui est DÉJÀ choisi. */
    var v = variants.filter(function (cand) {
      for (var i = 0; i < optCount; i++) {
        if (selected[i] != null && cand.options[i] !== selected[i]) return false;
      }
      return true;
    })[0];
    var url = v && (v.featured_image ? v.featured_image.src : (v.image ? v.image.src : null));
    if (!url) return;
    /* ⛔ SUR UNE GALERIE FILTREE PAR TEINTE, C'EST LA VIGNETTE QUI COMMANDE, PAS LA VARIANTE.
       Les douze variantes du cadre pointent toutes sur l'un des trois RENDUS, et ce rendu
       ecrasait la photo choisie par la vignette : la fiche s'ouvrait sur la vignette chene
       entouree et l'aplat blanc dans la scene. Releve deux fois en production, la seconde
       apres avoir ajoute un clic dans le filtre, qui ne pouvait pas gagner : `updateFrame`
       repasse derriere a chaque changement d'option.
       ⚠️ Le rendu reste utile la ou il l'a toujours ete, en image de variante : ligne de
       panier, pastille de moulure, fiche variante. C'est seulement la SCENE qu'il ne pilote
       plus, et seulement quand des photos existent pour la teinte. */
    if ($(".pdp-thumb-item[data-teinte]")) return;
    var m = $("#pdp-main");
    if (m) m.style.backgroundImage = 'url("' + url + '")';
    var solo = $('.pdp-thumb[data-solo="true"]');
    if (solo) { solo.setAttribute("data-img", url); solo.setAttribute("data-zoom", url); }
  }
  function updateFrame() {
    imageDeVariante();
    for (var i = 0; i < optCount; i++) {
      var v = selected[i];
      var none = v === NO_FRAME;
      var sw = FRAME_SWATCH[cleCouleurFr(v)];
      if (!sw && !none) continue;
      var f = $("#pdp-frame"), mp = $("#pdp-mockup-poster"), tp = $(".pdp-thumb__poster");
      // "Sans cadre" : on retire la moulure au lieu de la teindre. Sur la vue murale,
      // data-noframe supprime aussi le passe-partout (le CSS met l'affiche à fond perdu).
      var w = $(".pdp-gallery__wrap");
      if (w) { if (none) w.setAttribute("data-noframe", ""); else w.removeAttribute("data-noframe"); }
      if (f) { f.style.borderWidth = none ? "0px" : ""; if (sw) f.style.borderColor = sw; }
      if (mp) { mp.style.borderWidth = none ? "0px" : ""; if (sw) mp.style.borderColor = sw; }
      if (tp) { tp.style.borderWidth = none ? "0px" : ""; if (sw) tp.style.borderColor = sw; }
    }
  }
  /* Mode échelle. Ne s'active qu'au 1er clic sur un format : l'image de base reste
     une photo produit pleine et nette. Affiche et silhouette partagent le même px/cm. */
  function cmLabel(n) { return String(n).replace(".", ",") + " cm"; }
  // Cale le fond ET l'affiche de la mise en situation pour un format donné.
  //  - background-size : zoom par format (petit format = plus de zoom, mur rapproché) ;
  //  - background-position-y : 0 tant que le canapé reste au-dessus de MOCK_SOFA_TARGET ;
  //    au-delà, on descend le point de vue pour l'y maintenir → canapé toujours visible ;
  //  - l'affiche : centrée dans l'espace de mur entre la marge haute et le canapé.
  var mockFmt = SIZE_REF;
  /**
   * LE PASSE-PARTOUT DE LA PIECE, A LA LARGEUR DU TIRAGE.
   *
   * ⛔ IL VALAIT `MAT_RATIO`, 2,2 % DE L'AFFICHE, QUEL QUE SOIT LE FORMAT ET QUEL QUE SOIT LE
   * CHOIX DU CLIENT (Adrien, 22/08/2026 : « la largeur de la bordure est fausse dans les 3 vues
   * par piece, compare avec la capture 1 »). La vraie marge d'un 50 x 70 fait 5 % de la feuille,
   * plus du double ; celle d'un 21 x 30 n'est pas la meme que celle d'un 70 x 100 ; et « sans
   * bordure » n'en laissait aucune trace. Trois affiches differentes montrees comme une seule.
   *
   * ⚠️ LE CALCUL VIT DANS `bordure-blanche.js`, PAS ICI. `partCadre` rend les deux marges en
   * pourcentage de la LARGEUR DE FEUILLE, exactement ce dont un padding a besoin : un padding
   * en pourcentage se resout sur la largeur du conteneur, les quatre cotes compris. C'est le
   * meme appel que pour `#pdp-frame` sur l'affiche seule, donc les deux vues ne peuvent pas
   * diverger. Le refaire ici serait une troisieme copie de la table d'impression.
   *
   * ⛔ ET L'ANCIEN CARTON RESTE QUAND L'OPTION N'EST PAS PROPOSEE. Sur un accessoire, un
   * polyptyque ou une perso sans photo, `choisi` vaut « sans » faute de bloc : le lire comme un
   * refus retirerait un passe-partout que personne n'a decoche.
   */
  function margeMockup(v) {
    var B = window.AfBordure;
    if (window.AfSurMesure && window.AfSurMesure.format()) v = window.AfSurMesure.format();
    /* ⛔ `propose`, PAS `offert` (08/09/2026). `offert` repond « le choix part-il au panier
       maintenant ? », et il vaut faux tant que le bloc d'options attend qu'une taille soit
       choisie — donc a l'arrivee sur CHAQUE fiche. Le repli reposait alors ses 2,2 % de carton
       et le visiteur voyait un lisere blanc, alors que le defaut de la boutique est « sans
       bordure ». `propose` repond a l'autre question, celle qui compte ici : ce produit
       connait-il la bordure ? Un accessoire ou un polyptyque n'ont pas de champ du tout, et
       gardent le carton historique — la, il n'y a aucun choix a respecter. */
    if (!B || !B.propose) return { haut: MAT_RATIO, cote: MAT_RATIO };
    if (B.choisi !== "avec") return { haut: 0, cote: 0 };
    var c = B.partCadre(v, B.estPaysage && B.estPaysage());
    if (!c) return { haut: MAT_RATIO, cote: MAT_RATIO };
    return { haut: c.hautPct / 100, cote: c.cotePct / 100 };
  }
  function poseCarton(mkp, v, largeur) {
    var m = margeMockup(v);
    mkp.style.padding = (m.haut * largeur).toFixed(3) + "% " + (m.cote * largeur).toFixed(3) + "%";
  }
  function positionMockup(v) {
    var mk = $("#pdp-mockup"), mkp = $("#pdp-mockup-poster");
    if (!mk || !mkp || mk.hidden) return;
    if (v) mockFmt = v; else v = mockFmt;
    /* Le rapport est repose ici et pas seulement dans setRoom : la piece de repli (celle qui
       sert quand le gabarit n'a pas fourni ses photos) n'est pas carree, et personne n'appelle
       setRoom pour elle. Une boite carree sur une photo en 0,78 la rognerait a nouveau. */
    mk.style.setProperty("--room-ar", String(curRoom.ar || 1));
    mk.style.setProperty("--room-ar-poly", String(Math.min(curRoom.ar || 1, 1)));
    /* ⛔ ON MESURE LA BOITE DU FOND, PAS LA SCENE. Depuis que `#pdp-mockup` prend le rapport
       de la photo au lieu de remplir la scene, les deux n'ont plus la meme hauteur : 520 x 520
       contre 520 x 736 sur un ecran large. Toute la geometrie qui suit (le canape, le mur
       libre, la largeur de l'affiche) est en FRACTIONS DE LA PHOTO ; les rapporter a la scene
       poserait l'affiche 40 % trop bas, sous le meuble. */
    var cW = mk.clientWidth, cH = mk.clientHeight;
    if (!cW || !cH) return;
    // « cover » = fond juste rempli. Le zoom dépend de la pièce, jamais du format.
    var coverS = Math.max(1, curRoom.ar * cH / cW);
    var Z = zoomFormat(v);
    /* ⛔ LE FOND NE DESCEND JAMAIS SOUS LE « COVER ». Reculer le point de vue rend la piece
       plus petite ; sous le cover, la photo ne remplit plus la scene et une BANDE BLANCHE
       apparait sous le canape. Vu a l'ecran le 06/08/2026 sur le polyptyque 148 x 208 :
       recul 0,75 demande, cover a 1,104, fond pose a 1,062. Le recul disponible n'est pas
       infini, il vaut exactement ce que le cadrage « cover » laisse de marge dans la photo. */
    var Sdemande = coverS * (curRoom.zoom || MOCK_ROOM_ZOOM) * Z;
    var S = Math.max(coverS, Sdemande);
    /* ⛔ L'AFFICHE SUIT LE RECUL REELLEMENT APPLIQUE, PAS CELUI QU'ON A DEMANDE. Si le fond
       est retenu au cover et que l'affiche continue de reculer, elle retrecit toute seule par
       rapport aux meubles : l'apercu ment sur la taille, dans le sens qui dessert le produit.
       C'est ce qui faisait paraitre un polyptyque de 141 cm aussi large qu'une 70 x 100. */
    var Zeff = S / (coverS * (curRoom.zoom || MOCK_ROOM_ZOOM));
    var bgH = S * cW / curRoom.ar;
    // r = hauteur réelle du fond / hauteur de la scène. NE PAS supposer r == ramp : la
    // scène n'est pas toujours au ratio portrait (écrans larges → scène plus large →
    // r plus grand), sinon le canapé tombe hors cadre. On calcule r pour de vrai.
    var r = bgH / cH;
    var sofaNatural = curRoom.iy * r;
    // Si le meuble descendrait sous la cible, on fait descendre le point de vue pour
    // l'y maintenir (background-position-y), donc il reste toujours visible.
    var by = 0, sofaV = sofaNatural;
    if (sofaNatural > curRoom.target && r > 1) {
      by = (curRoom.target - curRoom.iy * r) / (1 - r);
      by = Math.max(0, Math.min(1, by));
      sofaV = curRoom.target;
    }
    mk.style.backgroundSize = (S * 100).toFixed(2) + "%";
    /* ⛔ LE MUR EST LAMBRISSE, ET L'AFFICHE DOIT TOMBER AU MILIEU D'UN PANNEAU (Adrien).
       Releve sur l'image : les deux joints verticaux marques sont a 0,4179 et 0,6009 de la
       largeur, donc le panneau central a son milieu a 0,5094 et NON a 0,50. En centrant le fond
       a 50 %, l'affiche se posait a un centieme de largeur du milieu du panneau : assez pour que
       les deux traits ne soient pas a la meme distance de ses bords, et l'oeil lit ce
       desequilibre comme une affiche posee de travers, meme quand elle est parfaitement droite.
       ⛔ LE POURCENTAGE DEPEND DU ZOOM, il ne peut pas etre ecrit en dur. `background-position`
       n'aligne pas un point de l'image sur un point de la boite : il repartit le DEBORDEMENT.
       Le point de l'image qui tombe au centre de la boite vaut P(1 - 1/S) + 1/(2S) ; on inverse
       pour obtenir le P qui y amene `cx`. A S = 1 il n'y a aucun debordement, donc rien a
       decaler et la formule n'a pas de solution : on retombe sur 50 %. */
    var cx = (curRoom.cx != null) ? curRoom.cx : 0.5;
    var px = 0.5;
    if (S > 1.0001) px = (cx - 0.5 / S) / (1 - 1 / S);
    px = Math.max(0, Math.min(1, px));
    mk.style.backgroundPosition = (px * 100).toFixed(2) + "% " + (by * 100).toFixed(2) + "%";
    // Le padding % se résout sur le CONTENEUR, pas sur l'affiche : on le recalcule
    // selon la largeur réelle de l'affiche pour garder un passe-partout fin.
    // Taille lisible dans la pièce. Pas de minimum caché : chaque format a son réglage.
    /* Le même Z que le décor : l'affiche avance avec la pièce, elle ne grossit pas toute
       seule. Sans lui, zoomer le fond ferait au contraire RAPETISSER l'affiche par rapport
       aux meubles : sa largeur est un pourcentage de la scène, pas du décor. */
    var orientK = (window.__pdpPerso && persoOrientation === "paysage") ? (1 / persoRatioPortrait()) : 1;
    var mw = (MOCK_W[v] || MOCK_W[SIZE_REF]) * (curRoom.scale || 1) * Zeff * orientK;
    mkp.style.width = mw + "%";
    poseCarton(mkp, v, mw);
    if (window.AfSurMesure && window.AfSurMesure.format()) {
      var artLibre = document.getElementById('pdp-mockup-art');
      if (artLibre) artLibre.style.backgroundPosition = window.AfSurMesure.position();
    }
    // Reflow synchrone : un poster absolu dans un fond zoomé n'est pas relayouté quand
    // sa largeur change ; le toggle force le calcul sans flash. offsetHeight lu ensuite.
    mkp.style.display = "none"; void mkp.offsetHeight; mkp.style.display = "";
    var ph = mkp.offsetHeight;
    // Accrochage selon le format : les petits formats étaient trop hauts (centre du mur),
    // les grands trop bas (clampés juste au-dessus du canapé). On baisse l'ancre pour
    // 21×30 / 30×40 et on remonte 70×100 (plus d'air au-dessus du meuble + ancre haute).
    var wMin = MOCK_W["21X30"], wMax = MOCK_W[SIZE_REF];
    var wCur = MOCK_W[v] || wMax;
    var sizeT = (wMax > wMin) ? Math.max(0, Math.min(1, (wCur - wMin) / (wMax - wMin))) : 1;
    var mobile = cW < 520;
    var clrBase = (curRoom.clr != null) ? curRoom.clr : (mobile ? 0.11 : 0.04);
    // Grands formats : plus de dégagement au-dessus du canapé → l'affiche remonte.
    var clr = clrBase + sizeT * (mobile ? 0.055 : 0.035);
    /* ⛔ UN POLYPTYQUE PREND LE MUR ENTIER, ET SANS CE CAS IL FAISAIT LA TAILLE D'UNE 70 x 100.
       Mesuré à l'écran le 06/08/2026 sur le salon : les trois formats sortaient à 27,8 % de la
       scène, exactement la même image, parce que le mur libre est le facteur limitant et qu'ils
       ont tous le même rapport hauteur/largeur. Un mur de 141 cm montré à la taille d'une
       affiche de 70 cm, c'est la mise en situation qui dit l'inverse du produit.
       La marge HAUTE tombe à un tiers : c'est du mur nu, personne ne le regarde.
       ⛔ LE DÉGAGEMENT AU-DESSUS DU MEUBLE, LUI, RESTE ENTIER. Je l'avais ramené à sa base pour
       gagner encore un peu de mur, et Adrien l'a vu tout de suite (06/08/2026, « le polyptyque
       est placé un peu trop bas ») : le bas des panneaux arrivait à 3,5 % du canapé, donc
       visuellement posé dessus. Cet air-là n'est pas du gâchis, c'est ce qui fait qu'un cadre
       est accroché et non appuyé.
       ⚠️ CE N'EST PAS L'ÉCHELLE VRAIE ET ÇA NE PEUT PAS L'ÊTRE : le polyptyque ressort environ
       1,3 fois plus large que la 70 x 100 là où la vérité est 2,0. Ce salon n'a pas assez de mur
       au-dessus du canapé pour 141 cm ; le montrer juste demande une photo de pièce plus large.
       Aucun des six formats simples ne passe ici. */
    var geant = (MOCK_W[v] || 0) > MOCK_W[SIZE_REF];
    var hautMur = curRoom.top * (geant ? 0.35 : 1);
    // Leave space for the room control, including on narrow screens and large formats.
    var choixPiece = $(".pdp-room-choice");
    if (choixPiece && !choixPiece.hidden && choixPiece.offsetHeight > 0) {
      hautMur = Math.max(hautMur, (choixPiece.offsetTop + choixPiece.offsetHeight + 12) / cH);
    }
    var wallBottom = sofaV - clr;                    // limite basse "mur libre"
    var band = (wallBottom - hautMur) * cH;          // hauteur de mur libre au-dessus du meuble
    /* L'affiche doit tenir ENTIÈREMENT dans le mur libre (marge en haut + au-dessus du
       meuble). Mais réduire CHAQUE format jusqu'à cette hauteur les rendait tous
       identiques dès qu'ils dépassaient : 50×70 et 70×100 finissaient tous deux à 26,3 %
       de large, soit exactement la même affiche à l'écran, alors que la mise en situation
       n'existe que pour montrer l'écart de taille.

       On calcule donc UN facteur, celui qui fait rentrer le PLUS GRAND format, et on
       l'applique à tous. Le mur reste respecté et les rapports entre formats sont
       conservés : 50×70 occupe bien 5/7 de la largeur de 70×100.

       Le rapport hauteur/largeur de l'affiche ne dépend pas du format (c'est celui de
       l'œuvre), donc `k` mesuré ici vaut pour tous et une seule mesure suffit. */
    var k = ph / parseFloat(mkp.style.width);        // px de hauteur par % de largeur
    /* ⛔ LA REFERENCE EST LE PLUS GRAND DES DEUX, SINON LE POLYPTYQUE SORT DU MUR. Le
       raisonnement ci-dessus supposait que tous les formats tiennent dans le format de
       reference ; le polyptyque, lui, est DEUX FOIS plus large qu'une 70 x 100. Garder
       `MOCK_W[SIZE_REF]` comme reference lui appliquait le facteur de la 70 x 100 : rapports
       exacts, mais 2,1 fois la hauteur du mur libre, donc une moitie derriere le canape et
       l'autre hors cadre en haut.
       Pour les six formats simples cette ligne ne change rien (le maximum EST la reference),
       donc aucune fiche du catalogue ne bouge. */
    var wRef = Math.max(MOCK_W[SIZE_REF], MOCK_W[v] || 0);
    var phRef = k * (wRef * (curRoom.scale || 1) * Zeff);
    if (phRef > band && band > 0) {
      var mw2 = parseFloat(mkp.style.width) * (band / phRef);
      mkp.style.width = mw2 + "%";
      poseCarton(mkp, v, mw2);
      mkp.style.display = "none"; void mkp.offsetHeight; mkp.style.display = "";
      ph = mkp.offsetHeight;
    }
    /* ⛔ L'AFFICHE RESTE AU MILIEU DE LA SCENE, TOUJOURS. J'avais ajoute ici un `ax` qui la
       poussait de cote pour degager les couverts de la cuisine ; Adrien l'a refuse du premier
       coup d'oeil (06/08/2026 : « tu as decale l'affiche au lieu de decaler le background, il
       faut que l'affiche reste centree »). Et il a raison au-dela du gout : une affiche posee
       hors du milieu du cadrage se lit comme une affiche MAL ACCROCHEE, pas comme un cadrage
       choisi. Le decor est ce qu'on deplace, parce que personne ne sait ou commence la photo.
       Quand le mur libre n'est pas au milieu de la piece, la reponse est `cx` (on decale le
       fond), et si `cx` ne suffit pas, c'est que la PHOTO est trop etroite : il en faut une
       plus large. C'est exactement ce qui a ete fait pour la cuisine. */
    mkp.style.left = "50%";
    var anchorBase = curRoom.anchor != null ? curRoom.anchor : 0.48;
    // sizeT=0 (21×30) → ancre basse ; sizeT=1 (70×100) → ancre haute.
    var anchorSpan = mobile ? 0.40 : 0.28;
    var anchor = anchorBase + (0.5 - sizeT) * anchorSpan;
    anchor = Math.max(0.28, Math.min(0.82, anchor));
    /* La même marge haute que celle du mur libre : sinon un polyptyque calculé sur 39 % de mur
       se ferait recaler à la marge des formats simples, et le gain repartirait aussitôt. */
    var centerY = (hautMur + (wallBottom - hautMur) * anchor) * cH;
    var top = centerY - ph / 2;
    var minTop = hautMur * cH;
    var maxTop = wallBottom * cH - ph;
    if (maxTop < minTop) maxTop = minTop;
    top = Math.max(minTop, Math.min(maxTop, top));
    mkp.style.top = top + "px";
  }
  /* ⚠️ NE JUGE PAS LA POSE DE L'AFFICHE SUR `getBoundingClientRect`, LIS LE STYLE POSE.
     J'ai cru le 06/08/2026 que le polyptyque se posait 41 px trop bas en cuisine, donc sur le
     tajine : le rectangle mesure donnait un haut a 54,5 px quand `style.top` disait 13,468.
     C'etait vrai, et sans defaut : `#pdp-mockup-poster` porte une transition de 400 ms sur
     `top`, et une transition n'avance QUE si la page est peinte. Dans un onglet qui ne rend
     pas, elle se fige a sa valeur de depart, indefiniment. Le rectangle montrait donc le debut
     d'une animation, pas une position.
     ⛔ J'AI CORRIGE UN DEFAUT QUI N'EXISTAIT PAS avant de m'en apercevoir : un ResizeObserver
     rappelait `positionMockup` quand la boite changeait de hauteur. Retire, faute de defaut a
     couvrir. Si un jour la boite change VRAIMENT de hauteur apres le calcul, la preuve sera un
     `style.top` faux, pas un rectangle en retard. */
  /* ⛔⛔⛔ LA SCENE TIENT SA HAUTEUR DE L'ECRAN, ET RIEN NE LUI DISAIT LA LARGEUR QU'IL RESTE
     (Jonathan, 30/08/2026 : « sur le responsive tu vois l'image depasse sur la partie de droite de la
     product page »). `#pdp-stage` prend `height: clamp(480px, 100vh - 130px, 865px)` et deduit sa
     largeur d'un `aspect-ratio` : sur un ecran HAUT ET ETROIT — 993 x 895, une fenetre de portable a
     cote d'une autre — cela demandait 491 px de large pour une colonne qui n'en offrait que 354.
     L'affiche passait alors par-dessus le titre et le prix.
     ⚠️ ET AUCUN `max-width` NE POUVAIT LE RATTRAPER, c'est ce qui rendait le defaut tenace : une boite
     qui tient sa hauteur d'un cote et son rapport de l'autre a une largeur INTRINSEQUE, que
     `min-width:auto` empeche une colonne de grille de comprimer. `max-width:100%` — deja present —
     ecraserait la largeur sans toucher la hauteur, donc deformerait l'affiche au lieu de la reduire.
     C'est la HAUTEUR qu'il faut borner, et elle seule.
     ⚠️ ON MESURE LE PARENT, JAMAIS LA GALERIE : `.pdp-gallery` est en `width:fit-content`, donc sa
     largeur DEPEND de son contenu. La mesurer pour borner ce meme contenu ferait une boucle qui
     rapetisse l'affiche a chaque passage — le parent, lui, ne bouge pas.
     ⚠️ ET LE RAPPORT SE RELIT A CHAQUE FOIS, il ne se devine pas : il vaut 1054/1492 sur une affiche,
     le rapport de l'oeuvre en metal, celui de la photo sur une fiche cadre, et `auto` en paysage — ou
     la hauteur est deja libre et ou il n'y a donc rien a borner. */
  function bornerLaScene() {
    var st = $("#pdp-stage"), gal = $(".pdp-gallery");
    if (!st || !gal || !gal.parentElement) return;
    var style = getComputedStyle(st);
    // La vue encadrée garde sa borne de largeur lorsque sa hauteur suit le contenu.
    var ar = style.getPropertyValue("--pdp-sizing-ratio") || style.aspectRatio || "";
    var n = /^([\d.]+)\s*\/\s*([\d.]+)$/.exec(ar.trim());
    var rap = n ? parseFloat(n[1]) / parseFloat(n[2]) : parseFloat(ar);
    if (!(rap > 0)) { st.style.removeProperty("--pdp-stage-max"); return; }
    var csg = getComputedStyle(gal), csp = getComputedStyle(gal.parentElement);
    /* ⛔⛔ ET LA PLACE EST CELLE DE LA COLONNE, PAS CELLE DU PARENT — mesure du 30/08/2026 a 993 px :
       la section fait 983 de large et sa colonne de galerie 444. Prendre le parent annonçait 709 px
       de place, donc une borne trois fois trop haute : le defaut restait entier et la mesure disait
       qu'il etait corrige, ce qui est pire que pas de correction.
       ⚠️ LA GALERIE ELLE-MEME NE PEUT PAS RENSEIGNER SA COLONNE : elle est en `width:fit-content` et
       DEBORDE des deux cotes — 0 a 500 la ou sa colonne va de 56 a 500. Une boite qui deborde ne
       connait plus la place qu'on lui laisse ; seule la grille la connait. */
    var place = gal.parentElement.clientWidth
      - (parseFloat(csp.paddingLeft) || 0) - (parseFloat(csp.paddingRight) || 0);
    var cols = csp.gridTemplateColumns;
    if (cols && cols !== "none") {
      var rang = Array.prototype.indexOf.call(gal.parentElement.children, gal);
      var larg = cols.split(" ").map(parseFloat);
      if (rang >= 0 && rang < larg.length && larg[rang] > 0) place = larg[rang];
    }
    /* ⛔⛔⛔ ET LA GALERIE A TOUJOURS EU LE DROIT DE MORDRE SUR LA GOUTTIERE — la borner a sa colonne
       PILE aurait retreci l'affiche partout. Mesure du 30/08/2026 : a 1800 px de large, l'affiche
       demande 611 px pour une colonne qui en offre 562, et personne ne s'en est jamais plaint parce que
       la galerie est CENTREE : ses 49 px de trop se partagent en deux, 24 de chaque cote, et se posent
       dans les 48 px de gouttiere qui separent les deux colonnes. Rien ne recouvre rien.
       ⚠️ LE DEFAUT N'EST DONC PAS DE DEBORDER, C'EST DE DEBORDER PLUS QUE LA GOUTTIERE : a 993 px il
       fallait 104 px de chaque cote, soit le double de ce qui existe, et le surplus tombait sur le titre
       et le prix. On accorde la gouttiere — pas davantage — ce qui laisse l'affiche exactement aussi
       grande qu'avant sur un ecran large et ne la reduit que la ou elle mordait sur le texte.
       ⚠️ UNE BORNE PLUS SEVERE AURAIT ETE INVISIBLE EN TEST ET VISIBLE EN VENTE : rien n'aurait
       « casse », l'affiche aurait juste ete 8 pour cent plus petite sur toutes les fiches. */
    place += (parseFloat(csp.columnGap) || 0);
    place -= (parseFloat(csg.paddingLeft) || 0) + (parseFloat(csg.paddingRight) || 0);
    /* La bande de vignettes prend sa colonne avant la scene : 84 px, ou 138 quand elle se replie. */
    var th = $("#pdp-thumbs");
    if (th && csg.display === "grid") {
      place -= th.offsetWidth + (parseFloat(csg.columnGap) || 0);
    }
    if (!(place > 80)) { st.style.removeProperty("--pdp-stage-max"); return; }
    st.style.setProperty("--pdp-stage-max", Math.round(place / rap) + "px");
  }
  /* ⛔⛔ DEUX PASSES, PARCE QUE LA BANDE DE VIGNETTES REPOND A LA PREMIERE. Mesure du 30/08/2026 a
     993 px : la bande occupait 84 px pendant le calcul et 140 apres, une fois la scene reduite — ses
     libelles se remettent alors sur une ligne. La premiere passe laissait donc la galerie 56 px plus
     large que sa colonne : le defaut principal etait corrige, un residu restait, et rien ne l'aurait
     signale. La seconde passe lit la bande dans son etat final.
     ⚠️ ET IL N'EN FAUT PAS UNE TROISIEME : la bande ne peut que S'ELARGIR quand la scene retrecit, donc
     la suite est monotone et s'arrete la. Une boucle a convergence libre, elle, pourrait osciller. */
  function bornerLaSceneDeuxFois() {
    bornerLaScene();
    requestAnimationFrame(bornerLaScene);
  }
  window.addEventListener("af:bordure", bornerLaSceneDeuxFois);
  document.addEventListener("DOMContentLoaded", bornerLaSceneDeuxFois);
  bornerLaSceneDeuxFois();

  var _mockRz;
  window.addEventListener("resize", function () {
    clearTimeout(_mockRz);
    _mockRz = setTimeout(function () {
      bornerLaSceneDeuxFois();
      positionMockup();
      refitPersoTextBands();
    }, 120);
  });
  function updateFormatScale() {
    var st = $("#pdp-stage"), wrap = $(".pdp-gallery__wrap");
    if (!st || !wrap) return;
    /* ⛔ RIEN DE TOUT CECI SUR LE PANNEAU (Adrien, 07/08/2026 : « c'est un produit a part qui
       ne se comporte pas comme les affiches »). Le clic de type presse une vignette de scene,
       setFrameVisible rebascule data-framed, et le garde-fou d'accessoire ne mordait plus :
       data-sized posait le rembourrage des cotes et l'echelle de format, et le panneau de
       bienvenue paraissait plus petit que les autres types. Le configurateur porte seul son
       rapport (ratioCourant) ; ni cotes, ni echelle d'affiche ici. */
    if (document.querySelector("[data-panneau]")) return;
    for (var i = 0; i < optCount; i++) {
      var v = selected[i], cm = A_CM[v], s = A_SCALE[v];
      if (!cm) continue;
      /* Conservé pour la mise en situation (positionMockup) : l'affiche du salon
         garde son échelle réelle. L'image 1 de la galerie, elle, ne s'en sert plus
         elle reste à taille fixe, seules les cotes ci-dessous changent. */
      st.style.setProperty("--fmt-scale", s);
      positionMockup(v);
      /* ⛔ A_CM EST ÉCRIT EN PORTRAIT, et la feuille tourne avec l'affiche. Sur une paysage,
         « 30X40 » se vend 40 de large et 30 de haut : les deux cotes étaient donc permutées,
         la ligne du dessus annonçant 30 cm au-dessus d'une image large de 40 (Adrien,
         05/08/2026, « Nu au canapé rouge »). Même retournement que les libellés de taille de
         la colonne d'achat, et il se lit à la même source : le sens porté par la galerie. */
      var estPaysage = !!(document.querySelector('.pdp-gallery[data-paysage="true"]'));
      if (window.__pdpPersoMetal) estPaysage = persoOrientation === "paysage";
      /* ⚠️ Un format DEJA couche ne se retourne pas : ses deux valeurs sont dans le bon ordre. */
      if (cm[0] > cm[1]) estPaysage = false;
      var large = estPaysage ? cm[1] : cm[0];
      var haute = estPaysage ? cm[0] : cm[1];
      var dw = $("#pdp-dim-w"), dh = $("#pdp-dim-h");
      if (dw) dw.textContent = cmLabel(large);
      if (dh) dh.textContent = cmLabel(haute);
      /* ⛔ LES COTES N'APPARAISSENT QUE SUR L'AFFICHE SEULE. Choisir un format depuis une
         autre vue de la galerie posait `data-sized` alors qu'on regardait une photo d'ambiance :
         la couche de l'affiche reprenait le dessus, et le client voyait la galerie « revenir »
         a l'image de depart sans avoir rien fait. Les vues suivantes sont des photos reelles,
         elles n'ont ni cadre ni cotes a montrer.
         Le format reste enregistre : `sizeEngaged` est vrai, et `setFrameVisible(true)` rappelle
         cette fonction des qu'on revient sur l'affiche. */
      if (wrap.getAttribute("data-framed") !== "false") wrap.setAttribute("data-sized", "true");
      return;
    }
  }
  /* ⛔ ET LA PIECE SE REFAIT QUAND LA BORDURE CHANGE. Choisir « sans bordure » ou changer de
     teinte pendant qu'on regarde le salon ne touchait a rien : le passe-partout gardait la
     largeur calculee au dernier changement de vue ou de format. `bordure-blanche.js` publie
     deja `af:bordure` ; on ne fait que reposer le carton. */
  window.addEventListener("af:bordure", function () { positionMockup(); });

  var sizeEngaged = false;
  function engageScale() {
    sizeEngaged = true;
    updateFormatScale();
    /* Le mockup change de largeur : sans refit, « MON BEAU SOUVENIR » reste à la
       taille du format précédent et se fait rogner (overflow:hidden). */
    refitPersoTextBands();
  }
  /* ⛔ DESELECTIONNER DOIT DEFAIRE TOUT CE QU'ENGAGER AVAIT FAIT, PAS SEULEMENT LES COTES.
     Le code d'avant ne retirait que `data-sized`. Releve a l'ecran le 06/08/2026 sur la vue
     salon : affiche a 155 x 221 sans format, 80 x 113 apres un clic sur 21 x 30, et TOUJOURS
     80 x 113 apres l'avoir declique. `--fmt-scale` restait a 0,55 et `positionMockup` n'etait
     jamais rappele avec la taille de reference, donc le client qui abandonnait son choix
     gardait sous les yeux la mise en situation du format abandonne.
     Trois choses a defaire, et l'oubli d'une seule suffit a laisser l'ecran mentir :
     l'echelle CSS, les cotes, et la pose dans la piece. `sizeEngaged` repasse a faux, sinon
     revenir sur l'affiche seule rappellerait `updateFormatScale` pour rien. */
  function disengageScale() {
    sizeEngaged = false;
    var st = $("#pdp-stage"), w = $(".pdp-gallery__wrap");
    if (st) st.style.removeProperty("--fmt-scale");
    if (w) w.removeAttribute("data-sized");
    positionMockup(SIZE_REF);
    refitPersoTextBands();
  }
  /* ⛔ L'APERCU DU POLYPTYQUE REMPLACE L'IMAGE DE LA FICHE QUAND LA TAILLE EST CHOISIE.
     Sans lui, choisir « Polyptyque 2x2 · 50x70 » laisserait l'affiche SEULE a l'ecran : le
     client paie quatre tirages et voit une affiche, ce qui est la meilleure facon de faire
     un retour. Les deux apercus sont deja dans la page, dessines sur la meme image, et on
     ne fait que montrer celui de la taille choisie. */
  /* ⛔ LES DEUX JEUX DE COTES, AVEC ET SANS CADRE, CALCULES PAR polyptyque.plan().
     L'ecart entre deux panneaux EST le cadre : deux baguettes de 18 mm plus 5 mm de mur, soit
     41 mm. Sans cadre il n'y a pas de baguette, donc 5 mm. Ce n'est pas un decor : le
     DECOUPAGE change aussi, puisque c'est cette bande que l'oeuvre perd, et les cotes au mur
     changent avec (108 x 148 encadre, 100 x 140 nu affiche).
     Adrien l'a signale trois fois avant que je l'entende : je traitais 41 mm comme une
     fatalite alors que c'est un parametre.
     Regenerer :
       node -e "const P=require('./catalogue/polyptyque');
                const S={feuillure:0,baguette:0,ecart:5,fondPerdu:3};
                console.log(P.plan({format:'50X70',n:2,m:2,cotes:S}))" */
  var POLY_COTES = {
    "50x70": {
      avec:  { ratio:'0.7292', cw:'49.768%', ch:'49.831%', px:'50.232%', py:'50.169%',
               bx:'3.358%', by:'2.446%', bsw:'209.400%', bsh:'216.048%',
               x0:'0.548%', x1:'99.452%', y0:'4.391%', y1:'95.609%', cm:[108,148], ech:0.729 },
      sans:  { ratio:'0.7153', cw:'49.751%', ch:'49.822%', px:'50.249%', py:'50.178%',
               bx:'0%', by:'0%', bsw:'202.200%', bsh:'208.619%',
               x0:'0.587%', x1:'99.413%', y0:'3.639%', y1:'96.361%', cm:[100,140], ech:0.716 }
    },
    "70x100": {
      avec:  { ratio:'0.7111', cw:'49.831%', ch:'49.880%', px:'50.169%', py:'50.120%',
               bx:'2.446%', by:'1.737%', bsw:'206.714%', bsh:'209.011%',
               x0:'0.402%', x1:'99.598%', y0:'2.253%', y1:'97.747%', cm:[148,208], ech:1 },
      sans:  { ratio:'0.7007', cw:'49.822%', ch:'49.875%', px:'50.178%', py:'50.125%',
               bx:'0%', by:'0%', bsw:'201.571%', bsh:'203.811%',
               x0:'0.422%', x1:'99.578%', y0:'1.595%', y1:'98.405%', cm:[141,201], ech:1 }
    }
  };
  /* L'ordre des polyptyques, du plus petit au plus grand. Sert de reference d'echelle. */
  var POLY_ORDRE = ["50x70", "70x100"];
  /** La cle POLY_COTES d'un titre de variante, ou null. « Polyptyque 2x2 · 70x100 » -> 70x100 */
  /* ⛔ LES NOMBRES, PAS LE MOT. Ce test cherchait « polyptyque » : traduit en « Polyptiek »,
     « Polyptychon », « Πολύπτυχο »... il ne trouvait rien hors francais, et la taille RETIREE
     DE LA VENTE restait affichee sur douze marches. Cinquieme occurrence de la meme faute le
     10/08/2026. La structure « panneaux puis feuille » ne se traduit pas. */
  function polyCleDeTitre(v) {
    var g = String(v || '').match(/(\d)\s*[x×]\s*(\d)\D+(\d{2,3})\s*[x×]\s*(\d{2,3})/i);
    return g ? Math.min(+g[3], +g[4]) + 'x' + Math.max(+g[3], +g[4]) : null;
  }
  /* ⛔ LA LISTE DES TAILLES MASQUEES VIENT DU GABARIT, elle ne se redeclare pas ici.
     `main-product.liquid` la tient en tete de section et s'en sert pour ne PAS ecrire la
     pastille ; product.js la relit pour l'echelle des apercus. Deux listes auraient diverge au
     premier changement, et le symptome aurait ete un apercu calcule pour une taille que
     personne ne peut plus choisir. Vide par defaut : rien n'est masque tant que le gabarit ne
     le demande pas. */
  /* La liste arrive en SIGNATURE (« 2x2~70x100 ») et non plus en libelle francais : le gabarit
     et le script parlent donc la meme langue, celle des nombres. On n'en garde que la feuille,
     qui est la cle des cotes. */
  var POLY_MASQUES = (window.__pdpTaillesMasqueesSig || [])
    .map(function (s) {
      var f = String(s).split('~')[1];
      var g = f && f.match(/(\d{2,3})\s*[x×]\s*(\d{2,3})/i);
      return g ? Math.min(+g[1], +g[2]) + 'x' + Math.max(+g[1], +g[2]) : null;
    })
    .filter(function (k) { return !!k; });
  /* L'etat courant, lu par le dessin ET par les cotes affichees sur l'image. */
  var polyEtat = { fmt: null, cadre: false };
  function orienterPolyCotes(c, paysage) {
    if (!c || !paysage) return c;
    var tourne = Object.assign({}, c, { ratio: String(1 / Number(c.ratio)), cm: [c.cm[1], c.cm[0]] });
    [['cw','ch'],['px','py'],['bx','by'],['bsw','bsh'],['x0','y0'],['x1','y1']].forEach(function (paire) {
      tourne[paire[0]] = c[paire[1]];
      tourne[paire[1]] = c[paire[0]];
    });
    return tourne;
  }
  function polyCotes(format) {
    var f = POLY_COTES[format || polyEtat.fmt];
    return orienterPolyCotes(f ? f[polyEtat.cadre ? 'avec' : 'sans'] : null,
      !!document.querySelector('.pdp-gallery[data-paysage="true"]'));
  }

  /* Le choix du cadre change l'ECART, donc le dessin entier : applyFramePreview appelle ce
     rappel apres avoir pose ou retire `data-noframe`, sinon cocher une moulure laissait les
     panneaux a l'ecart d'avant. */
  window.__pdpPolyRedessine = function () {
    try {
      var fi = formatGroupInfo();
      paintPolyptyque(fi ? selected[fi.idx] : null);
      /* La cote ne depend plus du cadre depuis le 06/08/2026 (elle est celle du papier, comme
         pour tous les autres formats), mais l'appel reste utile : `updateFormatScale` repose
         aussi l'echelle de la mise en situation, et le passage en geometrie encadree change le
         dessin. Sans lui, la piece garderait l'echelle de l'etat precedent. */
      updateFormatScale();
    } catch (e) { /* jamais bloquer le cadre pour un apercu */ }
  };

  function paintPolyptyque(valeur) {
    var v = String(valeur || '');
    /* ⛔ SIXIEME ET DERNIERE LECTURE DU MOT « POLYPTYQUE », et la plus visible : c'est ELLE qui
       DESSINE les quatre panneaux. Traduit, le test etait faux et le polyptyque n'etait
       simplement pas dessine sur douze marches. On passe par `polyCleDeTitre`, qui lit les
       nombres et rend deja la cle de `POLY_COTES` (« 50x70 », plus petit cote en premier). */
    var fmt = polyCleDeTitre(v);
    /* ⛔ LE POLYPTYQUE NE SE DESSINE QUE SUR L'OEUVRE (Adrien, 12/08/2026 : « en mode
       polyptyque l'image affichee pour ces thumbnails est fausse »).
       Les quatre panneaux sont un CALQUE pose par-dessus `#pdp-main`, dont l'opacite tombe a 0.
       Rien ne prevenait ce calque qu'on venait de changer de vue : en cliquant Papier ou Detail,
       la vignette changeait bien le fond de `#pdp-main`, mais on continuait de voir l'affiche
       decoupee en quatre, avec le badge « PAPIER D'ART 220 G/M² » pose dessus. Le clic marchait,
       il ne se voyait pas. Quatrieme ecran entre le clic et l'oeil sur ces deux vignettes-la,
       apres le conteneur qui n'ecoutait plus, les rendus de demo et l'image d'exemple.
       ⚠️ Les apercus de la MISE EN SITUATION ne sont pas concernes : ils vivent dans
       `#pdp-mockup-art`, qui n'est visible qu'en vue piece, et c'est bien un polyptyque qu'il
       faut y montrer. Le garde ne porte donc que sur le calque du cadre. */
    var surLOeuvre = vueCouranteEstOeuvre();
    var poly = !!fmt;
    var main = $("#pdp-main");
    var dansCadre = !!document.querySelector('.pdp-frame__inner .poly-holder:not([hidden])');
    if (main) main.style.opacity = '';
    /* La mise en situation montre l'affiche par un fond : on l'efface aussi, sinon l'oeuvre
       entiere reste derriere les quatre panneaux. */
    var montres = 0;
    document.querySelectorAll('.poly-holder').forEach(function (el) {
      var dansLeCadre = !!el.closest('.pdp-frame__inner');
      var ok = poly && el.getAttribute('data-poly') === fmt && (!dansLeCadre || surLOeuvre);
      el.hidden = !ok;
      if (ok) montres += 1;
    });
    /* ⛔ N'EFFACER LE FOND QUE SI UN APERCU LE REMPLACE VRAIMENT. Le 06/08/2026 la mise en
       situation montrait un rectangle BLANC : le gabarit n'avait pas encore ete repris par la
       synchro, les porte-apercus n'existaient pas dans la page, et on avait quand meme efface
       l'affiche. Un ecran vide est pire qu'un ecran pas encore a jour. */
    /* ⛔ ON REMET LE FOND D'ORIGINE, ON NE LE VIDE PAS. `style.backgroundImage = ''` RETIRE la
       declaration inline, or c'est Liquid qui l'a posee dans l'attribut style de l'element :
       la remettre a vide effacait donc l'affiche POUR DE BON, et la mise en situation restait
       blanche meme sur une affiche seule, quel que soit le format (06/08/2026). On garde la
       valeur d'origine au premier passage et on la restitue. */
    var mart = $("#pdp-mockup-art");
    if (mart) {
      if (mart.dataset.fondOrigine === undefined) mart.dataset.fondOrigine = mart.style.backgroundImage || '';
      var dansMockup = !!document.querySelector('#pdp-mockup-art .poly-holder:not([hidden])');
      mart.style.backgroundImage = (poly && dansMockup) ? 'none' : mart.dataset.fondOrigine;
    }
    /* #pdp-main garde son fond : on ne joue que sur l'opacite, jamais sur background-image,
       qui vient lui aussi d'un style inline pose par Liquid. */
    if (main) main.style.opacity = (poly && document.querySelector('.pdp-frame__inner .poly-holder:not([hidden])')) ? '0' : '1';
    /* ⛔ LE CADRE UNIQUE DOIT DISPARAITRE. #pdp-frame porte une moulure en bordure CSS : sur un
       polyptyque elle encadrait les quatre panneaux ensemble, ce qui est le contraire du
       produit. Les quatre moulures sont dessinees par l'apercu lui-meme.
       Et la boite change de proportion : l'encombrement d'un 2x2 (0,7292) n'est pas celui
       d'une affiche (0,6923). Sans ca les panneaux seraient etires. */
    var wrap = document.querySelector('.pdp-gallery__wrap');
    /* `is-poly` porte aussi la mise en situation : c'est lui qui efface la feuille creme de
       #pdp-mockup-poster, qui n'a de sens que pour une affiche seule. */
    if (wrap) {
      wrap.classList.toggle('is-poly', poly);
      /* ⛔ LES DEUX POLYPTYQUES SE COMPARENT, DONC ILS PARTAGENT UNE ECHELLE.
         Chacun remplissait la boite : le 148 x 208 etait donc rendu plus petit que le
         108 x 148 en millimetres par pixel, et sa baguette de 18 mm occupait moins de pixels.
         D'ou « les baguettes paraissent plus larges en 108 x 148 » — c'etait vrai, et c'etait
         le symptome d'une echelle qui changeait d'une taille a l'autre.
         La boite prend donc la proportion du PLUS GRAND (0,7111) dans les deux cas, et le
         108 x 148 occupe 1077/1477 = 72,9 % de sa largeur. Meme millimetre par pixel : les
         baguettes font la meme epaisseur a l'ecran, et l'ecart de taille se VOIT enfin, comme
         il se voit deja entre un 21 x 30 et un 70 x 100. */
      if (poly) {
        polyEtat.fmt = fmt;
        polyEtat.cadre = !wrap.hasAttribute('data-noframe');
        var c = polyCotes();
        if (c) {
          /* ⛔ L'ECHELLE PARTAGEE N'A PLUS DE SECOND TERME. Elle existait pour comparer les deux
             polyptyques dans la MEME boite : le 108 x 148 sortait a 0,729 de la largeur, le
             148 x 208 a 1, donc meme millimetre par pixel et memes baguettes a l'ecran.
             Le 148 x 208 est masque depuis le 06/08/2026 (voir POLY_MASQUES) : il ne reste
             qu'un seul format, la comparaison n'a plus d'objet, et garder 0,729 laissait
             l'apercu flotter au milieu d'un quart de boite vide. La boite prend donc la
             proportion du format AFFICHE, et l'apercu la remplit.
             Reste juste si l'on reaffiche le 148 : la reference redevient le plus grand des
             deux formats non masques.

             ⛔ ET « NON MASQUE » NE SUFFIT PAS : IL FAUT « VENDU » (Adrien, 16/08/2026,
             « l'image d'apercu avec les cotes est beaucoup trop petite »). POLY_MASQUES se
             deduit de `tailles_masquees_sig`, qui ne nomme une taille QUE SI LA FICHE LA PORTE
             ENCORE : c'est une liste de « presente mais a cacher ». Le 16/08 au matin la
             variante « Polyptyque 2x2 · 70x100 » a ete retiree des fiches (serie 353) ; la
             signature est donc devenue VIDE, plus rien n'etait masque, `cleRef` est repasse sur
             le 70x100 et l'apercu du 100 x 140 s'est mis a sortir a 0,716 de sa boite, soit un
             tiers de surface en moins que les autres apercus a cotes. Mesure : porteur
             480 x 671, apercu 343,7 x 480,5, MEME ratio des deux cotes.
             Retirer une variante est devenu la seule facon de faire mentir ce calcul : on ne
             lit donc plus une liste de refus, on lit ce que la fiche VEND. Une taille absente
             du selecteur n'est pas une reference, qu'elle soit masquee ou simplement partie. */
          var offerts = [];
          document.querySelectorAll('.opt-pill[data-value]').forEach(function (b) {
            var k = polyCleDeTitre(b.getAttribute('data-value'));
            if (k && offerts.indexOf(k) < 0) offerts.push(k);
          });
          var visibles = POLY_ORDRE.filter(function (k) {
            return POLY_MASQUES.indexOf(k) < 0 && (!offerts.length || offerts.indexOf(k) >= 0);
          });
          var cleRef = visibles.length ? visibles[visibles.length - 1] : polyEtat.fmt;
          var ref = polyCotes(cleRef) || c;
          var echelle = c.ech;
          if (Number(c.ratio) > 1) echelle *= Number(c.ratio) / Number(ref.ratio);
          wrap.style.setProperty('--art-ratio', ref.ratio);
          wrap.style.setProperty('--p-ech', String(cleRef === polyEtat.fmt ? 1 : echelle));
          ['ratio','cw','ch','px','py','bx','by','bsw','bsh','x0','x1','y0','y1'].forEach(function (k) {
            wrap.style.setProperty('--p-' + k, c[k]);
          });
        }
      } else {
        polyEtat.fmt = null;
        if (wrap.getAttribute("data-cote-libre") !== "true") wrap.style.removeProperty('--art-ratio');
        ['ech','ratio','cw','ch','px','py','bx','by','bsw','bsh','x0','x1','y0','y1'].forEach(function (k) {
          wrap.style.removeProperty('--p-' + k);
        });
      }
    }
  }

  // Affiche prix soldé (rouge) + prix normal barré quand la variante a un compare_at.
  function paintSaleBadge(onSale) {
    var badge = $("#pdp-sale-badge");
    if (!badge) return;
    badge.hidden = !onSale;
  }
  function paintPrice(pe, cmp, price, cap) {
    var onSale = cap > price;
    if (PRO_HT) {
      /* Ni prix barre ni badge : le parcours pro ignore les promos du grand public. */
      ecrirePrix(pe, plein(price, cap));
      if (pe) pe.classList.remove("is-sale");
      if (cmp) cmp.hidden = true;
      paintSaleBadge(false);
      return;
    }
    if (pe) { pe.textContent = money(price); pe.classList.toggle("is-sale", onSale); }
    if (cmp) { if (onSale) { cmp.textContent = money(cap); cmp.hidden = false; } else cmp.hidden = true; }
    paintSaleBadge(onSale);
  }
  /* ⛔ EXPOSE POUR QUE LE CHOIX DE SUPPORT PUISSE REFAIRE LE PRIX. `displate.js` masque des
     cotes ; sans ce rappel, la fiche garderait le prix « dès » de l'autre support jusqu'au
     prochain clic. Un seul nom, une seule fonction : on n'en ecrit pas une seconde. */
  var persoDernierRatio = null;
  function updatePrice() {
    if (window.__pdpPersoMetal) {
      var ratioMetal = persoRatioFeuille();
      var ratioChange = persoDernierRatio !== null && persoDernierRatio !== ratioMetal;
      persoDernierRatio = ratioMetal;
      if (ratioChange) setPersoOrientation(persoOrientation, true);
    }
    var quantityLess = document.getElementById('pdp-dec');
    if (quantityLess) quantityLess.disabled = qty <= 1;
    var breakdown = document.querySelector('.pdp-config-price-breakdown');
    if (breakdown) breakdown.hidden = true;
    if (window.__pdpPerso && window.__persoFunnel && formatChosen()) window.__persoFunnel("format");
    /* La taille est l'option 1 sur une affiche : c'est elle qui porte le polyptyque. */
    /* La taille porte le polyptyque : c'est le groupe de format, `selected` par son index. */
    try {
      var fi = formatGroupInfo();
      paintPolyptyque(fi ? selected[fi.idx] : null);
    } catch (e) { /* jamais bloquer le prix pour un apercu */ }
    var pe = $("#pdp-price"), cmp = $("#pdp-compare"), add = $("#pdp-add"), sp = $("#pdp-sticky-price");
    /* Les blocs d'apres (portes de creation, cadre, crochet) attendent le choix du format. */
    document.querySelectorAll("[data-apres-format]").forEach(function (el) { el.hidden = !(formatChosen() || (window.AfSurMesure && window.AfSurMesure.format())); });
    if (window.AfSurMesure && window.AfSurMesure.format()) {
      window.AfSurMesure.rafraichirPrix();
      return;
    }
    // Aucun format choisi → « dès {prix mini} » et invitation à choisir.
    if (!formatChosen()) {
      var mv = cheapestVariant(), mp = mv ? mv.price : 0, mc = mv && mv.compare_at_price ? mv.compare_at_price : 0;
      var prefixe = T.price_from || "dès";
      var mini = PRO_HT ? plein(mp, mc) : mp;
      ecrirePrix(pe, mini, prefixe);
      if (pe) pe.classList.toggle("is-sale", !PRO_HT && mc > mp);
      if (cmp) { if (!PRO_HT && mc > mp) { cmp.textContent = money(mc); cmp.hidden = false; } else cmp.hidden = true; }
      paintSaleBadge(!PRO_HT && mc > mp);
      /* ⛔⛔ ET AVANT LA TAILLE, IL Y A LA PHOTO. Ce libelle est ecrit ICI, a chaque changement de
         variante, et il repassait donc APRES celui que `syncPersoCta` venait de poser : le bouton
         redisait « Choisissez une taille » sur une fiche ou rien n'etait encore importe (mesure
         du 23/08/2026 en vue large, sur les deux fiches).
         Un seul endroit ecrit ce mot, c'est celui-ci : la condition y vit aussi. Sans photo, le
         geste qui reste n'est pas de choisir une taille. */
      if (add) {
        var motsAtelier = document.getElementById("perso-atelier-mots");
        /* ⛔ LE COLLAGE PARLE DE CASES, L'AFFICHE D'UNE PHOTO (Adrien, 23/08/2026 : « le CTA doit
           etre "CLIQUEZ SUR UNE CASE POUR IMPORTER" » sur le pele-mele, la ou il avait ecrit
           « UNE PHOTO » sur l'affiche personnalisee la veille). Deux produits, deux gestes : sur
           le collage on vise UNE case parmi six, sur l'affiche il n'y a qu'un emplacement. Un
           seul mot pour les deux enverrait la moitie des clients chercher la mauvaise cible. */
        var estCollage = !!document.querySelector(".pdp--pelemele");
        var motPhotoDabord = motsAtelier
          && motsAtelier.getAttribute(estCollage ? "data-case-dabord" : "data-photo-dabord");
        var manquePhoto = !!window.__pdpPerso && !window.__pdpPanneau
          && !document.querySelector(".pdp--perso-has-photo");
        add.textContent = (manquePhoto && motPhotoDabord)
          ? motPhotoDabord
          : (T.choose_format || "Choisir un format");
      }
      if (window.__pdpPanneauMajCta) window.__pdpPanneauMajCta();
      ecrirePrix(sp, mini, prefixe);
      return;
    }
    var v = currentVariant();
    var price = v ? v.price : (variants[0] && variants[0].price) || 0;
    var cap = v && v.compare_at_price ? v.compare_at_price : 0;
    /* Le prix affiche ce que coute l'ensemble compose sur cette page : l'affiche PLUS
       les accessoires coches. Je les avais retires en rendant les cases actives sur le
       panier, de peur de les compter deux fois ; l'effet a ete l'inverse : cocher un
       cadre a 59 € ne changeait plus rien a l'ecran.
       Il n'y a pas de double compte : le bouton annonce l'etat du panier APRES le clic,
       et le cadre y est deja. Le prix barre suit le meme supplement, sinon l'ecart
       affiche entre les deux montants ne correspondrait plus a la remise reelle. */
    var up = window.__pdpUpsell;
    var extra = (up && up.extraTotal) ? up.extraTotal(qty) : 0;
    paintPrice(pe, cmp, price * qty + extra, cap ? cap * qty + extra : 0);
    var total = price * qty + extra;
    if (window.__pdpPurchase) {
      var purchaseTotals = window.__pdpPurchase.totals(v, qty);
      if (purchaseTotals) {
        total = purchaseTotals.price;
        cap = purchaseTotals.compare > total ? purchaseTotals.compare / qty : 0;
        price = total / qty;
        extra = 0;
        paintPrice(pe, cmp, total, cap * qty);
      }
    }
    if (!PRO_HT && !window.__pdpPurchase && up && up.extraLines && document.querySelector('.pdp-configurator')) {
      var configLabels = JSON.parse(document.getElementById('pdp-config-labels').textContent);
      var parts = up.extraLines(configLabels);
      if (parts.length) {
        if (!breakdown) {
          breakdown = document.createElement('p');
          breakdown.className = 'pdp-config-price-breakdown';
          document.querySelector('.pdp-configurator .pdp-buy-actions').after(breakdown);
        }
        breakdown.textContent = configLabels.posterOnly + ' ' + money(price * qty) + ' + ' + parts.join(' + ');
        breakdown.hidden = false;
      }
    }
    if (add) {
      /* Sur telephone perso le prix reste dans #pdp-price, juste au-dessus : avec lui le
         bouton ne tient jamais en une ligne et iOS compressait la rangee quantite / CTA /
         download, pastille quantite etiree en cercle (02/08/2026). */
      var etroit = window.__pdpPerso && window.matchMedia("(max-width:560px)").matches;
      /* ⛔ LE BOUTON PORTE AUSSI L'ANCIEN PRIX (Adrien, 06/08/2026). C'est le dernier montant que
         le client lit avant de cliquer, et c'etait le seul de la page a ne pas dire ce qu'il
         economise : la ligne de prix le disait, le badge le disait, le bouton non.
         ⚠️ `textContent` NE PEUT PAS PORTER UNE BARRE : il ecrit du texte brut, et c'est pour ca
         que le montant y etait seul. On passe donc a des noeuds, et seulement quand il y a
         vraiment un ecart : le reste du temps le bouton garde exactement le texte d'avant, sans
         balise inutile.
         ⛔ L'ancien prix suit le meme supplement d'accessoires que le prix paye, sinon l'ecart
         affiche entre les deux ne serait plus la remise reelle. */
      var totalAvant = cap ? cap * qty + extra : 0;
      var libelle = T.add_to_cart || "Ajouter au panier";
      if (etroit) {
        add.textContent = libelle;
      } else if (PRO_HT) {
        /* Le bouton porte l'ancien prix pour dire l'economie de la promo. Dans le parcours pro
           il n'y a pas de promo a dire : un seul montant, hors taxes. */
        ecrirePrix(add, plein(total, totalAvant), libelle + " ·");
      } else if (totalAvant > total && !add.closest('.pdp-buy--catalogue')) {
        add.textContent = "";
        add.appendChild(document.createTextNode(libelle + " · "));
        var barre = document.createElement("s");
        barre.className = "pdp-add__was";
        barre.textContent = money(totalAvant);
        add.appendChild(barre);
        add.appendChild(document.createTextNode(" " + money(total)));
      } else {
        add.textContent = libelle + " · " + money(total);
      }
      if (window.__pdpPanneauMajCta) window.__pdpPanneauMajCta();
    }
    if (sp) {
      ecrirePrix(sp, PRO_HT ? plein(total, totalAvant) : total);
      sp.classList.toggle("is-sale", !PRO_HT && cap > price);
    }

    /* ⛔⛔ LE TABLEAU DEGRESSIF SE REPEINT ICI, DANS L'ENTONNOIR, ET NON CHEZ SES APPELANTS
       (Adrien, 29/08/2026 : « la colonne prix HT est vide, n'est pas dynamique selon l'option
       choisie »). Le repeint vivait dans `__pdpMajPrix`, un point d'entree EXTERNE : `updatePrice`
       est appele depuis DIX endroits du fichier — chaque cote, chaque support, chaque quantite —
       et un seul d'entre eux passait par la. Le tableau etait donc peint une fois, au chargement,
       quand aucune taille n'est choisie et que le prix unitaire vaut zero : trois tirets, pour
       toujours. Mesure du 29/08 : apres avoir clique « Classique », `__pdpPrixUnitaire()` rendait
       bien 1690 et la colonne affichait encore « — ».
       ⚠️ APRES LE CALCUL DU PRIX, jamais avant : le tableau lit la variante courante. */
    try { peindreDegressif(); } catch (e) { /* jamais bloquer le prix pour un tableau */ }
  }

  /* ⛔ LA SCENE PREND LE FORMAT DE LA PHOTO, ET C'EST LA SEULE FACON DE NE PAS AVOIR DE BANDES.
     Sur un accessoire la scene montre une PHOTO, pas une affiche : elle n'a donc pas de rapport
     a elle, elle prend celui de ce qu'elle montre. Une boite fixe en 3/4 avec un fond en
     `contain` marchait pour les huit photos verticales et posait deux grosses bandes beiges au
     premier plan large, `cadre-chene-2` en 1100 x 825 (Adrien : « il y a des bordures en haut et
     en bas des images sur fiche cadre »). Recadrer en `cover` aurait coupe un angle de moulure,
     c'est-a-dire ce qu'on vient regarder.
     ⚠️ On lit la taille NATURELLE de l'image, pas celle du fichier annonce : le rendu et les
     photos n'ont ni le meme rapport ni la meme source, et seul le navigateur sait ce qu'il a
     vraiment charge. Tant qu'elle n'est pas connue, la scene garde son rapport precedent : mieux
     vaut un rapport qui se corrige en un instant qu'un saut vers une valeur par defaut. */
  function sceneAuFormatDeLaPhoto(url) {
    var w = $(".pdp-gallery__wrap");
    if (!w || w.getAttribute("data-framed") !== "false" || !url) return;
    var im = new Image();
    im.onload = function () {
      if (!im.naturalWidth || !im.naturalHeight) return;
      /* ⛔ EN VUE PANNEAU, LE RAPPORT APPARTIENT AU CONFIGURATEUR. panneau-mariage.js pose
         sur ce meme wrap le rapport de la TAILLE choisie (5/7, 50/35...), mais ce onload
         arrive toujours APRES lui : la photo de la scene repassait le stage en carre a
         chaque chargement, et le panneau restait carre quel que soit le type (07/08/2026).
         La scene n'a le droit d'imposer sa photo que quand elle est a l'ecran. */
      var zonePanneau = document.querySelector("[data-panneau]");
      if (zonePanneau && !window.__panneauVueScene) return;
      w.style.setProperty("--acc-ar", im.naturalWidth + " / " + im.naturalHeight);
      /* ⛔⛔ ET ON REBORNE, PARCE QUE LE RAPPORT VIENT DE CHANGER (Adrien, 01/09/2026 : « bug
         chene clair image 2 » sur la fiche cadre).
         `bornerLaScene` calcule `--pdp-stage-max` A PARTIR du rapport de la scene. Il tournait au
         chargement, au redimensionnement et sur `af:bordure` — jamais quand une VIGNETTE change la
         photo. La borne restait donc celle du rapport precedent.
         Mesure sur /products/cadre-pour-affiche : les huit photos du cadre sont en PORTRAIT
         (825x1100) sauf `cadre-chene-2`, la seule en PAYSAGE (1100x825). En passant de 0,75 a
         1,333, la scene gardait `--pdp-stage-max: 813px`, se dessinait en 784x588 et sortait
         jusqu'a 967 px pour une galerie qui s'arrete a 825 : elle recouvrait le prix, la taille
         « Petit » et la pastille « Blanc ». Avec la relance : 457px, scene 609x457, plus rien qui
         deborde.
         ⚠️ DEUX PASSES, comme partout ailleurs : la bande de vignettes s'elargit en reponse a la
         premiere, et la seconde la lit dans son etat final. */
      bornerLaSceneDeuxFois();
    };
    im.src = url;
  }
  /* ⛔ LA GALERIE DU CADRE SUIT LA TEINTE CHOISIE (Adrien, 06/08/2026). Sans couleur choisie
     elle montre UNE photo par teinte : trois vignettes, une par moulure, c'est-a-dire l'offre
     entiere d'un coup d'oeil. Des qu'une couleur est cliquee, elle montre toute la serie de
     cette moulure-la et rien d'autre : a ce moment le client a choisi, il veut voir le detail
     de son cadre, pas comparer.
     ⚠️ LE BLANC N'A QU'UN RENDU, pas de photos. Sa serie fait donc une seule vignette, et c'est
     honnete : montrer les photos d'une autre teinte sous une pastille blanche serait pire.
     ⛔ ET LA VIGNETTE ACTIVE DOIT RESTER VISIBLE : si la vignette montree est masquee par le
     filtre, on bascule sur la premiere restante, sinon la scene garde une image que plus
     aucune vignette ne designe et le client ne peut plus revenir dessus. */
  /* ⛔ « AUCUNE COULEUR CHOISIE » VEUT DIRE « LE CLIENT N'A PAS CLIQUE », PAS « `selected` EST
     VIDE ». Releve en production : la pastille Blanc arrive avec `aria-pressed="true"`, posee
     par `option.selected_value` de Shopify, et l'init du theme retombe de toute facon sur la
     PREMIERE valeur quand rien n'est presse. `selected` porte donc toujours une teinte, l'etat
     d'ensemble n'existait jamais, et la fiche s'ouvrait sur une seule vignette : le rendu blanc,
     c'est-a-dire le visuel le moins parlant des onze, sans aucun moyen de voir les photos sans
     changer de couleur. On retient donc le clic, pas la selection.
     ⚠️ ET SEULEMENT LE CLIC SUR UNE COULEUR : cliquer une taille ne doit rien filtrer, sinon
     choisir 30 x 40 renverrait la galerie a l'etat d'ensemble. Recliquer la meme couleur la
     deselectionne, et la galerie revient d'elle-meme a une photo par teinte. */
  var teinteMontree = null;
  function majVignettesTeinte() {
    var items = $$(".pdp-thumb-item[data-teinte]");
    if (!items.length) return;
    var choisie = teinteMontree;
    var visibles = [];
    items.forEach(function (it) {
      var garde = choisie
        ? it.getAttribute("data-teinte") === choisie
        : it.hasAttribute("data-resume");
      it.hidden = !garde;
      if (garde) visibles.push(it.querySelector(".pdp-thumb"));
    });
    if (!visibles.length) return;
    /* ⛔ LA SCENE SUIT LA VIGNETTE ALLUMEE, TOUJOURS, ET PAS SEULEMENT QUAND LE FILTRE LA CACHE.
       Releve en production : la fiche s'ouvrait sur la vignette chene allumee et le rendu BLANC
       dans la scene, parce que `#pdp-main` est initialise par l'image de la variante presetie
       alors que la vignette l'est par sa position. Une vignette entouree qui ne montre pas ce
       qu'on regarde, c'est le client qui croit avoir clique a cote. Un clic de plus ne coute
       rien et remet les deux d'accord ; il ne CHANGE pas le choix quand il est deja valide. */
    /* ⛔ SANS COULEUR CHOISIE, ON REVIENT A L'IMAGE DE BASE, ET C'EST LA PREMIERE PHOTO DE CHENE
       (Adrien : « quand je deselectionne une couleur, ca ne revient pas sur l'image de base, je
       t'avais dit de prendre une photo du cadre chene pour l'image de base »). Garder la vignette
       allumee au retour laissait la scene sur la teinte qu'on venait justement d'abandonner.
       `visibles[0]` EST la premiere photo de chene : les medias sont ranges chene d'abord, et le
       filtre garde les deux premieres de chaque teinte dans l'ordre. */
    var actif = $('.pdp-thumb[aria-pressed="true"]');
    var aCliquer = choisie
      ? (actif && visibles.indexOf(actif) >= 0 ? actif : visibles[0])
      : visibles[0];
    /* ⛔ LE RAPPORT DE LA SCENE SE POSE ICI, PAS SEULEMENT PAR LE CLIC, ET C'EST TOUT LE DEFAUT
       QU'ADRIEN VOYAIT. Au chargement, cette fonction est appelee AVANT que les ecouteurs des
       vignettes soient poses, quelques centaines de lignes plus bas : le `.click()` ne declenche
       donc rien, et `sceneAuFormatDeLaPhoto`, qui vit dans cet ecouteur, n'etait jamais appelee.
       La scene restait a son repli 3/4 pendant que la premiere photo est en 1100 x 825, d'ou les
       deux bandes en haut et en bas de la fiche cadre a l'arrivee. Des qu'on cliquait une
       couleur, l'ecouteur existait et tout rentrait dans l'ordre : le defaut ne se voyait qu'au
       premier ecran, c'est-a-dire exactement la ou il compte.
       ⚠️ J'ai d'abord accuse le deploiement, en lisant les assets avec curl sur une page mise en
       cache, donc une vieille URL de version. Le deploiement etait bon. Lire l'asset DEPUIS LA
       PAGE CHARGEE, jamais depuis une URL reconstruite. */
    sceneAuFormatDeLaPhoto(aCliquer.getAttribute("data-img"));
    aCliquer.click();
  }
  // init selected from aria-pressed
  $$(".pdp-option").forEach(function (grp) {
    var idx = parseInt(grp.getAttribute("data-option-index"), 10);
    var on = grp.querySelector('[aria-pressed="true"]') || grp.querySelector("[data-value]");
    if (on) selected[idx] = on.getAttribute("data-value");
    grp.addEventListener("click", function (e) {
      var b = e.target.closest("[data-value]"); if (!b) return;
      /* ⛔ RECLIQUER UN FORMAT DEJA CHOISI LE DESELECTIONNE (Adrien, 06/08/2026). Il n'y avait
         aucun moyen de revenir a « dès <prix mini> » apres un premier clic : la page s'ouvre
         sans format, et cet etat devenait inatteignable des la premiere selection. Le client
         qui voulait comparer les tailles restait enferme dans la derniere cliquee. */
      var deja = b.getAttribute("aria-pressed") === "true";
      grp.querySelectorAll("[data-value]").forEach(function (x) {
        x.setAttribute("aria-pressed", (!deja && x === b) ? "true" : "false");
      });
      if (deja) delete selected[idx]; else selected[idx] = b.getAttribute("data-value");
      /* La rangee glisse sur telephone : une pastille cliquee alors qu'elle depassait a moitie
         doit finir de rentrer, sinon le client choisit un format qu'il ne voit qu'a moitie. */
      if (!deja && grp.scrollWidth > grp.clientWidth + 4 && b.scrollIntoView) {
        b.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
      }
      updatePrice(); updateFrame();
      if (deja) disengageScale(); else engageScale();
      /* Comparaison sur la liste plutot que sur un selecteur d'attribut : la valeur vient de
         Shopify et contient une espace et un accent (« Chêne clair »). L'echapper pour un
         selecteur marche, mais ca fait dependre un filtre de galerie des regles d'echappement
         CSS, pour une boucle de trois elements. */
      var val = b.getAttribute("data-value");
      var estTeinte = $$(".pdp-thumb-item[data-teinte]").some(function (it) {
        return it.getAttribute("data-teinte") === val;
      });
      if (estTeinte) { teinteMontree = deja ? null : val; majVignettesTeinte(); }
      syncPersoQc();
    });
  });
  if (optCount === 0 && variants[0]) selected = {};
  /* Panneau de mariage : ni le Type (option 1) ni la Finition (option 3) n'ont de ligne
     d'option. Le Type se choisit par les cartes du configurateur (panneau-mariage.js
     appelle __pdpPanneauType), la Finition par la case perforation du bloc upsell. On
     tient les deux selections ici, initialisees depuis ?variant= (cartes collection). */
  if (window.__pdpPanneau && optCount === 3) {
    (function () {
      var caseP = $("#pdp-up-perfo-check");
      var vSel = (function () {
        var m = location.search.match(/[?&]variant=(\d+)/);
        if (!m) return null;
        return variants.filter(function (v) { return String(v.id) === m[1]; })[0] || null;
      })();
      /* ⛔ LES DEUX FINITIONS SE LISENT DANS L'OPTION, JAMAIS DANS UNE CHAINE ECRITE ICI. Elles
         valaient « Sans perforation » et « Perforation » en dur, et la variante d'arrivee se
         jugeait au mot : depuis que les valeurs d'option sont traduites (07/08/2026), un client
         allemand recoit « Mit Ösen ». Le test ne trouvait plus rien, la case restait decochee sur
         une variante perforee, et `selected[2]` ne correspondait a aucune variante : le prix ne
         se calculait plus et l'ajout au panier partait sur la mauvaise ligne. L'ordre est celui
         de l'option : sans perforation d'abord, avec ensuite. */
      var FIN = window.__pdpPanneauFinitions || ["Sans perforation", "Perforation"];
      selected[0] = (vSel && vSel.option1)
        || (variants[0] && variants[0].option1)
        || (window.__pdpPanneauValeurs && window.__pdpPanneauValeurs[0]);
      var perfoInitiale = !!(vSel && vSel.option3 === FIN[1]);
      selected[2] = perfoInitiale ? FIN[1] : FIN[0];
      window.__pdpPanneauType = function (valeur) {
        selected[0] = valeur;
        updatePrice();
      };
      /* ⛔ ET LA FINITION AUSSI DOIT POUVOIR VENIR DU CONFIGURATEUR (Adrien, 08/08/2026, audit
         de la fiche panneau). `selected[2]` ne se reglait QUE par la case a cocher, juste en
         dessous. Or le panneau voiture impose sa perforation sans passer par elle : ses oeillets
         sont d'origine, la case est masquee, et c'est `panneau-mariage.js` qui force l'etat.
         product.js cherchait donc une variante « Panneau voiture / Sans perforation », qui
         n'existe pas, ne trouvait rien, et retombait sur le prix « des » du produit : 45,00 EUR
         barre 60,00 EUR au lieu de 33,70 EUR barre 45,00 EUR, alors que la pastille de taille
         juste a cote annoncait bien 33,70 EUR.
         Ce defaut vivait sous un autre : tant que la perforation restait collee a `true` d'une
         visite a l'autre, la case etait cochee au chargement, son evenement partait, et
         `selected[2]` tombait juste par ricochet. Reparer la fuite de perforation l'a mis a nu. */
      window.__pdpPanneauFinition = function (avecPerfo) {
        selected[2] = avecPerfo ? FIN[1] : FIN[0];
        updatePrice();
      };
      if (caseP) {
        caseP.checked = perfoInitiale;
        caseP.addEventListener("change", function () {
          selected[2] = caseP.checked ? FIN[1] : FIN[0];
          updatePrice();
        });
      }
    })();
  }

  // Par défaut AUCUN format n'est choisi : le prix affiche « dès {mini} », la mise en
  // situation (image 2) se rend en A0, et l'acheteur doit cliquer un format pour engager
  // le prix exact, les cotes et l'échelle. (Shopify pré-coche un format : on le retire.)
  (function defaultNoFormat() {
    var fi = formatGroupInfo();
    if (fi) {
      fi.pills.forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
      delete selected[fi.idx];
    }
    mockFmt = SIZE_REF;
    updatePrice();                              // prix « dès », pas d'engageScale()
  })();

  /* ---- Estimation de livraison ----
     Date unique à J+N en jours calendaires (week-ends et jours fériés compris),
     calculée dans le fuseau du visiteur. */
  (function () {
    var box = $("#pdp-delivery"), out = $("#pdp-delivery-date");
    if (!box || !out) return;
    var days = (window.MURMURE_SHIP || {}).deliveryDays || 4;
    /* ⛔ ET LE SUPPLEMENT DE LA FAMILLE, DECLARE PAR LE GABARIT. Un panneau demande trois jours
       de plus : support rigide, decoupe, sechage, et un colis qui ne part pas roule. Le nombre
       vient du serveur, ou la famille est connue avec certitude ; ici on ne fait que l'ajouter.
       Absent ou illisible vaut ZERO, ce qui est l'etat de toutes les autres fiches. */
    var enPlus = parseInt(box.getAttribute("data-jours-en-plus"), 10);
    if (isFinite(enPlus) && enPlus > 0) days += enPlus;

    var d = new Date();
    d.setDate(d.getDate() + days);
    // La locale vient du fichier de langue, pas de <html lang> : la boutique est
    // déclarée "en" alors que son contenu est français, la date sortait en anglais.
    var loc = (window.MURMURE_I18N || {}).date_locale || "fr-FR";
    try {
      out.textContent = d.toLocaleDateString(loc, { weekday: "long", day: "numeric", month: "long" });
    } catch (e) {
      out.textContent = d.toLocaleDateString();
    }
    box.hidden = false;
  })();

  /* ---- Zoom (lightbox) ---- */
  (function () {
    var overlay = $("#pdp-zoom"), zimg = $("#pdp-zoom-img"), zscene = $("#pdp-zoom-scene");
    if (!overlay || !zimg) return;
    var zoomTarget = zimg;
    var previewOpener = null, previewOverflow = "";
    /* Jeton d'ouverture : une HD arrivee apres une reouverture sur une AUTRE vue ne doit
       pas ecraser l'image en place. */
    var zoomJeton = 0;
    function bgUrl(el) {
      if (!el) return null;
      var m = (el.style.backgroundImage || getComputedStyle(el).backgroundImage || "").match(/url\(["']?(.*?)["']?\)/);
      return m && m[1] !== "none" ? m[1] : null;
    }
    function isMockupView() {
      var w = $(".pdp-gallery__wrap");
      return !!(w && w.getAttribute("data-mockup") === "true");
    }
    function currentSrc() {
      var main = $("#pdp-main"); if (!main) return null;
      // Photo importée ou aperçu généré : on zoome sur ce qui est réellement affiché.
      if (photo || viewCustom) return bgUrl(main);
      var t = $('.pdp-thumb[aria-pressed="true"]');
      if (t && t.getAttribute("data-zoom")) return t.getAttribute("data-zoom");
      return main.getAttribute("data-zoom") || bgUrl(main);
    }
    // Molette pour zoomer (1 → 4×), le point sous le curseur reste sous le curseur.
    var scale = 1;
    function resetZoom() {
      scale = 1;
      [zimg, zscene].forEach(function (el) {
        if (!el) return;
        el.style.transform = "";
        el.style.transformOrigin = "center";
        el.classList.remove("is-zoomed");
      });
    }
    function originAt(e) {
      if (!zoomTarget) return;
      var r = zoomTarget.getBoundingClientRect();
      if (!r.width || !r.height) return;
      zoomTarget.style.transformOrigin =
        ((e.clientX - r.left) / r.width * 100) + "% " + ((e.clientY - r.top) / r.height * 100) + "%";
    }
    function clearScene() {
      if (!zscene) return;
      zscene.hidden = true;
      zscene.innerHTML = "";
      zscene.style.width = "";
      zscene.style.height = "";
      zscene.style.backgroundColor = "";
    }
    function openContextPreview(button) {
      var art = button.querySelector('.pdp-context-preview__art');
      var bounds = button.getBoundingClientRect();
      if (!zscene || !art || !bounds.width || !bounds.height) return;
      // Agrandir la configuration affichee, independamment de la vignette de galerie active.
      ++zoomJeton;
      resetZoom();
      clearScene();
      var fit = Math.min((window.innerWidth - 32) / bounds.width, (window.innerHeight - 128) / bounds.height);
      var frame = document.createElement('div');
      frame.style.cssText = button.style.cssText;
      frame.style.boxSizing = 'border-box';
      frame.style.width = '100%';
      frame.style.height = '100%';
      frame.style.borderStyle = 'solid';
      frame.style.borderWidth = (parseFloat(button.style.borderWidth) || 0) * fit + 'px';
      var image = art.cloneNode(true);
      image.removeAttribute('class');
      image.style.display = 'block';
      image.style.width = '100%';
      image.style.height = '100%';
      if (image.querySelector('[data-sm-bordure-apercu]')) image.style.position = 'relative';
      image.style.backgroundPosition = 'center';
      image.style.backgroundRepeat = 'no-repeat';
      frame.appendChild(image);
      zscene.appendChild(frame);
      zscene.style.width = bounds.width * fit + 'px';
      zscene.style.height = bounds.height * fit + 'px';
      zscene.style.backgroundColor = 'transparent';
      zscene.hidden = false;
      zimg.hidden = true;
      zimg.style.display = 'none';
      zoomTarget = zscene;
      previewOpener = button;
      previewOverflow = document.body.style.overflow;
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeButton = overlay.querySelector('.pdp-zoom__close');
      if (closeButton) closeButton.focus({ preventScroll: true });
    }
    function fitScene(sw, sh) {
      var maxW = Math.min(sw, window.innerWidth - 64);
      var maxH = Math.min(sh, window.innerHeight - 64);
      var fit = Math.min(maxW / sw, maxH / sh, 1);
      zscene.style.width = Math.round(sw * fit) + "px";
      zscene.style.height = Math.round(sh * fit) + "px";
    }
    function copyPersoVars(from, to) {
      if (!from || !to) return;
      ["--perso-mat", "--perso-ink", "--perso-muted", "--art-ratio"].forEach(function (v) {
        var val = "";
        try { val = getComputedStyle(from).getPropertyValue(v); } catch (e) {}
        if (!val) val = from.style.getPropertyValue(v) || "";
        if (val) to.style.setProperty(v, val.trim());
      });
    }
    // Clone d'affiche avec texte (passe-partout / zone) : les sélecteurs #id
    // du CSS ne matchent plus après clone → on pose classes + styles inline.
    function styleZoomPoster(cPoster, srcPoster, cArt, srcArt) {
      if (!cPoster || !srcPoster) return;
      var design = srcPoster.getAttribute("data-perso-design") || "";
      var hasSub = srcPoster.getAttribute("data-has-sub") === "true";
      var pcs = getComputedStyle(srcPoster);
      cPoster.classList.add("pdp-zoom__poster");
      if (design) cPoster.setAttribute("data-perso-design", design);
      else cPoster.removeAttribute("data-perso-design");
      if (hasSub) cPoster.setAttribute("data-has-sub", "true");
      else cPoster.removeAttribute("data-has-sub");
      copyPersoVars(srcPoster, cPoster);
      var matBg = pcs.backgroundColor;
      if (!matBg || matBg === "rgba(0, 0, 0, 0)" || matBg === "transparent") {
        matBg = pcs.getPropertyValue("--perso-mat").trim() || "#ffffff";
      }
      if (design === "design") {
        cPoster.style.backgroundColor = matBg;
        cPoster.style.aspectRatio = pcs.aspectRatio || String(persoRatioFeuille());
        cPoster.style.overflow = "hidden";
        cPoster.style.position = cPoster.style.position || "relative";
      }
      if (cArt && srcArt) {
        cArt.id = "";
        cArt.classList.add("pdp-zoom__art");
        var artBg = srcArt.style.backgroundImage || getComputedStyle(srcArt).backgroundImage;
        var artOp = getComputedStyle(srcArt).opacity;
        if (design === "design") {
          cArt.style.cssText =
            "position:absolute;top:5%;left:5%;right:5%;bottom:" + (hasSub ? "28%" : "26%") + ";" +
            "width:auto;height:auto;margin:0;display:block;aspect-ratio:auto;" +
            "background-image:" + artBg + ";" +
            "background-size:cover;background-position:center;background-repeat:no-repeat;" +
            "opacity:" + artOp + ";";
        } else {
          cArt.style.cssText =
            "display:block;width:100%;aspect-ratio:" + (getComputedStyle(srcArt).aspectRatio || String(persoRatioFeuille())) + ";" +
            "background-image:" + artBg + ";" +
            "background-size:cover;background-position:center;background-repeat:no-repeat;" +
            "opacity:" + artOp + ";";
        }
      }
      var cBand = cPoster.querySelector(".pdp-textband");
      if (cBand) {
        copyPersoVars(srcPoster, cBand);
        if (design === "design") {
          cBand.style.background = "transparent";
          cBand.style.left = "5%";
          cBand.style.right = "5%";
          cBand.style.bottom = "2.5%";
          cBand.style.height = hasSub ? "22%" : "20%";
        } else if (design === "zone") {
          cBand.style.background = matBg;
        }
        requestAnimationFrame(function () {
          try { fitPersoTextBand(cBand); } catch (e) {}
        });
      }
    }
    // Vues 2-4 : cloner la scène pièce + affiche (pas l'œuvre seule).
    function openMockupScene() {
      var stage = $("#pdp-stage"), mk = $("#pdp-mockup"), mkp = $("#pdp-mockup-poster");
      if (!stage || !mk || !zscene || mk.hidden) return false;
      var sw = stage.clientWidth, sh = stage.clientHeight;
      if (!sw || !sh) return false;
      clearScene();
      zimg.hidden = true;
      zimg.removeAttribute("src");
      zimg.style.display = "none";
      fitScene(sw, sh);
      var clone = mk.cloneNode(true);
      clone.id = "";
      clone.hidden = false;
      clone.className = "pdp-zoom__mock";
      clone.style.cssText =
        "position:absolute;inset:0;width:100%;height:100%;" +
        "background-image:" + (mk.style.backgroundImage || getComputedStyle(mk).backgroundImage) + ";" +
        "background-size:" + (mk.style.backgroundSize || getComputedStyle(mk).backgroundSize) + ";" +
        "background-position:" + (mk.style.backgroundPosition || getComputedStyle(mk).backgroundPosition) + ";" +
        "background-repeat:no-repeat;border-radius:2px;";
      var cPoster = clone.querySelector("#pdp-mockup-poster") || clone.querySelector("[id$='mockup-poster']") || clone.children[0];
      if (cPoster && mkp) {
        cPoster.id = "";
        var sr = stage.getBoundingClientRect();
        var pr = mkp.getBoundingClientRect();
        var leftPct = ((pr.left + pr.width / 2 - sr.left) / sr.width) * 100;
        var topPct = ((pr.top - sr.top) / sr.height) * 100;
        var widthPct = (pr.width / sr.width) * 100;
        var design = mkp.getAttribute("data-perso-design") || "";
        /* ⛔ UN POLYPTYQUE N'A PAS DE HAUTEUR PROPRE, ET C'EST POUR CA QU'IL DISPARAISSAIT AU
           ZOOM (Adrien, 06/08/2026 : « quand on clique sur les apercus polyptyques pour zoomer,
           l'affiche disparait de l'image »). Sur une affiche simple, `height:auto` marche parce
           que `#pdp-mockup-art` a un rapport et pousse la boite ; les quatre panneaux, eux, sont
           dessines par des `.poly-holder` en position ABSOLUE, qui ne poussent rien : la boite
           du clone tombait a zero et il ne restait que la piece.
           ⚠️ ET LE REMBOURRAGE NE DOIT PAS ETRE EFFACE. `padding:0` retirait le passe-partout,
           qui est ce qui separe les quatre panneaux. Un pourcentage se resout sur la largeur du
           bloc conteneur, la meme des deux cotes ici : la valeur d'origine reste donc juste
           dans le clone, il suffit de la recopier.
           ⛔ ET `styleZoomPoster` NE PASSE PAS : elle cherche l'oeuvre par `querySelector("span")`
           faute de trouver `#pdp-mockup-art`, et le premier `span` d'un polyptyque est le porteur
           des panneaux, qu'elle habille alors comme une affiche unique. */
        var estPoly = !!mkp.querySelector(".poly-holder:not([hidden])");
        var heightPct = (pr.height / sr.height) * 100;
        cPoster.style.cssText =
          "position:absolute;left:" + leftPct + "%;top:" + topPct + "%;" +
          "transform:translateX(-50%);width:" + widthPct + "%;" +
          (estPoly ? "height:" + heightPct + "%;" : (design === "design" ? "" : "height:auto;")) +
          "box-sizing:border-box;padding:" + (estPoly ? (mkp.style.padding || "0") : "0") + ";" +
          "border:" + getComputedStyle(mkp).border + ";" +
          "box-shadow:" + getComputedStyle(mkp).boxShadow + ";";
        if (!estPoly) {
          var cArt = cPoster.querySelector("#pdp-mockup-art") || cPoster.querySelector("[id$='mockup-art']") || cPoster.querySelector("span");
          var art = $("#pdp-mockup-art");
          styleZoomPoster(cPoster, mkp, cArt, art);
        }
      }
      /* ⛔ LES COTES DU POLYPTYQUE VIVENT SUR `.pdp-gallery__wrap`, ET LE ZOOM N'EN EST PAS UN
         DESCENDANT. C'est LA raison pour laquelle l'affiche disparaissait au zoom (Adrien, deux
         fois) : les quatre panneaux prennent leur largeur de `var(--p-cw)`, leur hauteur de
         `var(--p-ch)`, leurs decalages de `--p-px`, `--p-py`, `--p-x0`... toutes posees par
         `updateFormatScale` sur le wrap. Le clone est ajoute dans `#pdp-zoom-scene`, ailleurs
         dans le document : les variables ne l'atteignent plus, `width:var(--p-cw)` devient
         invalide, et chaque panneau sort a ZERO PAR ZERO. Releve a l'ecran : porteur a
         148 x 214, apercu a 148 x 203, panneaux a 0 x 0.
         ⚠️ Ma correction precedente (hauteur du porteur) etait juste et ne suffisait pas : elle
         donnait une boite a des panneaux qui n'en avaient toujours aucune.
         La liste est la meme que celle qui les pose, a `ech` pres : une seule source, deux
         endroits qui la lisent, et un format ajoute demain suivra des deux cotes. */
      var wrapSrc = $(".pdp-gallery__wrap");
      if (wrapSrc) {
        ["art-ratio", "poly-moulure", "p-ech", "p-ratio", "p-cw", "p-ch", "p-px", "p-py",
         "p-bx", "p-by", "p-bsw", "p-bsh", "p-x0", "p-x1", "p-y0", "p-y1"].forEach(function (k) {
          var v = wrapSrc.style.getPropertyValue("--" + k);
          if (v) clone.style.setProperty("--" + k, v);
        });
      }
      zscene.appendChild(clone);
      zscene.hidden = false;
      zoomTarget = zscene;
      overlay.hidden = false;
      document.body.style.overflow = "hidden";
      return true;
    }
    // Affiche seule + texte encadré/zone : zoomer sur la composition, pas la photo nue.
    function openPersoFrameScene() {
      var stage = $("#pdp-stage"), frame = $("#pdp-frame"), inner = document.querySelector(".pdp-frame__inner");
      if (!stage || !frame || !inner || !zscene || frame.hidden) return false;
      var design = inner.getAttribute("data-perso-design");
      if (!design) return false;
      var fr = frame.getBoundingClientRect();
      var sw = fr.width, sh = fr.height;
      if (!sw || !sh) return false;
      clearScene();
      zimg.hidden = true;
      zimg.removeAttribute("src");
      zimg.style.display = "none";
      fitScene(sw, sh);
      var clone = frame.cloneNode(true);
      clone.id = "";
      clone.querySelectorAll("[id]").forEach(function (el) { el.id = ""; });
      // Pas de cotes / spinner / CTA placeholder dans le zoom.
      clone.querySelectorAll(".pdp-dim, #pdp-gen, .pdp-gen, .pdp-placeholder__cta, .pdp-placeholder").forEach(function (el) {
        if (el.classList && el.classList.contains("pdp-placeholder")) {
          // Garde le ghost exemple si pas de photo importée, retire le bouton.
          el.removeAttribute("aria-label");
          el.style.pointerEvents = "none";
          el.style.cursor = "default";
          /* L'invitation « Cliquer pour importer » n'a rien a faire dans le zoom : on y
             REGARDE l'affiche, on n'y importe pas. Le ghost d'exemple, lui, reste. */
          var invite = el.querySelector(".pdp-placeholder__cta");
          if (invite) invite.remove();
        } else {
          el.remove();
        }
      });
      clone.classList.add("pdp-zoom__frame");
      clone.style.cssText =
        "position:absolute;inset:0;width:100%;height:100%;" +
        "max-width:none;transform:none;margin:0;" +
        "box-sizing:border-box;";
      var cInner = clone.querySelector(".pdp-frame__inner") || clone;
      var cMain = cInner.querySelector("[data-zoom], .pdp-zoom__art") || cInner.children[0];
      var main = $("#pdp-main");
      if (cInner !== clone) {
        cInner.style.cssText = "position:relative;width:100%;height:100%;overflow:hidden;";
        copyPersoVars(inner, cInner);
        if (design) cInner.setAttribute("data-perso-design", design);
        var hasSub = inner.getAttribute("data-has-sub") === "true";
        if (hasSub) cInner.setAttribute("data-has-sub", "true");
        var matBg = getComputedStyle(inner).backgroundColor;
        if (design === "design") cInner.style.backgroundColor = matBg;
      }
      if (cMain && main) {
        cMain.classList.add("pdp-zoom__art");
        var mainBg = main.style.backgroundImage || getComputedStyle(main).backgroundImage;
        var hasSub2 = inner.getAttribute("data-has-sub") === "true";
        if (design === "design") {
          cMain.style.cssText =
            "position:absolute;top:5%;left:5%;right:5%;bottom:" + (hasSub2 ? "28%" : "26%") + ";" +
            "background-image:" + mainBg + ";" +
            "background-size:cover;background-position:center;background-repeat:no-repeat;";
        } else {
          cMain.style.cssText =
            "position:absolute;inset:0;bottom:" + (hasSub2 ? "26%" : "22%") + ";" +
            "background-image:" + mainBg + ";" +
            "background-size:cover;background-position:center;background-repeat:no-repeat;";
        }
      }
      var cBand = clone.querySelector(".pdp-textband");
      if (cBand) {
        copyPersoVars(inner, cBand);
        if (design === "design") {
          cBand.style.background = "transparent";
          cBand.style.left = "5%";
          cBand.style.right = "5%";
          cBand.style.bottom = "2.5%";
          cBand.style.height = inner.getAttribute("data-has-sub") === "true" ? "22%" : "20%";
        }
        requestAnimationFrame(function () {
          try { fitPersoTextBand(cBand); } catch (e) {}
        });
      }
      /* ⛔ LES COTES DU POLYPTYQUE VIVENT SUR `.pdp-gallery__wrap`, ET LE ZOOM N'EN EST PAS UN
         DESCENDANT. C'est LA raison pour laquelle l'affiche disparaissait au zoom (Adrien, deux
         fois) : les quatre panneaux prennent leur largeur de `var(--p-cw)`, leur hauteur de
         `var(--p-ch)`, leurs decalages de `--p-px`, `--p-py`, `--p-x0`... toutes posees par
         `updateFormatScale` sur le wrap. Le clone est ajoute dans `#pdp-zoom-scene`, ailleurs
         dans le document : les variables ne l'atteignent plus, `width:var(--p-cw)` devient
         invalide, et chaque panneau sort a ZERO PAR ZERO. Releve a l'ecran : porteur a
         148 x 214, apercu a 148 x 203, panneaux a 0 x 0.
         ⚠️ Ma correction precedente (hauteur du porteur) etait juste et ne suffisait pas : elle
         donnait une boite a des panneaux qui n'en avaient toujours aucune.
         La liste est la meme que celle qui les pose, a `ech` pres : une seule source, deux
         endroits qui la lisent, et un format ajoute demain suivra des deux cotes. */
      var wrapSrc = $(".pdp-gallery__wrap");
      if (wrapSrc) {
        ["art-ratio", "poly-moulure", "p-ech", "p-ratio", "p-cw", "p-ch", "p-px", "p-py",
         "p-bx", "p-by", "p-bsw", "p-bsh", "p-x0", "p-x1", "p-y0", "p-y1"].forEach(function (k) {
          var v = wrapSrc.style.getPropertyValue("--" + k);
          if (v) clone.style.setProperty("--" + k, v);
        });
      }
      zscene.appendChild(clone);
      zscene.hidden = false;
      zoomTarget = zscene;
      overlay.hidden = false;
      document.body.style.overflow = "hidden";
      return true;
    }
    function open() {
      resetZoom();
      if (isMockupView()) {
        if (openMockupScene()) return;
      }
      if (openPersoFrameScene()) return;
      clearScene();
      zimg.hidden = false;
      zimg.style.display = "";
      zoomTarget = zimg;
      var src = currentSrc(); if (!src) return;
      /* ⛔ LE PLEIN ECRAN S'OUVRE SUR L'IMAGE DEJA EN CACHE, LA HD LA REMPLACE. La source
         du zoom fait 2880 px (1,4 Mo sur une fiche courante) : chargee seule et a froid,
         le plein ecran restait VIDE plusieurs secondes (Adrien, 07/08/2026 : « ca met une
         plombe a charger »). La version 900 du meme media est celle que la fiche affiche
         deja, donc en cache : on la montre tout de suite, et on ne bascule vers la 2880
         que quand ELLE est prete, si le plein ecran est toujours ouvert sur la meme vue. */
      var apercu = null;
      var presse = $('.pdp-thumb[aria-pressed="true"]');
      if (presse && presse.getAttribute("data-zoom") === src && presse.getAttribute("data-img")) {
        apercu = presse.getAttribute("data-img");
      } else {
        var fondMain = bgUrl($("#pdp-main"));
        if (fondMain && fondMain.split("?")[0] === src.split("?")[0]) apercu = fondMain;
      }
      if (apercu && apercu !== src) {
        var jeton = ++zoomJeton;
        zimg.src = apercu;
        var hd = new Image();
        hd.onload = function () {
          if (jeton === zoomJeton && !overlay.hidden) zimg.src = src;
        };
        hd.src = src;
      } else {
        zimg.src = src;
      }
      overlay.hidden = false;
      document.body.style.overflow = "hidden";
    }
    function close() {
      if (overlay.hidden) return;
      ++zoomJeton;
      overlay.hidden = true;
      zimg.removeAttribute("src");
      zimg.hidden = false;
      zimg.style.display = "";
      clearScene();
      zoomTarget = zimg;
      document.body.style.overflow = previewOpener ? previewOverflow : "";
      resetZoom();
      if (previewOpener) {
        if (previewOpener.isConnected) previewOpener.focus({ preventScroll: true });
        previewOpener = null;
      }
    }
    document.addEventListener('click', function (e) {
      var button = e.target.closest && e.target.closest('[data-pdp-preview-zoom]');
      if (button) openContextPreview(button);
    });
    overlay.addEventListener('keydown', function (e) {
      if (previewOpener && e.key === 'Tab') {
        e.preventDefault();
        overlay.querySelector('.pdp-zoom__close').focus();
      }
    });
    // Clic / tap sur la scène = zoom. Après un swipe, data-swiping bloque le click fantôme.
    var st = $("#pdp-stage");
    if (st) st.addEventListener("click", function (e) {
      if (st.getAttribute("data-swiping") === "1") return;
      /* ⛔ NI SUR LE BLOC DE DÉPÔT. C'EST LUI QUI FAISAIT APPARAÎTRE LA DÉMONSTRATION.
         Sur mobile, l'appui pour choisir un fichier remonte du placeholder jusqu'ici : le
         plein écran s'ouvrait DERRIÈRE le sélecteur de fichiers, à un instant où `photo` est
         encore nul. Le garde-fou plus bas ne mordait donc pas, et `currentSrc()` retombait sur
         le média du produit, c'est-à-dire l'affiche de démonstration. Au retour du sélecteur,
         le client trouvait cette affiche en plein écran par-dessus sa propre photo. */
      if (e.target && e.target.closest
        && e.target.closest(".pdp-room-choice, .pdp-murs, .pdp-dots, #pdp-qc, #pdp-placeholder, #pdp-upload")) return;
      /* ⛔ SUR UNE PHOTO IMPORTÉE, LE CLIC SERT À CADRER, PAS À AGRANDIR.
         Les deux gestes se disputaient le même appui : on glissait pour placer sa photo et,
         au relâchement, l'aperçu plein écran s'ouvrait par-dessus. Le cadrage est le travail
         de cet écran ; l'agrandissement reste accessible depuis les vignettes de la galerie,
         qui ne sont pas cadrables. */
      /* ⛔ SUR LA FICHE PERSO, LA VUE DE L'AFFICHE N'OUVRE JAMAIS LE PLEIN ÉCRAN.
         Sans condition, et c'est voulu. Ce garde-fou a été resserré trois fois et chaque
         version laissait un trou : d'abord `.pdp-frame__inner` seul, qui laissait passer la
         marge du `#pdp-stage` ; puis l'ajout de `photo`, qui laissait passer tout l'instant de
         l'import, celui-là même où le client tape pour choisir son fichier. Le plein écran
         s'ouvrait alors derrière le sélecteur, et le client le retrouvait par-dessus sa photo
         au retour. Un client qui importe doit voir son affiche SUR LA PAGE, pas dans une
         couche par-dessus. La mise en situation garde le sien : ce n'est pas une photo
         cadrable, l'agrandissement y a un sens. */
      if (window.__pdpPerso && !isMockupView()) return;
      open();
    });

    overlay.addEventListener("click", close);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !overlay.hidden) close(); });
    // Clic sur l'image / la scène = quitter l'aperçu (comme sur le fond).
    zimg.addEventListener("click", close);
    if (zscene) zscene.addEventListener("click", close);
    function onWheel(e) {
      e.preventDefault();
      originAt(e);
      scale = Math.min(4, Math.max(1, scale + (e.deltaY < 0 ? 0.5 : -0.5)));
      if (!zoomTarget) return;
      zoomTarget.style.transform = scale > 1 ? "scale(" + scale + ")" : "";
      zoomTarget.classList.toggle("is-zoomed", scale > 1);
    }
    zimg.addEventListener("wheel", onWheel, { passive: false });
    if (zscene) zscene.addEventListener("wheel", onWheel, { passive: false });
    function onMove(e) { if (scale > 1) originAt(e); }
    zimg.addEventListener("mousemove", onMove);
    if (zscene) zscene.addEventListener("mousemove", onMove);
  })();

  /* ---- Description repliable ---- */
  (function () {
    var box = $(".pdp-desc"), body = $("#pdp-desc-body"), btn = $("#pdp-desc-more");
    if (!box || !body || !btn) return;
    // Pas de bouton si le texte tient déjà dans les 2 lignes.
    if (body.scrollHeight <= body.clientHeight + 2) return;
    btn.hidden = false;
    btn.addEventListener("click", function () {
      var open = box.getAttribute("data-expanded") === "true";
      box.setAttribute("data-expanded", open ? "false" : "true");
      btn.setAttribute("aria-expanded", open ? "false" : "true");
      // Libellés fournis par le Liquid (data-more/data-less) : ils étaient en dur.
      btn.textContent = open ? (btn.dataset.more || "Voir plus") : (btn.dataset.less || "Voir moins");
    });
  })();

  /* ---- Guide des tailles ---- */
  (function () {
    var modal = $("#pdp-guide"), openButtons = document.querySelectorAll("#pdp-guide-open, [data-config-guide]");
    if (!modal || !openButtons.length) return;
    var closeBtn = $("#pdp-guide-close"), panel = modal.querySelector(".pdp-guide__panel");
    var opener = null;
    function open(event) {
      opener = event.currentTarget;
      modal.hidden = false;
      document.body.style.overflow = "hidden";
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      modal.hidden = true;
      document.body.style.overflow = "";
      if (opener) opener.focus(); // on rend le focus au déclencheur visible
    }
    openButtons.forEach(function (button) { button.addEventListener("click", open); });
    if (closeBtn) closeBtn.addEventListener("click", close);
    // clic sur le fond uniquement, pas à travers le panneau
    modal.addEventListener("click", function (e) { if (!panel.contains(e.target)) close(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !modal.hidden) close(); });
  })();

  /* ⛔ LA FENETRE VIDEO DE L'ATELIER A ETE RETIREE LE 22/08/2026, avec son ouvreur. Elle jouait
     `atelier-coupe.mp4` avec le son ; « Voir l'atelier » mene desormais a la page atelier, qui
     montre cette video et le reste. Deux mecanismes pour une seule commande, c'est le defaut que
     ce fichier combat partout ailleurs, et le second finit toujours par diverger.
     ⚠️ L'APERCU DE LA CARTE, LUI, RESTE : `.pdp-atelier-proof__video` joue en boucle et muet
     dans le bandeau, et personne ne l'arrete plus puisqu'il n'y a plus de fenetre a ouvrir. */

  // thumbnails
  // Seule la 1re vue (l'affiche seule) reçoit le cadre simulé. Les autres sont des photos
  // réelles (ambiance, macro papier) qui contiennent déjà leur propre décor.
  function setFrameVisible(on) {
    var w = $(".pdp-gallery__wrap"); if (!w) return;
    /* ⛔ SUR UN ACCESSOIRE, `data-framed` NE REPASSE JAMAIS A VRAI. Toute la fiche cadre tient a
       cet attribut : c'est lui qui retire la baguette doree, le carton, les cotes et qui donne
       a la scene le rapport de la photo. Il est pose a faux par le gabarit, et cette fonction
       le remettait a vrai des qu'on revenait sur la premiere vignette, parce qu'elle est ecrite
       pour une AFFICHE, ou la premiere vue est l'oeuvre a encadrer.
       ⚠️ RELEVE A L'ECRAN LE 06/08/2026 : au chargement, bordure 0 et rapport 900/675, la photo ;
       apres avoir choisi puis DESELECTIONNE une couleur, bordure 7 px et rapport 1054/1492,
       celui d'une affiche. Le cadre revenait par la porte de derriere, et seulement dans ce
       chemin-la, ce qui est exactement le genre de defaut qu'on ne voit qu'en le refaisant. */
    if (w.getAttribute("data-framed") === "false" && $(".pdp-thumb-item[data-teinte]")) {
      w.setAttribute("data-sized", "false");
      return;
    }
    w.setAttribute("data-framed", on ? "true" : "false");
    if (on) {
      // retour sur l'affiche seule : on restaure les cotes si un format a déjà été choisi
      if (sizeEngaged) updateFormatScale();
    } else {
      // photo réelle : ni cotes ni réduction, elle doit remplir la scène
      w.setAttribute("data-sized", "false");
    }
  }
  /* ---------- LES MURS DE COULEUR : ONZE AU SALON, ONZE EN CUISINE ----------
     Onze rendus de la MEME piece, seule la couleur du mur change : la geometrie de la scene est
     donc identique d'une pastille a l'autre, et changer de mur ne demande que de remplacer
     l'image de fond. ⛔ VERIFIE AVANT DE BRANCHER, ET PAS A L'OEIL. Salon : le haut du canape
     tombe a 0,4087 sur les onze. Cuisine : les onze recalees sur la beige par correlation d'un
     profil de CONTOURS, ecart maximal 2 px sur 1024 en vertical, 0 en horizontal.
     ⚠️ LE PROFIL DE LUMINANCE NE MARCHE PAS ICI, ET IL M'A MENTI : sur un mur sombre le plan de
     travail n'est plus le point le plus contraste de la colonne, et quatre teintes ressortaient
     decalees de 56 px alors qu'elles ne le sont pas. Un profil de gradient survit au changement
     de couleur, un profil de luminance non.
     ⛔ LA CHAMBRE N'A PAS DE SERIE, donc pas de rangee : proposer des murs qui n'existent pas
     serait pire que ne rien proposer.
     ⛔ ON NE PRECHARGE QU'A L'ENTREE DANS LA PIECE, serie par serie. Les onze d'une piece pesent
     environ 2 Mo ; les tirer au chargement ferait payer a tout le monde un choix que la plupart
     ne feront pas, et les vingt-deux d'un coup encore moins. */
  /* ⛔ CHAQUE PIECE A SA SERIE, ET LA RANGEE SE REPEINT QUAND ON CHANGE DE PIECE (Adrien,
     06/08/2026 : « pour le background cuisine je t'ai mis les autres couleurs, il faut ajouter
     les pastilles comme pour salon »). `window.__pdpMurs` etait un tableau, c'est desormais un
     objet indexe par le nom de la serie, et chaque piece dit la sienne (`room.murs`). Une piece
     sans serie, la chambre, n'a simplement pas de rangee.
     ⚠️ INDEXER PAR LE NOM ET NON PAR LE RANG DE LA PIECE : le rang change des qu'on ajoute une
     piece au milieu de la liste, et ce jour-la les murs du salon partiraient a la cuisine sans
     que rien ne le signale.
     ⛔ CHAQUE PIECE RETIENT SON PROPRE CHOIX, dans `room.murChoisi` : un client qui met le salon
     en petrole puis passe en cuisine doit trouver la cuisine telle qu'il l'a laissee, pas
     repeinte par la piece d'a cote. C'est la meme raison qui fait retenir `room.img`. */
  var MURS_PAR_SERIE = window.__pdpMurs || {};
  if (Array.isArray(MURS_PAR_SERIE)) MURS_PAR_SERIE = { salon: MURS_PAR_SERIE };
  function listeMurs(r) { return (r && MURS_PAR_SERIE[r.murs]) || []; }
  /* Une invitation acceptee ne se rejoue pas : le rebond s'arrete au premier clic et il reste
     arrete, y compris apres que la rangee a ete repeinte pour une autre piece. */
  var mursDejaServis = false;
  function peindreMurs() {
    var stage = $("#pdp-stage"); if (!stage) return;
    var ancienne = $(".pdp-murs");
    if (ancienne) ancienne.remove();
    var liste = listeMurs(curRoom);
    if (liste.length < 2) return;
    if (curRoom.murChoisi == null) curRoom.murChoisi = liste[0].cle;
    if (curRoom.murPose == null) curRoom.murPose = liste[0].cle;
    var murChoisi = curRoom.murChoisi;
    var row = document.createElement("div");
    row.className = "pdp-murs" + (mursDejaServis ? " a-servi" : "");
    row.style.setProperty("--mur-count", String(liste.length));
    row.addEventListener("click", function (e) { e.stopPropagation(); });
    liste.forEach(function (m) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "pdp-mur" + (m.cle === murChoisi ? " is-on" : "");
      b.style.background = m.hex;
      b.dataset.mur = m.cle;
      /* Le nom n'est PAS affiche : il ne sert qu'a l'etiquette accessible, une pastille de
         couleur ne disant rien a qui ne voit pas l'ecran. */
      b.setAttribute("aria-label", m.nom || m.cle);
      b.setAttribute("aria-pressed", m.cle === murChoisi ? "true" : "false");
      b.addEventListener("click", function (e) {
        e.stopPropagation();
        poserMur(m.cle);
      });
      row.appendChild(b);
    });
    stage.appendChild(row);
  }
  /* ⛔ LA PASTILLE S'ALLUME TOUT DE SUITE, LE MUR CHANGE QUAND L'IMAGE EST PRETE. Poser
     `background-image` sur un fichier pas encore decode laisse le mur PRECEDENT a l'ecran
     pendant le telechargement, sans que rien ne dise que quelque chose se passe : le client
     croit que son clic n'a pas pris et reclique ailleurs. On separe donc les deux temps : le
     retour visuel est immediat sur la pastille, et le fond bascule d'un coup, sans etape
     intermediaire, une fois l'image decodee.
     Le repli sans `decode()` n'est pas une precaution de style : Safari ne l'a eu qu'en 2021,
     et une promesse absente ferait planter le changement de mur au lieu de le ralentir. */
  function poserMur(cle) {
    var m = listeMurs(curRoom).filter(function (x) { return x.cle === cle; })[0];
    if (!m) return;
    curRoom.murChoisi = cle;
    /* Le rebond de la deuxieme pastille s'arrete au premier clic, sur n'importe laquelle : une
       invitation qui continue apres qu'on l'a acceptee devient un tic. */
    mursDejaServis = true;
    var rangee = $(".pdp-murs");
    if (rangee) rangee.classList.add("a-servi");
    /* La piece courante retient l'image choisie : revenir a la chambre puis au salon doit
       ramener le mur du client, pas le beige de depart. */
    var piece = curRoom;
    $$(".pdp-mur").forEach(function (b) {
      var on = b.dataset.mur === cle;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
    var mk = $("#pdp-mockup");
    if (!mk) return;
    if (m.mask) {
      if (rangee) rangee.setAttribute("aria-busy", "true");
      var rendu = window.AfRoomWalls ? window.AfRoomWalls.render(m) : Promise.reject(new Error("Wall renderer unavailable"));
      rendu.then(function (url) {
        if (piece.murChoisi !== cle) return;
        piece.img = url;
        piece.murPose = cle;
        if (piece !== curRoom) return;
        mk.style.backgroundImage = "url('" + url + "')";
        var row = $(".pdp-murs");
        if (row) row.removeAttribute("aria-busy");
      }).catch(function () {
        if (piece.murChoisi !== cle) return;
        piece.murChoisi = piece.murPose;
        if (piece === curRoom) { peindreMurs(); majMurs(); }
      });
      return;
    }
    curRoom.img = m.img;
    if (rangee) rangee.removeAttribute("aria-busy");
    var poser = function () {
      /* Le client a pu recliquer, ou changer de piece, entre-temps : on ne pose que le mur
         encore choisi, et seulement si on est encore dans la piece qui l'a demande. */
      if (piece === curRoom && piece.murChoisi === cle) { mk.style.backgroundImage = "url('" + m.img + "')"; piece.murPose = cle; }
    };
    /* ⛔ `decode()` ET `onload` COURENT ENSEMBLE, LE PREMIER ARRIVE POSE LE MUR. La promesse de
       `decode()` peut ne JAMAIS revenir, ni tenir ni rompre, quand la page n'est pas peinte :
       le navigateur repousse le decodage d'une image qu'il ne va pas afficher. Releve le
       06/08/2026 dans un onglet en arriere-plan : pastille allumee, `room.img` a jour, fond
       inchange apres six secondes, et il fallait changer de piece et revenir pour voir la
       couleur. Ce n'est pas une lenteur, c'est une promesse qui ne revient pas.
       ⚠️ Ca arrive aussi a un vrai client : un onglet passe au second plan, un telephone
       verrouille, et il revient sur un mur qui n'a pas change alors qu'il a clique.
       `onload` arrive un peu avant `decode` (fichier recu, pas encore decode) et ne depend
       d'aucune peinture : il garantit qu'on ne reste jamais bloque, sans rien perdre du but,
       qui est de ne pas basculer sur un fichier absent. `poser` est protege par ses gardes,
       l'appeler deux fois ne fait rien. */
    var im = new Image();
    im.onload = poser;
    im.onerror = poser;
    im.src = m.img;
    if (im.complete) poser();
    else if (im.decode) im.decode().then(poser).catch(poser);
  }
  /* ⛔ LES MURS SE PRECHARGENT A L'OUVERTURE DU SALON, PAS AU CLIC (Adrien : « les images
     mettent trop de temps a charger, ce n'est pas assez fluide »). Aller chercher un fichier
     de 165 Ko au moment ou l'on clique, c'est une seconde de mur vide entre deux couleurs, et
     comparer devient impossible : on ne compare que ce qu'on peut alterner vite.
     ⛔ MAIS PAS AU CHARGEMENT DE LA PAGE. Les onze pesent 1,8 Mo ; les tirer d'emblee ferait
     payer a tout le monde un choix que la plupart ne feront pas, et retarderait l'affiche
     elle-meme. Le moment juste est l'ENTREE DANS LE SALON : le client vient de dire qu'il
     regarde la piece, et il lui faut encore quelques secondes avant de viser une pastille.
     `fetchPriority = "low"` pour que ces onze requetes ne passent jamais devant l'image que
     le client est en train de regarder. */
  var mursPrecharges = {};
  function prechargerMurs() {
    var liste = listeMurs(curRoom);
    if (liste.length < 2 || mursPrecharges[curRoom.murs]) return;
    mursPrecharges[curRoom.murs] = true;
    var teinte = liste.filter(function (m) { return m.mask; })[0];
    if (teinte && window.AfRoomWalls) window.AfRoomWalls.preload(teinte).catch(function () {});
    liste.forEach(function (m) {
      var im = new Image();
      if ("fetchPriority" in im) im.fetchPriority = "low";
      im.decoding = "async";
      im.src = m.img;
    });
  }
  /* ⛔ SUR TELEPHONE, LE SAUT ATTEND QUE L'IMAGE SOIT ARRIVEE, PUIS UNE SECONDE (Adrien).
     La galerie mobile GLISSE d'une vue a l'autre. La rangee de pastilles, elle, devient
     visible des que la vue salon est demandee, c'est-a-dire PENDANT le glissement : le saut
     partait donc au milieu d'un mouvement horizontal, ou il ne se distingue pas du glissement
     lui-meme, et il etait fini quand l'oeil se posait enfin sur la piece.
     On attend donc deux choses, dans cet ordre : que le glissement soit termine (`data-swiping`
     est pose par `go()` pendant toute sa duree), puis une seconde de plus, le temps que le
     regard finisse de parcourir la piece avant qu'on lui montre autre chose.
     Sur desktop il n'y a pas de glissement : la rangee est prete tout de suite. */
  var minuterieSaut = null;
  function armerSaut(montrer) {
    var row = $(".pdp-murs"); if (!row) return;
    if (minuterieSaut) { clearTimeout(minuterieSaut); minuterieSaut = null; }
    if (!montrer) { row.classList.remove("pret"); return; }
    var mobile = window.matchMedia && window.matchMedia("(max-width:900px)").matches;
    if (!mobile) { row.classList.add("pret"); return; }
    row.classList.remove("pret");
    var stage = $("#pdp-stage");
    var attendre = function () {
      if (stage && stage.hasAttribute("data-swiping")) { minuterieSaut = setTimeout(attendre, 80); return; }
      minuterieSaut = setTimeout(function () { row.classList.add("pret"); }, 1000);
    };
    attendre();
  }
  /* La rangee ne se montre que sur le salon ET dans la mise en situation : sur l'affiche seule
     il n'y a pas de mur a colorer. */
  function majMurs() {
    var row = $(".pdp-murs"); if (!row) return;
    row.classList.toggle("a-servi", mursDejaServis);
    var w = $(".pdp-gallery__wrap");
    var enPiece = w && w.getAttribute("data-mockup") === "true";
    var montrer = !!(enPiece && listeMurs(curRoom).length > 1);
    row.hidden = !montrer;
    if (montrer) prechargerMurs();
    armerSaut(montrer);
  }
  // Choix de la pièce (salon, chambre…) : change le fond + la géométrie de compositing.
  function setRoom(i) {
    if (!ROOMS[i]) return;
    curRoom = ROOMS[i];
    var choix = $(".pdp-room-choice select");
    if (choix) {
      choix.value = String(i);
      choix.dispatchEvent(new Event("afich:piece"));
    }
    var mk = $("#pdp-mockup");
    if (mk && curRoom.img) mk.style.backgroundImage = "url('" + curRoom.img + "')";
    /* ⛔ LA BOITE PREND LA FORME DE LA PHOTO, C'EST CE QUI EVITE DE LA ROGNER. Les trois
       photos de piece sont CARREES et la galerie est verticale (0,707) : couvrir l'une avec
       l'autre imposait un fond a 141,5 %, donc 70,7 % de la largeur visible et 15 % coupes de
       chaque cote. Au salon, ca supprimait les etageres a gauche et la baie a droite ; en
       cuisine, la fenetre. Mesure du 06/08/2026, Adrien : « l'image de base est plus large
       que ca ». La boite du fond n'occupe donc plus toute la hauteur de la scene, elle prend
       le rapport de la photo et se centre ; la galerie, elle, ne bouge pas d'un pixel. */
    if (mk) mk.style.setProperty("--room-ar", String(curRoom.ar || 1));
    /* ⛔ EN POLYPTYQUE LA BOITE N'EST JAMAIS PLUS LARGE QUE CARREE. Montrer la photo entiere
       corrige le rognage tant qu'elle est carree ou plus haute ; sur la cuisine, large de 3/2,
       ca reposerait la boite aux lettres qu'on venait justement de supprimer (86 px de vide en
       haut ET en bas d'une scene de 520). Une photo plus large que la scene se recadre, et
       c'est sans dommage : elle a ete faite large exprement, pour que le carre du milieu
       contienne encore tout le mur libre. */
    if (mk) mk.style.setProperty("--room-ar-poly", String(Math.min(curRoom.ar || 1, 1)));
    peindreMurs();
    majMurs();
  }
  // Vue "sur un mur" : pièce en fond + affiche à l'échelle. Pas une image produit.
  function setMockup(on) {
    var w = $(".pdp-gallery__wrap"), mk = $("#pdp-mockup");
    if (!w || !mk) return;
    w.setAttribute("data-mockup", on ? "true" : "false");
    mk.hidden = !on;
    var choix = $(".pdp-room-choice");
    if (choix) choix.hidden = !on;
    // Format choisi → à son échelle ; sinon rendu par défaut en A0.
    if (on) { if (formatChosen()) updateFormatScale(); else positionMockup(SIZE_REF); }
    majMurs();
  }
  // Une seule vignette memorise la piece choisie. Tous les effets passent par activateThumb.
  (function brancherChoixPiece() {
    var choix = $(".pdp-room-choice select");
    if (!choix) return;
    var widget = choix.closest(".pdp-room-choice");
    var trigger = document.createElement("button");
    trigger.type = "button";
    trigger.className = "pdp-room-choice__trigger";
    trigger.setAttribute("aria-expanded", "false");
    trigger.setAttribute("aria-controls", "pdp-room-choice-options");
    var icon = widget.querySelector(".pdp-room-choice__icon");
    if (icon) trigger.appendChild(icon);
    var current = document.createElement("span");
    current.className = "pdp-room-choice__current";
    trigger.appendChild(current);
    var arrow = widget.querySelector(".pdp-room-choice__arrow");
    if (arrow) trigger.appendChild(arrow);
    var panel = document.createElement("div");
    panel.id = "pdp-room-choice-options";
    panel.className = "pdp-room-choice__panel";
    panel.hidden = true;
    panel.setAttribute("role", "group");
    panel.setAttribute("aria-label", choix.getAttribute("aria-label") || "");
    var heading = document.createElement("p");
    heading.className = "pdp-room-choice__heading";
    heading.textContent = choix.getAttribute("aria-label");
    panel.appendChild(heading);
    var grid = document.createElement("div");
    grid.className = "pdp-room-choice__grid";
    var options = [];
    Array.from(choix.options).forEach(function (option) {
      var room = ROOMS[Number(option.value)];
      if (!room) return;
      var button = document.createElement("button");
      button.type = "button";
      button.className = "pdp-room-choice__option";
      button.dataset.room = option.value;
      var preview = document.createElement("img");
      preview.src = room.img;
      preview.alt = "";
      preview.loading = "lazy";
      preview.width = 48;
      preview.height = 48;
      var name = document.createElement("span");
      name.textContent = option.textContent;
      button.append(preview, name);
      button.addEventListener("click", function () {
        if (choix.value !== option.value) {
          choix.value = option.value;
          choix.dispatchEvent(new Event("change", { bubbles: true }));
        }
        expand(false);
        trigger.focus({ preventScroll: true });
      });
      options.push(button);
      grid.appendChild(button);
    });
    panel.appendChild(grid);
    widget.append(trigger, panel);
    widget.setAttribute("data-enhanced", "true");
    function paintChoice() {
      var option = choix.options[choix.selectedIndex];
      current.textContent = option ? option.textContent : "";
      trigger.setAttribute("aria-label", (choix.getAttribute("aria-label") || "") + " : " + current.textContent);
      trigger.setAttribute("aria-busy", choix.getAttribute("aria-busy") || "false");
      options.forEach(function (button) { button.setAttribute("aria-pressed", String(button.dataset.room === choix.value)); });
    }
    choix.addEventListener("afich:piece", paintChoice);
    var scene = widget.closest("#pdp-stage");
    function fitPanel() {
      if (panel.hidden || !scene) return;
      var available = scene.getBoundingClientRect().bottom - trigger.getBoundingClientRect().bottom - 16;
      panel.style.maxHeight = Math.max(80, Math.min(360, available)) + "px";
    }
    if (scene && typeof ResizeObserver !== "undefined") new ResizeObserver(fitPanel).observe(scene);
    function expand(on, focus) {
      panel.hidden = !on;
      trigger.setAttribute("aria-expanded", String(on));
      if (on) fitPanel();
      if (on && focus) (options.find(function (button) { return button.dataset.room === choix.value; }) || options[0]).focus();
    }
    trigger.addEventListener("click", function () { expand(panel.hidden); });
    trigger.addEventListener("keydown", function (event) {
      if (event.key !== "ArrowDown" && event.key !== "ArrowUp") return;
      event.preventDefault();
      expand(true, true);
    });
    panel.addEventListener("keydown", function (event) {
      var index = options.indexOf(document.activeElement);
      var columns = options[1] && options[0].offsetTop === options[1].offsetTop ? 2 : 1;
      var step = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: columns, ArrowUp: -columns }[event.key];
      var next = event.key === "Home" ? 0 : event.key === "End" ? options.length - 1 : step ? Math.max(0, Math.min(options.length - 1, index + step)) : null;
      if (next === null) return;
      event.preventDefault();
      options[next].focus();
    });
    widget.addEventListener("keydown", function (event) {
      if (event.key !== "Escape" || panel.hidden) return;
      event.preventDefault();
      event.stopPropagation();
      expand(false);
      trigger.focus({ preventScroll: true });
    });
    document.addEventListener("click", function (event) { if (!widget.contains(event.target)) expand(false); });
    widget.addEventListener("focusout", function (event) { if (!widget.contains(event.relatedTarget)) expand(false); });
    new MutationObserver(function () { if (widget.hidden) expand(false); }).observe(widget, { attributes: true, attributeFilter: ["hidden"] });
    paintChoice();
    var requete = 0;
    trigger.addEventListener("focus", function () {
      ROOMS.forEach(function (room) { var image = new Image(); image.src = room.img; });
    }, { once: true });
    choix.addEventListener("change", function () {
      var i = Number(choix.value), vignette = $('.pdp-thumb[data-mockup="true"]');
      if (!Number.isInteger(i) || !ROOMS[i] || !vignette) return;
      if (typeof stopGalleryNudge === "function") stopGalleryNudge();
      var courant = ++requete, image = new Image(), applique = false;
      choix.setAttribute("aria-busy", "true");
      paintChoice();
      image.onload = function () {
        if (courant !== requete || applique) return;
        applique = true;
        choix.removeAttribute("aria-busy");
        paintChoice();
        vignette.setAttribute("data-room", String(i));
        var fond = vignette.querySelector(".pdp-thumb__room");
        if (fond) fond.style.backgroundImage = "url('" + ROOMS[i].img + "')";
        if (vignette.getAttribute("aria-pressed") === "true") activateThumb(vignette);
      };
      image.onerror = function () {
        if (courant !== requete) return;
        choix.removeAttribute("aria-busy");
        choix.value = vignette.getAttribute("data-room") || "0";
        paintChoice();
      };
      image.src = ROOMS[i].img;
      if (image.complete && image.naturalWidth) image.onload();
    });
  })();
  peindreMurs();
  /* Au chargement : sans couleur choisie, la galerie du cadre s'ouvre sur une photo par teinte. */
  majVignettesTeinte();
  /* ⚠️ CACHEE DES LA CONSTRUCTION. Sans cet appel la rangee naissait visible et se posait sur
     l'affiche SEULE, la vue d'ouverture, ou il n'y a aucun mur a colorer. Vu a l'ecran :
     `hidden` a faux avant meme d'avoir touche une vignette. `majMurs` n'etait rappelee que par
     un changement de piece ou de vue, c'est-a-dire jamais au chargement. */
  majMurs();
  // Points de navigation DANS l'image (mobile) : un point par vignette. Ils déclenchent
  // le clic de la vignette correspondante, donc toute la logique reste au même endroit.
  (function buildDots() {
    var stage = $("#pdp-stage"), thumbList = $$(".pdp-thumb");
    if (!stage || thumbList.length < 2) return;
    var dots = document.createElement("div");
    dots.className = "pdp-dots"; dots.setAttribute("aria-hidden", "true");
    thumbList.forEach(function (th) {
      var d = document.createElement("button");
      d.type = "button";
      // Ne pas forcer le 1er point : sur la perso, l'état initial est le cadre
      // + CTA d'import, aucune vignette mockup n'est active.
      d.className = "pdp-dot" + (th.getAttribute("aria-pressed") === "true" ? " is-on" : "");
      d.addEventListener("click", function () {
        if (stopGalleryNudge) stopGalleryNudge();
        activateThumb(th);
      });
      dots.appendChild(d);
    });
    stage.appendChild(dots);
  })();

  function syncDots(activeThumb) {
    var thumbList = $$(".pdp-thumb"), dots = $$(".pdp-dot");
    var idx = thumbList.indexOf(activeThumb);
    dots.forEach(function (d, i) { d.classList.toggle("is-on", i === idx); });
  }

  /* ⛔ LES VUES 4 ET 5 ARRIVAIENT EN RETARD PARCE QUE LA GRANDE IMAGE N'EN EST PAS UNE.
     `#pdp-main` porte un `background-image` : le navigateur ne demande le fichier 900 px qu'au
     moment où la règle s'applique, c'est-à-dire au clic ou au glissement. Il n'y a donc aucun
     `loading="lazy"` à corriger, pas de balise <img> du tout, et les deux gros plans de papier
     se chargeaient sous les yeux du visiteur (Adrien, 06/08/2026).
     On les demande nous-mêmes, mais APRES `load` et une par une : préchargées en parallèle
     pendant le rendu, elles disputeraient la bande passante à l'affiche elle-même, qui est ce
     qu'on est venu voir. La version 1800 px du zoom reste à la demande, elle est trop lourde
     pour être tirée à l'avance sur cinq vues. */
  function prechargerVues() {
    var vues = {}, urls = [];
    $$(".pdp-thumb").forEach(function (th) {
      var u = th.getAttribute("data-img");
      if (u && !vues[u]) { vues[u] = 1; urls.push(u); }
    });
    var i = 0;
    (function suivante() {
      if (i >= urls.length) return;
      var im = new Image();
      if ("fetchPriority" in im) im.fetchPriority = "low";
      im.onload = im.onerror = suivante;
      im.src = urls[i++];
    })();
  }
  if (document.readyState === "complete") setTimeout(prechargerVues, 400);
  else window.addEventListener("load", function () { setTimeout(prechargerVues, 400); });

  var thumbs = $("#pdp-thumbs");
  /* La galerie ne peut rester epinglee que si elle tient dans la fenetre, et c'est la bande de
     vignettes qui fait sa hauteur. Au format paysage elle deborde ; on la replie sur deux
     colonnes plutot que d'en cacher le bas. La decision se prend a la mesure et non par un
     seuil de hauteur d'ecran : le nombre de vignettes change d'une fiche a l'autre, et un
     seuil replierait des bandes qui tenaient tres bien. On retire l'attribut avant de mesurer,
     sinon on mesure la bande deja repliee et elle ne revient jamais a une colonne. */
  function majBandeColonnes() {
    var g = document.querySelector(".pdp-gallery");
    if (!g || !thumbs) return;
    g.removeAttribute("data-bande");
    if (window.innerWidth < 901) return;
    /* ⛔ LE REPLI EST UNE AFFAIRE DE TABLETTE, JAMAIS DE DESKTOP (Adrien, 07/08/2026 :
       « certains produits ont leurs thumbnails sur 2 colonnes sur desktop »). Huit vignettes
       depassent la fenetre d'un MacBook aussi ; mais sur desktop la page defile et l'epingle
       s'arrete deja sur le bas de l'affiche : une colonne passe tres bien. La hauteur ne
       distingue pas un iPad Air paysage (820) d'un MacBook (820) ; le POINTEUR si. */
    if (!window.matchMedia("(pointer: coarse)").matches) return;
    thumbs.style.maxHeight = "";
    var v = thumbs.querySelector(".pdp-thumb");
    /* Meme piege qu'au-dessous : sur la fiche perso, la bande du cadre est masquee tant que la
       galerie de demos occupe la place. Une vignette presente mais non rendue mesure 0, la
       rangee tombait a 10 px, et le seuil devenait franchissable par n'importe quelle galerie :
       la bande se repliait en deux colonnes sur tablette sans raison. Presente sans boite vaut
       absente, on reprend la rangee par defaut. */
    var rang = (v && v.getClientRects().length) ? v.getBoundingClientRect().height + 10 : 94;
    /* ⛔ LE CRITERE EST LA HAUTEUR D'ECRAN, PAS LA HAUTEUR DE L'IMAGE (Adrien, 07/08/2026 :
       « tu as applique a tort ce format de vignette sur iPad Pro portrait, alors qu'une colonne
       de thumbnails passe tres bien »). J'avais compare la bande a l'affiche : sur un iPad Pro
       en portrait la bande depasse bien l'affiche, mais l'ecran fait 1366 px de haut, tout
       tenait, et le repli ne servait qu'a retrecir l'image pour rien.
       Le repli ne repare qu'une chose : une galerie plus haute que la fenetre. On ne le
       declenche donc que la, avec une demi-rangee de tolerance pour ne pas repartir sur un
       liseré de 31 px et changer un desktop qu'Adrien a valide. */
    if (g.getBoundingClientRect().height - window.innerHeight > rang / 2) {
      g.setAttribute("data-bande", "2");
    }
  }
  /* ⛔ L'EPINGLE S'ARRETE SUR LE BAS DE L'AFFICHE, PAS SUR LE BAS DE LA GALERIE (Adrien,
     07/08/2026 : « s'arreter quand le bas de l'affiche arrive au niveau du bord du bas du bloc
     Imprimee a la main a Fayence », puis « elle s'arrete un peu trop haut » sur trois iPad).
     `position:sticky` relache quand la BOITE de l'element atteint le bas de son conteneur. Or
     la galerie ne s'arrete pas ou l'affiche s'arrete : la bande de vignettes descend plus bas
     qu'elle. Mesure en 1180 x 820 : au relachement, le bas de la galerie tombait pile sur le
     bloc Fayence, et le bas de l'affiche 101 px plus haut. Le calcul etait juste, il portait sur
     le mauvais objet.
     Une marge basse NEGATIVE de la hauteur de ce creux raccourcit la boite jusqu'au bas de
     l'affiche : l'epingle tient 101 px de plus et lache a l'endroit demande. Le creux se mesure,
     il ne se devine pas : il vaut 27 px sur un ecran large et 101 sur un iPad, parce qu'il est
     l'ecart entre la bande et l'affiche, et que l'affiche retrecit avec la colonne. */
  function majArretEpingle() {
    var g = document.querySelector(".pdp-gallery");
    var stage = $("#pdp-stage");
    if (!g || !stage) return;
    g.style.marginBottom = "";
    var section = g.closest("section.two-col");
    if (section) section.style.paddingBottom = "";
    if (window.innerWidth < 901) return;
    /* ⛔ NE MESURE JAMAIS UN ELEMENT SANS BOITE (Adrien, 08/08/2026 : « va sur la page et scroll
       qu'on rigole un peu » : 1 061 px de blanc sous la fiche, puis « je ne veux plus aucun bug
       sur cette page »).
       Le creux est l'ecart entre le bas de la GALERIE et le bas de l'AFFICHE. Tant que le client
       n'a pas pose de photo, la galerie de demos occupe le cadre et `#pdp-stage` est en
       `display:none` : son rectangle vaut 0 x 0, en haut a gauche de la fenetre. Le creux
       devenait donc la hauteur entiere de la galerie, la marge negative valait -1 061 px et la
       section s'allongeait d'autant. Le trou etait exactement la mesure d'un objet absent.
       Un rectangle nul n'est pas une mesure, c'est une absence de mesure : sans affiche a
       l'ecran il n'y a pas d'epingle a raccourcir, donc rien a faire ici. `getClientRects()`
       rend une liste vide pour un element non rendu, la ou `getBoundingClientRect()` ment en
       rendant des zeros qui se calculent. */
    if (!stage.getClientRects().length) return;
    var creux = Math.round(g.getBoundingClientRect().bottom - stage.getBoundingClientRect().bottom);
    if (creux > 0) {
      g.style.marginBottom = -creux + "px";
      /* ⛔ LE DEBORDEMENT SE RESOUT PAR L'ESPACE, PAS PAR UN CLIP (Adrien, 07/08/2026 : « les
         vignettes ne doivent jamais passer au-dessus de la barre du bas »). La marge negative
         raccourcit la boite pour que l'AFFICHE s'arrete au bloc Fayence ; la bande, plus longue,
         depasse alors d'autant sous la section et recouvrait la barre d'arguments. Un overflow
         casserait l'epingle (l'ancetre deviendrait son conteneur de defilement) ; on allonge
         donc la section de ce meme creux : la barre descend, le debordement atterrit dans du
         vide, et l'arret de l'epingle ne bouge pas (la course d'un sticky est la CONTENT box
         de son parent, le padding n'y entre pas). */
      if (section) section.style.paddingBottom = creux + "px";
    }
  }
  function majGalerieEpinglee() { majBandeColonnes(); majArretEpingle(); }
  window.__pdpMajBande = majGalerieEpinglee;
  majGalerieEpinglee();
  window.addEventListener("load", majGalerieEpinglee);
  var _bandeRz;
  window.addEventListener("resize", function () {
    clearTimeout(_bandeRz);
    _bandeRz = setTimeout(majGalerieEpinglee, 120);
  }, { passive: true });
  /* Le badge vit dans la scene, au meme niveau que les pastilles de mur (32 px du bas) : les
     deux sont des objets poses sur l'image, pas des elements d'interface au-dessus d'elle. */
  /* ⛔ LE FILTRE `t` DE SHOPIFY REND DU TEXTE ECHAPPE POUR LE HTML, ET `textContent` NE LE
     DECODE PAS. Une traduction qui contient une apostrophe arrive sous la forme `l&#39;atelier`,
     et c'est exactement ce qui s'affichait dans la fenetre qualite le 09/08/2026, en toutes
     lettres, sur le badge « Photo prise par l'atelier ». Rien ne le montre au code : posee dans
     du HTML, la meme chaine s'affiche correctement, et le defaut n'apparait que la ou on
     l'ecrit en TEXTE.
     Le `textarea` est le decodeur sur : le navigateur y decode les entites sans jamais
     interpreter de balise ni executer quoi que ce soit, contrairement a `innerHTML` sur un
     element ordinaire.
     ⚠️ AUCUN `hd_badge` NE PORTE D'APOSTROPHE AUJOURD'HUI, dans aucune des treize langues : le
     badge de la galerie n'a donc jamais montre le defaut. Il l'aurait montre au premier libelle
     retouche, et c'est pour ca qu'il passe par la meme fonction. */
  function texteTraduit(s) {
    var t = document.createElement("textarea");
    t.innerHTML = String(s == null ? "" : s);
    return t.value;
  }
  /* ⛔ LE BADGE PORTE UN TEXTE, PLUS UN BOOLEEN (Adrien, 09/08/2026 : « sur l'image Papier
     ajoute le badge "Papier d'art 220 g/m²", sur Detail ajoute "Photo prise par l'atelier" »).
     Il n'y en avait qu'un, celui du zoom, et la fonction prenait un `on` : trois badges
     differents selon la vignette ne rentrent pas dans un booleen. Chaque vignette porte
     desormais le sien en `data-badge` ; celles qui n'en portent pas n'ont pas de badge, ce qui
     reste le cas de toutes les autres. Le texte est REECRIT a chaque changement de vignette :
     le garder du passage precedent afficherait « Papier d'art » sur le zoom. */
  /* Lit l'oeil de masquage d'un champ. Absent (panneau, sticker) = rien de masque. */
  function persoTexteMasque(quel) {
    var b = document.querySelector('[data-perso-oeil="' + quel + '"]');
    return !!b && b.getAttribute("aria-pressed") === "true";
  }
  /* Le clic bascule l'etat et redessine : delegue, donc valable meme si le bloc est reconstruit. */
  document.addEventListener("click", function (e) {
    var b = e.target && e.target.closest && e.target.closest("[data-perso-oeil]");
    if (!b) return;
    b.setAttribute("aria-pressed", b.getAttribute("aria-pressed") === "true" ? "false" : "true");
    if (typeof syncPersoTextPreview === "function") syncPersoTextPreview();
  });
  function majBadgeHd(texte) {
    var stage = $("#pdp-stage");
    if (!stage) return;
    var el = $("#pdp-hd");
    if (!texte) { if (el) el.hidden = true; return; }
    if (!el) {
      el = document.createElement("span");
      el.id = "pdp-hd";
      el.className = "pdp-hd sans";
      stage.appendChild(el);
    }
    el.textContent = texteTraduit(texte);
    el.hidden = false;
  }
  /* ⛔ « LA VUE MONTRE-T-ELLE L'OEUVRE ? » : UNE SEULE DEFINITION, ET ELLE NE LIT AUCUN MOT.
     Elle etait ecrite DEUX FOIS a l'identique dans ce fichier, et il en fallait une troisieme
     pour le polyptyque. Trois copies d'une meme regle divergent au premier deplacement de
     vignette, et c'est exactement ce qui est deja arrive une fois ici (« l'oeuvre, c'est
     l'indice 0 » a cesse d'etre vrai quand Papier a demenage dans le rail des demos).
     ⛔ ET ELLE SE PREND SUR DES ATTRIBUTS, JAMAIS SUR UN LIBELLE. `data-fixe` marque les gros
     plans de notre papier, `data-mockup` les mises en situation ; le gabarit pose aussi
     `data-cle` (« papier », « detail », « zoom », « mediaN »), qui ne se traduit pas davantage.
     Les legendes, elles, existent en treize langues : « Papier », « Papel », « Χαρτί ». */
  function estVignetteOeuvre(x) {
    return !!x && !x.hasAttribute("data-fixe") && x.getAttribute("data-mockup") !== "true";
  }
  function vignetteDeLOeuvre() {
    return $$(".pdp-thumb").filter(estVignetteOeuvre)[0] || null;
  }
  /** La vignette actuellement selectionnee montre-t-elle l'oeuvre ? */
  function vueCouranteEstOeuvre() {
    var active = $$(".pdp-thumb").filter(function (x) {
      return x.getAttribute("aria-pressed") === "true";
    })[0];
    /* Aucune vignette pressee : on est au chargement, et la vue par defaut EST l'oeuvre. */
    return active ? estVignetteOeuvre(active) : true;
  }
  /** La vignette selectionnee est-elle une vue FIXE (Papier, Detail) ?
   *
   * ⛔ CE N'EST PAS L'INVERSE DE vueCouranteEstOeuvre, ET LES CONFONDRE COUTE UNE REGRESSION.
   * `estVignetteOeuvre` exclut les vues fixes ET les mises en situation. Or une mise en
   * situation montre l'affiche DU CLIENT sur un mur : son texte doit y rester. Seules les vues
   * fixes sont des photos d'atelier prises sur une autre affiche.
   */
  function vueCouranteEstFixe() {
    var active = $$(".pdp-thumb").filter(function (x) {
      return x.getAttribute("aria-pressed") === "true";
    })[0];
    return !!active && active.hasAttribute("data-fixe");
  }

  function activateThumb(b) {
    if (!b || !b.classList.contains("pdp-thumb")) return;
    syncDots(b);
    /* ⛔ ET LE CREUX SE REMESURE A CHAQUE VUE. La scene ne garde pas le meme rapport d'une
       vignette a l'autre : une maquette de piece est en 520/617 la ou l'affiche est en
       1054/1492. Sa hauteur change donc, le creux sous elle aussi, et une marge calculee sur la
       vue precedente ferait lacher l'epingle au mauvais endroit. On differe d'une image : le
       rapport est pose par la classe, et il n'est lisible qu'apres le rendu. */
    setTimeout(majArretEpingle, 0);
    var all = $$(".pdp-thumb");
    all.forEach(function (x) {
      x.setAttribute("aria-pressed", x === b ? "true" : "false");
      x.style.borderColor = x === b ? "var(--copper)" : "#D6CAB2";
    });
    /* ⛔ ET LA DEMO CHOISIE S'ETEINT. Papier et Detail vivent dans le rail des demos depuis
       qu'il n'y a plus qu'une colonne, mais les deux familles se marquaient chacune de son
       cote : `aria-pressed` ici, la classe `est-choisi` la-bas. Deux cadres allumes a la fois
       dans une seule bande, et le client lisait le sien comme n'ayant pas bouge (Adrien,
       13/08/2026). Une bande, une selection. */
    if (typeof window.__persoEteindreDemos === "function") window.__persoEteindreDemos();
    /* ⛔ TROIS VUES PORTENT UN BADGE, ET TROIS SEULEMENT. Le zoom dit ce qu'il DEMONTRE, un
       morceau du tirage a sa taille reelle (Adrien, 07/08/2026). Papier dit le grammage,
       Detail dit d'ou vient la photo (Adrien, 09/08/2026). Sur une mise en situation ou sur
       l'oeuvre, un badge deviendrait un argument decoratif pose sur une image qui ne prouve
       rien : elles n'ont pas de `data-badge`, elles n'ont donc pas de badge.
       ⚠️ LE ZOOM GARDE SON CHEMIN D'ORIGINE. Son libelle vit sur `#pdp-stage[data-hd]` depuis
       le 07/08 et sert aussi de repli ; les deux vignettes fixes, elles, portent le leur. */
    var txtBadge = b.getAttribute("data-badge");
    if (!txtBadge && b.getAttribute("data-hd") === "1") {
      var st = $("#pdp-stage");
      txtBadge = (st && st.getAttribute("data-hd")) || "";
    }
    /* ⛔ ET AUCUN REPLI SUR L'OEUVRE. Le 15/08/2026 j'ai fait descendre ce libelle sur la vue
       de l'oeuvre des configurateurs, en croyant repondre a « il manque le badge voir la
       qualite sur les produits personnalises ». C'ETAIT UN AUTRE OBJET : il parlait du BOUTON
       « Voir la qualite » de la colonne d'achat, sous la phrase d'introduction, et sa cause
       etait dans main-product.liquid, ou le bouton etait enferme dans la branche du catalogue.
       Ma « correction » a fait apparaitre « IMPRESSION HAUTE RESOLUTION » sur l'image 1 du
       pele-mele et de l'affiche personnalisee, que personne n'avait demande.
       ⚠️ LA LECON : nommer l'element exact avant de coder. « Badge » designait ici deux objets
       a trois ecrans d'ecart, et j'ai passe une journee sur le mauvais. */
    majBadgeHd(txtBadge);
    var isMockup = b.getAttribute("data-mockup") === "true";
    if (isMockup) setRoom(parseInt(b.getAttribute("data-room"), 10) || 0);
    setMockup(isMockup);
    if (isMockup) setFrameVisible(false);
    else {
      /* ⛔ L'AFFICHE SE RECONNAIT A SA NATURE, PAS A SA POSITION (Adrien, 08/08/2026 :
         « papier ne doit pas avoir de cadre autour »).
         `all.indexOf(b) === 0` voulait dire « la premiere vignette, c'est l'oeuvre ». C'etait
         vrai tant que toutes les vignettes vivaient dans `#pdp-thumbs`. En deplacant Papier et
         Detail dans le rail des demos, qui vient plus TOT dans la page, j'ai fait de Papier la
         vignette d'indice 0 : le theme l'a prise pour l'oeuvre et lui a mis la moulure autour,
         alors que c'est un gros plan de notre papier.
         L'oeuvre est la premiere vignette qui n'est ni une vue fixe (`data-fixe`) ni une mise
         en situation. Cette definition ne depend d'aucun ordre, donc plus rien ne la casse. */
      setFrameVisible(b === vignetteDeLOeuvre());
      /* ⛔ UNE VUE FIXE MONTRE NOTRE PAPIER, MEME QUAND LE CLIENT A POSE SA PHOTO (Adrien,
         08/08/2026). `viewCustom` empeche d'ecraser la scene une fois la photo importee, et
         c'est juste pour les vues de l'OEUVRE : elles doivent toutes montrer la sienne. Mais
         Papier et Detail ne montrent pas son affiche, ils montrent notre matiere : cliquer
         dessus rendait sa propre photo, donc rien de neuf, donc un clic mort. */
      if (viewCustom && b.hasAttribute("data-fixe") && b.getAttribute("data-img")) {
        var mf = $("#pdp-main");
        if (mf) {
          mf.style.backgroundImage = "url(" + b.getAttribute("data-img") + ")";
          sceneAuFormatDeLaPhoto(b.getAttribute("data-img"));
        }
      }
      if (!viewCustom) {
        var m = $("#pdp-main");
        if (m && b.getAttribute("data-img")) {
          m.style.backgroundImage = "url(" + b.getAttribute("data-img") + ")";
          sceneAuFormatDeLaPhoto(b.getAttribute("data-img"));
        }
      }
    }
    /* ⛔ LE TEXTE SE REMESURE UNE FOIS LA VUE VISIBLE, JAMAIS AVANT.
       `syncPersoTextPreview` remet la taille de police à zéro puis la recalcule d'après la
       largeur de la bande. Elle était appelée ICI, alors que le cadre venait d'être masqué par
       la vignette précédente : la mesure trouvait une largeur nulle, renonçait, et la police
       restait à sa valeur CSS. Le titre sortait alors du cadre, rogné d'une lettre, en
       revenant sur la première vue (« DÉSERT DE CHEGAG », relevé le 01/08/2026). */
    if (persoTextOn) { syncPersoTextPreview(); refitPersoTextBands(); }
    /* ⛔ ET LE CALQUE DU POLYPTYQUE SE REVALUE A CHAQUE VUE. Il ne se redessinait qu'au
       changement de TAILLE : une fois montre, il restait pose sur `#pdp-main` quelle que soit
       la vignette choisie ensuite. Le raccrocher ici plutot qu'au seul ecouteur de clic couvre
       aussi le balayage mobile et le retour a l'oeuvre, qui appellent cette fonction sans
       passer par un clic. */
    if (window.__pdpPolyRedessine) window.__pdpPolyRedessine();
    fondreLaVue();
  }
  /* ⛔ LE FONDU SE RELANCE PAR UN REFLUX LU, PAS PAR UN rAF (Adrien, 23/08/2026 : « on passe
     d'une image a l'autre de maniere abrupte »).
     Retirer puis remettre une classe d'animation dans la meme tache ne relance rien : le
     navigateur ne voit qu'un etat final identique. Lire `offsetWidth` entre les deux le force
     a recalculer, et c'est SYNCHRONE. Un `requestAnimationFrame` aurait fait la meme chose sur
     le papier, mais une fenetre native ouverte par-dessus la page les suspend : l'animation
     n'arriverait qu'au retrait de la fenetre, c'est-a-dire au mauvais moment ou jamais.
     ⚠️ LES DEUX CALQUES, PAS UN. `#pdp-main` porte l'oeuvre, `#pdp-mockup` porte la piece :
     passer de l'affiche a une mise en situation change le second, pas le premier. Poser le
     fondu ici, en fin d'`activateThumb`, couvre les six chemins qui changent de vue (clic sur
     vignette, fleche, glissement, retour a l'oeuvre, vue fixe, mise en situation) sans en
     oublier un ; les poser a cote de chaque affectation de `background-image` en aurait laisse
     passer, comme les huit portes de `__pdpMontrerLAffiche` l'ont deja montre. */
  function fondreLaVue() {
    ["#pdp-main", "#pdp-mockup"].forEach(function (sel) {
      var el = $(sel); if (!el) return;
      el.classList.remove("pdp-fondu");
      void el.offsetWidth;
      el.classList.add("pdp-fondu");
    });
  }
  /* ⛔ LA DELEGATION PORTE SUR LA GALERIE, PAS SUR LA BANDE (Adrien, 08/08/2026 : « les
     vignettes Papier et Detail ne sont pas cliquables »).
     Le clic etait delegue sur `#pdp-thumbs`. Sur la fiche perso, ces deux vignettes-la
     DEMENAGENT dans le rail des demos pour ne faire qu'une colonne : sorties du conteneur qui
     ecoutait, elles recevaient toujours le clic mais plus personne ne l'entendait. Le bouton
     etait la, visible, cliquable, et sans effet.
     La galerie contient les DEUX emplacements, la bande comme le rail : un seul ecouteur y
     couvre les vignettes ou qu'elles vivent, et le filtre `closest` garantit que rien d'autre
     ne passe. Un ecouteur pose sur chaque bouton aurait marche aussi, mais il aurait fallu y
     repenser au prochain deplacement ; l'ancetre commun, non. */
  /* ⛔ REVENIR A L'OEUVRE EST UNE OPERATION A PART ENTIERE (Adrien, 08/08/2026 : « quand on
     clique paysage, c'est le mauvais format et il n'y a pas de cadre »).
     Une vue fixe (Papier, Detail) fige la scene au rapport de SA photo : 0,881 au lieu de
     0,714, 1,640 au lieu de 1,429. C'est juste pour une photo produit, faux des qu'on revient
     a l'affiche. Changer d'orientation, ou poser une photo, veut dire « montre-moi mon
     affiche » : on ramene donc la vue de l'oeuvre avant de recalculer quoi que ce soit. */
  window.__pdpRevenirALOeuvre = function () {
    var w = document.querySelector(".pdp-gallery__wrap");
    if (w) w.removeAttribute("data-vue-fixe");
    var oeuvre = vignetteDeLOeuvre();
    if (oeuvre && oeuvre.getAttribute("aria-pressed") !== "true") activateThumb(oeuvre);
  };
  /* ⛔⛔ LE DEFAUT DE FOND DE LA BANDE, ET IL A HUIT PORTES (Adrien, 13/08/2026 : « il y a
     vraiment un probleme de fond avec tes thumbnails qui sont buguees et instables, revois le
     code au lieu de patcher sans resoudre le fond »).
     « Le client vient de changer sa composition, montre-lui SON affiche » est UN geste. Il
     etait ecrit en DEUX fonctions :
       `__pdpRevenirALOeuvre` : quitte la vue fixe (Papier, Detail) et rend le cadre ;
       `__persoQuitterDemos`  : retire les grands rendus de demo et garde le rail.
     Sur les HUIT endroits qui repondent a ce geste, UN SEUL appelait les deux : l'orientation.
     Les sept autres (mode texte, mise en page, couleur, police, encre, titre, sous-titre)
     n'appelaient que le second. Consequence exacte, celle de la capture d'Adrien : on clique
     « Papier », la scene prend la photo produit et PERD son cadre, c'est voulu ; on clique
     « Avec texte », les demos partent, la scene revient, mais `data-vue-fixe` est toujours la
     et le cadre ne revient jamais. Le client compose son texte sur une photo de papier.
     ⚠️ CE N'ETAIT PAS UN OUBLI ISOLE MAIS UNE FORME QUI L'APPELAIT : deux fonctions pour un
     geste obligent chaque nouvel appelant a se souvenir des deux. Il n'y en a plus qu'une, et
     les huit portes passent par elle. Ajouter un neuvième reglage demain ne pose plus la
     question. */
  window.__pdpMontrerLAffiche = function () {
    if (window.__pdpRevenirALOeuvre) window.__pdpRevenirALOeuvre();
    if (window.__persoQuitterDemos) window.__persoQuitterDemos();
  };
  var zoneVignettes = document.querySelector(".pdp-gallery") || thumbs;
  if (zoneVignettes) zoneVignettes.addEventListener("click", function (e) {
    var b = e.target.closest(".pdp-thumb"); if (!b) return;
    /* ⛔ ET LES RENDUS DE DEMO S'EFFACENT. Le cadre vit SOUS eux tant qu'aucune photo n'est
       posee : la vignette changeait bien son image, et on continuait de voir la demo. Le clic
       fonctionnait, il ne se voyait pas, ce qui revient au meme pour la cliente.
       Revenir sur une vignette de demo les rappelle, la boucle est fermee. */
    if (window.__persoQuitterDemos) window.__persoQuitterDemos();
    activateThumb(b);
    /* ⛔ ET L'IMAGE D'EXEMPLE S'EFFACE DEVANT UNE VUE QUI N'EST PAS L'AFFICHE. Tant qu'aucune
       photo n'est posee, `#pdp-placeholder` recouvre la scene : la vignette Papier changeait
       bien le fond de `#pdp-main`, et on continuait de voir les oranges par-dessus. Troisieme
       ecran successif entre le clic et l'oeil, apres le conteneur qui n'ecoutait plus et les
       rendus de demo. Papier et Detail ne montrent pas l'affiche du client, ils montrent notre
       papier : l'exemple n'a rien a y faire. */
    var cadreVue = document.querySelector(".pdp-gallery__wrap");
    if (cadreVue) {
      if (b.hasAttribute("data-fixe")) cadreVue.setAttribute("data-vue-fixe", "1");
      else cadreVue.removeAttribute("data-vue-fixe");
    }
  });


  if (zoneVignettes) zoneVignettes.addEventListener("pointerover", function (e) {
    if (e.pointerType !== "mouse" || e.buttons !== 0 || !window.matchMedia("(any-hover: hover)").matches) return;
    var b = e.target.closest(".pdp-thumb");
    if (!b || b.disabled || b.getAttribute("aria-pressed") === "true") return;
    if (e.relatedTarget && b.contains(e.relatedTarget)) return;
    b.click();
  });

  // Swipe galerie mobile : glisser horizontalement change de vue (affiche ↔ pièces).
  // Touch events = chemin Safari iOS. Pointer mouse = DevTools Chrome.
  // activateThumb (pas .click) car #pdp-thumbs est display:none sur mobile.
  // + bumper « peek » au chargement pour montrer qu'on peut swiper.
  var startGalleryNudge = null;
  var stopGalleryNudge = null;
  (function () {
    var stage = $("#pdp-stage"); if (!stage) return;
    var x0 = null, y0 = null, axis = null, active = false;
    var stopNudge = null, softNudge = null;

    function canSlide() {
      if (window.__pdpPerso && !photo && !persoUrl && !viewCustom) return false;
      /* Un glissement sur une photo cadrable la DÉPLACE : il ne doit pas, en plus, faire
         défiler la galerie. Les deux gestes sont le même sur un écran tactile. */
      if (window.__pdpPerso && photo && document.querySelector(".pdp-frame__inner.est-cadrable:not([hidden])")
          && !document.querySelector(".pdp-gallery__wrap[data-mockup='true']")) return false;
      return $$(".pdp-thumb").length >= 2;
    }
    function go(dx) {
      if (stopNudge) stopNudge();
      var all = $$(".pdp-thumb"); if (all.length < 2) return;
      var cur = all.indexOf($('.pdp-thumb[aria-pressed="true"]'));
      if (cur < 0) cur = 0;
      var next = dx < 0 ? cur + 1 : cur - 1;
      if (next < 0) next = all.length - 1;
      if (next >= all.length) next = 0;
      stage.setAttribute("data-swiping", "1");
      setTimeout(function () { stage.removeAttribute("data-swiping"); }, 450);
      activateThumb(all[next]);
    }
    function ignoreTarget(t) {
      return !!(t && t.closest && t.closest(".pdp-room-choice, .pdp-murs, .pdp-dots, .pdp-fleche"));
    }

    /* ⛔ LES DEUX FLECHES DE LA GALERIE MOBILE (Adrien, 23/08/2026, capture d'un concurrent :
       « ajoute des fleches comme ca a droite et gauche de la galerie mobile pour montrer qu'on
       peut slide »).
       ⚠️ ELLES SONT CONSTRUITES ICI, DANS LA PORTEE DE `go`, ET NON A COTE DES POINTS. `go`
       porte deja la seule regle qui dit ce qu'est la vue suivante, bouclage compris, et c'est
       elle que le doigt appelle. Une fleche qui recalculerait son index de son cote serait une
       deuxieme regle pour un seul geste : le jour ou l'ordre des vignettes change, les deux
       divergent sans que rien ne le signale. Le signe de `dx` est celui du doigt, donc
       negatif pour aller vers la suivante.
       ⚠️ `type="button"` : la scene vit dans le formulaire d'achat, et un bouton sans type y
       vaut « submit ». Une fleche aurait ajoute au panier.
       ⚠️ Le libelle n'est jamais peint : `aria-hidden` sur le trace, `aria-label` sur le
       bouton, dans la langue du marche. */
    (function fleches() {
      if ($$(".pdp-thumb").length < 2) return;
      var T = window.MURMURE_I18N || {};
      /* Trait fin et chevron large : c'est le dessin de la reference. A 26 px rendus, une
         epaisseur de 1,6 dans une boite de 24 peint 1,7 px, soit un trait net et leger. */
      var TRACE = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">'
        + '<path d="M15.5 4.5l-8 7.5 8 7.5" stroke="currentColor" stroke-width="1.6" '
        + 'stroke-linecap="round" stroke-linejoin="round"/></svg>';
      [["prec", T.galerie_prec || "", 1], ["suiv", T.galerie_suiv || "", -1]]
        .forEach(function (f) {
          var b = document.createElement("button");
          b.type = "button";
          b.className = "pdp-fleche pdp-fleche--" + f[0];
          if (f[1]) b.setAttribute("aria-label", f[1]);
          b.innerHTML = TRACE;
          b.addEventListener("click", function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            go(f[2]);
          });
          /* ⛔ ELLES VIVENT DANS L'ENVELOPPE, PAS DANS LA SCENE (Adrien, 24/08/2026 : « les
             fleches ne doivent pas etre au dessus de l'image »).
             Mesure sur la page servie, iPhone 390 px : la scene va de 16 a 374 et ROGNE
             (`overflow:hidden`), le cadre de 26 a 364. Il y a donc 26 px de marge entre le bord
             de l'ecran et l'oeuvre, et c'est la seule place disponible sans retrecir la galerie,
             ce qu'il a interdit. Une fleche posee dans la scene ne peut pas l'atteindre : elle
             serait coupee au bord. `.pdp-gallery__wrap` a exactement la meme boite, mais elle
             ne rogne pas, et elle est deja `position:relative` : un decalage negatif y sort du
             cadre sans sortir de la page. */
          (document.querySelector(".pdp-gallery__wrap") || stage).appendChild(b);
        });
    })();

    // Bumper périodique : glisse fluide et montre une partie de l'image suivante.
    // Mobile seulement, ≥2 vues, s'arrête dès le premier geste (touch / swipe / dot).
    /* ⛔ 768 ET NON 900, PARCE QUE LA FEUILLE DIT 768 (Adrien, 15/08/2026, capture d'un iPad
       Air : « sur tablette il y a l'effet pour signaler le scroll, ce qui n'a aucun sens car
       il y a les vignettes »). base.css eteint `.pdp-peek` et `.pdp-peek-voisin` des
       `min-width:768px`, avec la bonne raison ecrite a cote : quand la bande de vignettes est
       la, elle dit mieux que lui qu'on peut changer de vue. Mais CE seuil-ci etait reste a
       900 : entre 768 et 900, le voisin etait invisible et le cadre bougeait quand meme.
       L'affiche se decalait toute seule, sans rien montrer, a cote de six vignettes.
       ⚠️ DEUX PASSES QUI SE COMPLETENT DOIVENT COUVRIR LE MEME ENSEMBLE. Le peintre et le
       moteur sont deux moities du meme effet ; un seuil different entre eux ne produit pas
       une demi-animation, il produit une animation nue. `tests/bumper-seuil.test.js` les
       tient desormais egaux. */
    startGalleryNudge = function startSwipeNudge() {
      if (stopNudge) return;
      if (!window.matchMedia || !matchMedia("(max-width:767px)").matches) return;
      if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      if (!canSlide()) return;
      var INTERVAL_MS = 4200;
      var FIRST_MS = 700;
      /* ⛔ PLUS DE PLAFOND (Adrien, 08/08/2026 : « il continue a se manifester quoi qu'il
         arrive tant que la galerie n'a pas ete slidee »). L'ancien MAX = 5 l'eteignait au
         bout de vingt secondes, et le premier TOUCHER l'eteignait aussi, meme un simple
         defilement vertical qui passait sur la galerie. Desormais seul un VRAI glissement
         l'arrete : le geste horizontal, un point de navigation, ou go(). Un toucher ne fait
         qu'interrompre le cycle en cours, et il revient. */
      var SLIDE_MS = 550;
      var HOLD_MS = 480;
      var n = 0, timer = null, busy = false, peekEl = null, holdTimer = null, backTimer = null;

      function thumbBg(th) {
        if (!th) return "";
        if (th.getAttribute("data-mockup") === "true") {
          var room = th.querySelector(".pdp-thumb__room");
          if (room && room.style.backgroundImage) return room.style.backgroundImage;
        }
        var img = th.getAttribute("data-img");
        if (img) return "url('" + img + "')";
        return th.style.backgroundImage || "";
      }
      function removePeek() {
        if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
        if (backTimer) { clearTimeout(backTimer); backTimer = null; }
        if (peekEl && peekEl.parentNode) peekEl.parentNode.removeChild(peekEl);
        peekEl = null;
        /* Le clippeur s'en va avec son locataire : laisse en place, il resterait une boite
           absolue vide par-dessus l'affiche, invisible mais bien reelle. */
        var cl = document.querySelector("#pdp-stage .pdp-peek-clip");
        if (cl && cl.parentNode) cl.parentNode.removeChild(cl);
        // Le cadre est un élément RÉEL : s'il a été déplacé, il faut le remettre, sinon un
        // geste ou un changement de format en plein glissement le laisse décalé pour de bon.
        var f = $("#pdp-frame");
        if (f && f.style.transform) { f.style.transform = ""; f.style.transition = ""; }
      }
      function clear() {
        if (timer) { clearTimeout(timer); timer = null; }
        removePeek();
        busy = false;
        stopNudge = null;
      }
      stopNudge = clear;
      stopGalleryNudge = clear;
      softNudge = function () {
        if (!busy && !peekEl) return;
        removePeek();
        busy = false;
        if (timer) { clearTimeout(timer); timer = null; }
        schedule(INTERVAL_MS);
      };
      function schedule(delay) { timer = setTimeout(nudge, delay); }

      function nudge() {
        if (busy) { schedule(INTERVAL_MS); return; }
        if (!matchMedia("(max-width:767px)").matches || !canSlide()) { clear(); return; }
        var r = stage.getBoundingClientRect();
        if (r.bottom < 40 || r.top > (window.innerHeight || 0) - 40) {
          schedule(INTERVAL_MS);
          return;
        }
        var all = $$(".pdp-thumb");
        if (all.length < 2) { clear(); return; }
        var cur = all.indexOf($('.pdp-thumb[aria-pressed="true"]'));
        if (cur < 0) cur = 0;
        var next = cur + 1 < all.length ? cur + 1 : 0;
        var curBg = thumbBg(all[cur]);
        var nextBg = thumbBg(all[next]);
        // Vue affiche (pas mockup) : on préfère le visuel réel de la scène.
        var wrap = $(".pdp-gallery__wrap");
        var main = $("#pdp-main");
        if (wrap && wrap.getAttribute("data-mockup") !== "true" && main && main.style.backgroundImage) {
          curBg = main.style.backgroundImage;
        }
        if (!curBg || !nextBg) { schedule(INTERVAL_MS); return; }

        busy = true; n += 1;
        removePeek();

        /* ⛔ C'EST L'AFFICHE ENTIÈRE QUI GLISSE, PAS SON IMAGE.
           Deux versions ont été refusées avant celle-ci, pour la même raison de fond : le
           bumper redessinait l'affiche au lieu de la déplacer.
             - Couche pleine scène : elle recouvrait baguette, passe-partout et cotes, et
               reposait l'image brute en plein cadre. Le format choisi semblait annulé.
             - Couche dans `.pdp-frame__inner` : le cadre et les cotes restaient immobiles
               pendant que l'image glissait dedans, comme derrière une fenêtre.
           Ici rien n'est redessiné : `#pdp-frame` est décalé pour de vrai, et les cotes le
           suivent puisqu'elles sont ses enfants. Le bloc qui glisse fait donc exactement la
           hauteur de l'affiche, cotes comprises. Un seul élément est fabriqué : le VOISIN,
           posé à droite, qui porte la vue suivante et se déplace du même nombre de pixels.
           `#pdp-stage` est en `overflow:hidden`, il fait la fenêtre.
           En mockup le cadre est en `display:none` (la pièce EST la scène) : on retombe alors
           sur l'ancienne couche pleine scène, qui y est juste. */
        var wrapPeek = $(".pdp-gallery__wrap");
        var frame = $("#pdp-frame");
        var enCadre = frame && wrapPeek
          && wrapPeek.getAttribute("data-mockup") !== "true"
          && wrapPeek.getAttribute("data-framed") !== "false"
          && frame.getBoundingClientRect().width > 0;

        var glisse, retour;
        if (enCadre) {
          var rf = frame.getBoundingClientRect();
          var rs = stage.getBoundingClientRect();
          /* L'écart n'est pas un choix de goût, c'est la place de la COTE.
             Sans format choisi il n'y a rien à droite de l'affiche : les deux vues se touchent,
             et la bande claire qui traînait là était du vide gratuit, la première chose que
             l'oeil lisait pendant le glissement. Avec un format, la cote de hauteur est posée
             hors du cadre ; la vue suivante doit démarrer APRÈS elle, sinon elle lui passe
             dessus. On mesure donc son débord réel plutôt que de le supposer : elle bouge avec
             la taille de police et le palier d'écran. */
          var cote = $("#pdp-dim-h");
          var ecart = 0;
          if (cote && getComputedStyle(cote).display !== "none") {
            var rc = cote.getBoundingClientRect();
            if (rc.width > 0) ecart = Math.max(0, Math.round(rc.right - rf.right)) + 4;
          }
          var pas = Math.round(rf.width * 0.24);     // ce qu'on laisse voir du voisin
          var tr = "transform " + SLIDE_MS + "ms cubic-bezier(.22,.61,.36,1)";
          peekEl = document.createElement("div");
          peekEl.className = "pdp-peek-voisin";
          peekEl.setAttribute("aria-hidden", "true");
          peekEl.style.cssText = "position:absolute;z-index:2;pointer-events:none;"
            + "top:" + Math.round(rf.top - rs.top) + "px;"
            + "left:" + Math.round(rf.left - rs.left + rf.width + ecart) + "px;"
            + "width:" + Math.round(rf.width) + "px;height:" + Math.round(rf.height) + "px;"
            + "background:center/cover no-repeat;border-radius:2px;"
            + "box-shadow:0 24px 48px rgba(26,34,56,.22);transition:" + tr;
          peekEl.style.backgroundImage = nextBg;
          /* ⛔⛔ LE VOISIN VIT DANS SON PROPRE CLIPPEUR, PAS DANS LA SCENE (Adrien, 23/08/2026 :
             « quand on choisit format sur mesure, le contenu devient plus large que l'ecran et
             l'image galerie est decalee vers la gauche »).
             Il est pose UNE LARGEUR DE CADRE A DROITE du cadre : il ne tenait a l'ecran que
             grace a l'`overflow:hidden` de la scene. Or le format sur mesure pose
             `data-sized="true"`, et la feuille leve alors ce rognage pour que la cote de hauteur,
             tournee a 90 degres, ne soit pas coupee. Le voisin s'echappait donc : mesure en
             WebKit, iPhone 390 px, format 40x60 — le document passait a 694 px, soit 304 px de
             trop, pendant environ une seconde et demie.
             ⚠️ CHROMIUM NE LE MONTRE PAS. Trois balayages en Chromium (six largeurs, quatre
             formats) n'ont rien vu ; le meme banc en WebKit le voit du premier coup. C'est un
             defaut de MOTEUR, et il fallait l'instrument de l'appareil ou il vit.
             ⚠️ ET LE CLIPPEUR NE DEPEND DE PERSONNE. Le regler sur la scene reviendrait a
             rendre le rognage qu'on vient de lever, donc a recouper la cote ; le masquer sous
             `data-sized` retirerait l'affordance de glissement au format sur mesure. Une boite
             a lui, qui rogne toujours, ne coute rien et ne se defait pas. */
          var clip = stage.querySelector(".pdp-peek-clip");
          if (!clip) {
            clip = document.createElement("div");
            clip.className = "pdp-peek-clip";
            clip.setAttribute("aria-hidden", "true");
            stage.appendChild(clip);
          }
          clip.appendChild(peekEl);
          // La transition du cadre est posée en ligne : celle de la feuille ne couvre que
          // `border-color` et `width`, qu'on garde telles quelles.
          frame.style.transition = tr + ",border-color .3s ease,width .25s ease";
          glisse = function () {
            frame.style.transform = "translate3d(-" + pas + "px,0,0)";
            if (peekEl) peekEl.style.transform = "translate3d(-" + pas + "px,0,0)";
          };
          retour = function () {
            frame.style.transform = "translate3d(0,0,0)";
            if (peekEl) peekEl.style.transform = "translate3d(0,0,0)";
          };
        } else {
          peekEl = document.createElement("div");
          peekEl.className = "pdp-peek";
          peekEl.setAttribute("aria-hidden", "true");
          peekEl.innerHTML = '<div class="pdp-peek__track"><div class="pdp-peek__slide"></div><div class="pdp-peek__slide"></div></div>';
          var slides = peekEl.querySelectorAll(".pdp-peek__slide");
          slides[0].style.backgroundImage = curBg;
          slides[1].style.backgroundImage = nextBg;
          stage.appendChild(peekEl);
          glisse = function () { if (peekEl) peekEl.classList.add("is-out"); };
          retour = function () {
            if (!peekEl) return;
            peekEl.classList.add("is-hold");
            peekEl.classList.remove("is-out");
          };
        }

        // Double rAF : pose l'état initial avant d'enclencher la transition.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (!peekEl) return;
            glisse();
            holdTimer = setTimeout(function () {
              if (!peekEl) return;
              retour();
              backTimer = setTimeout(function () {
                removePeek();
                busy = false;
                schedule(INTERVAL_MS);
              }, SLIDE_MS + 40);
            }, SLIDE_MS + HOLD_MS);
          });
        });
      }
      schedule(FIRST_MS);
    };

    /* ⛔ ET IL S'ARRETE DES QU'ON DESCEND (Adrien, 23/08/2026 : « desactive le slider automatique
       quand on scrolle vers le bas »). Le bumper existe pour DIRE qu'on peut glisser, tant que le
       client regarde l'affiche. Des qu'il descend vers les options, il ne regarde plus : l'image
       qui se decale toute seule sous ses yeux pendant qu'il choisit une taille n'annonce plus
       rien, elle bouge. Et depuis que la galerie s'epingle, elle bouge SOUS SES YEUX pendant tout
       le choix, ce qui est pire.
       ⚠️ VERS LE BAS SEULEMENT, ET UNE SEULE FOIS. Un simple `scroll` s'ecouterait aussi au
       moindre rebond de la barre d'outils iOS, qui n'est pas un geste du client. On compare donc
       a la position precedente, et on exige un vrai deplacement. */
    (function arreterAuDefilement() {
      var precedent = window.pageYOffset || 0;
      function surDefilement() {
        var y = window.pageYOffset || 0;
        if (y > precedent + 24) {
          if (stopNudge) stopNudge();
          window.removeEventListener("scroll", surDefilement);
          return;
        }
        if (y < precedent) precedent = y;
      }
      window.addEventListener("scroll", surDefilement, { passive: true });
    })();

    /* ⛔ UN SEUL ESSAI AU CHARGEMENT NE SUFFIT PAS, et c'est ce qui tuait le bumper dans le
       navigateur integre de Meta (Adrien, 09/08/2026). `startSwipeNudge` abandonne en silence
       si l'une de ses conditions n'est pas remplie A CET INSTANT : largeur > 900 px, ou moins
       de deux vignettes. Or ces navigateurs ouvrent la page sous une barre d'outils qui se
       replie ensuite, la largeur utile n'est donc pas encore la bonne au moment ou le script
       tourne, et les vignettes peuvent arriver apres. Un seul appel, une seule chance, et un
       echec muet : le bumper ne partait jamais.
       ⚠️ ON REESSAIE SUR SIGNAL, PAS EN BOUCLE. Trois occasions : les premieres secondes,
       chaque changement de taille ou d'orientation, et le retour de l'onglet au premier plan
       (ces navigateurs le declenchent quand la vue de la publicite s'installe). Des que le
       bumper tourne, `stopNudge` est pose et `startSwipeNudge` sort de lui-meme : les essais
       suivants ne coutent rien et ne peuvent pas le lancer deux fois. */
    (function relancerTantQueCaNaPasPris() {
      /* ⛔⛔ LE BUMPER NE DEMARRE PLUS (Adrien, 29/08/2026 : « vire le bumper automatique »).
         Il glissait l'affiche toutes les 4,2 s pour montrer un bout de la vue suivante, jusqu'au
         premier vrai geste. Demande le 08/08/2026, retire le 29/08 : une image qui bouge toute
         seule sous les yeux de quelqu'un qui lit un prix est une gene, pas une aide.
         ⚠️ ON ETEINT AU LANCEUR, ET ON GARDE LA MECANIQUE. `stopNudge` reste nul, donc les huit
         appels `if (stopNudge) stopNudge()` semes dans le fichier deviennent muets sans qu'on
         ait a les retirer un par un — c'est justement en les retirant qu'on casserait le
         glissement, qui partage ces memes points d'entree. Un jour ou il le redemanderait,
         c'est cette ligne-ci qui saute, et rien d'autre.
         ⚠️ CE N'EST PAS LE GLISSEMENT. Le doigt fait toujours defiler la galerie, et les points
         de navigation sous l'affiche disent toujours combien de vues elle contient. */
      return;
      /* eslint-disable no-unreachable */
      var essais = 0;
      function tenter() {
        if (stopNudge) return true;      // deja lance
        startGalleryNudge();
        return !!stopNudge;
      }
      if (tenter()) return;
      var minuteur = setInterval(function () {
        essais += 1;
        if (tenter() || essais >= 12) clearInterval(minuteur);   // ~6 s au plus
      }, 500);
      ["resize", "orientationchange"].forEach(function (ev) {
        window.addEventListener(ev, tenter, { passive: true });
      });
      document.addEventListener("visibilitychange", function () {
        if (!document.hidden) tenter();
      });
    })();

    stage.addEventListener("touchstart", function (e) {
      if (!canSlide() || !e.touches || !e.touches[0]) return;
      if (ignoreTarget(e.target)) return;
      if (softNudge) softNudge();
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
      axis = null;
      active = true;
    }, { passive: true });
    stage.addEventListener("touchmove", function (e) {
      if (!active || x0 === null || !e.touches || !e.touches[0]) return;
      var dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
      if (axis === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        axis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
        /* Le geste est HORIZONTAL : la galerie est glissee, le bumper a fait son office. */
        if (axis === "x" && stopNudge) stopNudge();
      }
      if (axis === "x" && e.cancelable) e.preventDefault();
    }, { passive: false });
    stage.addEventListener("touchend", function (e) {
      if (!active || x0 === null) return;
      var t = e.changedTouches && e.changedTouches[0];
      var dx = t ? t.clientX - x0 : 0;
      var dy = t ? t.clientY - y0 : 0;
      var horizontal = axis === "x" || (axis === null && Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy));
      x0 = null; y0 = null; axis = null; active = false;
      if (!horizontal || Math.abs(dx) < 40) return;
      if (!canSlide()) return;
      go(dx);
    }, { passive: true });
    stage.addEventListener("touchcancel", function () {
      x0 = null; y0 = null; axis = null; active = false;
    }, { passive: true });

    stage.addEventListener("pointerdown", function (e) {
      if (e.pointerType !== "mouse") return;
      if (!canSlide() || e.button !== 0) return;
      if (ignoreTarget(e.target)) return;
      if (stopNudge) stopNudge();
      x0 = e.clientX; y0 = e.clientY; axis = null; active = true;
    });
    stage.addEventListener("pointermove", function (e) {
      if (e.pointerType !== "mouse" || !active || x0 === null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      if (axis === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        axis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
      }
    });
    stage.addEventListener("pointerup", function (e) {
      if (e.pointerType !== "mouse" || !active || x0 === null) return;
      var dx = e.clientX - x0;
      var dy = e.clientY - y0;
      var horizontal = axis === "x" || (axis === null && Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy));
      x0 = null; y0 = null; axis = null; active = false;
      if (!horizontal || Math.abs(dx) < 40) return;
      if (!canSlide()) return;
      go(dx);
    });
    stage.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest(".pdp-dot") && stopNudge) stopNudge();
    });

    /* ⛔ ET LE MEME GESTE AU TRACKPAD (Adrien, 19/08/2026 : « active le slider sur la galerie
     * desktop, typiquement sur mac quand on glisse sur l'image avec 2 doigts »). Deux doigts sur
     * un pave tactile ne produisent aucun `touch` : ils produisent des `wheel` avec un `deltaX`.
     * Le geste existait donc sur telephone et nulle part ailleurs.
     *
     * ⛔ TROIS PIEGES, ET AUCUN NE LEVE D'ERREUR :
     * 1. UN DEFILEMENT VERTICAL PORTE UN PEU DE deltaX. Sur un pave tactile, un geste vertical
     *    n'est jamais parfaitement vertical : comparer les deux axes sans marge ferait sauter la
     *    galerie pendant qu'on descend la page. D'ou le facteur 1,4 et le plancher de 3 px.
     * 2. LE NAVIGATEUR PREND UN GLISSEMENT HORIZONTAL POUR UN RETOUR EN ARRIERE. Sans
     *    `preventDefault`, le premier geste vers la droite quitte la fiche. On ne le previent
     *    qu'une fois l'axe reconnu : le prevenir plus tot bloquerait le defilement de la page.
     * 3. UN GESTE = UNE RAFALE D'EVENEMENTS, prolongee par l'inertie. Sans verrou, un seul
     *    glissement traverserait toute la galerie. On accumule jusqu'a un seuil, on avance
     *    d'une vue, puis on ignore tout jusqu'a une pause de 260 ms : c'est la fin de l'inertie
     *    qui arme le geste suivant, pas un delai fixe.
     *
     * ⚠️ SENS : glisser deux doigts vers la GAUCHE donne un deltaX POSITIF et veut dire « vue
     * suivante ». `go()` attend l'inverse, comme pour le doigt sur l'ecran, ou aller a gauche
     * donne un ecart negatif. Le signe s'inverse donc ici, une seule fois. */
    var rouleX = 0, rouleVerrou = false, rouleFin = null;
    stage.addEventListener("wheel", function (e) {
      if (!canSlide() || ignoreTarget(e.target)) return;
      var ax = Math.abs(e.deltaX), ay = Math.abs(e.deltaY);
      if (ax < 3 || ax <= ay * 1.4) return;
      e.preventDefault();
      if (stopNudge) stopNudge();
      clearTimeout(rouleFin);
      rouleFin = setTimeout(function () { rouleX = 0; rouleVerrou = false; }, 260);
      if (rouleVerrou) return;
      rouleX += e.deltaX;
      if (Math.abs(rouleX) < 55) return;
      var sens = rouleX > 0 ? -1 : 1;
      rouleX = 0;
      rouleVerrou = true;
      go(sens);
    }, { passive: false });
  })();

  // qty
  var qv = $("#pdp-qty");
  $("#pdp-inc") && $("#pdp-inc").addEventListener("click", function () { qty++; qv.textContent = qty; updatePrice(); });
  $("#pdp-dec") && $("#pdp-dec").addEventListener("click", function () { qty = Math.max(1, qty - 1); qv.textContent = qty; updatePrice(); });

  /* ---- Photo personnalisee ----
     Plus d'effet artistique ni d'appel de generation : la photo importee est
     posee directement dans le cadre et sur l'apercu mural. L'ancien flux imposait
     une attente artificielle de 40 a 80 secondes avant d'afficher une simple
     photo filtree en CSS, il n'y avait rien a calculer. */
  /* Le CTA sticky d'un produit personnalisable annonce l'etape reellement suivante :
     importer la photo tant qu'il n'y en a pas, ajouter au panier ensuite. */
  /* L'atelier rappelle ce calcul quand il arme son bouton : voir `armeCta()`. */
  window.__pdpSyncCta = function () { try { syncPersoCta(); } catch (e) {} };
  function syncPersoCta() {
    if (!window.__pdpPerso) return;
    /* Panneau : bienvenue et plan de table s'ajoutent sans photo, seul le type photo
       importe ; panneau-mariage.js tient les libelles des deux boutons. */
    if (window.__pdpPanneau) return;
    /* ⛔ ET LA PAGE NE GARDE PAS SON BLOC D'ACHAT EN DOUBLE quand la fenetre est le chemin
       (Adrien, 20/08/2026). Pose ici parce que cette fonction est deja rappelee a chaque
       changement de photo, et c'est la photo qui ouvre ou ferme ce chemin. */
    if (window.murAchatParModale) {
      /* ⛔ LE DRAPEAU NE DEPEND PAS DE LA PHOTO (Adrien, 20/08/2026 : « a l'etat "importer ma
         photo" il faut virer ca aussi »). Sans photo, le client gardait sous les yeux les
         formats, la quantite et « Choisissez une taille », alors que le seul geste attendu de
         lui est d'importer. Le BOUTON, lui, garde sa condition : sans photo il dit « Importer ma
         photo » et renvoie a l'import, il n'ouvre pas une fenetre sur du vide. */
      window.murAchatParModale(function () {
        return !!(window.murEstMobile && window.murEstMobile());
      });
    }
    /* ⚠️ `photo` ET `persoUrl` : la premiere est le fichier local, la seconde ce qui est deja
       monte. `.pdp--perso-has-photo` ne repondrait pas pour une photo restauree de session. */
    if (window.murPhotoPosee) {
      window.murPhotoPosee(function () { return !!(photo || persoUrl); });
    }
    /* ⛔ EN MODE TEXTE, AUCUNE PHOTO N'EST ATTENDUE. `layout=message` ouvre la fiche en mode
       texte, champs deja visibles, et pourtant le sticky annoncait « Importer ma photo » et
       sautait en boucle : il reclamait un fichier dont la composition n'a pas besoin. Meme
       faute que le panneau de bienvenue le 06/08/2026, au meme endroit, pour la meme raison :
       l'etape suivante etait deduite de `photo` seul, sans regarder ce que le client compose.
       La photo reste possible en mode texte, elle n'est simplement plus l'etape a annoncer. */
    var attendPhoto = !photo && !persoTextOn;
    var b = $("#pdp-sticky-add");
    if (b) {
      /* ⛔⛔ SUR TELEPHONE, LA BARRE DIT LE MEME MOT QUE LE CTA DE PAGE (Adrien, 23/08/2026,
         « plusieurs erreurs sur mobile »). Les deux boutons ouvrent DEJA la meme fenetre, le
         sticky relayant sur `#pdp-add` que l'atelier intercepte : seuls les mots divergeaient.
         Le client lisait « Creer mon affiche » en haut et « Importer ma photo » en bas, deux
         promesses pour un seul geste, dont l'une renvoyait au parcours d'avant la refonte.
         ⚠️ UN SEUL ENDROIT ECRIT CE LIBELLE, celui-ci : `armeCta()` rappelle cette fonction
         quand il pose `.pa-dispo`, plutot que d'ecrire le mot une seconde fois. Deux ecritures
         d'un meme libelle finissent toujours par diverger. */
      var ctaAtelier = document.getElementById("perso-atelier-cta");
      var motAtelier = (document.documentElement.classList.contains("pa-dispo")
        && ctaAtelier && !ctaAtelier.hidden) ? (ctaAtelier.textContent || "").trim() : "";
      /* ⛔ ET EN VUE LARGE, LE MEME MOT QUE LE CTA DE PAGE : « Cliquez sur une case pour
         importer » sur le collage, « une photo » sur l'affiche. Sans cela la barre epinglee
         disait encore « Importer ma photo », c'est-a-dire le parcours d'avant. Le mot se prend
         a la MEME source que le formateur de prix, jamais en relisant l'autre bouton : deux
         lectures croisees finissent par se recouvrir l'une l'autre. */
      var mots = document.getElementById("perso-atelier-mots");
      var motCase = mots && mots.getAttribute(
        document.querySelector(".pdp--pelemele") ? "data-case-dabord" : "data-photo-dabord");
      b.textContent = attendPhoto
        ? (motAtelier || motCase || b.getAttribute("data-label-perso") || b.textContent)
        : (b.getAttribute("data-label-add") || b.textContent);
    }
    /* ⛔⛔ ET LE CTA DE LA FICHE DIT LE GESTE QUI RESTE A FAIRE (Adrien, 23/08/2026 : « sur
       desktop quand aucune photo n'a ete importee, le CTA doit etre "cliquez sur une photo pour
       importer" »). Je ne l'avais fait que dans la fenetre plein ecran, c'est-a-dire sur
       telephone : en vue large il n'y a pas de fenetre, et le bouton continuait d'annoncer une
       taille a choisir alors que rien n'etait encore importe.
       ⚠️ LE MOT VIENT DU GABARIT, comme les onze autres de l'atelier : `#perso-atelier-mots` est
       rendu sur les fiches personnalisees quelle que soit la largeur, donc la traduction est la.
       ⚠️ ET ON NE TOUCHE AU LIBELLE QUE TANT QU'IL MANQUE UNE PHOTO : des qu'elle arrive, le
       bouton reprend celui que `product.js` calcule avec le prix, sans qu'on ait rien memorise. */
    /* ⚠️ LE LIBELLE DU BOUTON DE PAGE N'EST PLUS ECRIT ICI. Je l'y avais pose, et le formateur de
       prix — qui s'execute a chaque changement de variante — le recouvrait aussitot. Il vit
       desormais a UN seul endroit, celui qui ecrit deja ce mot. Deux ecritures pour un meme
       libelle, c'est toujours la seconde qui gagne, et jamais celle qu'on croit. */
    // Depot en cours : l'ajout au panier attend, sinon la ligne partirait sans son URL.
    var a = $("#pdp-add");
    /* ⛔ « IL MANQUE LA PHOTO » SE POSE ICI, PAS DANS UNE CLASSE DE RACINE.
       Le rebond du CTA s'appuyait d'abord sur `.pdp--perso-has-photo`, qui n'est posee qu'a un
       import REEL : au retour de session la photo est restauree sans elle, et le bouton
       rebondissait devant un client qui avait deja donne son fichier (constate en production le
       08/08/2026). `photo` est la seule verite, et c'est cette fonction qui la tient, la meme
       qui choisit deja le libelle. Un seul endroit decide, l'attribut le dit au CSS.
       ⚠️ Le panneau sort plus haut par `return` : il n'aura donc jamais l'attribut, et c'est
       voulu, sa composition se fait au clavier sans fichier a fournir. */
    [a, b].forEach(function (el) {
      if (!el) return;
      el.disabled = !!persoUploading;
      el.style.opacity = persoUploading ? ".6" : "";
      el.style.cursor = persoUploading ? "progress" : "";
      /* ⛔ LE REBOND N'APPARTIENT QU'AU BOUTON QUI INVITE A DEPOSER LA PHOTO.
         Il etait pose sur les DEUX boutons des que `photo` etait vide. Or `#pdp-add`, sur une
         affiche personnalisee, est toujours libelle « Ajouter au panier · 21,30 € » : il
         n'a pas de `data-label-perso`, seul le sticky en a un. Le client voyait donc sauter un
         bouton d'ACHAT qui, une fois clique, refusait et le renvoyait plus haut vers la zone
         de depot. Un rebond promet un geste ; celui-la promettait le mauvais.
         Effet de bord voulu : en mode TEXTE SEUL, ou aucune photo n'est attendue, plus rien ne
         saute nulle part, parce que le sticky y porte deja son libelle d'achat.
         (Adrien, 13/08/2026 : « le CTA doit rebondir uniquement quand aucune photo n'a ete
         importee, pas quand on est sur add to cart ».) */
      var invite = attendPhoto && !!el.getAttribute("data-label-perso");
      if (invite) el.setAttribute("data-attend-photo", "1");
      else el.removeAttribute("data-attend-photo");
    });
  }
  /* ⛔ UNE BOITE NULLE N'EST PAS UNE CIBLE, ET NE LEVE AUCUNE ERREUR. Mesure du 23/08/2026 en vue
     large sur `affiche-personnalisee` : `#pdp-placeholder` rend 0 x 0 et `#pdp-stage` est en
     `display:none` tant que rien n'est importe — avant l'import, la colonne montre `#perso-demos`,
     pas le cadre. La classe se posait donc sur du vide, l'animation tournait sur une boite sans
     surface, et il ne restait a l'ecran que l'anneau du bouton. On MESURE avant de designer, et
     on ne compte comme designe que ce qui a une surface.

     ⛔ ET PAS DE `requestAnimationFrame` : un onglet occulte par une fenetre native voit ses rAF
     suspendus, et la classe n'arrive qu'apres le retrait programme. Le clignotement ne clignote
     alors jamais, sans rien dans la console. Lire `offsetWidth` relance l'animation tout de
     suite, sans dependre d'une image a venir. */
  function clignote(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 8 || r.height < 8) return false;
    el.classList.remove("pdp-upload--ask");
    void el.offsetWidth;
    el.classList.add("pdp-upload--ask");
    setTimeout(function () { el.classList.remove("pdp-upload--ask"); }, 1600);
    return true;
  }
  function askPhoto() {
    if (!window.__pdpPeleMele && !window.__pdpPanneau) {
      var fichier = $("#pdp-file");
      if (fichier) { fichier.click(); return; }
    }
    /* ⛔ LA CASE DE L'AFFICHE CLIGNOTE AUSSI, pas seulement la zone de depot : c'est SUR ELLE
       qu'on clique pour importer, et c'est elle que le client regarde. Meme classe que le bloc
       des tailles sur les fiches du catalogue, pour que le geste se reconnaisse d'une page a
       l'autre. Trois cibles possibles selon l'etat de la fiche, une seule a une surface a la
       fois : le placeholder du cadre, la scene, ou le rendu de demo affiche avant tout import. */
    ["#pdp-placeholder", "#pdp-stage", ".perso-demos__rendu[data-actif]"].forEach(function (sel) {
      clignote($(sel));
    });
    var z = $("#pdp-upload") || $("#pdp-placeholder"); if (!z) return;
    z.scrollIntoView({ behavior: "smooth", block: "center" });
    clignote(z);
  }
  /* Le geste dépend de l'appareil : un écran tactile n'a ni molette ni double-clic, une souris
     ne pince pas. Décrire les deux, ou décrire celui que l'appareil ne sait pas faire, c'est
     donner une consigne fausse à la moitié des clients. `pointer: coarse` sans survol, c'est
     le doigt ; tout le reste reçoit la formulation à la souris. */
  function aideCadreSelonAppareil() {
    var el = document.querySelector("[data-pdp-cadre-aide]");
    if (!el) return;
    var tactile = false;
    try {
      tactile = window.matchMedia("(hover: none) and (pointer: coarse)").matches;
    } catch (e) { tactile = "ontouchstart" in window; }
    var t = el.getAttribute(tactile ? "data-aide-tactile" : "data-aide-souris");
    if (t) el.textContent = t;
  }
  function syncCropControls() {
    /* ⛔ Sur le pele-mele, l'aide et le curseur de cadrage appartiennent a
       pele-mele.js (c'est LUI qui tient les photos ; `photo` reste null ici).
       Sans cette porte, le moindre passage par ici rehabille la fiche en « sans
       photo » et fait disparaitre l'aide epinglee (Adrien, 03/08/2026). */
    if (window.__pdpPeleMele || window.__pdpPanneau) return;
    var hasPhoto = !!photo && window.__pdpPerso;
    /* Le mode d'emploi n'a de sens qu'une fois la photo posée : avant, il n'y a rien à cadrer. */
    var aide = document.querySelector("[data-pdp-cadre-aide]");
    if (aide) aide.hidden = !hasPhoto;
    var inner = document.querySelector(".pdp-frame__inner");
    if (inner) inner.classList.toggle("est-cadrable", hasPhoto);
  }

  /* Le texte reste sous l'image tant qu'il y a une photo : il ne recouvre plus rien, donc rien
     ne justifie de le faire disparaître. Il s'effaçait après six secondes, et celui qui
     revenait sur sa fiche plus tard ne savait plus qu'il pouvait cadrer. */
  function montrerAideCadre() {
    aideCadreSelonAppareil();
    syncCropControls();
  }
  function applyPersoCrop(opts) {
    if (!window.__pdpPerso) return;
    persoCrop.x = clampPct(persoCrop.x);
    persoCrop.y = clampPct(persoCrop.y);
    persoPrintKey = "";
    persoCrop.z = clampZoom(persoCrop.z);
    var pos = persoCropPosition();
    var taille = persoCoverPct();
    var css = taille.auto ? "cover" : taille.w.toFixed(2) + "% " + taille.h.toFixed(2) + "%";
    var root = document.querySelector(".pdp--perso") || document.documentElement;
    root.style.setProperty("--perso-crop-x", persoCrop.x + "%");
    root.style.setProperty("--perso-crop-y", persoCrop.y + "%");
    root.style.setProperty("--perso-crop-z", String(persoCrop.z));
    ["#pdp-main", "#pdp-mockup-art", "#pdp-photo-thumb", '.pdp-thumb[data-solo="true"]'].forEach(function (sel) {
      var el = $(sel);
      if (!el) return;
      /* ⛔⛔ LA MARGE BLANCHE EST DEJA UNE TAILLE DE FOND (Adrien, 23/08/2026). Quand une bordure
         est posee, `bordure-blanche.js` a ecrit sur cette meme propriete la part de feuille que
         l'image occupe, zoom compris : la recouvrir par notre « cover » ferait deborder la photo
         par-dessus sa propre marge, c'est-a-dire montrer autre chose que ce qui sera imprime.
         On ne touche alors qu'a la POSITION, qui reste notre affaire, et on lui redemande sa
         taille a lui : un seul calcul par propriete, et c'est celui qui connait la marge. */
      if (el.getAttribute("data-bordure") === "avec") {
        el.style.backgroundPosition = pos;
        if (window.AfBordure && typeof window.AfBordure.tailleFond === "function") {
          var t = window.AfBordure.tailleFond();
          if (t) el.style.backgroundSize = t;
        }
        return;
      }
      el.style.backgroundPosition = pos; el.style.backgroundSize = css;
    });
    $$(".pdp-thumb__poster").forEach(function (el) {
      el.style.backgroundPosition = pos; el.style.backgroundSize = css;
    });
    syncCropControls();
    /* Le zoom change ce qui sera imprimé : l'indicateur de qualité doit suivre le geste, pas
       attendre un rechargement. C'est même le seul moment où il apprend quelque chose. */
    syncPersoQc();
    if (!opts || opts.persist !== false) persistPersoSession();
  }
  /* ⛔ DEUX POIGNEES POUR `bordure-blanche.js`, ET RIEN DE PLUS. Il a besoin du zoom et de la
     position pour ne pas les ecraser en posant la marge blanche ; il n'a pas a savoir comment
     ils se calculent, ni sur quelle zone ils portent. Hors fiche personnalisee elles rendent
     leur valeur neutre, et ce fichier se comporte comme avant.
     ⚠️ `__pdpAppliqueCadrage` NE PERSISTE PAS : elle est appelee pendant une repeinture, pas
     apres un geste du client, et ecrire la session a chaque repeinture ferait de l'etat une
     consequence de l'affichage. */
  window.__pdpZoomPhoto = function () {
    return (window.__pdpPerso && photo) ? clampZoom(persoCrop.z) : 1;
  };
  window.__pdpPositionPhoto = function () {
    return (window.__pdpPerso && photo) ? persoCropPosition() : "";
  };
  window.__pdpAppliqueCadrage = function () {
    if (!window.__pdpPerso || !photo) return;
    applyPersoCrop({ persist: false });
  };
  function setPersoCrop(x, y, z, opts) {
    persoCrop.x = clampPct(x);
    persoCrop.y = clampPct(y);
    if (z !== undefined && z !== null) persoCrop.z = clampZoom(z);
    applyPersoCrop(opts);
  }
  function resetPersoCrop(opts) {
    setPersoCrop(50, 50, 1, opts);
  }
  function bindPersoCropControls() {
    if (!window.__pdpPerso) return;
    /* Recentrer sans bouton : le double-clic, ou le double-tap, qui est le geste que tout le
       monde essaie déjà sur une image qu'on vient de déplacer. */
    var inner0 = document.querySelector(".pdp-frame__inner");
    if (inner0) inner0.addEventListener("dblclick", function (e) {
      if (!photo || !window.__pdpPerso) return;
      e.preventDefault(); e.stopPropagation();
      resetPersoCrop();
    });

    /* Le clavier fait tout ce que fait le doigt. C'est ce que les trois curseurs assuraient
       sans le dire, et c'est la seule chose qu'il fallait leur reprendre proprement. */
    var inner = document.querySelector(".pdp-frame__inner");
    if (inner) {
      inner.setAttribute("tabindex", "0");
      inner.addEventListener("keydown", function (e) {
        if (!photo || !window.__pdpPerso) return;
        var pas = e.shiftKey ? 10 : 3;
        var k = e.key;
        if (k === "ArrowLeft") setPersoCrop(persoCrop.x - pas, persoCrop.y);
        else if (k === "ArrowRight") setPersoCrop(persoCrop.x + pas, persoCrop.y);
        else if (k === "ArrowUp") setPersoCrop(persoCrop.x, persoCrop.y - pas);
        else if (k === "ArrowDown") setPersoCrop(persoCrop.x, persoCrop.y + pas);
        else if (k === "+" || k === "=") setPersoCrop(persoCrop.x, persoCrop.y, persoCrop.z * 1.25);
        else if (k === "-" || k === "_") setPersoCrop(persoCrop.x, persoCrop.y, persoCrop.z / 1.25);
        else return;
        e.preventDefault();
      });
    }

    var drag = null;
    function dragTarget(el) {
      return el && (el.closest("#pdp-main") || el.closest("#pdp-mockup-art"));
    }
    document.addEventListener("pointerdown", function (e) {
      if (!photo || !window.__pdpPerso || !dragTarget(e.target)) return;
      var t = dragTarget(e.target);
      var r = t.getBoundingClientRect();
      if (!r.width || !r.height) return;
      drag = { id: e.pointerId, sx: e.clientX, sy: e.clientY, x: persoCrop.x, y: persoCrop.y, w: r.width, h: r.height, target: t };
      try { t.setPointerCapture(e.pointerId); } catch (err) {}
      t.classList.add("is-cropping");
      e.preventDefault();
    });
    document.addEventListener("pointermove", function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      setPersoCrop(drag.x - ((e.clientX - drag.sx) / drag.w) * 100, drag.y - ((e.clientY - drag.sy) / drag.h) * 100);
    });
    ["pointerup", "pointercancel"].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        if (pinch.a && (e.pointerId === pinch.a.id || (pinch.b && e.pointerId === pinch.b.id))) finPincement();
        if (!drag || e.pointerId !== drag.id) return;
        if (drag.target) drag.target.classList.remove("is-cropping");
        drag = null;
      });
    });

    /* ⛔ TROIS GESTES POUR UN SEUL RÉGLAGE, parce qu'aucun n'est disponible partout : la molette
       n'existe pas sur un téléphone, le pincement n'existe pas sur un ordinateur sans écran
       tactile, et les curseurs sont les seuls à fonctionner au clavier. Le client n'a pas à
       deviner lequel il a : les trois écrivent dans le même état. */
    document.addEventListener("wheel", function (e) {
      if (!photo || !window.__pdpPerso || !dragTarget(e.target)) return;
      e.preventDefault();
      setPersoCrop(persoCrop.x, persoCrop.y, persoCrop.z * (e.deltaY < 0 ? 1.08 : 1 / 1.08));
    }, { passive: false });

    var pinch = { a: null, b: null, d0: 0, z0: 1 };
    function ecart() {
      var dx = pinch.a.x - pinch.b.x, dy = pinch.a.y - pinch.b.y;
      return Math.sqrt(dx * dx + dy * dy);
    }
    function finPincement() { pinch.a = null; pinch.b = null; }
    document.addEventListener("pointerdown", function (e) {
      if (!photo || !window.__pdpPerso || !dragTarget(e.target) || e.pointerType === "mouse") return;
      var pt = { id: e.pointerId, x: e.clientX, y: e.clientY };
      if (!pinch.a) { pinch.a = pt; return; }
      if (!pinch.b && e.pointerId !== pinch.a.id) {
        pinch.b = pt; pinch.d0 = ecart(); pinch.z0 = persoCrop.z;
        /* Deux doigts posés : ce n'est plus un déplacement, sinon l'image partirait de travers
           pendant qu'on l'agrandit. */
        if (drag) { if (drag.target) drag.target.classList.remove("is-cropping"); drag = null; }
      }
    });
    document.addEventListener("pointermove", function (e) {
      if (!pinch.a || !pinch.b) return;
      if (e.pointerId === pinch.a.id) { pinch.a.x = e.clientX; pinch.a.y = e.clientY; }
      else if (e.pointerId === pinch.b.id) { pinch.b.x = e.clientX; pinch.b.y = e.clientY; }
      else return;
      if (pinch.d0 > 0) setPersoCrop(persoCrop.x, persoCrop.y, pinch.z0 * (ecart() / pinch.d0));
    });
  }
  function setPhoto(url) {
    photo = url; viewCustom = true;
    syncPersoCta();
    var up = $("#pdp-upload"), blk = $("#pdp-photo-block"), th = $("#pdp-photo-thumb");
    if (up) up.style.display = "none";
    if (blk) blk.hidden = false;
    if (th) th.style.backgroundImage = "url(" + url + ")";
    var ph = $("#pdp-placeholder");
    if (ph) ph.hidden = true;
    // le cadre de la fiche
    var m = $("#pdp-main");
    if (m) {
      m.style.backgroundImage = "url(" + url + ")"; m.style.filter = "none";
      /* ⛔ ET SON `data-zoom`. C'était le dernier endroit où la DÉMONSTRATION du produit
         survivait à l'import : le fond passait à la photo du client, l'attribut restait sur le
         fjord en 1800 px, et l'agrandissement le ressortait. Toutes les autres vignettes
         voyaient leur `data-zoom` réécrit, celle-ci avait été oubliée (relevé le 01/08/2026). */
      m.setAttribute("data-zoom", url);
    }
    /* ⛔ ET L'IMAGE DU PLEIN ÉCRAN. Le liquid lui écrit le média du produit au rendu de la
       page : sur la fiche perso, ce média est la DÉMONSTRATION. `open()` la remplace bien,
       mais tant qu'il n'a pas tourné l'élément porte le visuel de démonstration dans le DOM,
       et tout ce qui rend cette couche visible avant un ouvrir/fermer le montre au client.
       C'était le dernier endroit où la démonstration survivait à l'import (01/08/2026). */
    var zi = $("#pdp-zoom-img");
    if (zi) { zi.src = url; zi.setAttribute("data-perso", "1"); }
    // et l'affiche de la mise en situation, pour que « Sur votre mur » suive.
    // data-example marque l'affiche d'exemple estompee : la photo du client la remplace.
    var mp = $("#pdp-mockup-art");
    if (mp) { mp.style.backgroundImage = "url(" + url + ")"; mp.removeAttribute("data-example"); }
    // Vignette « Encadrée » (affiche seule) + zoom.
    var solo = $('.pdp-thumb[data-solo="true"]');
    if (solo) {
      solo.setAttribute("data-img", url);
      solo.setAttribute("data-zoom", url);
      solo.style.backgroundImage = "url(" + url + ")";
    }
    // les vignettes pointent encore sur le visuel d'origine : on les resynchronise
    /* ⛔ SAUF CELLES QUI NE SONT PAS L'OEUVRE. `data-fixe` marque les deux gros plans de papier
       (qual-01 « Papier », qual-03 « Detail »), identiques sur toutes les fiches : ils montrent
       la MATIERE, pas l'affiche. Ils recevaient la photo du client comme les autres, si bien que
       la fiche personnalisee perdait les deux seules images qui parlent de qualite d'impression
       et affichait, sous le mot « Papier », un gros plan d'oranges (Adrien, 08/08/2026).
       Le marqueur vient du liquid, ou le nom de fichier est connu : voir main-product.liquid. */
    $$("#pdp-thumbs .pdp-thumb").forEach(function (b) {
      if (b.getAttribute("data-fixe") === "true") return;
      if (b.hasAttribute("data-img") && b.getAttribute("data-mockup") !== "true") {
        b.setAttribute("data-img", url); b.setAttribute("data-zoom", url);
        /* ⛔ ET SON FOND. Le liquid pose l'image du produit en style INLINE sur ces vignettes.
           Seuls les attributs etaient reecrits : la vignette « Encadree » continuait donc
           d'afficher la demonstration alors qu'elle pointait deja sur la photo du client.
           Un attribut mis a jour sans le pixel qu'il represente, ca ne se voit pas au code. */
        b.style.backgroundImage = "url(" + url + ")";
      }
    });
    // Une vignette de piece par decor : les mettre toutes a jour, pas seulement la premiere.
    $$(".pdp-thumb__poster").forEach(function (room) {
      room.style.backgroundImage = "url(" + url + ")";
      room.removeAttribute("data-example");
    });
    // Comme les autres PDP : rester sur l'affiche seule ; le slider (pièces) apparaît.
    var persoRoot = document.querySelector(".pdp--perso");
    if (persoRoot) persoRoot.classList.add("pdp--perso-has-photo");
    planifierRecentPerso();
    setMockup(false);
    setFrameVisible(true);
    /* ⛔ ET ON REVIENT A L'OEUVRE. Si le client regardait Papier ou Detail au moment d'importer,
       la scene restait sur la photo produit et il ne voyait pas la sienne (Adrien, 08/08/2026 :
       « ca affiche la mauvaise image quand on importe une photo »). Poser une photo veut dire
       « montre-la moi » : la vue de l'oeuvre revient d'abord. */
    if (window.__pdpRevenirALOeuvre) window.__pdpRevenirALOeuvre();
    /* Papier et Detail rentrent dans la bande : la photo du client est la, la bande complete
       s'affiche, et ces deux vignettes-la n'ont plus rien a faire dans le rail des demos. */
    (function rendreLesVignettesFixes() {
      var bande = document.getElementById("pdp-thumbs");
      var railDemo = document.querySelector(".perso-demos__rail");
      if (!bande || !railDemo) return;
      Array.prototype.forEach.call(
        railDemo.querySelectorAll(".pdp-thumb-item[data-fixe]"),
        function (it) { bande.appendChild(it); }
      );
    })();
    /* Le cadre vient d'apparaitre : l'arret de l'epingle se mesure sur lui, il faut le
       reprendre. `__pdpMajBande` n'etait appelee de nulle part : la page gardait la mesure
       faite a l'arrivee, quand l'affiche n'existait pas encore. */
    if (typeof window.__pdpMajBande === "function") window.__pdpMajBande();
    if (typeof startGalleryNudge === "function") startGalleryNudge();
    if (solo) {
      $$(".pdp-thumb").forEach(function (x) {
        var on = x === solo;
        x.setAttribute("aria-pressed", on ? "true" : "false");
        x.style.borderColor = on ? "var(--copper)" : "#D6CAB2";
      });
      syncDots(solo);
    }
    applyPersoCrop({ persist: false });
    syncPersoTextPreview();
    measurePersoPixels(url);
    montrerAideCadre();
  }

  /* ---- Persistance photo (survit au refresh de la fiche) ---- */
  function persoStoreKey() {
    return "murmure-perso:" + String(location.pathname || "/products/affiche-personnalisee");
  }
  function persistPersoSession() {
    if (!window.__pdpPerso) return;
    var url = persoUrl || persoPreview;
    if (!url || String(url).indexOf("blob:") === 0) return;
    try {
      sessionStorage.setItem(persoStoreKey(), JSON.stringify({
        url: persoUrl || url,
        preview: persoPreview || url,
        source: persoSourceUrl || persoPreview || persoUrl || url,
        crop: { x: clampPct(persoCrop.x), y: clampPct(persoCrop.y), z: clampZoom(persoCrop.z) },
        ts: Date.now()
      }));
    } catch (e) {}
  }
  function clearPersoSession() {
    try { sessionStorage.removeItem(persoStoreKey()); } catch (e) {}
  }
  /* ---- Persistance du texte (même session que la photo) ----
     La photo survivait au refresh mais pas le titre / sous-titre : on repartait
     d'une bande vide alors que l'image était toujours là. */
  function persoTextStoreKey() { return persoStoreKey() + ":text"; }
  /* ⛔ RIEN NE S'ÉCRIT EN SESSION AVANT D'AVOIR TENTÉ DE LA RELIRE.
   *
   * `persistPersoTextSession` EFFACE la clé quand le texte est éteint. Au chargement, restaurer
   * la photo repose la bande, donc déclenche un persist, alors que `persoTextOn` est encore
   * faux : le titre, le sous-titre et la police enregistrés étaient effacés une fraction de
   * seconde avant qu'on aille les relire. Le client retrouvait sa photo et perdait son texte.
   *
   * Le défaut ne se voyait QU'AVEC une photo : sans elle, `restorePersoSession` s'arrête avant
   * de reposer quoi que ce soit, aucun persist ne part, et le texte revenait correctement. */
  var persoSessionRelue = false;
  function persistPersoTextSession() {
    if (!window.__pdpPerso || !persoSessionRelue) return;
    try {
      if (!persoTextOn) { sessionStorage.removeItem(persoTextStoreKey()); return; }
      var titleIn = $("#perso-text-title"), subIn = $("#perso-text-sub");
      sessionStorage.setItem(persoTextStoreKey(), JSON.stringify({
        on: true,
        /* ⛔ L'OEIL COUPE LE TEXTE ICI, ET NULLE PART AILLEURS (Adrien, 15/08/2026 : « certains
           clients ne veulent pas tous les textes »). Ce payload est le point UNIQUE par lequel
           les deux textes partent : l'apercu comme le fichier d'impression le lisent. Masquer
           plus haut, dans le dessin, laisserait le texte partir au tirage — un texte cache a
           l'ecran mais imprime est pire que pas de bouton du tout.
           ⚠️ LE CHAMP N'EST PAS VIDE POUR AUTANT : l'etat vit sur `aria-pressed` du bouton, donc
           le client retrouve son texte en le reaffichant. */
        title: persoTextTitle(),
        sub: persoTextSub(),
        ink: persoInkTitre,
        inkSous: persoInkSous,
        design: persoTextDesign,
        color: persoTextColor,
        font: persoFont,
        ts: Date.now()
      }));
    } catch (e) {}
  }
  /* Le drapeau se lève QUOI QU'IL ARRIVE, y compris quand il n'y avait rien à relire : sans
     cela, un client qui n'a jamais rien enregistré ne pourrait plus rien enregistrer. */
  function restorePersoTextSession() {
    try { restaurerTexteDepuisSession(); } finally { persoSessionRelue = true; }
    /* Réécrit ce qu'on vient de relire : la fenêtre de 48 h repart de cette visite, sinon un
       client qui revient chaque jour verrait son texte expirer sans y avoir touché. */
    if (persoTextOn) persistPersoTextSession();
  }
  function restaurerTexteDepuisSession() {
    if (!window.__pdpPerso) return;
    var data = null;
    try { data = JSON.parse(sessionStorage.getItem(persoTextStoreKey()) || "null"); } catch (e) { return; }
    if (!data || !data.on) return;
    // Même fenêtre que la photo : au-delà, le dépôt n'est plus garanti.
    if (data.ts && (Date.now() - data.ts) > 48 * 3600 * 1000) {
      try { sessionStorage.removeItem(persoTextStoreKey()); } catch (e) {}
      return;
    }
    var titleIn = $("#perso-text-title"), subIn = $("#perso-text-sub");
    if (titleIn) titleIn.value = data.title || "";
    if (subIn) subIn.value = data.sub || "";
    if (data.ink !== undefined) setPersoTextInk(data.ink, "titre");
    if (data.inkSous !== undefined) setPersoTextInk(data.inkSous, "sous");
    if (data.design) setPersoTextDesign(data.design);
    /* Un texte deja saisi rouvre le bloc replie : le client retrouve son travail visible.
       Et la galerie de demos s'efface : la scene live doit montrer SON texte, pas nos
       exemples (galerieDemos lit ce drapeau, elle s'initialise apres). */
    if (data.title || data.sub) {
      /* Sur mobile le bloc reste replie meme avec un texte retrouve : l'ecran est trop
         court pour l'ouvrir d'office (Adrien, 02/08/2026). Desktop garde l'ouverture. */
      if (!window.matchMedia("(max-width:900px)").matches) {
        var plier = $("#perso-text-plier"); if (plier) plier.open = true;
      }
      window.__persoSessionTexte = true;
    }
    if (data.color) setPersoTextColor(data.color);
    if (data.font) setPersoFont(data.font);
    setPersoTextMode(true);
  }
  function restorePersoSession() {
    if (!window.__pdpPerso || photo || persoUrl) return;
    try {
      var raw = sessionStorage.getItem(persoStoreKey());
      if (!raw) return;
      var data = JSON.parse(raw);
      if (!data || !(data.preview || data.url)) return;
      // Retirer uniquement la photo de recette laissee dans cette session le 30/10.
      // Les fichiers importes par les clients conservent leur restauration habituelle.
      if (window.__pdpPersoMetal && /\/custom_20261030130152\.png(?:\?|$)/.test(data.source || data.preview || data.url)) {
        clearPersoSession();
        return;
      }
      // Expire après 48 h : le dépôt MinIO n'est pas une bibliothèque permanente.
      if (data.ts && (Date.now() - data.ts) > 48 * 3600 * 1000) {
        clearPersoSession();
        return;
      }
      persoUrl = data.url || data.preview;
      persoPreview = data.preview || data.url;
      persoSourceUrl = data.source || persoPreview || persoUrl;
      if (data.crop && (data.crop.x !== undefined || data.crop.y !== undefined)) {
        persoCrop.x = clampPct(data.crop.x);
        persoCrop.y = clampPct(data.crop.y);
        persoCrop.z = clampZoom(data.crop.z);
      }
      setPhoto(persoPreview || persoUrl);
    } catch (e) {}
  }

  /* ---- Contrôle qualité (DPI vs format) ---- */
  var persoPx = { w: 0, h: 0 };
  var QC_ORDER = ["21X30", "30X40", "50X70", "70X100"];
  var QC_KEYS = { 1: "faible", 2: "ok", 3: "bon", 4: "excellent" };
  function qcDpiFor(cm, pxW, pxH) {
    if (!cm || !pxW || !pxH) return 0;
    // Photo en cover sur le format : densité limitée par le côté le plus contraignant.
    var dpiW = pxW / (cm[0] / 2.54);
    var dpiH = pxH / (cm[1] / 2.54);
    return Math.min(dpiW, dpiH);
  }

  /* ⛔ LE CONTRÔLE QUALITÉ COMPTE CE QUI SERA IMPRIMÉ, PAS CE QUI A ÉTÉ IMPORTÉ.
   *
   * Il mesurait le fichier d'origine contre le format entier. Deux erreurs opposées, et
   * personne ne les voyait :
   *   un zoom à 2 n'imprime qu'un quart des pixels, et l'indicateur annonçait toujours la
   *   pleine résolution : il promettait « Excellent » sur un tirage qui sortirait flou ;
   *   à l'inverse, sous un passe-partout la photo n'occupe que 90 % de la largeur et les deux
   *   tiers de la hauteur, donc elle est imprimée PLUS PETITE et plus dense, l'indicateur
   *   était alors pessimiste et décourageait une commande qui aurait été bonne.
   * On compte donc les pixels de la zone retenue, sur les centimètres de la zone photo. */
  function qcPixelsImprimes() {
    if (!persoPx.w || !persoPx.h) return null;
    return zoneRetenue(persoPx.w, persoPx.h);
  }
  function qcZoneCm(cm) {
    var g = persoGeometrie();
    return [cm[0] * g.img.w, cm[1] * g.img.h];
  }
  function qcDpiPerso(cm) {
    var px = qcPixelsImprimes();
    if (!px || !cm) return 0;
    return qcDpiFor(qcZoneCm(cm), px.w, px.h);
  }
  /* ⛔ LES SEUILS TIENNENT COMPTE DE L'UPSCALE. Tout tirage passe par un
     agrandissement avant impression : exiger 200 DPI dans le fichier importe
     alarmait sur des photos qui sortent tres bien, et la pastille rouge faisait
     renoncer des clients pour rien (Adrien, 03/08/2026). Ce qui n'est pas
     rattrapable, c'est une image DEJA pixellisee : sous 60 DPI a l'impression,
     l'agrandissement n'invente pas le detail absent, il l'etale. */
  function qcLevel(dpi) {
    if (dpi >= 120) return 4;
    if (dpi >= 90) return 3;
    if (dpi >= 60) return 2;
    return 1;
  }
  /* Le pele-mele n'a pas UNE photo mais une par case, et chacune est imprimee a la
     taille de sa case. `pele-mele.js` rend le pire rapport « pixels de la photo par
     pixel de l'affiche » ; multiplie par la densite de l'affiche au format choisi,
     il donne le DPI de la photo la plus juste du lot. Le fichier d'impression fait
     toujours 2200 px de large, quel que soit le format. */
  var PELE_LARGEUR_PX = 2200;
  function qcDpiCourant(cm) {
    if (!cm) return 0;
    if (window.__pdpPeleMele) {
      var ratio = window.__pelemelePireRatio ? window.__pelemelePireRatio() : 0;
      if (!ratio) return 0;
      return (PELE_LARGEUR_PX / (cm[0] / 2.54)) * ratio;
    }
    return qcDpiPerso(cm);
  }
  function qcSelectedKey() {
    var fi = formatGroupInfo();
    if (fi && selected[fi.idx] && A_CM[selected[fi.idx]]) return selected[fi.idx];
    return "30X40";
  }
  function qcLabel(key) {
    var cm = A_CM[key]; if (!cm) return key;
    return String(cm[0]).replace(".", ",") + " × " + String(cm[1]).replace(".", ",") + " cm";
  }
  window.__pdpQcSync = function () { try { syncPersoQc(); } catch (e) {} };

  /* ⛔ APRES L'IMPORT, ON REMONTE SUR LES OPTIONS. La zone de depot est haute : une
     fois la photo posee, le client se retrouvait sous les reglages, ne voyait aucune
     option et descendait chercher plus bas ce qui etait au-dessus de lui (Adrien,
     03/08/2026). On amene donc en haut d'ecran le premier libelle de reglage : « Texte
     sur l'affiche » sur l'affiche personnalisee, « Mise en page » sur le pele-mele.
     L'entete est collante, on lui laisse sa hauteur. */
  window.__pdpRemonteOptions = function () {
    try {
      var cible = window.__pdpPeleMele
        ? document.querySelector(".pelemele-bloc")
        : document.getElementById("perso-text");
      if (!cible) return;
      /* ⛔ LA HAUTEUR D'ENTETE SE MESURE, ELLE NE SE LIT PAS SEULEMENT. La variable
         `--site-header-h` est posee dans un requestAnimationFrame : tant qu'il n'a pas
         tourne elle est vide, et le libelle se serait range SOUS l'entete collante. On
         retombe donc sur la mesure directe, et on ne retire cette hauteur que si
         l'entete est effectivement collante. */
      var barre = document.querySelector(".site-header");
      var entete = parseFloat(getComputedStyle(document.documentElement)
        .getPropertyValue("--site-header-h")) || 0;
      if (!entete && barre) {
        var pos = getComputedStyle(barre).position;
        if (pos === "sticky" || pos === "fixed") entete = barre.getBoundingClientRect().height;
      }
      var y = cible.getBoundingClientRect().top + window.pageYOffset - entete - 14;
      window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
    } catch (e) {}
  };
  function measurePersoPixels(src) {
    if (!src || /\.pdf($|\?)/i.test(src)) { persoPx = { w: 0, h: 0 }; syncPersoQc(); return; }
    var img = new Image();
    img.onload = function () {
      persoPx = { w: img.naturalWidth || img.width || 0, h: img.naturalHeight || img.height || 0 };
      /* La photo dicte l'orientation par defaut : une photo couchee bascule la feuille en
         paysage, une photo debout en portrait. Le selecteur reste maitre ensuite. */
      if (persoPx.w && persoPx.h) setPersoOrientation(persoPx.w > persoPx.h ? "paysage" : "portrait");
      /* ⛔ LE CADRAGE SE REPOSE ICI, UNE FOIS LE RATIO DE L'IMAGE CONNU.
         `persoCoverPct` a besoin de ce ratio pour traduire le zoom en `background-size` ;
         tant qu'il l'ignore il rend « cover », c'est-à-dire zoom 1. Au retour de session,
         `applyPersoCrop` tourne AVANT cette mesure : le zoom enregistré s'affichait donc à 1
         alors qu'il valait toujours sa vraie valeur en mémoire, et le fichier composé, lui,
         la respectait. L'écran montrait un cadrage, le tirage en portait un autre. */
      applyPersoCrop({ persist: false });
      syncPersoQc();
    };
    img.onerror = function () { persoPx = { w: 0, h: 0 }; syncPersoQc(); };
    if (src.indexOf("blob:") !== 0) img.crossOrigin = "anonymous";
    img.src = src;
  }
  /* ⛔ LA PASTILLE NE PARLE QUE QUAND IL Y A QUELQUE CHOSE A DIRE. Annoncer
     « Excellent » sur chaque photo n'aide personne a decider et met un doute la ou
     il n'y en a pas ; seule la qualite BASSE merite d'interrompre (Adrien,
     03/08/2026). Le detail reste accessible en la touchant, quand elle s'affiche. */
  function syncPersoQc() {
    var pill = $("#pdp-qc"), modal = $("#pdp-qc-modal");
    if (!pill) return;
    var mesurable = window.__pdpPeleMele
      ? !!(window.__pelemelePireRatio && window.__pelemelePireRatio())
      : !!(window.__pdpPerso && photo && persoPx.w && persoPx.h);
    var key = qcSelectedKey();
    var dpi = mesurable ? qcDpiCourant(A_CM[key]) : 0;
    var level = qcLevel(dpi);
    var show = mesurable && level === 1;
    pill.hidden = !show;
    if (!show) {
      if (modal && !modal.hidden) closePersoQc();
      return;
    }
    var lvlKey = QC_KEYS[level];
    var word = modal ? (modal.getAttribute("data-lvl-" + lvlKey) || lvlKey) : lvlKey;
    pill.setAttribute("data-level", String(level));
    var wordEl = pill.querySelector("[data-pdp-qc-word]");
    if (wordEl) wordEl.textContent = word;
    if (!modal || modal.hidden) return;
    paintPersoQcModal(key, dpi, level);
  }
  function paintPersoQcModal(key, dpi, level) {
    var modal = $("#pdp-qc-modal"); if (!modal) return;
    var lvlKey = QC_KEYS[level];
    var status = modal.querySelector("[data-pdp-qc-status]");
    var scale = modal.querySelector("[data-pdp-qc-scale]");
    var res = modal.querySelector("[data-pdp-qc-res]");
    var size = modal.querySelector("[data-pdp-qc-size]");
    var dpiEl = modal.querySelector("[data-pdp-qc-dpi]");
    var msg = modal.querySelector("[data-pdp-qc-msg]");
    var list = modal.querySelector("[data-pdp-qc-sizes]");
    if (status) status.textContent = modal.getAttribute("data-lvl-" + lvlKey) || "";
    if (scale) scale.setAttribute("data-level", String(level));
    /* La résolution montrée est celle de la zone retenue : c'est elle qui sera imprimée, et
       c'est d'elle que sort le DPI juste au-dessus. Afficher celle du fichier d'origine à côté
       d'un DPI calculé sur autre chose donnait deux nombres qui ne se répondaient pas. */
    var pxImp = qcPixelsImprimes();
    if (res && pxImp) res.textContent = Math.round(pxImp.w) + " × " + Math.round(pxImp.h) + " px";
    if (size) size.textContent = qcLabel(key);
    if (dpiEl) dpiEl.textContent = Math.round(dpi) + " DPI";
    if (msg) msg.textContent = modal.getAttribute("data-msg-" + lvlKey) || "";
    if (!list) return;
    list.innerHTML = "";
    QC_ORDER.forEach(function (k) {
      if (!A_CM[k]) return;
      var d = qcDpiCourant(A_CM[k]);
      var lv = qcLevel(d);
      var b = document.createElement("button");
      b.type = "button";
      b.className = "pdp-qc-modal__size sans" + (k === key ? " is-on" : "");
      b.setAttribute("data-qc-size", k);
      b.setAttribute("role", "listitem");
      b.innerHTML = '<span>' + qcLabel(k) + '</span><span class="pdp-qc-modal__size-meta"><i class="pdp-qc-modal__dot" data-level="' + lv + '"></i>' +
        (modal.getAttribute("data-lvl-" + QC_KEYS[lv]) || "") + "</span>";
      list.appendChild(b);
    });
  }
  function openPersoQc() {
    var modal = $("#pdp-qc-modal"); if (!modal || !persoPx.w) return;
    var key = qcSelectedKey();
    var dpi = qcDpiCourant(A_CM[key]);
    paintPersoQcModal(key, dpi, qcLevel(dpi));
    modal.hidden = false;
    document.body.style.overflow = "hidden";
  }
  function closePersoQc() {
    var modal = $("#pdp-qc-modal"); if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = "";
  }
  function selectQcSize(key) {
    if (!A_CM[key]) return;
    var fi = formatGroupInfo(); if (!fi) return;
    var pill = null;
    for (var i = 0; i < fi.pills.length; i++) {
      if (fi.pills[i].getAttribute("data-value") === key) { pill = fi.pills[i]; break; }
    }
    if (pill) pill.click();
    else {
      selected[fi.idx] = key;
      fi.pills.forEach(function (x) { x.setAttribute("aria-pressed", x.getAttribute("data-value") === key ? "true" : "false"); });
      updatePrice(); updateFrame(); engageScale();
    }
    syncPersoQc();
  }
  (function bindPersoQc() {
    var pill = $("#pdp-qc"), modal = $("#pdp-qc-modal");
    if (!pill || !modal) return;
    pill.addEventListener("click", openPersoQc);
    var c1 = $("#pdp-qc-close"), c2 = $("#pdp-qc-close-btn");
    if (c1) c1.addEventListener("click", closePersoQc);
    if (c2) c2.addEventListener("click", closePersoQc);
    modal.addEventListener("click", function (e) {
      if (e.target === modal) closePersoQc();
      var s = e.target.closest("[data-qc-size]");
      if (s) selectQcSize(s.getAttribute("data-qc-size"));
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !modal.hidden) closePersoQc();
    });
  })();

  /* ---- Zone de texte (bande + titre / sous-titre) ---- */
  /* ⛔ LE MASQUAGE VIT ICI, PAS DANS LE PAYLOAD (Adrien, 15/08/2026 : « l'oeil ne marche pas »).
     Je l'avais mis dans l'objet envoye au panier : le panier et le fichier d'impression
     voyaient bien le texte retire, mais l'APERCU appelle ces deux fonctions, qui lisent la
     valeur du champ DIRECTEMENT. L'oeil basculait donc sans que rien ne change a l'ecran.
     C'est la meme lecon que le pele-mele une heure plus tot : il faut trouver le point UNIQUE
     que TOUT traverse, et ces deux fonctions le sont ici. Le payload les appelle aussi, donc
     poser le masque a cet endroit couvre l'ecran ET le tirage, sans double garde. */
  /* ⛔ MASQUER N'EST PAS EFFACER, ET LA DIFFERENCE SE VOIT A L'ECRAN (Adrien, 15/08/2026 :
     « quand on masque un texte, ca modifie l'autre texte ainsi que l'image importee »).
     Le masquage rendait la chaine VIDE, et tout l'aval lit le vide comme « cette affiche n'a
     pas de sous-titre » :
       - `data-has-sub` bascule a false -> la bande change de proportion ;
       - la zone photo change de forme -> `applyPersoCrop` RECADRE la photo du client ;
       - `fitPersoTextBand` reajuste le texte restant -> l'autre ligne change de corps.
     Trois consequences pour un clic qui ne devait qu'eteindre une ligne.
     => LA SAISIE ET L'AFFICHAGE SONT DEUX QUESTIONS. Ce qui decide de la GEOMETRIE (bande,
     forme de la zone photo, calibrage) lit la valeur SAISIE ; ce qui part au panier et a
     l'impression lit la valeur masquee. La ligne eteinte garde sa place, donc rien ne bouge
     autour d'elle, et le client retrouve exactement sa mise en page en la rallumant. */
  function persoTextTitleSaisi() {
    var el = $("#perso-text-title");
    return el ? String(el.value || "").trim() : "";
  }
  function persoTextSubSaisi() {
    var el = $("#perso-text-sub");
    return el ? String(el.value || "").trim() : "";
  }
  function persoTextTitle() {
    return persoTexteMasque("titre") ? "" : persoTextTitleSaisi();
  }
  function persoTextSub() {
    return persoTexteMasque("sous") ? "" : persoTextSubSaisi();
  }
  function fitPersoTextBand(band) {
    var tEl = band.querySelector("[data-pdp-textband-title]");
    var sEl = band.querySelector("[data-pdp-textband-sub]");
    if (!tEl || band.hidden || !band.clientWidth || !band.clientHeight) return;
    var hasSub = !!(sEl && sEl.textContent);
    /* Le bloc titre fait 100 % de large : sous ce seuil, scrollWidth ne mesure plus
       rien. Un Range mesure les glyphes eux-memes, meme centres. */
    function largeurGlyphes(el) {
      var r = document.createRange();
      r.selectNodeContents(el);
      return r.getBoundingClientRect().width;
    }
    /* ⛔ DEBORD CENTRE INVISIBLE AU scrollHeight : la bande centre son contenu (flex),
       un contenu trop haut depasse par le HAUT et par le bas, et scrollHeight ne voit
       pas le debord du haut. En arche paysage, titre et sous-titre sortaient rognes
       sans qu'aucune boucle ne reagisse (02/08/2026). On compare les rectangles reels
       du contenu (filet ::before compris, il vit dans le sous-titre) a la boite
       interieure de la bande. */
    var csBande = getComputedStyle(band);
    var padHaut = parseFloat(csBande.paddingTop) || 0;
    var padBas = parseFloat(csBande.paddingBottom) || 0;
    function deborde() {
      var rb = band.getBoundingClientRect();
      var rt = tEl.getBoundingClientRect();
      var haut = rt.top, bas = rt.bottom;
      if (hasSub && sEl) {
        var rs = sEl.getBoundingClientRect();
        haut = Math.min(haut, rs.top);
        bas = Math.max(bas, rs.bottom);
      }
      return haut < rb.top + padHaut - 1 || bas > rb.bottom - padBas + 1;
    }
    /* Marge laterale : l'impression garde ses marges de cote, l'ecran s'y cale au lieu
       de laisser le titre courir d'un bord a l'autre (arche paysage, 02/08/2026).
       L'editorial garde sa colonne : le min retient la plus etroite des deux. */
    var largeurUtile = Math.min(tEl.clientWidth, band.clientWidth * 0.86);
    var maxTitle = band.clientHeight * (hasSub ? 0.38 : 0.52);
    var softMin = Math.max(7, band.clientHeight * 0.16);
    var hardMin = 5; /* en dessous : illisible, mais mieux que rogner « SOUVENIR » */
    var size = maxTitle;
    tEl.style.whiteSpace = "nowrap";
    tEl.style.fontSize = size + "px";
    // Réduit jusqu'à tenir sur une ligne dans la largeur utile.
    var guard = 28;
    while (guard-- > 0 && size > softMin && largeurGlyphes(tEl) > largeurUtile) {
      size *= 0.9;
      tEl.style.fontSize = size + "px";
    }
    // Encore trop long : 2 lignes max, largeur + hauteur de bande.
    if (largeurGlyphes(tEl) > largeurUtile) {
      tEl.style.whiteSpace = "normal";
      size = band.clientHeight * (hasSub ? 0.28 : 0.36);
      tEl.style.fontSize = size + "px";
      guard = 32;
      while (
        guard-- > 0 &&
        size > hardMin &&
        (tEl.scrollWidth > tEl.clientWidth + 1 ||
          tEl.scrollHeight > band.clientHeight * (hasSub ? 0.58 : 0.78) ||
          deborde())
      ) {
        size *= 0.9;
        tEl.style.fontSize = size + "px";
      }
    }
    if (hasSub && sEl && band.getAttribute("data-design") === "editorial") {
      /* ⛔ EDITORIAL EST EN RANG, PAS EN PILE : le sous-titre vit dans sa colonne a
         droite du filet et se pose sur DEUX lignes, comme drawPersoEditorial et
         traceEditorial (0.20h). Le nowrap du chemin commun l'ecrasait a une ligne
         dans la colonne etroite : minuscule quel que soit le font-size du CSS,
         puisque la taille est ecrite ici en ligne (02/08/2026). */
      var subEd = band.clientHeight * 0.20;
      sEl.style.whiteSpace = "normal";
      sEl.style.overflow = "hidden";
      sEl.style.fontSize = subEd + "px";
      guard = 24;
      while (guard-- > 0 && subEd > hardMin &&
        (sEl.scrollHeight > sEl.clientHeight + 1 || sEl.scrollWidth > sEl.clientWidth + 1)) {
        subEd *= 0.9;
        sEl.style.fontSize = subEd + "px";
      }
    } else if (hasSub && sEl) {
      /* La largeur seule regle le sous-titre ici : la hauteur se regle plus bas, a deux.
         Le laisser encaisser seul le debord de hauteur l'ecrasait au minimum (5 px)
         pendant que le titre restait plein (arche paysage, 02/08/2026). */
      var subSize = Math.min(size * 0.55, band.clientHeight * 0.2);
      sEl.style.whiteSpace = "nowrap";
      sEl.style.fontSize = Math.max(hardMin, subSize) + "px";
      guard = 24;
      while (guard-- > 0 && subSize > hardMin && sEl.scrollWidth > sEl.clientWidth + 1) {
        subSize *= 0.9;
        sEl.style.fontSize = subSize + "px";
      }
    }
    /* La hauteur se regle a deux : titre et sous-titre descendent ensemble, en gardant
       leur rapport, jusqu'a tenir dans la bande (courte en paysage). */
    guard = 20;
    while (guard-- > 0 && size > hardMin && deborde()) {
      size *= 0.92;
      tEl.style.fontSize = size + "px";
      if (hasSub && sEl) {
        var sfs = Math.max(hardMin, (parseFloat(sEl.style.fontSize) || size * 0.55) * 0.92);
        sEl.style.fontSize = sfs + "px";
      }
    }
  }
  /* ⛔ LA BANDE SE REMESURE QUAND SA BOÎTE CHANGE, PAS QUAND ON CROIT QU'ELLE VA CHANGER.
     Deux correctifs ont déjà tenté de deviner l'instant : deux rAF après un changement de
     format, puis un appel de plus au retour de la galerie. Chacun ratait encore un cas, la
     mesure tombant pendant que le cadre changeait de largeur. Le titre gardait alors la
     taille de l'ancienne largeur et overflow:hidden le rognait ; changer de format puis
     revenir « réparait », parce que ça provoquait une mesure de plus au bon moment.
     L'observateur supprime la devinette : quelle que soit la cause (format, galerie,
     fenêtre, fin de transition, bande masquée puis remontrée), la bande se réajuste. */
  var _bandRz = null, _bandFitting = false;
  function observePersoTextBands() {
    if (typeof ResizeObserver === "undefined") return;
    if (!_bandRz) {
      _bandRz = new ResizeObserver(function (entries) {
        if (_bandFitting) return; /* la police écrite ici ne doit pas se rappeler elle-même */
        _bandFitting = true;
        try { entries.forEach(function (en) { fitPersoTextBand(en.target); }); }
        finally { _bandFitting = false; }
      });
    }
    /* observe() deux fois sur le même élément est sans effet : les bandes clonées après
       coup (mise en situation) sont donc couvertes sans tenir de registre. */
    $$("[data-pdp-textband]").forEach(function (b) { _bandRz.observe(b); });
  }
  /* Reste utile quand c'est le TEXTE qui change : la boîte ne bouge pas, l'observateur ne
     se déclenche pas, et il faut quand même recalculer la taille de police. */
  function refitPersoTextBands() {
    if (!persoTextOn) return;
    observePersoTextBands();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        $$("[data-pdp-textband]").forEach(fitPersoTextBand);
      });
    });
  }
  /* ⛔ AJUSTER TOUT DE SUITE, SANS ATTENDRE UNE IMAGE DE L'ECRAN.
   *
   * `refitPersoTextBands` passe par deux requestAnimationFrame imbriques, et le ResizeObserver
   * ne se declenche que si la BOITE bouge. Ni l'un ni l'autre ne s'execute tant que l'onglet ne
   * peint pas. Or `composePersoWithText` lit la bande AFFICHEE pour en tirer ses fractions :
   * quand l'ajustement n'a pas encore eu lieu, elle lit la taille de base de base.css et grave
   * un titre deux fois trop petit dans le fichier qui part a la presse.
   *
   * Mesure du 08/08/2026, fiche perso en production, bande de 385 x 136 : titre a 12 px avant
   * ajustement (fraction 0,088), a 27,46 px apres (fraction 0,202). Le fichier compose entre les
   * deux portait donc un titre de moitie celui que la cliente voyait, et rien ne le signalait.
   *
   * Le composeur ne fait plus confiance a l'etat du DOM, il l'etablit. C'est synchrone,
   * idempotent, et ca coute une mesure. */
  function ajusterBandesMaintenant() {
    if (!persoTextOn) return;
    try { $$("[data-pdp-textband]").forEach(fitPersoTextBand); } catch (e) {}
  }
  /* Recentes du composeur : le rendu personnalise est une affiche comme une autre.
     Chaque etat stable du rendu (photo posee, cadrage, mise en page, couleurs, textes)
     remplace l'entree precedente dans les recemment vues, et le composeur de mur
     l'affiche comme n'importe quelle fiche (Adrien, 02/08/2026 ; jusqu'ici la fiche
     perso etait exclue des recentes). La vignette est le rendu du panier reduit :
     MEME composition, jamais une variante d'ecran. */
  var recentPersoTimer = null;
  function planifierRecentPerso() {
    if (!window.__pdpPerso || !window.MurRecent) return;
    var racine = document.querySelector(".pdp--perso");
    if (!racine || !racine.classList.contains("pdp--perso-has-photo")) return;
    clearTimeout(recentPersoTimer);
    recentPersoTimer = setTimeout(function () {
      composePersoWithText().then(function (fichier) {
        var url = URL.createObjectURL(fichier);
        var img = new Image();
        img.onload = function () {
          try {
            var w = 360, h = Math.max(1, Math.round(w * img.height / img.width));
            var c = document.createElement("canvas");
            c.width = w; c.height = h;
            c.getContext("2d").drawImage(img, 0, 0, w, h);
            var data = c.toDataURL("image/jpeg", 0.72);
            var card = window.__pdpRecent || {};
            var vmap = {};
            (variants || []).forEach(function (v) {
              if (!v || !v.option1) return;
              var cents = typeof v.price === "number" ? v.price : Math.round(parseFloat(v.price) * 100);
              vmap[v.option1] = { id: v.id, cents: cents, ok: v.available !== false };
            });
            window.MurRecent.push({
              handle: card.handle || "affiche-personnalisee",
              title: card.title || document.title,
              img: data,
              variants: vmap
            });
          } catch (e) {}
          URL.revokeObjectURL(url);
        };
        img.onerror = function () { URL.revokeObjectURL(url); };
        img.src = url;
      }).catch(function () {});
    }, 1600);
  }
  function applyPersoMatVars(el) {
    if (!el) return;
    var mat = persoMatTheme();
    var eff = encreEffective(mat, persoTextDesign === "voile");
    el.style.setProperty("--perso-mat", mat.bg);
    el.style.setProperty("--perso-ink", eff.ink);
    el.style.setProperty("--perso-muted", eff.muted);
  }
  function syncPersoTextPreview() {
    calculerEncreVoileAuto();
    /* La GEOMETRIE se decide sur la saisie, jamais sur le masquage : voir persoTextTitle. */
    var title = persoTextTitleSaisi(), sub = persoTextSubSaisi();
    var show = !!(persoTextOn && (title || sub));
    var design = show ? persoTextDesign : "";
    var frameInner = document.querySelector(".pdp-frame__inner");
    var mockPoster = $("#pdp-mockup-poster");
    [frameInner, mockPoster].forEach(function (el) {
      if (!el) return;
      if (design) {
        el.setAttribute("data-perso-design", design);
        el.setAttribute("data-has-sub", sub ? "true" : "false");
        applyPersoMatVars(el);
      } else {
        el.removeAttribute("data-perso-design");
        el.removeAttribute("data-has-sub");
        el.style.removeProperty("--perso-mat");
        el.style.removeProperty("--perso-ink");
        el.style.removeProperty("--perso-muted");
      }
    });
    // Avant import : la photo d'exemple est le ghost du placeholder.
    // On la reporte sur #pdp-main pour que Design (passe-partout) / Zone la recadrent.
    //
    // ⛔ SEULEMENT QUAND LA VUE COURANTE EST L'OEUVRE. Sinon cette ligne EFFACE la vue fixe.
    // Le defaut, en production jusqu'au 13/08/2026 : en mode « Avec texte », activateThumb
    // ecrivait qual-01.jpg dans #pdp-main, puis appelait syncPersoTextPreview() trois
    // instructions plus loin (ligne 2441, gardee par persoTextOn), qui remettait aussitot
    // l'image d'exemple. Les deux ecritures dans le meme clic, en synchrone : a l'ecran, un
    // clic sur Papier ou Detail ne faisait rien. En « Photo seule », activateThumb n'appelle
    // pas cette fonction, donc les memes vignettes marchaient : d'ou « ca ne marche que dans
    // avec texte », qui ressemblait a un probleme de vignettes et n'en etait pas un.
    //
    // ⚠️ aria-pressed est deja pose sur la bonne vignette quand on arrive ici (activateThumb
    // le fait avant), donc vueCouranteEstOeuvre() lit l'etat d'apres le clic, pas d'avant.
    // Ne pas remplacer ce test par [data-vue-fixe] : cet attribut n'est ecrit qu'APRES le
    // retour d'activateThumb, il vaudrait encore l'ancienne vue.
    var main = $("#pdp-main");
    var ghost = document.querySelector("#pdp-placeholder .pdp-placeholder__ghost");
    var ph = $("#pdp-placeholder");
    if (main && ghost && ph && !ph.hidden && !photo && vueCouranteEstOeuvre()) {
      var gBg = "";
      try { gBg = window.getComputedStyle(ghost).backgroundImage || ""; } catch (e) {}
      if (!gBg || gBg === "none") gBg = ghost.style.backgroundImage || "";
      if (gBg && gBg !== "none") main.style.backgroundImage = gBg;
    }
    /* ⛔ PAS DE TEXTE SUR LES VUES FIXES. Papier et Detail sont des photos de BENEFICE prises
       a l'atelier, sur une tout autre affiche : y poser « VOTRE MESSAGE » laisse croire que le
       texte du client s'imprimera sur cette image-la. Elles doivent rester independantes du
       configurateur. Adrien, 13/08/2026, captures a l'appui.
       ⚠️ Les mises en situation, elles, GARDENT le texte : c'est l'affiche du client sur un mur.
       D'ou vueCouranteEstFixe et pas !vueCouranteEstOeuvre, qui exclurait les deux.
       ⚠️ Masquer ne derange pas le calibrage : fitPersoTextBand sort sur `band.hidden` et sur
       une boite nulle, donc la taille de police posee pour l'oeuvre survit au detour, et
       syncPersoTextPreview la recalcule au retour. */
    var porteLeTexte = show && !vueCouranteEstFixe();
    $$("[data-pdp-textband]").forEach(function (band) {
      band.hidden = !porteLeTexte;
      band.setAttribute("aria-hidden", porteLeTexte ? "false" : "true");
      band.setAttribute("data-font", persoFont);
      band.setAttribute("data-design", persoTextDesign);
      band.setAttribute("data-color", persoTextColor);
      band.setAttribute("data-has-sub", sub ? "true" : "false");
      applyPersoMatVars(band);
      var tEl = band.querySelector("[data-pdp-textband-title]");
      var sEl = band.querySelector("[data-pdp-textband-sub]");
      /* Chaque texte porte SA police : la bande garde la sienne pour tout le reste. */
      if (tEl) tEl.setAttribute("data-font", fontIdDe("titre"));
      if (sEl) sEl.setAttribute("data-font", fontIdDe("sous"));
      /* ⛔⛔ ET LA FAMILLE SE POSE AUSSI EN LIGNE, PARCE QUE L'ATTRIBUT NE SUFFIT PAS TOUJOURS
         (Adrien, 23/08/2026, sur iPhone : « ca ne change pas la police sur l'image, c'est la
         police au niveau de chaque texte »). L'attribut ne fait rien par lui-meme : il faut que
         la regle qui le traduit soit servie ET qu'elle gagne. Elle existe, elle gagne en
         specificite, et elle marche sur les moteurs que je peux mesurer — mais elle depend d'une
         chaine de six regles ecrites a deux endroits de la feuille, et une seule d'entre elles
         qui manque ou qui perd rend le choix invisible sans lever d'erreur.
         Un style en ligne ne depend de personne. On le pose quand le texte a SA police, et on le
         retire quand il reprend celle de la bande — pour que la bande garde alors la main. */
      var famChamp = function (cible) {
        var id = (cible === "sous") ? persoFontSous : persoFontTitre;
        if (!id) return "";
        var f = PERSO_FONTS[id];
        return f ? f.family : "";
      };
      if (tEl) tEl.style.fontFamily = famChamp("titre");
      if (sEl) sEl.style.fontFamily = famChamp("sous");
      /* ⛔ `visibility`, PAS `display` NI UNE CHAINE VIDE. Les deux autres retirent la boite du
         calibrage : le texte restant se recalculerait pour l'espace libere, ce qui est
         exactement le defaut qu'on ferme. `visibility:hidden` garde la boite, sa hauteur et sa
         part dans fitPersoTextBand ; seuls les glyphes disparaissent. */
      if (tEl) {
        tEl.textContent = title; tEl.style.fontSize = ""; tEl.style.whiteSpace = "";
        tEl.style.visibility = persoTexteMasque("titre") ? "hidden" : "";
      }
      if (sEl) {
        sEl.textContent = sousAffiche(sub); sEl.style.fontSize = ""; sEl.style.whiteSpace = "";
        sEl.style.visibility = persoTexteMasque("sous") ? "hidden" : "";
      }
    });
    /* Le texte vient de changer : la boîte ne bouge pas, l'observateur ne dira rien.
       Il mesure quand même, et il prend en charge les bandes créées depuis. */
    observePersoTextBands();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        $$("[data-pdp-textband]").forEach(fitPersoTextBand);
      });
    });
    persistPersoTextSession();
    /* ⛔ LE CADRAGE SE RECALCULE ICI. La zone photo change de forme selon le texte : presque
       carrée dans le passe-partout, pleine feuille sans texte, amputée d'une bande dans le
       design « zone ». Sans ce rappel, la photo restait cadrée pour la forme précédente et
       l'aperçu ne correspondait plus au fichier. */
    applyPersoCrop({ persist: false });
    planifierRecentPerso();
  }
  var persoTextStep = 1;
  var PERSO_TEXT_STEPS = 1;
  function setPersoTextStep(n, opts) {
    opts = opts || {};
    persoTextStep = Math.max(1, Math.min(PERSO_TEXT_STEPS, Number(n) || 1));
    /* ⛔ MEME PORTEE QUE LES AUTRES : l'atelier emporte ces boutons hors de `#perso-text`, qui
       reste sur la fiche. Cherche dans ce seul conteneur, l'etat visible n'atteignait jamais le
       bouton deplace : « Avec texte » s'appliquait a l'affiche sans jamais s'allumer
       (mesure du 23/08/2026 : bande de texte presente, `aria-pressed` a false). */
    var root = document;
    var fields = root && root.querySelector("[data-perso-text-fields]");
    if (!fields) return;
    fields.setAttribute("data-perso-text-step", String(persoTextStep));
    $$("[data-perso-text-panel]", fields).forEach(function (panel) {
      var id = Number(panel.getAttribute("data-perso-text-panel"));
      panel.hidden = id !== persoTextStep;
    });
    $$("[data-perso-text-goto]", fields).forEach(function (dot) {
      var id = Number(dot.getAttribute("data-perso-text-goto"));
      var on = id === persoTextStep;
      var done = id < persoTextStep;
      dot.classList.toggle("is-on", on);
      dot.classList.toggle("is-done", done);
      if (on) dot.setAttribute("aria-current", "step");
      else dot.removeAttribute("aria-current");
    });
    var labelEl = fields.querySelector("[data-perso-step-label]");
    if (labelEl) {
      var name = fields.getAttribute("data-step-label-" + persoTextStep) || "";
      labelEl.textContent = persoTextStep + "/" + PERSO_TEXT_STEPS + (name ? " · " + name : "");
    }
    var back = fields.querySelector("[data-perso-text-back]");
    var next = fields.querySelector("[data-perso-text-next]");
    if (back) back.hidden = persoTextStep <= 1;
    if (next) next.hidden = persoTextStep >= PERSO_TEXT_STEPS;
    if (opts.focusTitle && persoTextStep === 2) {
      var titleIn = $("#perso-text-title");
      if (titleIn) try { titleIn.focus({ preventScroll: true }); } catch (err) { try { titleIn.focus(); } catch (e2) {} }
    }
  }
  /* Les deux pastilles, peintes depuis LA MEME source que le dessin : `encreEffective`. Un
     second calcul, meme juste le jour ou on l'ecrit, finit par diverger. */
  function majPastillesPersoTexte() {
    var mat = persoMatTheme();
    var eff = encreEffective(mat, persoTextDesign === "voile" || persoTextDesign === "voile-bas");
    var swT = $("#perso-text-ink-swatch");
    if (swT) swT.style.background = eff.ink;
    var swS = $("#perso-text-ink-sous-swatch");
    if (swS) swS.style.background = eff.muted;
  }
  function setPersoTextInk(id, cible) {
    var valeur = (id && PERSO_MATS[id]) ? id : "";
    if (cible === "sous") persoInkSous = valeur; else persoInkTitre = valeur;
    majPastillesPersoTexte();
    syncPersoTextPreview();
  }
  /* La police d'UN texte : meme fenetre et meme geste que le panneau de mariage. */
  var persoModalePolice = null, persoChampPolice = "titre";
  function majPastillesPersoPolice() {
    $$("[data-perso-font-champ]").forEach(function (b) {
      var cible = b.getAttribute("data-perso-font-champ");
      var ex = b.querySelector(".perso-text__font-ex");
      var f = PERSO_FONTS[fontIdDe(cible)] || PERSO_FONTS.classic;
      if (ex) ex.style.fontFamily = f.family;
      b.classList.toggle("is-on", !!(cible === "sous" ? persoFontSous : persoFontTitre));
    });
  }
  function ouvrirPersoModalePolice(cible) {
    persoChampPolice = cible;
    if (!persoModalePolice) {
      var m = document.createElement("div");
      m.className = "perso-ink-modal";
      m.setAttribute("role", "dialog");
      m.setAttribute("aria-modal", "true");
      var pan = document.createElement("div");
      pan.className = "perso-ink-modal__panel sans";
      var tete = document.createElement("div");
      tete.className = "perso-ink-modal__head";
      var t = document.createElement("span");
      t.textContent = (window.__pdpT && window.__pdpT.police) || "Police";
      var x = document.createElement("button");
      x.type = "button"; x.className = "perso-ink-modal__x"; x.textContent = "\u00d7";
      x.addEventListener("click", function () { m.hidden = true; });
      tete.appendChild(t); tete.appendChild(x);
      pan.appendChild(tete);
      var g = document.createElement("div");
      g.className = "perso-modale-polices";
      Object.keys(PERSO_FONTS).forEach(function (id) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "perso-text__font";
        b.setAttribute("data-perso-modale-font", id);
        b.style.fontFamily = PERSO_FONTS[id].family;
        b.textContent = "Aa";
        b.addEventListener("click", function () {
          /* Recliquer la police posee la retire : ce texte reprend celle de l'affiche. */
          var courant = persoChampPolice === "sous" ? persoFontSous : persoFontTitre;
          var val = courant === id ? "" : id;
          if (persoChampPolice === "sous") persoFontSous = val; else persoFontTitre = val;
          majPastillesPersoPolice();
          $$("[data-perso-modale-font]").forEach(function (o) {
            var on = o.getAttribute("data-perso-modale-font") === val;
            o.classList.toggle("is-on", on);
            o.setAttribute("aria-pressed", on ? "true" : "false");
          });
          syncPersoTextPreview();
          persistPersoTextSession();
        });
        g.appendChild(b);
      });
      pan.appendChild(g);
      m.appendChild(pan);
      m.addEventListener("click", function (e) { if (e.target === m) m.hidden = true; });
      document.body.appendChild(m);
      persoModalePolice = m;
    }
    $$("[data-perso-modale-font]").forEach(function (o) {
      var on = o.getAttribute("data-perso-modale-font") === (cible === "sous" ? persoFontSous : persoFontTitre);
      o.classList.toggle("is-on", on);
      o.setAttribute("aria-pressed", on ? "true" : "false");
    });
    persoModalePolice.hidden = false;
  }
  document.addEventListener("click", function (e) {
    var b = e.target && e.target.closest ? e.target.closest("[data-perso-font-champ]") : null;
    if (!b) return;
    ouvrirPersoModalePolice(b.getAttribute("data-perso-font-champ"));
  });

  (function bindPersoInk() {
    var modal = $("#perso-ink-modal");
    if (!modal) return;
    var cible = "titre";
    var fermer = function () { modal.hidden = true; };
    [["#perso-text-ink", "titre"], ["#perso-text-ink-sous", "sous"]].forEach(function (paire) {
      var bouton = $(paire[0]);
      if (bouton) bouton.addEventListener("click", function () { cible = paire[1]; modal.hidden = false; });
    });
    modal.addEventListener("click", function (e) {
      if (e.target === modal || e.target.closest("[data-perso-ink-close]")) { fermer(); return; }
      var choix = e.target.closest("[data-perso-ink]");
      if (!choix) return;
      if (window.__pdpMontrerLAffiche) window.__pdpMontrerLAffiche();
      setPersoTextInk(choix.getAttribute("data-perso-ink"), cible);
      persistPersoTextSession();
      fermer();
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !modal.hidden) fermer(); });
    setPersoTextInk("", "titre");
  })();
  function setPersoTextMode(on) {
    persoTextOn = !!on;
    /* ⛔ MEME PORTEE QUE LES AUTRES : l'atelier emporte ces boutons hors de `#perso-text`, qui
       reste sur la fiche. Cherche dans ce seul conteneur, l'etat visible n'atteignait jamais le
       bouton deplace : « Avec texte » s'appliquait a l'affiche sans jamais s'allumer
       (mesure du 23/08/2026 : bande de texte presente, `aria-pressed` a false). */
    var root = document;
    if (root) {
      $$("[data-perso-text-mode]", root).forEach(function (b) {
        var isOn = (b.getAttribute("data-perso-text-mode") === "on") === persoTextOn;
        b.classList.toggle("is-on", isOn);
        b.setAttribute("aria-pressed", isOn ? "true" : "false");
      });
      var fields = root.querySelector("[data-perso-text-fields]");
      if (fields) fields.hidden = !persoTextOn;
    }
    // Comme le concurrent : texte d'exemple déjà posé, pas de toast « importez d'abord ».
    if (persoTextOn) {
      var titleIn = $("#perso-text-title"), subIn = $("#perso-text-sub");
      if (titleIn && !String(titleIn.value || "").trim() && titleIn.placeholder) titleIn.value = titleIn.placeholder;
      if (subIn && !String(subIn.value || "").trim() && subIn.placeholder) subIn.value = subIn.placeholder;
      setPersoTextStep(1);
    }
    /* Le CTA suit le mode : passer en texte retire l'invitation a deposer une photo, revenir en
       photo la remet. Sans cet appel, le libelle et le rebond restaient sur l'etat d'avant la
       bascule, et c'est precisement ce que le client vient de changer. */
    syncPersoCta();
    /* Et la bande de demos aussi : en mode texte elle montre des exemples AVEC TEXTE, en mode
       photo des exemples sans. Une vignette doit montrer ce que le clic va produire. */
    if (typeof window.__persoMajDemos === "function") window.__persoMajDemos();
    syncPersoTextPreview();
  }
  function setPersoTextDesign(id) {
    if (["design", "zone", "entete", "editorial", "voile", "voile-bas", "arche", "musee"].indexOf(id) === -1) return;
    persoTextDesign = id;
    /* ⚠️ LA MISE EN PAGE CHANGE L'ENCRE : sur « Sur la photo » elle suit la luminance, ailleurs
       elle suit le fond. Les pastilles se repeignent donc ici aussi, sinon elles gardent la
       couleur de la mise en page precedente. */
    try { majPastillesPersoTexte(); } catch (e) {}
    /* Voile et Voile bas n'ont pas de fond : la pastille "Couleur du fond" y colorait
       le texte, source de confusion. On la masque ; la couleur du texte s'y regle par
       les pastilles d'encre a cote des champs. */
    var colonnes = document.querySelector(".perso-text__colors");
    if (colonnes) colonnes.hidden = id === "voile" || id === "voile-bas";
    /* ⛔ ET L'ETAT VISIBLE SE POSE SUR TOUS LES BOUTONS, OU QU'ILS SOIENT. Meme cause que la
       delegation : `#perso-text` reste sur la fiche pendant que l'atelier emporte ses boutons
       dans ses onglets. Cherchee dans ce seul conteneur, la pastille active n'etait jamais
       marquee : la cliente cliquait une police, l'affiche changeait, et AUCUN bouton ne
       s'allumait. Mesure du 23/08/2026 : les huit polices rendues correctement (Montserrat,
       Anton, Great Vibes, Marcellus, Cormorant, Cinzel) et `aria-pressed` immobile sur la
       premiere. Un choix applique mais pas montre se relit comme un clic perdu. */
    var root = document;
    if (root) {
      $$("[data-perso-design]", root).forEach(function (b) {
        var on = b.getAttribute("data-perso-design") === id;
        b.classList.toggle("is-on", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
      /* Slider horizontal mobile : la puce active revient sous le doigt. block:nearest
         pour ne jamais faire defiler la page elle-meme. */
      var actif = root.querySelector(".perso-text__modes--design .perso-text__mode.is-on");
      if (actif && window.matchMedia("(max-width:900px)").matches) {
        try { actif.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" }); } catch (e) {}
      }
    }
    syncPersoTextPreview();
  }
  /* Luminance relative (sRGB) et contraste WCAG entre deux hexas. */
  function lumiDe(hex) {
    var n = parseInt(String(hex).replace("#", ""), 16);
    var c = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }
  function contrasteHex(a, b) {
    var l1 = lumiDe(a), l2 = lumiDe(b);
    var hi = Math.max(l1, l2), lo = Math.min(l1, l2);
    return (hi + 0.05) / (lo + 0.05);
  }
  /* ⛔ JAMAIS D'ILLISIBLE : au changement de fond, une encre choisie par le client qui
     ne contraste plus (blanc sur blanc, creme sur blanc, fonce sur fonce...) retombe en
     automatique, qui s'adapte toujours ; une encre encore lisible est respectee
     (demande du 02/08/2026). Seuil 1.9 : attrape creme sur blanc (1.14) et foret sur
     marine (1.35), laisse terracotta sur creme (2.2). */
  function veillerContrasteEncres() {
    var fondHex = persoMatTheme().bg;
    [["titre", persoInkTitre], ["sous", persoInkSous]].forEach(function (paire) {
      var cle = paire[1];
      if (!cle || !PERSO_MATS[cle]) return;
      if (contrasteHex(PERSO_MATS[cle].bg, fondHex) < 1.9) setPersoTextInk("", paire[0]);
    });
  }
  function setPersoTextColor(id) {
    if (!PERSO_MATS[id]) return;
    persoTextColor = id;
    /* ⛔ ET L'ETAT VISIBLE SE POSE SUR TOUS LES BOUTONS, OU QU'ILS SOIENT. Meme cause que la
       delegation : `#perso-text` reste sur la fiche pendant que l'atelier emporte ses boutons
       dans ses onglets. Cherchee dans ce seul conteneur, la pastille active n'etait jamais
       marquee : la cliente cliquait une police, l'affiche changeait, et AUCUN bouton ne
       s'allumait. Mesure du 23/08/2026 : les huit polices rendues correctement (Montserrat,
       Anton, Great Vibes, Marcellus, Cormorant, Cinzel) et `aria-pressed` immobile sur la
       premiere. Un choix applique mais pas montre se relit comme un clic perdu. */
    var root = document;
    if (root) {
      $$("[data-perso-color]", root).forEach(function (b) {
        var on = b.getAttribute("data-perso-color") === id;
        b.classList.toggle("is-on", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
      var actifC = root.querySelector(".perso-text__color-grid .is-on");
      if (actifC && window.matchMedia("(max-width:900px)").matches) {
        try { actifC.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" }); } catch (e) {}
      }
    }
    syncPersoTextPreview();
    veillerContrasteEncres();
    /* ⚠️ ON REPEINT LES PASTILLES, ON NE REJOUE PAS UN CHOIX D'ENCRE. La ligne d'avant appelait
       `setPersoTextInk(persoInkTitre, "titre")` pour obtenir le meme effet : elle REECRIVAIT la
       valeur au passage, et un detour qui ecrit pour rafraichir finit toujours par ecrire ce
       qu'il ne fallait pas. */
    majPastillesPersoTexte();
  }
  function setPersoFont(id) {
    if (!PERSO_FONTS[id]) return;
    persoFont = id;
    try { majPastillesPersoPolice(); } catch (e) {}
    /* ⛔ ET L'ETAT VISIBLE SE POSE SUR TOUS LES BOUTONS, OU QU'ILS SOIENT. Meme cause que la
       delegation : `#perso-text` reste sur la fiche pendant que l'atelier emporte ses boutons
       dans ses onglets. Cherchee dans ce seul conteneur, la pastille active n'etait jamais
       marquee : la cliente cliquait une police, l'affiche changeait, et AUCUN bouton ne
       s'allumait. Mesure du 23/08/2026 : les huit polices rendues correctement (Montserrat,
       Anton, Great Vibes, Marcellus, Cormorant, Cinzel) et `aria-pressed` immobile sur la
       premiere. Un choix applique mais pas montre se relit comme un clic perdu. */
    var root = document;
    if (root) {
      $$("[data-perso-font]", root).forEach(function (b) {
        var on = b.getAttribute("data-perso-font") === id;
        b.classList.toggle("is-on", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
      var actifF = root.querySelector(".perso-text__font-grid .is-on");
      if (actifF && window.matchMedia("(max-width:900px)").matches) {
        try { actifF.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" }); } catch (e) {}
      }
    }
    syncPersoTextPreview();
  }
  /* ⛔ CONTRAT D'URL UNIFIE (Adrien, 12/08/2026, serie 119) : layout= porte le TYPE
     (photo, message, texte), comme sur le pele-mele ; occasion= porte l'INTENTION
     (mariage, chien, ...), le meme parametre que les collections. look= est l'HERITAGE
     des annonces et liens historiques : un type y devient layout, tout le reste occasion,
     et il ne gagne jamais contre un parametre neuf. Les nouvelles URLs n'ecrivent plus
     jamais look=. Defini ICI, hors de toute IIFE gardee : les lecteurs (mode texte,
     rejeu apres session, H1 et filigrane) s'executent tous apres. */
  window.__persoUrlParams = function () {
    var layout = "", occasion = "";
    try {
      /* ⛔ UNE ADRESSE MAL FORMEE NE DOIT PAS RENDRE LA PAGE MUETTE (Adrien, 13/08/2026 :
         « le placeholder image adapte a occasion= ne fonctionne pas », capture d'un
         `?layout=photo?occasion=chien` avec un SECOND point d'interrogation au lieu d'une
         esperluette). Lu tel quel, `layout` valait « photo?occasion=chien », qui n'est aucun
         type connu, et `occasion` etait nul : ni le type ni l'intention ne s'appliquaient, la
         fiche montrait le filigrane generique, et RIEN ne signalait pourquoi.
         ⚠️ Verifie le meme jour : ni le theme ni les annonces Google ne fabriquent cette forme
         (les RSA vivantes portent `layout=photo&occasion=chien` dans leur suffixe ; les deux
         URL en `look=` retrouvees sont des annonces SUPPRIMEES). Elle vient donc d'ailleurs :
         une adresse recopiee a la main, un lien recolle par un client de messagerie, un
         partenaire. Ce sont exactement les cas ou personne ne viendra corriger l'adresse.
         Un `?` en deuxieme position n'a aucun autre sens possible que « et aussi » : on le lit
         comme tel plutot que de perdre le parametre. */
      var q = new URLSearchParams(String(location.search || "").replace(/\?/g, function (m, i) {
        return i === 0 ? "?" : "&";
      }));
      var TYPES = ["photo", "message", "texte"];
      layout = (q.get("layout") || "").toLowerCase();
      occasion = (q.get("occasion") || "").toLowerCase();
      var heritage = (q.get("look") || "").toLowerCase();
      if (heritage) {
        if (TYPES.indexOf(heritage) >= 0) { if (!layout) layout = heritage; }
        else if (!occasion) occasion = heritage;
      }
      if (TYPES.indexOf(layout) < 0) layout = "";
    } catch (e) { layout = ""; occasion = ""; }
    return { layout: layout, occasion: occasion };
  };
  (function bindPersoText() {
    /* ⛔⛔ LA DELEGATION VIT SUR LE DOCUMENT, PLUS SUR `#perso-text`.
       Elle etait posee sur ce conteneur, et l'atelier plein ecran en SORT les blocs (mises en
       page, polices, couleurs, saisie) pour les repartir dans ses onglets. Les clics ne
       remontaient donc plus jusqu'a l'ecouteur : dans la fenetre, AUCUNE option ne faisait quoi
       que ce soit. Mesure du 23/08/2026 dans le Chrome d'Adrien, huit mises en page et huit
       polices cliquees une a une : `aria-pressed` ne bougeait pas, et l'apercu rendait Playfair
       Display du premier au dernier clic.
       ⚠️ ET C'EST BIEN UN DEFAUT DE PORTEE, PAS D'ECOUTEUR PERDU : un ecouteur suit le noeud sur
       lequel il est pose ; celui-ci etait pose sur l'ANCETRE, qui n'a pas bouge. Le pele-mele,
       lui, attache ses ecouteurs a chacun de ses blocs : ils voyagent avec eux, et ses reglages
       marchent dans la fenetre.
       ⚠️ `button[data-perso-design]` ET NON `[data-perso-design]` : cet attribut est aussi pose
       sur l'apercu lui-meme (`el.setAttribute("data-perso-design", …)`). Sur le document, un clic
       sur l'affiche aurait donc rejoue la mise en page courante a chaque fois. Les deux autres
       n'existent que sur des boutons, mais on les ecrit pareil : une regle qui se lit en une
       fois vaut mieux qu'une exception a retenir. */
    document.addEventListener("click", function (e) {
      if (!e.target || !e.target.closest) return;
      var mode = e.target.closest("[data-perso-text-mode]");
      if (mode) {
        if (window.__pdpMontrerLAffiche) window.__pdpMontrerLAffiche();
        setPersoTextMode(mode.getAttribute("data-perso-text-mode") === "on");
        return;
      }
      var goto = e.target.closest("[data-perso-text-goto]");
      if (goto) { setPersoTextStep(goto.getAttribute("data-perso-text-goto"), { focusTitle: true }); return; }
      var back = e.target.closest("[data-perso-text-back]");
      if (back) { setPersoTextStep(persoTextStep - 1); return; }
      var next = e.target.closest("[data-perso-text-next]");
      if (next) {
        if (persoTextStep >= PERSO_TEXT_STEPS) return;
        setPersoTextStep(persoTextStep + 1, { focusTitle: true });
        return;
      }
      var design = e.target.closest("button[data-perso-design]");
      if (design) {
        if (window.__pdpMontrerLAffiche) window.__pdpMontrerLAffiche();
        setPersoTextDesign(design.getAttribute("data-perso-design"));
        return;
      }
      var color = e.target.closest("button[data-perso-color]");
      if (color) {
        if (window.__pdpMontrerLAffiche) window.__pdpMontrerLAffiche();
        setPersoTextColor(color.getAttribute("data-perso-color"));
        return;
      }
      var font = e.target.closest("button[data-perso-font]");
      if (font) {
        if (window.__pdpMontrerLAffiche) window.__pdpMontrerLAffiche();
        setPersoFont(font.getAttribute("data-perso-font"));
      }
    });
    ["perso-text-title", "perso-text-sub"].forEach(function (id) {
      var el = $("#" + id);
      if (el) el.addEventListener("input", function () {
        if (window.__pdpMontrerLAffiche) window.__pdpMontrerLAffiche();
        syncPersoTextPreview();
      });
    });
    // Lien marketing ?layout=message : ouvrir directement le mode texte.
    try {
      var pTexte = window.__persoUrlParams();
      /* ⛔ L'ENTREE MARKETING PRIME LA SESSION. La carte « Photo personnalisee » de la
         collection ouvrait la fiche en mode texte : la session du visiteur, restauree
         plus haut, gardait le dernier etat vu. Un parametre pose dans l'URL dit
         explicitement ce que la page doit montrer : texte pour layout=message/texte,
         photo pour layout=photo comme pour une occasion seule. */
      if (pTexte.layout === "message" || pTexte.layout === "texte") setPersoTextMode(true);
      else if (pTexte.layout || pTexte.occasion) setPersoTextMode(false);
    } catch (err) {}
  })();

  function loadPersoImage() {
    return new Promise(function (resolve, reject) {
      var src = null;
      // Toujours repartir de la photo d'origine, jamais d'une composition déjà bandée.
      if (photoSourceFile && /^image\//.test(photoSourceFile.type)) src = URL.createObjectURL(photoSourceFile);
      else if (persoSourceUrl && !/\.pdf($|\?)/i.test(persoSourceUrl)) src = persoSourceUrl;
      else if (persoPreview) src = persoPreview;
      else if (photo && !/\.pdf($|\?)/i.test(photo)) src = photo;
      if (!src) { reject(new Error("no_image")); return; }
      var img = new Image();
      img.onload = function () {
        if (src.indexOf("blob:") === 0) try { URL.revokeObjectURL(src); } catch (e) {}
        resolve(img);
      };
      img.onerror = function () { reject(new Error("img_load")); };
      // blob: OK ; URL runway : CORS doit autoriser le canvas (sinon toBlob échoue).
      if (src.indexOf("blob:") !== 0) img.crossOrigin = "anonymous";
      img.src = src;
    });
  }
  function wrapCanvasText(ctx, text, maxW) {
    var words = String(text || "").split(/\s+/).filter(Boolean);
    if (!words.length) return [];
    var lines = [], line = words[0];
    for (var i = 1; i < words.length; i++) {
      var test = line + " " + words[i];
      if (ctx.measureText(test).width <= maxW) line = test;
      else { lines.push(line); line = words[i]; }
    }
    lines.push(line);
    return lines.slice(0, 2);
  }
  /* ⛔ LE FICHIER COPIE LA BANDE QUE LE CLIENT REGARDE, IL NE LA REFAIT PAS.
   *
   * La mise en page du texte était écrite DEUX FOIS, et les deux versions avaient divergé :
   * marge latérale 5,5 % dans base.css contre 8 % ici, police réduite jusqu'à tenir sur une
   * ligne à l'écran contre taille fixe puis retour à la ligne ici, interlettrage appliqué par
   * le CSS et absent du canvas, interligne 1,26 contre 1,15. « Désert de Chegaga » tenait donc
   * sur une ligne à l'écran et sortait sur deux dans le fichier envoyé au panier, puis à
   * l'impression (A1032, 01/08/2026).
   *
   * Tout se lit désormais sur l'élément RÉELLEMENT AFFICHÉ, en fractions de sa boîte, et se
   * rejoue à l'échelle de la feuille. Deux conséquences voulues : la taille de police retenue
   * est celle que `fitPersoTextBand` a déjà calculée, donc le nombre de lignes est le même par
   * construction ; et modifier base.css suffit, le fichier suit sans qu'on y touche.
   */
  function reglagesBandeAffichee() {
    var band = document.querySelector("#pdp-frame [data-pdp-textband]");
    if (!band || band.hidden) return null;
    var bw = band.offsetWidth, bh = band.offsetHeight;
    var tEl = band.querySelector("[data-pdp-textband-title]");
    if (!bw || !bh || !tEl || !tEl.clientWidth) return null;
    var ct = getComputedStyle(tEl), cb = getComputedStyle(band);
    var ts = parseFloat(ct.fontSize) || 0;
    if (!ts) return null;
    var sEl = band.querySelector("[data-pdp-textband-sub]");
    var cs = sEl && sEl.textContent ? getComputedStyle(sEl) : null;
    var em = function (v, base) { var n = parseFloat(v); return isFinite(n) ? n / base : 0; };
    /* ⛔ LES POSITIONS DU TEXTE SE MESURENT, ELLES NE SE RECALCULENT PLUS.
     *
     * Le canvas reconstruisait la place de chaque ligne : hauteur du bloc, interligne, ecart
     * titre/sous-titre, puis centrage vertical du tout. Six operations qui refont, a la main,
     * ce que le moteur de rendu a deja fait a l'ecran. Elles ont diverge autant de fois qu'on
     * les a touchees ; derniere en date le 08/08/2026, le sous-titre imprime plus bas que sur
     * la fiche parce que `rowGap` et l'avance de ligne ne se composent pas comme suppose.
     *
     * Desormais on releve le RECTANGLE REELLEMENT PEINT de chaque element, en fractions de la
     * bande. Le fichier place son texte la ou le navigateur l'a mis. Il n'y a plus de calcul a
     * faire diverger, et ca vaut pour les quatre mises en page d'un coup.
     *
     * `lignes` compte les lignes peintes : un titre sur deux lignes a un rectangle deux fois
     * plus haut, et l'avance vaut sa hauteur divisee par ce compte. La aussi, mesure. */
    var boite = function (el) {
      if (!el) return null;
      var re = el.getBoundingClientRect(), rb = band.getBoundingClientRect();
      if (!re.width || !re.height) return null;
      return {
        cx: (re.left + re.width / 2 - rb.left) / rb.width,
        cy: (re.top + re.height / 2 - rb.top) / rb.height,
        h: re.height / rb.height,
        lignes: Math.max(1, el.getClientRects().length)
      };
    };
    return {
      titreBoite: boite(tEl),
      sousBoite: (sEl && sEl.textContent) ? boite(sEl) : null,
      /* Largeur utile : celle du titre lui-même, padding de la bande déjà retiré. */
      utile: tEl.clientWidth / bw,
      titre: ts / bh,
      titreTracking: em(ct.letterSpacing, ts),
      titrePoids: ct.fontWeight || "700",
      titreFamille: ct.fontFamily,
      titreMajuscules: ct.textTransform === "uppercase",
      interligne: em(ct.lineHeight, ts) || 1.26,
      sous: cs ? (parseFloat(cs.fontSize) || 0) / bh : 0,
      sousTracking: cs ? em(cs.letterSpacing, parseFloat(cs.fontSize) || 1) : 0,
      sousFamille: cs ? cs.fontFamily : null,
      sousPoids: cs ? cs.fontWeight || "400" : "400",
      sousInterligne: cs ? em(cs.lineHeight, parseFloat(cs.fontSize) || 1) || 1.26 : 1.26,
      sousMajuscules: cs ? cs.textTransform === "uppercase" : false,
      ecart: (parseFloat(cb.rowGap || cb.gap) || 0) / bh,
      /* L'écran a-t-il dû passer à deux lignes ? Si non, le fichier ne s'y autorise pas. */
      retourLigne: ct.whiteSpace === "normal"
    };
  }
  /* L'interlettrage du canvas n'existe pas partout (Safari ancien). Là où il manque, le titre
     sort un peu plus court que sur la maquette : c'est le seul écart qui subsiste, et il ne
     change ni la taille ni le nombre de lignes. */
  function poserInterlettrage(ctx, px) {
    try { ctx.letterSpacing = (px || 0) + "px"; } catch (e) { /* non supporté : sans effet */ }
  }

  /**
   * ⛔ LE TEXTE, POSE LA OU L'ECRAN L'A MIS. LE SEUL CHEMIN.
   *
   * Quatre fonctions dessinaient le texte des quatre mises en page, chacune avec sa propre
   * arithmetique de centrage. Quatre occasions de diverger de l'ecran, et elles l'ont fait.
   * Celle-ci les remplace toutes : elle ne calcule aucune position, elle rejoue les rectangles
   * releves par `reglagesBandeAffichee` a l'echelle de la feuille.
   *
   * Rend `true` quand elle a pu dessiner. Sinon l'appelant garde son ancien chemin, qui reste
   * le repli des cas ou la bande n'est pas mesurable (composition hors ecran).
   */
  /* ⛔ UNE CURSIVE NE PART JAMAIS EN CAPITALES, QUEL QUE SOIT LE GABARIT (Adrien, 15/08/2026 :
     « police illisible, verifie PARTOUT ou elle est utilisee »). Les majuscules d'une anglaise
     sont des parafes, dessines pour ouvrir un mot UNE fois : sept a la suite, leurs boucles se
     traversent et le mot devient un noeud. Le defaut a ete vu sur le pele-mele et corrige la ;
     cette garde ferme le meme trou ici.
     ⚠️ AUJOURD'HUI LE DEFAUT NE SE VOIT PAS, ET C'EST JUSTEMENT POURQUOI ON LE FERME. La table
     des polices donne `titleTransform: "none"` a `script`, donc `majuscules` est faux par
     ricochet. Mais la ligne qui decide s'ecrit `r ? r.titreMajuscules : font.titleTransform`,
     et un gabarit qui poserait `titreMajuscules: true` ECRASERAIT le reglage de la police sans
     rien savoir d'elle. Aucun ne le fait ce jour ; le premier qui le fera n'aura pas a y penser.
     C'est exactement la forme du bug du pele-mele : une regle de gabarit qui ignore la famille
     choisie par la cliente. */
  function estCursive(fam) {
    return /Great Vibes|Apple Chancery|Snell|cursive/i.test(String(fam || ""));
  }
  /* ⛔⛔ NE PLUS FORCER LA MAJUSCULE NE SUFFIT PAS, IL FAUT LA DEFAIRE (Adrien, 20/08/2026 :
     « toujours le meme probleme, toujours avec la meme police, corrige partout »). Cette page
     savait deja ne pas METTRE en capitales une anglaise : `majuscules && !estCursive(...)`. Mais
     la cliente, elle, tape souvent en capitales — « MOMENTS DE BONHEUR » —, et son texte partait
     tel quel. Les majuscules d'une anglaise sont des PARAFES, dessines pour ouvrir un mot une
     fois : a la suite, leurs boucles se traversent et le mot devient un noeud.
     C'est mot pour mot la lecon deja payee sur le pele-mele le 15/08/2026, et elle n'avait pas
     traverse jusqu'ici. Les trois configurateurs appliquent desormais la meme regle.
     ⚠️ SEULE L'INITIALE DE LA PHRASE SE LEVE, PAS CHAQUE MOT : « TOI ET MOI » doit donner « Toi
     et moi », pas « Toi Et Moi », qui est une capitalisation anglaise, fautive en francais et
     bien visible sur une affiche encadree. */
  function enBasDeCasse(txt) {
    var bas = String(txt).toLowerCase();
    return bas.replace(/\p{L}/u, function (l) { return l.toUpperCase(); });
  }
  /* La casse d'un texte, selon sa famille. UN seul juge pour les six traces de cette page. */
  function casseTexte(texte, famille, majuscules) {
    if (estCursive(famille)) return enBasDeCasse(texte);
    return majuscules ? String(texte).toUpperCase() : String(texte);
  }
  function dessinerTexteMesure(ctx, bx, by, bw, bh, r, title, sub, mat) {
    if (!r || !r.titreBoite) return false;
    var poser = function (b, texte, taille, famille, poids, tracking, majuscules, couleur) {
      if (!b || !texte) return;
      var px = Math.round(bh * taille);
      ctx.font = poids + " " + px + "px " + famille;
      poserInterlettrage(ctx, px * (tracking || 0));
      ctx.fillStyle = couleur;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      var mot = casseTexte(texte, famille, majuscules);
      var x = bx + bw * b.cx;
      /* Le rectangle mesure couvre TOUTES les lignes : l'avance est sa hauteur divisee par
         leur nombre, et la premiere ligne se centre a un demi-pas du haut. Rien a deviner. */
      var lignes = b.lignes > 1 ? wrapCanvasText(ctx, mot, bw * 0.92) : [mot];
      var pas = (bh * b.h) / lignes.length;
      var haut = by + bh * b.cy - (bh * b.h) / 2;
      for (var i = 0; i < lignes.length; i += 1) {
        ctx.fillText(lignes[i], x, haut + pas * (i + 0.5));
      }
    };
    poser(r.titreBoite, title, r.titre, r.titreFamille, r.titrePoids, r.titreTracking, r.titreMajuscules, mat.ink);
    poser(r.sousBoite, sub, r.sous, r.sousFamille || r.titreFamille, r.sousPoids, r.sousTracking, r.sousMajuscules, mat.muted);
    poserInterlettrage(ctx, 0);
    return true;
  }
  /* ⛔ EDITORIAL, LES MEMES FRACTIONS PARTOUT : titre centre dans [6 %, 58 %] de la
     bande, barre verticale a 60 % (de 22 % a 78 % de la hauteur), sous-titre a gauche
     dans [64 %, 94 %], deux lignes au plus. base.css et perso-tirage.js les portent
     aussi ; en changer une sans les autres ferait mentir l'apercu (02/08/2026). */
  function drawPersoEditorial(ctx, x, y, w, h, title, sub, font, mat) {
    /* ⛔ LE FILET SE TRACE AVANT DE DELEGUER. Il n'est pas du texte : `dessinerTexteMesure`
       ne pose que des lettres, et un `return` place au-dessus l'aurait fait disparaitre. */
    if (sub) {
      ctx.strokeStyle = mat.muted;
      ctx.lineWidth = Math.max(1, h * 0.015);
      ctx.beginPath();
      ctx.moveTo(x + w * 0.60, y + h * 0.22);
      ctx.lineTo(x + w * 0.60, y + h * 0.78);
      ctx.stroke();
    }
    /* Le texte est pose aux places relevees sur l'ecran : voir dessinerTexteMesure.
       L'ancien calcul reste dessous, en repli, pour une bande non mesurable. */
    if (dessinerTexteMesure(ctx, x, y, w, h, reglagesBandeAffichee(), title, sub, mat)) return;
    var r = reglagesBandeAffichee();
    var famT = (r && r.titreFamille) || font.family;
    var poidsT = (r && r.titrePoids) || font.titleWeight;
    var majuscules = (r ? r.titreMajuscules : font.titleTransform === "uppercase")
      && !estCursive(font.family);
    var drawTitle = casseTexte(title, font.family, majuscules);
    var zoneTitreX = x + w * 0.06, zoneTitreW = w * 0.52;
    var titleSize = Math.round(h * 0.40);
    ctx.textAlign = "center"; ctx.textBaseline = "middle";
    var garde = 24;
    ctx.font = poidsT + " " + titleSize + "px " + famT;
    while (garde-- > 0 && titleSize > 8 && ctx.measureText(drawTitle).width > zoneTitreW) {
      titleSize = Math.round(titleSize * 0.92);
      ctx.font = poidsT + " " + titleSize + "px " + famT;
    }
    ctx.fillStyle = mat.ink;
    ctx.fillText(drawTitle, zoneTitreX + zoneTitreW / 2, y + h / 2);
    if (sub) {
      ctx.strokeStyle = mat.muted;
      ctx.lineWidth = Math.max(1, h * 0.015);
      ctx.beginPath();
      ctx.moveTo(x + w * 0.60, y + h * 0.22);
      ctx.lineTo(x + w * 0.60, y + h * 0.78);
      ctx.stroke();
      var famS = (r && r.sousFamille) || font.family;
      /* 0.20h : sous-titre lisible (0.155 trop petit, 02/08/2026). Meme fraction dans
         traceEditorial (perso-tirage.js) et meme bond que le 9px de base.css. */
      var subSize = Math.round(h * 0.20);
      ctx.font = "400 " + subSize + "px " + famS;
      ctx.textAlign = "left";
      var zoneSubX = x + w * 0.64, zoneSubW = w * 0.30;
      /* Aucun mot ne se perd : on reduit jusqu'a ce que deux lignes portent tout. */
      var drawSub = casseTexte(sub, font.family, !!(r && r.sousMajuscules));
      var attendu = drawSub.split(/\s+/).filter(Boolean).join(" ");
      var lignes = wrapCanvasText(ctx, drawSub, zoneSubW).slice(0, 2);
      var gardeSub = 14;
      while (gardeSub-- > 0 && lignes.join(" ") !== attendu && subSize > 5) {
        subSize = Math.round(subSize * 0.88);
        ctx.font = "400 " + subSize + "px " + famS;
        lignes = wrapCanvasText(ctx, drawSub, zoneSubW).slice(0, 2);
      }
      var bloc = lignes.length * subSize * 1.3;
      var sy = y + h / 2 - bloc / 2 + subSize * 0.65;
      ctx.fillStyle = mat.muted;
      for (var i = 0; i < lignes.length; i++) { ctx.fillText(lignes[i], zoneSubX, sy); sy += subSize * 1.3; }
      ctx.textAlign = "center";
    }
  }
  /* ⛔ ARCHE ET GALERIE : les memes fractions que base.css et perso-tirage.js
     (traceArche : titre 30 %, filet 12 % de largeur, sous-titre 16 % ; traceMusee :
     cartel a gauche, titre 34 %, sous-titre 24 %) (02/08/2026). */
  function drawPersoArche(ctx, x, y, w, h, title, sub, font, mat) {
    /* ⛔ LE FILET SE TRACE AVANT DE DELEGUER, meme raison que l'editorial. */
    if (sub) {
      ctx.strokeStyle = mat.muted;
      ctx.lineWidth = Math.max(1, h * 0.012);
      ctx.beginPath();
      ctx.moveTo(x + w / 2 - w * 0.06, y + h * 0.52);
      ctx.lineTo(x + w / 2 + w * 0.06, y + h * 0.52);
      ctx.stroke();
    }
    /* Le texte est pose aux places relevees sur l'ecran : voir dessinerTexteMesure.
       L'ancien calcul reste dessous, en repli, pour une bande non mesurable. */
    if (dessinerTexteMesure(ctx, x, y, w, h, reglagesBandeAffichee(), title, sub, mat)) return;
    var r = reglagesBandeAffichee();
    var famT = (r && r.titreFamille) || font.family;
    var famS = (r && r.sousFamille) || font.family;
    var majuscules = (r ? r.titreMajuscules : font.titleTransform === "uppercase")
      && !estCursive(font.family);
    var drawTitle = casseTexte(title, font.family, majuscules);
    var titleSize = Math.round(h * 0.30);
    ctx.textAlign = "center"; ctx.textBaseline = "middle";
    ctx.font = ((r && r.titrePoids) || font.titleWeight) + " " + titleSize + "px " + famT;
    var garde = 20;
    while (garde-- > 0 && titleSize > 8 && ctx.measureText(drawTitle).width > w * 0.88) {
      titleSize = Math.round(titleSize * 0.92);
      ctx.font = ((r && r.titrePoids) || font.titleWeight) + " " + titleSize + "px " + famT;
    }
    ctx.fillStyle = mat.ink;
    ctx.fillText(drawTitle, x + w / 2, y + h * (sub ? 0.30 : 0.55));
    if (sub) {
      ctx.strokeStyle = mat.muted;
      ctx.lineWidth = Math.max(1, h * 0.012);
      ctx.beginPath();
      ctx.moveTo(x + w / 2 - w * 0.06, y + h * 0.52);
      ctx.lineTo(x + w / 2 + w * 0.06, y + h * 0.52);
      ctx.stroke();
      var subSize = Math.round(h * 0.16);
      ctx.font = "400 " + subSize + "px " + famS;
      ctx.fillStyle = mat.muted;
      ctx.fillText(sub, x + w / 2, y + h * 0.74);
    }
  }
  function drawPersoMusee(ctx, x, y, w, h, title, sub, font, mat) {
    /* Le texte est pose aux places relevees sur l'ecran : voir dessinerTexteMesure.
       L'ancien calcul reste dessous, en repli, pour une bande non mesurable. */
    if (dessinerTexteMesure(ctx, x, y, w, h, reglagesBandeAffichee(), title, sub, mat)) return;
    var r = reglagesBandeAffichee();
    var famT = (r && r.titreFamille) || font.family;
    var famS = (r && r.sousFamille) || font.family;
    var majuscules = (r ? r.titreMajuscules : font.titleTransform === "uppercase")
      && !estCursive(font.family);
    var drawTitle = casseTexte(title, font.family, majuscules);
    ctx.textAlign = "left"; ctx.textBaseline = "alphabetic";
    var titleSize = Math.round(h * 0.34);
    ctx.font = ((r && r.titrePoids) || font.titleWeight) + " " + titleSize + "px " + famT;
    ctx.fillStyle = mat.ink;
    ctx.fillText(drawTitle, x, y + titleSize * 0.9);
    if (sub) {
      var subSize = Math.round(h * 0.24);
      ctx.font = "400 " + subSize + "px " + famS;
      ctx.fillStyle = mat.muted;
      ctx.fillText(sub, x, y + titleSize * 0.9 + h * 0.05 + subSize * 1.05);
    }
    ctx.textAlign = "center"; ctx.textBaseline = "middle";
  }
  function drawPersoTextBlock(ctx, x, y, w, h, title, sub, font, mat) {
    /* Le texte est pose aux places relevees sur l'ecran : voir dessinerTexteMesure.
       L'ancien calcul reste dessous, en repli, pour une bande non mesurable. */
    if (dessinerTexteMesure(ctx, x, y, w, h, reglagesBandeAffichee(), title, sub, mat)) return;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    var r = reglagesBandeAffichee();
    /* Repli quand la bande n'est pas mesurable (composition hors écran) : les valeurs de
       base.css, écrites ici en clair, et la même règle « une ligne d'abord ». */
    var utile = r ? r.utile : 0.89;
    var maxW = w * utile;
    var titleSize = Math.round(h * (r ? r.titre : (sub ? 0.38 : 0.52)));
    var subSize = Math.round(h * (r ? r.sous : 0.18));
    var trackT = titleSize * (r ? r.titreTracking : 0.04);
    var trackS = subSize * (r ? r.sousTracking : 0.01);
    var interT = r ? r.interligne : 1.26;
    var interS = r ? r.sousInterligne : 1.26;
    var majuscules = (r ? r.titreMajuscules : font.titleTransform === "uppercase")
      && !estCursive(font.family);
    var famT = r ? r.titreFamille : font.family;
    var poidsT = r ? r.titrePoids : font.titleWeight;
    var famS = (r && r.sousFamille) || font.family;
    var poidsS = r ? r.sousPoids : "400";
    var drawTitle = casseTexte(title, font.family, majuscules);
    var poserT = function () {
      ctx.font = poidsT + " " + titleSize + "px " + famT;
      poserInterlettrage(ctx, trackT);
    };
    poserT();
    /* Sans réglage lu à l'écran, on refait ici la règle de `fitPersoTextBand` : réduire pour
       tenir sur une ligne, et ne couper qu'en dernier recours. */
    if (!r) {
      var plancher = Math.max(7, h * 0.16), garde = 28;
      while (garde-- > 0 && titleSize > plancher && ctx.measureText(drawTitle).width > maxW) {
        titleSize = Math.round(titleSize * 0.9); trackT = titleSize * 0.04; poserT();
      }
    }
    var titleLines = (r && !r.retourLigne) ? [drawTitle] : wrapCanvasText(ctx, drawTitle, maxW);
    var subLines = [];
    if (sub) {
      ctx.font = poidsS + " " + subSize + "px " + famS;
      poserInterlettrage(ctx, trackS);
      subLines = [casseTexte(sub, font.family, !!(r && r.sousMajuscules))];
    }
    var blockH = titleLines.length * titleSize * interT
      + (subLines.length ? subSize * interS * subLines.length + h * (r ? r.ecart : 0.06) : 0);
    var ty = y + h / 2 - blockH / 2 + titleSize * interT * 0.5;
    var cx = x + w / 2;
    poserT();
    ctx.fillStyle = mat.ink;
    titleLines.forEach(function (ln) {
      ctx.fillText(ln, cx, ty);
      ty += titleSize * interT;
    });
    if (subLines.length) {
      ty += h * (r ? r.ecart : 0.06);
      ctx.font = poidsS + " " + subSize + "px " + famS;
      poserInterlettrage(ctx, trackS);
      ctx.fillStyle = mat.muted;
      subLines.forEach(function (ln) {
        ctx.fillText(ln, cx, ty);
        ty += subSize * interS;
      });
    }
    poserInterlettrage(ctx, 0);
  }
  /* ⛔ LA SORTIE EST AU RATIO DE L'AFFICHE, ET ELLE PORTE LE CADRAGE DU CLIENT.
   *
   * Elle dessinait l'image ENTIÈRE, à son ratio à elle. Deux conséquences, toutes deux payées
   * par le client : le cadrage qu'il venait de régler à l'écran ne servait à rien, et sa photo
   * partait à l'impression avec des bandes blanches dès que son ratio n'était pas celui de
   * l'affiche (le tirage place en « contain » depuis le 21/07/2026). Relevé le 01/08/2026 sur
   * A1032 : une image en 1053x2096 commandée en 30x40.
   *
   * Le rectangle source se calcule exactement comme l'aperçu : `cover` multiplié par le zoom,
   * puis positionné par x et y en pourcentage du débordement. C'est la même arithmétique que
   * `background-size` et `background-position`, sans quoi l'aperçu et le tirage divergeraient. */
  /* La zone retenue, en pixels de l'image d'origine : la plus grande qui tienne dans le ratio
     de la zone photo, réduite par le zoom. Séparée du dessin parce que le contrôle qualité en a
     besoin AUSSI, et qu'il ne charge pas l'image : il ne connaît que ses dimensions. */
  function zoneRetenue(iw, ih) {
    var rc = persoRatioCible();
    var z = clampZoom(persoCrop.z);
    var sw, sh;
    if (iw / ih > rc) { sh = ih / z; sw = sh * rc; }
    else { sw = iw / z; sh = sw / rc; }
    return { w: Math.min(sw, iw), h: Math.min(sh, ih) };
  }

  function rectangleSource(img) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    var zone = zoneRetenue(iw, ih);
    var sw = zone.w, sh = zone.h;
    /* x et y disent où l'on regarde DANS le débordement : 0 % à gauche, 100 % à droite. */
    var sx = (iw - sw) * (clampPct(persoCrop.x) / 100);
    var sy = (ih - sh) * (clampPct(persoCrop.y) / 100);
    return { sx: sx, sy: sy, sw: sw, sh: sh };
  }

  /* Le côté long du fichier composé. Assez pour imprimer un 70x100 correctement, borné pour ne
     pas fabriquer un JPEG de vingt mégaoctets dans le navigateur d'un téléphone. */
  /* ⛔ CETTE TOILE EST CE QUI PART A LA PRESSE (Adrien, 08/08/2026 : « on upscale directement
     la composition du client »). Le serveur ne redessine plus rien : ce fichier est agrandi
     tel quel, texte compris. Sa definition est donc la matiere premiere de l'agrandissement,
     et non plus un simple apercu.
     2400 px de large jusqu'a ce soir, ce qui bornait une photo de telephone bien au-dessous
     de ce qu'elle offrait. 2800 double presque le nombre de pixels et reste sous la limite de
     surface des canvas iOS (2800 × 4045 = 11,3 Mpx, la barre est vers 16,7).
     ⛔ LA FEUILLE FAIT TOUJOURS CETTE TAILLE, MEME SI LA PHOTO EST PLUS PETITE (Adrien,
     08/08/2026 : « envoie au serveur une qualite suffisante pour qu'on puisse upscaler
     derriere »). La hauteur etait le MINIMUM de ce plafond et de la resolution de la photo,
     ce qui avait du sens quand le serveur retracait le texte a 300 dpi : la toile n'etait
     alors qu'un apercu. Depuis qu'elle EST le fichier d'impression, ce minimum grave le
     texte a la definition de la photo. Commande 1084 : photo de 1200x1600, donc toile de
     1108x1600, donc un titre a agrandir 5,4 fois pour tenir un 50x70 a 300 dpi. Les lettres
     n'y survivent pas.
     La photo, elle, est rééchantillonnee par le navigateur pour remplir sa zone. C'est le
     prix, et il est faible : Topaz aurait eu ce meme agrandissement a faire, et il le fait
     desormais sur un texte deja net au lieu de le faire sur un texte deja mou.
     La composition ne change pas d'un pixel de mise en page : memes fractions, meme cadrage,
     memes couleurs. Seul l'echantillonnage monte. */
  var PERSO_SORTIE_MAX = 2800;

  /* ⛔ LA SOURCE VOULUE : le cadrage du client, seul, a pleine resolution (Adrien, 07/08/2026 :
     « _source reste le fichier source voulu par le client, avec recadrage, zoom, crop »). Ni
     mise en page, ni bande, ni texte : exactement le rectangle que le client a choisi dans
     l'interface, decoupe dans l'image d'origine. Elle part en _perso_source ; l'originale
     complete part en _perso_source_uncropped. */
  function composePersoSourceCadree() {
    return loadPersoImage().then(function (img) {
      var src = rectangleSource(img);
      var canvas = document.createElement("canvas");
      canvas.width = Math.max(1, Math.round(src.sw));
      canvas.height = Math.max(1, Math.round(src.sh));
      canvas.getContext("2d").drawImage(img, src.sx, src.sy, src.sw, src.sh, 0, 0, canvas.width, canvas.height);
      return new Promise(function (resolve, reject) {
        canvas.toBlob(function (b) {
          if (b) resolve(new File([b], "source.jpg", { type: "image/jpeg" }));
          else reject(new Error("blob"));
        }, "image/jpeg", 0.92);
      });
    });
  }

  /* ⛔⛔⛔ LA POLICE DOIT ETRE CHARGEE AVANT QUE LE CANVAS DESSINE, ET RIEN NE LE DISAIT.
     Adrien, 20/08/2026 : « la police affichee dans l'apercu ne correspond pas au rendu client
     qu'on est cense imprimer ». Cause mesuree : `composePersoWithText` fabrique l'image QUI
     PART A LA PRESSE, et un canvas qui rencontre une police pas encore telechargee ne l'attend
     pas : il dessine avec le repli systeme, sans erreur, sans avertissement. L'apercu, lui, est
     du DOM : le navigateur le repeint tout seul quand la police arrive. L'ecran montrait donc
     Great Vibes et le fichier partait en cursive systeme.
     ⚠️ CE N'EST PAS UNE THEORIE : le pele-mele charge deja ses polices avant de composer
     (`pele-mele.js`, document.fonts.load), et product.js ne le faisait NULLE PART.
     ⚠️ ON CHARGE LES TROIS GRAISSES UTILISEES : `document.fonts.load` ne charge que la variante
     demandee, et un titre en 700 ne vient pas avec un sous-titre en 400.
     ⚠️ ET ON N'ECHOUE JAMAIS DESSUS : une police indisponible doit degrader le dessin, pas
     empecher la cliente de commander. */
  function policesPretes(font) {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    var fam = String((font && font.family) || "");
    if (!fam) return Promise.resolve();
    var essais = ["400 64px " + fam, "500 64px " + fam, "700 64px " + fam];
    return Promise.all(essais.map(function (f) {
      try { return document.fonts.load(f).catch(function () {}); }
      catch (e) { return Promise.resolve(); }
    })).then(function () {
      return document.fonts.ready ? document.fonts.ready.catch(function () {}) : null;
    }).catch(function () {});
  }

  function composePersoWithText() {
    /* ⛔ D'ABORD POSER L'ECRAN, ENSUITE LE LIRE. Tout ce qui suit tire ses fractions de la bande
       affichee ; une bande pas encore ajustee donnerait un titre deux fois trop petit dans le
       fichier d'impression. Voir `ajusterBandesMaintenant`. */
    ajusterBandesMaintenant();
    var title = persoTextOn ? persoTextTitle() : "";
    var sub = sousAffiche(persoTextOn ? persoTextSub() : "");
    var font = PERSO_FONTS[fontIdDe("titre")] || PERSO_FONTS.classic;
    var fontSous = PERSO_FONTS[fontIdDe("sous")] || font;
    var mat = persoMatTheme();
    var g = persoGeometrie();
    return Promise.all([policesPretes(font), policesPretes(fontSous)])
      .then(loadPersoImage).then(function (img) {
      var src = rectangleSource(img);
      /* La FEUILLE d'abord : sa hauteur est le côté long autorisé, sa largeur suit le ratio de
         l'affiche. Tout le reste se place dedans, en fractions, exactement comme la maquette à
         l'écran. Voir PERSO_SORTIE_MAX : cette taille ne depend PAS de la photo, sinon le texte
         serait grave a la definition de la photo et l'agrandissement le detruirait. */
      var H = Math.round(PERSO_SORTIE_MAX / Math.max(g.R, 0.2));
      var W = Math.round(H * g.R);
      if (!W || !H) throw new Error("bad_size");
      var canvas = document.createElement("canvas");
      canvas.width = W; canvas.height = H;
      var ctx = canvas.getContext("2d");
      /* La feuille est plus grande que la photo dans presque tous les cas : c'est le navigateur
         qui rééchantillonne, et son filtre par defaut est le moins bon des trois. Ce reglage ne
         coute rien et c'est la seule qualite d'image qu'on maitrise avant Topaz. */
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      /* Le fond de la feuille : la couleur du passe-partout quand il y en a un, blanc sinon.
         Il n'est jamais visible ailleurs, mais un JPEG n'a pas de transparence : sans lui, les
         bords sortiraient en noir. */
      ctx.fillStyle = g.passePartout ? mat.bg : "#fff";
      ctx.fillRect(0, 0, W, H);
      var ix = Math.round(g.img.x * W), iy = Math.round(g.img.y * H);
      var iw = Math.round(g.img.w * W), ih = Math.round(g.img.h * H);
      if (persoTextDesign === "arche") {
        /* ⛔ LA VOUTE EST UNE DEMI-ELLIPSE, PAS UN DEMI-CERCLE : rayons 50 % de la
           largeur et 45 % de la hauteur de la zone, exactement le border-radius CSS de
           l'ecran et le masque SVG du composer (perso-tirage.js). En portrait c'est un
           quasi plein cintre ; en paysage, le demi-cercle (rayon = largeur/2) mangeait
           toute la photo alors que l'ecran montrait un dome bas (02/08/2026). */
        var rax = iw / 2, ray = ih * 0.45;
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(ix, iy + ray);
        ctx.ellipse(ix + rax, iy + ray, rax, ray, 0, Math.PI, 0);
        ctx.lineTo(ix + iw, iy + ih);
        ctx.lineTo(ix, iy + ih);
        ctx.closePath();
        ctx.clip();
        ctx.drawImage(img, src.sx, src.sy, src.sw, src.sh, ix, iy, iw, ih);
        ctx.restore();
      } else {
        ctx.drawImage(img, src.sx, src.sy, src.sw, src.sh, ix, iy, iw, ih);
      }
      if (g.bande && title) {
        var bx = Math.round(g.bande.x * W), by = Math.round(g.bande.y * H);
        var bw = Math.round(g.bande.w * W), bh = Math.round(g.bande.h * H);
        /* Sur la photo (design « zone »), la bande a besoin de son fond ; dans le
           passe-partout, le fond de la feuille suffit déjà. */
        if (!g.passePartout && !g.voile) { ctx.fillStyle = mat.bg; ctx.fillRect(bx, by, bw, bh); }
        var matTexte = encreEffective(mat, g.voile);
        if (g.voile) {
          /* ⛔ L'ENCRE DU VOILE SUIT LA PHOTO : luminance des pixels reellement composes
             sous le texte, MEMES seuil (0.55) et couleurs que l'ecran (encreVoileAuto)
             et l'impression (perso-tirage.js). Pastille explicite prioritaire. */
          try {
            /* 70 % centraux et MEDIANE, comme l'ecran et le tirage. */
            var vbx = Math.max(0, Math.round(bx + bw * 0.15));
            var vd = ctx.getImageData(vbx, Math.max(0, by),
              Math.max(1, Math.min(W - vbx, Math.round(bw * 0.7))), Math.max(1, Math.min(H - by, bh))).data;
            var vAuto = encresParLuminance(luminanceMediane(vd));
            if (!persoInkTitre) matTexte.ink = vAuto.ink;
            if (!persoInkSous) matTexte.muted = vAuto.muted;
          } catch (e) {}
        }
        if (persoTextDesign === "editorial") drawPersoEditorial(ctx, bx, by, bw, bh, title, sub, font, matTexte);
        else if (persoTextDesign === "arche") drawPersoArche(ctx, bx, by, bw, bh, title, sub, font, matTexte);
        else if (persoTextDesign === "musee") drawPersoMusee(ctx, bx, by, bw, bh, title, sub, font, matTexte);
        else drawPersoTextBlock(ctx, bx, by, bw, bh, title, sub, font, matTexte);
      }
      return new Promise(function (resolve, reject) {
        /* ⛔ 0,95 ET NON 0,92 : ce fichier passe dans Topaz, qui amplifie les artefacts de
           compression au lieu de les effacer. Un bloc de 8x8 mal code autour d'une lettre
           devient une bavure visible sur un 50x70. Le surcout est d'environ 40 % d'octets,
           soit 6 a 9 Mo pour une feuille de 2800x4045, tres en dessous des 30 Mo acceptes
           par /perso/upload. */
        canvas.toBlob(function (blob) {
          if (!blob) { reject(new Error("toBlob")); return; }
          resolve(new File([blob], title ? "affiche-perso-texte.jpg" : "affiche-perso.jpg", { type: "image/jpeg" }));
        }, "image/jpeg", 0.95);
      });
    });
  }

  /* ---- Depot de la photo client ----
     L'apercu se contentait d'une URL blob, locale a l'onglet : la photo ne quittait
     jamais le navigateur, donc la commande partait en production sans image. Le fichier
     est desormais depose sur l'app, et l'URL rendue voyage dans les proprietes de la
     ligne de panier : vignette du panier et fichier de production viennent de la. */
  function uploadPerso(f) {
    var endpoint = window.__persoUpload;
    if (!endpoint) return Promise.resolve(null); // pas configure : on ne bloque pas la vente
    persoUrl = null; persoUploading = true; syncPersoCta();
    return fetch(endpoint, { method: "POST", headers: { "Content-Type": f.type }, body: f })
      .then(function (r) { return r.ok ? r.json() : r.json().catch(function () { return {}; }).then(function (j) { throw new Error(j.error || r.status); }); })
      .then(function (j) {
        if (!j || !j.url) throw new Error("no_url");
        var hadSource = !!persoSourceUrl;
        persoUrl = j.url;
        if (window.__persoFunnel) window.__persoFunnel("import", j.preview || j.url);
        persoPreview = j.preview || null;
        // Source d'origine pour recomposer le texte : ne pas l'écraser si on
        // re-upload une version déjà textée (ATC « Avec texte »).
        if (!persoSourceUrl) {
          persoSourceUrl = (j.kind === "pdf" ? (persoPreview || null) : null) || persoPreview || persoUrl;
        }
        // Un PDF ne s'affiche pas dans une <img> : l'apercu n'existe qu'une fois la
        // premiere page rendue par l'app, donc on ne peut le poser qu'ici.
        if (j.kind === "pdf") {
          if (persoPreview) setPhoto(persoPreview);
          else if (window.murToast) {
            window.murToast(T.perso_no_preview || "PDF reçu : aperçu indisponible, le fichier sera bien imprimé");
          }
        } else if (!hadSource && (persoPreview || persoUrl)) {
          // Remplace le blob local par l'URL stable (survit au refresh).
          setPhoto(persoPreview || persoUrl);
        }
        persistPersoSession();
        return j;
      })
      .catch(function (err) {
        var m = String(err.message || "");
        if (window.murToast) {
          window.murToast(m === "too_large" ? T.perso_too_large || "Photo trop lourde (30 Mo maximum)"
                                            : T.perso_upload_failed || "Envoi de la photo impossible, réessayez");
        }
        throw err;
      })
      .then(function (j) { persoUploading = false; syncPersoCta(); return j; },
            function (err) { persoUploading = false; syncPersoCta(); throw err; });
  }
  $("#pdp-file") && $("#pdp-file").addEventListener("change", function (e) {
    /* Pêle-mêle : l'import (multiple) appartient à pele-mele.js, pas à la mécanique
       photo unique d'ici. Sans cette garde, la première photo de la sélection
       devenait LA photo perso et partait seule en upload. Le panneau de mariage
       consomme la sienne dans panneau-mariage.js, pour la meme raison. */
    if (window.__pdpPeleMele || window.__pdpPanneau) return;
    var f = e.target.files && e.target.files[0];
    if (!f) return;
    // L'app n'accepte que JPG, PNG et PDF : le dire ici evite un aller-retour pour rien.
    if (!/^(image\/(jpeg|png)|application\/pdf)$/.test(f.type)) {
      if (window.murToast) window.murToast(T.perso_bad_type || "Format non accepté : importez un JPG, un PNG ou un PDF");
      e.target.value = "";
      return;
    }
    photoFile = f;
    photoSourceFile = f;
    persoSourceUrl = null;
    persoCadreeUrl = null;
    resetPersoCrop({ persist: false });
    // Le JPG et le PNG s'affichent tout de suite depuis le fichier local ; le PDF attend
    // l'apercu rendu par l'app, pose plus bas par uploadPerso().
    if (f.type !== "application/pdf") setPhoto(URL.createObjectURL(f));
    /* Apres le rendu de la photo, sinon la cible n'a pas encore sa position finale. */
    setTimeout(function () { window.__pdpRemonteOptions(); }, 120);
    uploadPerso(f).catch(function () {});
  });
  $("#pdp-placeholder") && $("#pdp-placeholder").addEventListener("click", function () {
    var fi = $("#pdp-file"); if (fi) fi.click();
  });
  /* Sans photo importee, TOUTE la scene est une invitation a importer : un clic
     n'importe ou dans le slide principal (affiche d'exemple, piece en situation,
     zone du cadre) ouvre le selecteur (Adrien, 02/08/2026, apres une premiere
     version limitee a l'affiche dans la piece). Seule la navigation reste elle-meme
     (points ; les vignettes vivent hors du stage). En phase de capture avec
     stopPropagation : le gestionnaire du stage ouvrait sinon le plein ecran
     derriere le selecteur de fichiers (meme piege que le bloc de depot). */
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    /* ⛔ PAS SUR LE PANNEAU DE MARIAGE. Quatre de ses cinq types n'ont aucune photo a importer,
       et Adrien l'a deja dit du bouton d'appel le 06/08/2026 : « ca n'a aucun sens d'avoir
       importer ma photo comme CTA alors qu'il n'y a pas de photo a importer pour ces designs ».
       Un clic sur son propre panneau en train de se composer ouvrait le selecteur de fichiers.
       Le type photo, lui, a son bloc de depot, qui reste. */
    if (window.__pdpPanneau) return;
    /* ⛔ NI SUR LE PELE-MELE, ET C'EST UNE QUESTION DE CIBLE, PAS DE DOUBLON. Adrien,
       15/08/2026 : « l'image se met sur la premiere case et pas sur la case sur laquelle on a
       clique ». Ce gestionnaire est en phase de CAPTURE et appelle stopPropagation : tant
       qu'aucune photo n'est importee, il prenait le clic AVANT que le canvas de pele-mele.js
       ne le voie, et ouvrait le selecteur sans poser la case visee. La photo tombait donc sur
       la premiere case libre, et seulement au PREMIER import, puisque ce garde sort des que
       .pdp--perso-has-photo est la : de quoi passer pour un hasard.
       La scene du pele-mele n'a besoin de personne ici : son propre gestionnaire traite deja le
       clic sur une case ET le clic sur le fond (import sans cible). */
    if (window.__pdpPeleMele) return;
    var racinePerso = document.querySelector(".pdp--perso");
    if (!racinePerso || racinePerso.classList.contains("pdp--perso-has-photo")) return;
    var scene = e.target.closest("#pdp-stage");
    if (!scene) return;
    if (scene.getAttribute("data-swiping") === "1") return;
    if (e.target.closest(".pdp-room-choice, .pdp-murs, .pdp-dots, #pdp-qc, #pdp-upload")) return;
    var fi = $("#pdp-file");
    if (fi) { e.stopPropagation(); fi.click(); }
  }, true);
  /* ⛔ « CHANGER DE PHOTO » OUVRE LE SELECTEUR, IL NE REMET PAS LA DEMONSTRATION.
     Il appelait clearPhoto, qui efface la session et RECHARGE la page : le client qui voulait
     simplement remplacer son image se retrouvait devant l'affiche de demonstration, sa photo
     perdue, son texte et son cadrage avec (02/08/2026). Le changement de fichier suffit :
     le gestionnaire de #pdp-file remplace la photo, remet le cadrage a zero et televerse. */
  $("#pdp-photo-reset") && $("#pdp-photo-reset").addEventListener("click", function () {
    var fi = $("#pdp-file");
    if (fi) fi.click();
  });
  bindPersoCropControls();

  // Restaure la dernière photo déposée sur cette fiche (session navigateur).
  // Pêle-mêle : rien à restaurer ici, l'état collage appartient à pele-mele.js.
  if (!window.__pdpPeleMele && !window.__pdpPanneau) {
    restorePersoSession();
    restorePersoTextSession();
    /* ⛔ L'ORDRE FAIT LA REGLE. Le parametre d'URL etait applique AVANT ces restaurations,
       qui rallumaient le mode texte derriere lui : ?layout=photo rouvrait « Avec texte »
       (Adrien, 04/08/2026). L'entree marketing se rejoue donc APRES la session. */
    try {
      var pApres = window.__persoUrlParams ? window.__persoUrlParams() : { layout: "", occasion: "" };
      if (pApres.layout === "message" || pApres.layout === "texte") setPersoTextMode(true);
      else if (pApres.layout || pApres.occasion) setPersoTextMode(false);
    } catch (e) {}
  }

  // add to cart
  function pushCartLine() {
    if (window.__persoFunnel) window.__persoFunnel("panier");
    var v = currentVariant() || variants[0];
    if (!v) return;
    var props = {};
    if ((photo || persoUrl) && viewCustom) {
      props["_perso"] = "1";
      // L'URL du fichier depose : c'est elle que lisent la vignette du panier et l'atelier.
      // Prefixee d'un underscore, donc absente du panier et du mail de confirmation, mais
      // presente dans la commande cote administration.
      if (persoUrl) props["_perso_url"] = persoUrl;
      // Vignette panier : PDF → rendu JPG ; JPG/PNG → même URL. Toujours poser
      // _perso_preview quand on a une image affichable (le panier la lit en priorité).
      if (persoPreview) props["_perso_preview"] = persoPreview;
      else if (persoUrl && !/\.pdf($|\?)/i.test(persoUrl)) props["_perso_preview"] = persoUrl;
      if (window.__persoLook) props["_perso_look"] = window.__persoLook;
      if (window.__persoVid) props["_perso_vid"] = window.__persoVid;
      /* Le cadrage retenu, pour que l'atelier sache que le fichier EST déjà cadré et n'aille pas
         chercher à le refaire depuis l'original. */
      props["_perso_crop"] = Math.round(clampPct(persoCrop.x)) + "," + Math.round(clampPct(persoCrop.y))
        + "," + clampZoom(persoCrop.z).toFixed(2);
      /* Le fichier porte-t-il déjà ce cadrage ? Non pour un PDF, non si la composition a
         échoué. L'atelier ne doit pas avoir à le deviner. */
      props["_perso_crop_ok"] = persoCropApplique ? "1" : "0";
      props["_perso_orient"] = persoOrientation;
      if (window.__pdpPersoMetal) props["_support"] = "metal";
      if (persoOrientation === "paysage") props["Orientation"] = "Paysage";
      if (persoTextOn && persoTextTitle()) {
        props["_perso_text"] = "1";
        props["_perso_title"] = persoTextTitle();
        if (persoTextSub()) props["_perso_subtitle"] = persoTextSub();
        props["_perso_font"] = persoFont;
        /* ⚠️ SEULEMENT SI CE TEXTE NE SUIT PAS LA POLICE DE L'AFFICHE : une propriete qui repete
           la valeur globale se lit comme un choix, et l'atelier la traiterait comme tel. */
        if (persoFontTitre && persoFontTitre !== persoFont) props["_perso_font_titre"] = persoFontTitre;
        if (persoFontSous && persoFontSous !== persoFont) props["_perso_font_sous"] = persoFontSous;
        props["_perso_design"] = persoTextDesign;
        props["_perso_color"] = persoTextColor;
        if (persoGabarit) props["_perso_gabarit"] = persoGabarit;
        if (persoInkTitre) props["_perso_encre"] = persoInkTitre;
        if (persoInkSous) props["_perso_encre_sous"] = persoInkSous;
        /* LA PHOTO D'ORIGINE, sans le texte ni le passe-partout.
           Elle etait suivie ici depuis le debut (persoSourceUrl, « source d'origine pour recomposer
           le texte ») mais n'est jamais partie dans la commande : l'atelier ne recevait que la
           composition faite par CE navigateur, dont le ratio est celui de la PHOTO et non du format
           commande. Sur A1032, une photo en 9:16 a donne une toile a 0,50 pour un 30x40 qui en
           demande 0,7222, soit 60 mm de blanc de chaque cote au tirage.
           Avec cette propriete, le Studio recompose au ratio du format et trace le texte a la
           resolution du tirage. Sans elle, il imprime la composition telle quelle.

           ⚠️ Elle ne part QUE s'il y a du texte, et c'est la seule raison d'etre de la source. Hors
           texte, persoSourceUrl vaut l'apercu du depot ; pour un PDF, le JPG de sa premiere page.
           L'envoyer alors ferait imprimer cet apercu a la place du PDF du client. */
        /* ⛔ TROIS ETAGES (Adrien, 07/08/2026) : _perso_source est la source VOULUE (le cadrage
           seul, depose ci-dessus), _perso_source_uncropped l'originale complete. Le serveur
           recompose le texte depuis l'originale (cadrage rejoue a la resolution native) ; la
           cadree documente le geste et s'apparie en custom_<ts>_source au classement.
           ⚠️ PDF : l'apercu JPG de la premiere page reste la seule « source » possible, ancien
           contrat conserve : _perso_source la porte, sans _uncropped ni cadree. */
        var pdfDepose = /\.pdf($|\?)/i.test(String(persoUrl || ""));
        if (pdfDepose) {
          if (persoSourceUrl && persoSourceUrl !== persoUrl) props["_perso_source"] = persoSourceUrl;
        } else {
          if (persoCadreeUrl) props["_perso_source"] = persoCadreeUrl;
          if (persoSourceUrl && persoSourceUrl !== persoUrl) props["_perso_source_uncropped"] = persoSourceUrl;
        }
      } else if (persoSourceUrl && persoSourceUrl !== persoUrl
          && !/\.pdf($|\?)/i.test(String(persoUrl || ""))) {
        /* ⛔ SANS TEXTE, L'ORIGINALE PART AUSSI (Adrien, 07/08/2026). La composition (_perso_url)
           EST deja la version cadree voulue : pas de _perso_source distinct. L'originale part en
           _perso_source_uncropped : le SAV peut recadrer sans redemander la photo, et le
           classement l'appariera en custom_<ts>_source_uncropped. Le serveur ne l'imprime
           jamais hors texte. ⚠️ PAS pour un PDF (apercu JPG, pas une originale). */
        props["_perso_source_uncropped"] = persoSourceUrl;
      }
    }
    /* Les accessoires ne sont plus joints ici : cocher la case cadre ou crochet ecrit
       directement dans le panier, donc les rajouter a l'ajout de l'affiche creerait un
       doublon. Cf. syncUpsells(). */
    /* Les champs de personnalisation poses en Liquid (name="properties[...]") partent avec
       la ligne. Moisson generique : un futur produit a champs n'aura rien a coder ici.
       Les champs requis du groupe VISIBLE bloquent l'ajout tant qu'ils sont vides : un
       panneau de bienvenue sans prenoms n'est pas imprimable. */
    var champsPerso = document.querySelectorAll('#pdp-form [name^="properties["]');
    for (var ci = 0; ci < champsPerso.length; ci++) {
      var ch = champsPerso[ci];
      if (ch.closest('[hidden]')) continue;
      /* Une radio ou une case NON cochee porte quand meme une value : sans ce saut, la
         couleur du fond du panneau partirait toujours en « Camel », la derniere du groupe,
         quel que soit le choix de la cliente. */
      if ((ch.type === 'radio' || ch.type === 'checkbox') && !ch.checked) continue;
      var nom = ch.name.slice(11, -1);
      if (ch.hasAttribute('data-panneau-requis') && !String(ch.value).trim()) {
        if (window.murToast) window.murToast((T.pan_requis || "À compléter : ") + (nom.charAt(0) === '_' ? (T.pan_photo || 'votre photo') : nom));
        try { (ch.type === 'hidden' ? document.getElementById('panneau-photo-fichier') : ch).focus(); } catch (e) {}
        return;
      }
      if (String(ch.value).trim()) props[nom] = ch.value;
    }
    var items = [{ id: v.id, quantity: qty, properties: props }];
    if (window.__pdpPurchase) {
      items = window.__pdpPurchase.items(items[0]);
      if (!items) return;
    }
    if (window.murAddToCart) window.murAddToCart({ items: items });
  }
  function add() {
    // Affiche personnalisee sans photo : il n'y a rien a imprimer. On renvoie a
    // l'import plutot que de laisser passer une commande sans image.
    if (window.__pdpPerso && !photo && !persoUrl) { askPhoto(); return; }
    if (window.__pdpPerso && persoUploading) {
      if (window.murToast) window.murToast(T.perso_uploading || "Envoi de votre photo en cours…");
      return;
    }
    // Pas de format choisi : on ne met rien au panier, on invite à en choisir un.
    if (!formatChosen()) {
      var fi = formatGroupInfo();
      if (fi) {
        /* Sous l'unite epinglee, jamais derriere elle (iOS, 02/08/2026). */
        if (window.__persoDefilerVers) window.__persoDefilerVers(fi.grp);
        else fi.grp.scrollIntoView({ behavior: "smooth", block: "center" });
        fi.grp.classList.add("pdp-option--ask");
        setTimeout(function () { fi.grp.classList.remove("pdp-option--ask"); }, 1400);
      }
      return;
    }
    /* ⛔ ON COMPOSE MÊME SANS TEXTE. Sans cela, le fichier envoyé restait la photo d'origine et
       le cadrage réglé à l'écran n'existait nulle part : le client recevait le cadrage par
       défaut, et son affiche partait avec des bandes blanches si sa photo n'avait pas le ratio
       de l'affiche. Le texte n'est qu'une option DANS la composition, il n'en est pas la
       condition. */
    /* Un PDF ne se recadre pas dans un canvas : il part tel quel, comme avant. C'est le seul
       cas où le cadrage de l'écran ne peut pas suivre, et l'atelier le voit au drapeau. */
    var estPdf = (photoSourceFile && photoSourceFile.type === "application/pdf")
      || /\.pdf($|\?)/i.test(String(persoUrl || photo || ""));
    if (window.__pdpPerso && !estPdf && (photoSourceFile || persoSourceUrl || photo)) {
      /* ⛔ UN TITRE MASQUE EST UN TITRE SAISI, ET CE GARDE-FOU BLOQUAIT LA VENTE. Avec la valeur
         masquee, un client qui eteint sa ligne de titre se voyait refuser l'ajout au panier avec
         « Ajoutez un titre » alors qu'il venait de l'ecrire : le seul chemin restant etait de
         rallumer un texte dont il ne voulait pas. Le garde existe pour refuser un champ VIDE. */
      if (persoTextOn && !persoTextTitleSaisi()) {
        if (window.murToast) window.murToast(T.perso_text_need_title || "Ajoutez un titre, ou repassez en photo seule.");
        var titleInput = $("#perso-text-title");
        if (titleInput) {
          titleInput.focus();
          if (window.__persoDefilerVers) window.__persoDefilerVers(titleInput);
          else titleInput.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return;
      }
      persoUploading = true; syncPersoCta();
      composePersoWithText()
        .then(function (file) {
          // Ne pas setPhoto(composé) : l'aperçu reste la photo + bande CSS (sinon double bande).
          if (!window.__persoUpload) return null;
          return uploadPerso(file);
        })
        .then(function () {
          /* La source VOULUE (le cadrage seul, sans texte) part en depot silencieux : elle ne
             touche ni persoUrl ni l'apercu, elle n'existe que pour _perso_source. Best effort :
             un echec ne bloque jamais la vente, l'originale (_perso_source_uncropped) suffit au
             serveur pour recomposer. Jamais pour un PDF : ce bloc n'est atteint que hors PDF. */
          if (!(persoTextOn && persoTextTitleSaisi()) || !window.__persoUpload) return null;
          return composePersoSourceCadree()
            .then(function (f2) {
              return fetch(window.__persoUpload, { method: "POST", headers: { "Content-Type": f2.type }, body: f2 });
            })
            .then(function (r) { return r && r.ok ? r.json() : null; })
            .then(function (j) { persoCadreeUrl = (j && j.url) || null; })
            .catch(function () { persoCadreeUrl = null; });
        })
        .then(function () { persoCropApplique = true; pushCartLine(); })
        .catch(function () {
          /* ⛔ UN ÉCHEC DE COMPOSITION NE FAIT PAS PERDRE LA VENTE. Le canvas peut échouer pour
             une raison qui n'appartient pas au client (image distante refusée au canvas après
             un rechargement de page). On ajoute donc la ligne avec son fichier d'origine, et on
             pose le drapeau qui dit à l'atelier que le cadrage N'EST PAS dans le fichier :
             mieux vaut un cadrage à reprendre qu'un panier qui refuse de se remplir. */
          persoCropApplique = false;
          if (window.murToast) window.murToast(T.perso_text_compose_failed || "Cadrage non appliqué : la photo part telle quelle.");
          pushCartLine();
        })
        .then(function () { persoUploading = false; syncPersoCta(); });
      return;
    }
    pushCartLine();
  }
  /* Pont pêle-mêle : pele-mele.js intercepte le clic d'ajout (phase capture) et fait
     sa propre ligne de panier, mais la résolution de variante et l'exigence de format
     restent d'ici : une seule vérité sur « quel format est choisi ». */
  window.__pdpMetalPreview = function () {
    if (!window.__pdpPersoMetal) return Promise.resolve(null);
    if (!photo && !persoUrl) {
      var demo = document.querySelector('.perso-demos__rendu[data-actif]');
      return Promise.resolve({ image: demo ? demo.src : null, ratio: persoRatioFeuille() });
    }
    return composePersoWithText().then(function (file) {
      return { image: URL.createObjectURL(file), ratio: persoRatioFeuille() };
    });
  };
  window.__pdpPontPerso = { varianteCourante: currentVariant, formatChoisi: formatChosen, groupeFormat: formatGroupInfo };
  /* ⛔ SUR TELEPHONE, UNE PERSO AVEC PHOTO MONTRE LE RENDU ; PARTOUT AILLEURS ELLE AJOUTE.
     Sur grand ecran l'apercu occupe deja la moitie de la page : une fenetre qui le remontre
     ajoute un clic et n'apprend rien (Adrien, 20/08/2026). Et une affiche du CATALOGUE n'a
     jamais rien de plus a montrer que ce qui est a l'ecran. */
  $("#pdp-add") && $("#pdp-add").addEventListener("click", function () {
    if (window.__pdpPerso && (photo || persoUrl)
        && window.murEstMobile && window.murEstMobile()) { ouvrirRenduPerso(); return; }
    add();
  });
  /* ⛔ ON MONTRE AVANT DE VENDRE (Adrien, 20/08/2026 : « pour TOUS LES PRODUITS PERSONNALISES
     il faut s'assurer que le rendu affiche dans la modale soit EXACTEMENT ce qui est envoye
     pour impression, pas de concession possible »). La fenetre vit dans `global.js` et ne
     dessine RIEN : on lui donne `composePersoWithText`, c'est-a-dire la fonction qui fabrique
     le fichier envoye a l'impression, et elle montre son resultat. Le bouton de telechargement
     qui faisait deja cette composition a disparu le meme jour, a sa demande : il n'y a plus
     qu'une porte vers ce fichier, et c'est celle que le client regarde avant de payer.
     ⚠️ SANS PHOTO, RIEN A MONTRER : on renvoie a l'import, exactement comme `add()` le fait. */
  function ouvrirRenduPerso() {
    if (!photo && !persoUrl) { askPhoto(); return; }
    var st = $("#pdp-sticky-add");
    window.murRenduModale({
      compose: composePersoWithText,
      fermer: T.close || "Fermer",
      libelleAjout: (st && st.getAttribute("data-label-add")) || "Ajouter au panier",
      /* ⛔ LE CHOIX DES TAILLES ET LES OPTIONS ENTRENT DANS LA FENETRE, ils n'y sont pas
         recopies : la liste vit dans `global.js`, une seule fois pour les trois
         configurateurs. Sans eux, le client voyait son rendu puis retombait sur
         « Choisissez une taille » a la fermeture. */
      commandes: window.murCommandesAchat,
      quantite: ".pdp-buy-actions > .pdp-qty-sel",
      reassurance: ".pdp-avis__note",
      onAjouter: add,
    }).catch(function () {
      if (window.murToast) window.murToast(T.perso_text_compose_failed || "Composition impossible pour le moment.");
    });
  }

  /* ⛔ UN PREMIER APPEL AU CHARGEMENT, SANS QUOI L'ETAT INITIAL N'EXISTE PAS.
     `syncPersoCta` n'etait appelee que par `setPhoto` et par les depots, c'est-a-dire seulement
     une fois QUELQUE CHOSE arrive. Or l'etat qui compte pour le rebond est justement celui ou
     rien n'est arrive : sans cet appel, `data-attend-photo` n'etait jamais pose et le bouton
     restait immobile devant un client qui n'a pas encore compris qu'on attend son fichier. */
  syncPersoCta();
  /* ⛔ UNE SEULE PORTE VERS LA CAISSE, ET C'EST CELLE-CI. L'atelier plein ecran
     (`perso-atelier.js`) a son propre bouton « Ajouter au panier » en haut a droite de son second
     ecran : il appelle CETTE fonction. En ecrire une seconde la-bas serait une deuxieme porte,
     sans les gardes de celle-ci (moisson du formulaire, taille choisie, envoi de la photo).
     ⚠️ EXPOSEE, PAS RECOPIEE : l'atelier ne connait ni les champs ni les etapes, et il n'a pas a
     les connaitre. */
  /* ⛔ SAUF LA OU UN AUTRE CONFIGURATEUR A LE SIEN. `product.js` se charge sur TOUTES les fiches ;
     le pele-mele et le panneau composent leur ligne de panier eux-memes, avec leurs propres
     proprietes. Poser cette fonction-ci chez eux, c'est ajouter au panier sans le collage : le
     23/08/2026, sur WebKit en profil iPhone, le panier du pele-mele restait a zero, sans erreur
     et sans message. */
  if (!document.querySelector(".pdp--pelemele") && !document.querySelector(".pdp--panneau")) {
    window.__persoAjouter = add;
  }

  /* ⛔ LA DEPOSE AU SAV EST UN PARCAGE, JAMAIS UN `top` PILOTE PAR FRAME.
   *
   * Une glissade ecrite a chaque evenement de scroll est fluide sur desktop et SACCADEE
   * sur iOS : Safari delivre les evenements de defilement desynchronises du compositeur,
   * et la bande sautait par a-coups en passant le SAV (iPhone 15 Pro, 02/08/2026). A
   * l'arrivee du SAV, la bande et le bandeau basculent donc UNE FOIS de `fixed` vers
   * `absolute`, ancres a l'endroit exact ou ils sont : la page les emporte ensuite
   * nativement, zero ecriture par frame. En remontant, ils se re-fixent quand leur bord
   * repasse la ligne d'epingle. Chaque bascule est sans couture par construction (l'element
   * est parque LA OU IL EST) et protegee par l'anti-battement.
   *
   * Toujours `absolute`, jamais `relative` : `relative` decale depuis la position de flux,
   * et une coordonnee de document posee dessus projette le bloc des centaines de pixels
   * plus bas (cinq correctifs rates sur cette base avant de la retirer).
   */
  /* ⛔ L'EPINGLAGE EST EN POSITION:FIXED, PILOTE D'ICI, STYLES POSES EN LIGNE.
   *
   * En ligne et non par une classe CSS : les deux fichiers ne se deploient pas au meme
   * instant, et un JS nouveau avec un CSS ancien a deja gele la place sans rien fixer,
   * poussant toute la fiche d'un ecran vers le bas (02/08/2026). Ce bloc ne depend que de
   * lui-meme.
   *
   * Ce qui s'epingle est LA BANDE DE L'IMAGE, pleine largeur : ni le mode d'emploi ni la
   * pastille de qualite, qui suivent la page (cadre rouge d'Adrien, 02/08/2026).
   * position:sticky reste impossible ici : tous les conteneurs sont trop courts, et un
   * element sorti de sa boite devient item de grille, prisonnier de sa zone.
   */
  (function () {
    var cadre = document.querySelector(".pdp--perso .pdp-gallery__wrap");
    /* La depose vise le badge SAV sous le bouton d'achat : l'affiche reste sous les
       yeux pendant TOUS les choix et jusqu'au CTA. Le badge est filtre par langue
       (sav_locales) : repli sur la liste de reassurance, puis le bloc de texte. */
    /* ⛔ LE REPERE DE DEPOSE DOIT EXISTER DANS TOUTES LES LANGUES. Le badge SAV est
       filtre par sav_locales (FR seul), et la liste de reassurance n'existe pas sur
       les fiches perso : le repli tombait sur le bloc de texte lui-meme, et sur les
       locales sans badge l'unite se parquait immediatement au milieu des options,
       laissant sa place gelee vide en haut de page (captures NL d'Adrien,
       02/08/2026). La description produit, elle, suit le CTA partout. */
    /* Sans badge (langues hors sav_locales), la depose vise le texte de livraison
       sous le CTA (« Bestel vandaag... »), pas la description : meme point d'arret
       visuel que le badge en FR (Adrien, 02/08/2026). Devoile plus haut dans ce
       fichier (box.hidden = false) avant que ce bloc ne s'initialise. */
    var livraison = document.querySelector(".pdp--perso #pdp-delivery");
    var cible = document.querySelector(".pdp--perso .pdp-sav")
      || (livraison && !livraison.hidden ? livraison : null)
      || document.querySelector(".pdp--perso .pdp-buy .pdp-desc")
      || document.querySelector("#perso-text");
    /* ⛔ CE QUI SE CALE SOUS L'IMAGE EST LE SELECTEUR Photo seule / Avec texte SEUL.
       Le libelle « TEXTE SUR L'AFFICHE » file sous l'image et disparait comme le reste
       du contenu : le bas de la galerie s'arrete juste apres lui (Adrien, 02/08/2026,
       apres deux lectures fausses : bandeau entier cale dessous, puis bandeau entier
       passe dessus). */
    var tete = document.querySelector("#perso-text .perso-text__modes");
    if (!cadre || !cible || !window.__pdpPerso) return;
    /* ⛔ CE MECANISME NE VAUT PLUS QUE POUR LES PANNEAUX DE MARIAGE (Adrien, 23/08/2026 : « tu
       vas retirer la sticky galerie et l'agrandissement de l'image. Reviens a une page produit
       normale »). Sa demande porte sur LES DEUX AFFICHES PERSONNALISEES, ou la personnalisation
       demenage dans une fenetre plein ecran : la fiche y redevient une fiche produit ordinaire.
       ⚠️ LE PANNEAU N'EST PAS CONCERNE ET GARDE TOUT. Il porte le meme tag « Personnalisable »,
       donc la meme classe `.pdp--perso`, et retirer le bloc l'aurait emporte avec les affiches
       sans que personne l'ait demande : sa galerie collee, son ecran opaque et le calage de son
       selecteur sont a lui. Le banc `tests/panneau-galerie.test.js` l'a dit avant la mise en
       ligne, ce qui est exactement son role.
       ⚠️ ON SORT ICI, ON NE SUPPRIME PAS : le jour ou le panneau suivra les affiches, ces lignes
       partiront ensemble, d'un seul geste et sans reconstruire ce qui marche. */
    if (!document.querySelector(".pdp--panneau")) return;
    /* L'aide au cadrage (« Glissez la photo... ») VIT DANS la bande de l'image sur
       mobile : reparentee une fois ici, elle s'epingle, se parque et se libere AVEC
       l'image, sans aucune mecanique propre. Pilotee a part, elle se perdait au
       retour vers le haut et reapparaissait au milieu des blocs (02/08/2026). */
    var aide = document.querySelector(".pdp--perso .pdp-gallery .pdp-cadre__aide");
    var aideNid = aide && aide.parentElement;   /* sa place d'origine, hors bande */
    /* ⛔ ET LA BOITE SE RELIT QUAND L'AIDE PARAIT OU DISPARAIT, sans attendre un retour en haut
       de page. Les deux nombres ne se relevent qu'au repos (`p === 0`) ; or le texte d'aide
       s'allume et s'eteint AU MILIEU du defilement, quand le client attrape sa photo. La boite
       change alors de hauteur pendant que le modele garde l'ancienne, et l'ecart se voit comme
       une marge.
       ⚠️ `offsetHeight` IGNORE `transform` : c'est la hauteur naturelle, lisible meme unite
       agrandie, et c'est la seule raison pour laquelle cette relecture est possible ici. Une
       lecture par evenement, pas par image : la boucle de defilement reste sans mesure. */
    if (aide && window.MutationObserver) {
      new MutationObserver(function () {
        var hn = cadre && cadre.offsetHeight;
        if (!hn) return;
        if (hn !== hauteurLibre) { hauteurLibre = hn; kMaxFige = 0; hMemo = 0; }
        hAide = aide.offsetHeight || 0;
      }).observe(aide, { attributes: true, attributeFilter: ["style", "class", "hidden"] });
    }
    function logerAide() {
      if (!aide) return;
      var mobile = window.matchMedia("(max-width:900px)").matches;
      if (mobile && !cadre.contains(aide)) cadre.appendChild(aide);
      else if (!mobile && cadre.contains(aide) && aideNid) aideNid.appendChild(aide);
    }
    /* ⛔ REJOUE A CHAQUE CHANGEMENT DE LARGEUR. Evalue une seule fois au
       chargement, une page ouverte en paysage ou sur tablette gardait l'aide hors
       de la bande, donc non epinglee, meme apres rotation (Adrien, 03/08/2026). */
    logerAide();
    var prevu = false, fixe = false, posee = false;
    var teteFixe = false, teteBloc = 0, teteDelta = 0; /* selecteur cale : hauteur totale et repere de flux */
    /* ⛔ LA LIGNE D'EPINGLE PASSE SOUS LE BANDEAU PROMO, ELLE N'EST PLUS A 8 PX DU BORD.
       Adrien, 15/08/2026 : « la galerie passe sous le haut et est coupee en haut ». `BASE` valait
       8 px comptes depuis le HAUT DE L'ECRAN, alors que le bandeau promo occupe le haut de
       l'ecran en permanence : l'unite s'epinglait donc DERRIERE lui, et le bord haut de l'affiche
       disparaissait. Ca se voyait deja avant (releve du matin : 18 px avales), mais l'image
       agrandie a 1,53 l'a rendu franc.
       ⚠️ RECALCULEE TANT QU'ON N'EST PAS EPINGLE, FIGEE ENSUITE. Le bandeau ne fait pas la meme
       hauteur deplie (deux lignes) et compacte (une) : la recalculer pendant que l'unite est
       epinglee ferait glisser l'image a chaque changement d'etat de l'en-tete. Avant l'epingle
       il n'y a ni echelle ni `transform`, donc cette mesure ne coute pas de calcul force ; apres,
       la valeur ne bouge plus.

       ⛔ ET CETTE MESURE SE PREND SUR LA HAUTEUR DU BANDEAU, JAMAIS SUR SON BAS (Adrien,
       serie 318 : « reste toujours la marge trop elevee entre le promotion bar et la galerie,
       mais bizarrement je ne la vois que sur mon iphone »).

       LE BAS DU BANDEAU N'EST PAS UNE CONSTANTE DE MISE EN PAGE, C'EST UNE POSITION. Le bandeau
       est le DERNIER enfant de l'en-tete (verifie dans header.liquid) : c'est pour cela que
       `top: calc(-1 * (--site-header-h - --promo-h))` ne laisse que lui a l'ecran. Tant que
       l'en-tete se retire, son bas descend de ~220 px a sa seule hauteur, et il vaut donc une
       chose differente A CHAQUE PIXEL DE DEFILEMENT. Figer `BASE` a l'epingle, c'est figer la
       valeur qu'a vue le DERNIER evenement de defilement recu avant elle.

       ⚠️ ET C'EST LA QUE LES DEUX APPAREILS DIVERGENT, ce qui explique le « je ne la vois que sur
       mon iphone ». Chrome envoie un evenement tous les quelques pixels : le dernier releve avant
       l'epingle voyait deja le bandeau pose, 26 px, donc `BASE` = 34, et la mesure dans son Chrome
       donnait bien 8 px d'ecart. iOS Safari REGROUPE les evenements pendant l'inertie : le dernier
       releve avant l'epingle pouvait tomber en pleine retraction, bas a 120 ou 200 px. `BASE`
       gelait alors 100 px trop bas, pour toute la duree de l'epinglage. Une seule ligne separait
       une page juste d'une page fausse, et rien ne la signalait sur la machine qui sert a juger.

       LA HAUTEUR, ELLE, NE DEPEND PAS DU DEFILEMENT. On borne donc le bas par la hauteur : pendant
       que le bandeau s'en va, son bas est le plus petit des deux et c'est lui qui compte (il ne
       reste que ce qui depasse) ; une fois pose, les deux sont egaux. La valeur figee est juste
       quel que soit le moment ou l'epingle tombe, et la mesure sur deux lignes reste suivie
       puisqu'elle passe par la hauteur reelle. */
    var MARGE_HAUT = 8;   /* le filet d'air entre le bandeau et l'image */
    var BASE = MARGE_HAUT;
    /* ⛔ DEUX BANDEAUX POSSIBLES, UN SEUL VISIBLE. Depuis le 23/08/2026 le parcours
       professionnel porte `.pro-bar` la ou le grand public porte `.summer-bar`, et les deux
       sont dans le DOM : l'un des deux est toujours en `display:none`.
       ⚠️ ON NE PREND PAS LE PREMIER TROUVE, ON PREND CELUI QUI A UNE HAUTEUR. Un `querySelector`
       sur les deux selecteurs aurait rendu celui qui vient en premier dans le document, donc
       zero une fois sur deux, et l'image se serait collee sous un bandeau vert de 47 px sans
       qu'aucune erreur ne soit levee. */
    function hautPromo() {
      var barres = document.querySelectorAll(".summer-bar, .pro-bar");
      for (var i = 0; i < barres.length; i += 1) {
        var r = barres[i].getBoundingClientRect();
        if (r.height) return Math.max(0, Math.min(Math.round(r.bottom), Math.round(r.height)));
      }
      return 0;
    }
    var LIP = 12;   /* levre sous l'image : la ligne d'arret du selecteur */
    var BAS = 14;   /* respiration sous le selecteur fige */
    /* ⛔ L'AGRANDISSEMENT SE POSE ICI, EN STYLE INLINE, ET AUCUNE FEUILLE NE PEUT LE FAIRE A SA
       PLACE. Adrien, 15/08/2026, quatre fois : « l'image n'augmente pas », puis « je la vois
       grandir puis revenir a sa position initiale ». Mesure dans son Chrome, unite epinglee :

         attribut style de .pdp-gallery__wrap
         position: fixed | top: 8px | left: 86px | width: 318px

       Ces quatre valeurs sont ecrites en STYLE INLINE par le gel, plus bas dans ce fichier. Six
       regles seulement disputent `width` et `position` a cet element, et AUCUNE ne dit `fixed` :
       la preuve que la valeur peinte ne venait d'aucune feuille. Or un style inline bat toute
       feuille. La regle `body.galerie-agrandie { width: 96% }` posee dans base.css s'appliquait
       donc pendant la fraction de seconde precedant le gel, puis l'epinglage reposait 318 px
       par-dessus : le « grandit puis revient », que nulle surenchere de specificite n'aurait
       corrige. C'est de la que vient la regle qui suit : ce qui possede la geometrie de l'unite
       est le seul a pouvoir l'agrandir. Un seul proprietaire. */
    /* ⛔ ET TOUTE LA CROISSANCE PASSE PAR L'ECHELLE, PLUS DU TOUT PAR LA LARGEUR. Mesure du
       15/08/2026 : la hauteur de l'unite ne bouge PAS quand on l'elargit (381 px de 318 a
       484 px de large), parce que la scene tient sa taille de la HAUTEUR disponible. Elargir la
       boite ne faisait donc grandir l'affiche que de biais : releve au canvas, +17,7 % pour
       +30 % de boite. Une echelle, elle, multiplie tout uniformement, cadre compris, et c'est
       la seule facon d'agrandir vraiment (Adrien : « tu peux encore agrandir »).
       ⚠️ ET C'EST AUSSI CE QUI REND LA PROGRESSION POSSIBLE. Une largeur ecrite a chaque image
       de defilement serait un calcul de mise en page par image, ce que ce fichier s'interdit
       depuis le 02/08 (« jamais un top pilote par frame » : sur iOS les evenements de
       defilement sont desynchronises du compositeur et le rendu saute). `transform` ne
       declenche aucune mise en page : il se compose, et suit le doigt sans a-coup. */
    var KMAX_DUR = 1.6;     /* garde-fou absolu, quelle que soit la taille de l'ecran */
    /* ⚠️ 4 px, LA MEME VALEUR QUE LA FEUILLE, ET C'EST LE POINT. `base.css` pose `margin-top:4px`
       sous 900 px depuis le 02/08 ; ecrire ici un autre nombre ferait sauter l'ecart au premier
       pixel de defilement, puis revenir au relachement. Ce qu'on ecrit n'est pas une valeur
       nouvelle, c'est la MEME valeur exprimee dans l'unite ou l'echelle la peindra. */
    var ECART_AIDE = 4;     /* l'ecart PEINT entre le bas de l'image et le texte d'aide */
    var hAide = 0;          /* sa hauteur naturelle, relevee au repos */
    var largeurLibre = 0;   /* largeur en flux, relevee au repos */
    var hauteurLibre = 0;   /* hauteur en flux, relevee au repos */
    var centreLibre = 0;    /* et son axe : l'agrandissement s'ouvre de part et d'autre */
    var echelleVue = 0;     /* la derniere echelle ecrite, pour n'ecrire qu'au changement */
    /* La hauteur PEINTE, echelle comprise. `offsetHeight` ignore `transform` : s'en servir
       ferait remonter l'ecran opaque et le selecteur DANS l'image agrandie, et le contenu
       reapparaitrait par-dessous. Ce qui fixe le bas de l'unite, c'est ce que l'oeil voit.

       ⛔ MESUREE UNE SEULE FOIS PAR PASSE, ET C'EST CE QUI REND LA CROISSANCE FLUIDE. Adrien,
       15/08/2026 : « l'agrandissement progressif n'est pas fluide, la galerie grossit par
       a-coups ». Cette fonction est appelee jusqu'a QUATRE fois dans une meme evaluation
       (`basUnite`, `hauteurEcran`, la levre du selecteur, sa position), et l'evaluation ecrit
       entre-temps `ecran.style.height` et `tete.style.top`.
       ⚠️ AVANT L'ECHELLE, CELA NE COUTAIT RIEN : la geometrie ne changeait pas pendant le
       defilement, le navigateur rendait une mise en page deja calculee. Depuis que `transform`
       s'ecrit a chaque image, chaque lecture qui SUIT une ecriture oblige a tout recalculer :
       lire, ecrire, lire, ecrire, quatre fois par image, sur une page qui porte un canvas. C'est
       la definition du calcul de mise en page force, et c'est exactement ce qui se voit comme
       des a-coups. Le memo tombe a la premiere ligne de `evaluer` et a chaque nouvelle echelle :
       il ne peut donc jamais rendre une valeur perimee. */
    var hMemo = 0;
    function hauteurUnite() {
      /* ⛔ CALCULEE, PLUS MESUREE, ET C'EST LA VRAIE REPONSE AUX A-COUPS. Adrien, 15/08/2026,
         apres un premier correctif insuffisant : « il y a toujours des a-coups a
         l'agrandissement ET au retrecissement ». Mesurer UNE fois par image au lieu de quatre
         divisait le cout, mais n'enlevait pas le defaut : il restait UNE lecture de geometrie
         apres l'ecriture de `transform`, donc un calcul de mise en page force a chaque image.
         Or cette hauteur n'a pas besoin d'etre mesuree : elle EST la hauteur naturelle
         multipliee par l'echelle, deux nombres que ce fichier connait deja. Une multiplication
         ne touche pas le DOM. Il ne reste alors, dans la boucle de defilement, que des
         ECRITURES, et les ecritures se groupent : le navigateur n'est plus jamais oblige de
         s'arreter pour recalculer au milieu d'une image.
         ⚠️ LA MESURE RESTE, EN REPLI, tant que la hauteur naturelle n'a pas ete relevee (les
         toutes premieres images, avant le premier passage au repos). Un repli qui mesure vaut
         mieux qu'un zero qui ferait remonter l'ecran opaque dans l'image. */
      /* ⛔ ET LE TEXTE D'AIDE N'EST PAS A L'ECHELLE, LUI. Adrien, 15/08/2026 : « encore trop de
         marge sous le texte ». Mesure dans son Chrome, iPhone XR : wrap peint 467 px (mise en
         page 305 x 1,531), ecran opaque 525 px, soit 49 px de vide sous l'image.
         `hauteurLibre x k` supposait que TOUT le contenu grandit. C'etait vrai jusqu'a ce que je
         contre-mette le texte a l'echelle : sa hauteur, elle, reste constante, et ma marge
         negative retire d'autant a la boite. La hauteur peinte vaut donc `hauteurLibre x k` MOINS
         ce que le texte ne prend pas, `hAide x (k - 1)`.
         ⚠️ C'est mon propre correctif qui a rendu la formule fausse, et rien ne l'a signale :
         l'ecran opaque descendait simplement plus bas que l'image, ce qui se lit comme une marge
         et pas comme une erreur de calcul. */
      if (hauteurLibre) {
        var kk = echelleVue || 1;
        return Math.round(hauteurLibre * kk - (hAide || 0) * (kk - 1));
      }
      if (!hMemo) hMemo = Math.round(cadre.getBoundingClientRect().height);
      return hMemo;
    }
    /* ⛔ LE PLAFOND SE FIGE, IL NE SE RELIT PAS A CHAQUE IMAGE, ET C'EST LA MEME LECON QUE LA
       COURSE DU MENU. `window.innerHeight` change a CHAQUE defilement sur iOS : la barre
       d'outils de Safari se retracte puis se deploie, et ce fichier porte deja la trace de ce
       piege depuis le 02/08 (« un changement de HAUTEUR seul ne change ni la largeur figee ni
       l'ecran : on ne depose que si la largeur bouge vraiment »). Un plafond calcule en direct
       sur cette hauteur ferait respirer l'image pendant tout le defilement, sans que rien ne le
       signale.
       ⚠️ ET LA MESURE L'A MONTRE AVANT LA LIVRAISON : deux releves de la meme page ont rendu
       1,52 puis 1,21, simplement parce que la boite naturelle et la hauteur de fenetre n'avaient
       pas ete lues au meme instant. Deux plafonds, et le plus bas gagne : un filet d'air de 8 px
       de chaque cote, et un bas d'unite qui ne descend pas sous 80 % de l'ecran, sinon le
       selecteur cale dessous et le contenu qui suit n'ont plus de place. */
    var kMaxFige = 0;
    function echelleMax() {
      if (kMaxFige) return kMaxFige;
      if (!largeurLibre || !hauteurLibre) return 1;
      kMaxFige = Math.max(1, Math.min(KMAX_DUR,
        (window.innerWidth - 16) / largeurLibre,
        (window.innerHeight * 0.80 - BASE) / hauteurLibre));
      return kMaxFige;
    }
    /* ⛔ L'AGRANDISSEMENT SUIT LE DEFILEMENT, IL NE BASCULE PLUS (Adrien, 15/08/2026 :
       « elle doit s'agrandir proportionnellement au scroll jusqu'a atteindre sa taille finale
       quand le menu est completement masque »). La course du menu est la meme constante figee
       que celle du juge d'en-tete : elle se prend une fois, en haut de page, et ne bouge plus.
       C'est ce gel qui empeche la boucle du 15/08 (l'en-tete se compacte, la course raccourcit,
       le seuil repasse sous la position courante, l'image revient). */
    function poserEchelle() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var course = window.__murCourseMenu || 0;
      var p = course > 0 ? Math.max(0, Math.min(1, y / course)) : 0;
      if (p === 0) {
        /* Au repos, le rectangle peint EST le rectangle naturel : seul moment ou on peut le
           relever sans avoir a defaire une echelle. La boite et le plafond se prennent ENSEMBLE,
           sur le meme etat : les separer, c'est le releve a 1,52 contre 1,21. */
        var rn = cadre.getBoundingClientRect();
        if (rn.width && (rn.width !== largeurLibre || rn.height !== hauteurLibre)) {
          largeurLibre = rn.width; hauteurLibre = rn.height; kMaxFige = 0;
          /* ⛔ LA HAUTEUR DE L'AIDE SE RELEVE DANS LE MEME SOUFFLE QUE LA BOITE, et zero est une
             reponse valable. Elle etait relevee a cote, sous un `if (aide.offsetHeight)` cense
             proteger d'un zero : le jour ou le texte d'aide disparait, la boite retrecit d'autant
             et `hAide` garde son ancienne valeur. Les deux nombres decrivent alors deux etats
             differents, et la formule rend 452 px la ou l'image en peint 417 (mesure du
             20/08/2026, fiche perso, echelle 1,4059). L'ecran opaque descendait donc 35 px trop
             bas et le selecteur cale flottait d'autant sous l'image : la « enorme marge ».
             ⚠️ ET LE ZERO NE PEUT PAS FAIRE REMONTER L'ECRAN : quand `hAide` diminue, le terme
             soustrait diminue avec lui, donc l'ecran descend. Le repli protegeait de l'inverse. */
          hAide = (aide && aide.offsetHeight) ? aide.offsetHeight : 0;
        }
      }
      if (!largeurLibre) return;
      var k = 1 + (echelleMax() - 1) * p;
      if (Math.abs(k - echelleVue) < 0.002) return;   /* n'ecrit qu'au vrai changement */
      echelleVue = k;
      hMemo = 0;                                      /* la hauteur peinte vient de changer */
      /* ⚠️ ORIGINE EN HAUT, PAS AU CENTRE : le haut de l'unite doit rester sur sa ligne, sinon
         l'image grandit aussi vers le haut et passe sous le bandeau promo. */
      cadre.style.transformOrigin = "50% 0";
      cadre.style.transform = k > 1.001 ? "scale(" + k.toFixed(4) + ")" : "";
      /* ⚠️ ANNONCE FAITE AU NAVIGATEUR, ET SEULEMENT PENDANT LA CROISSANCE. `will-change` previent
         qu'il va devoir composer cet element image apres image : il le prepare une fois au lieu
         de reorganiser son arbre de couches a chaque changement d'echelle. Pose en permanence,
         il couterait de la memoire sur une page qui porte deja un canvas ; il tombe donc des que
         l'echelle revient a 1. */
      cadre.style.willChange = k > 1.001 ? "transform" : "";
      /* ⛔ LE TEXTE D'AIDE NE GROSSIT PAS AVEC L'IMAGE (Adrien, 15/08/2026 : « le texte sous
         l'image ne doit pas grossir en meme temps que l'image »). Il VIT dans la bande depuis le
         02/08 : reparenté la pour s'epingler, se parquer et se liberer avec elle, sans mecanique
         propre. Il herite donc de l'echelle, et une consigne de manipulation n'a aucune raison
         de grandir : ce qu'on vient regarder, c'est l'oeuvre.
         ⚠️ L'ECHELLE INVERSE, PAS UNE TAILLE DE POLICE FIXEE : les echelles imbriquees se
         multiplient, k x 1/k rend exactement 1, quelle que soit la valeur de k et sans jamais
         toucher a la mise en page. Une taille recalculee en pixels, elle, devrait etre reglee
         pour chaque palier et ne retomberait juste qu'a un seul. */
      /* ⛔ ET SA PLACE NE GROSSIT PAS NON PLUS (Adrien, 15/08/2026 : « trop de marge au-dessus et
         en dessous du texte »). Contre-mettre le TEXTE a l'echelle ne suffisait pas : `transform`
         ne touche pas la mise en page, donc la BOITE du texte restait peinte a `H x k` pendant
         que le texte revenait a `H`. Il restait `H (k - 1)` de vide dessous, et la marge du haut,
         elle aussi multipliee par k, ecartait le texte de l'image. De l'air proportionnel au
         zoom, au-dessus et en dessous : c'est ma contre-echelle qui l'avait fabrique.
         ⚠️ LES MARGES SE COMPENSENT DANS L'UNITE OU ELLES SERONT PEINTES. Une marge CSS de M se
         peint M x k : pour un ecart PEINT constant G, on ecrit G / k. Et pour effacer le vide
         du bas, une marge negative de H (k - 1) / k, qui se peint exactement H (k - 1).
         ⚠️ AUCUNE MESURE ICI : H a ete releve une fois au repos, k est connu. Ce sont deux
         ecritures de plus dans la meme image que `transform`, et les ecritures se groupent. */
      if (aide) {
        aide.style.transformOrigin = "50% 0";
        if (k > 1.001) {
          aide.style.transform = "scale(" + (1 / k).toFixed(4) + ")";
          aide.style.marginTop = (ECART_AIDE / k).toFixed(2) + "px";
          aide.style.marginBottom = (-(hAide || 0) * (k - 1) / k).toFixed(2) + "px";
        } else {
          aide.style.transform = "";
          aide.style.marginTop = "";
          aide.style.marginBottom = "";
        }
      }
    }
    /* ⛔ ANTI-BATTEMENT iOS : l'animation de la barre d'outils Safari fait osciller
       les mesures autour des seuils, et un etat qui s'inverse a chaque frame fait
       frissonner l'ecran (iPhone, 02/08/2026). Une bascule ne s'inverse pas dans les
       300 ms ; un premier franchissement passe toujours. */
    var basculeCadre = { t: 0, vers: "" }, basculeTete = { t: 0, vers: "" };
    /* ⛔ UNE BASCULE BLOQUEE REPLANIFIE TOUJOURS UNE EVALUATION. L'anti-battement refuse
       l'inversion dans les 300 ms, et c'est voulu ; mais une remontee rapide finissait
       PENDANT cette fenetre : la liberation etait refusee, l'elan mourait, plus aucun
       evenement ne relancait evaluer, et la bande restait figee sous l'en-tete, image
       coupee en haut de page (captures perso et pele-mele d'Adrien, 08/08/2026). Un seul
       rendez-vous a la fermeture de la fenetre suffit : l'etat se reglera tout seul. */
    var rendezVous = 0;
    function basculeBloquee(b, vers) {
      var bloquee = b.vers && b.vers !== vers && performance.now() - b.t < 300;
      if (bloquee && !rendezVous) {
        rendezVous = setTimeout(function () { rendezVous = 0; planifier(); }, 320);
      }
      return bloquee;
    }
    /* ⛔ UN SEUL ECRAN OPAQUE DERRIERE L'UNITE, PLEINE LARGEUR, JAMAIS PLUS BAS QUE
       SON BAS. Les ombres directionnelles (copies en box-shadow) laissaient une bande
       transparente en haut du viewport et des flancs decouverts en vue large : le
       contenu apparaissait derriere l'unite a l'approche du SAV (captures 768 px
       d'Adrien, 02/08/2026, regression du retrait de la marge fantome 4259d0f).
       L'ecran couvre du haut du viewport au bas de l'unite : sans selecteur cale,
       il s'arrete au bas de l'IMAGE (la levre de 12 px reste ouverte, le contenu y
       passe visible, jamais de pare-soleil qui mange le H1) ; selecteur cale, il
       descend jusqu'a la respiration sous lui. Il se parque et se libere avec
       l'unite. pointer-events:none : pure peinture, sous l'image (z 5 < 6 < 7). */
    var ecran = document.createElement("div");
    ecran.style.pointerEvents = "none";
    /* ⛔ L'ECRAN PREND LA COULEUR DE LA GALERIE, PAS CELLE DE LA PAGE (Adrien, 20/08/2026 :
       « assure-toi que le beige derriere la galerie est aussi visible au scroll vers le bas »).
       Il peignait le fond de page : des que l'unite s'epingle, le panneau beige disparaissait
       sous un rectangle presque blanc, et l'affiche perdait le bord que ce beige lui donne.
       ⚠️ LA COULEUR SE LIT SUR LA GALERIE, elle ne se recopie pas : ecrire la teinte ici en
       ferait une seconde source, et un banc compte deja ses ecritures dans la feuille. Repli sur
       le fond de page si la lecture ne rend rien, plutot qu'un ecran transparent. */
    var teinteGalerie = "";
    try {
      var galerieFond = document.querySelector(".pdp-gallery");
      if (galerieFond) teinteGalerie = getComputedStyle(galerieFond).backgroundColor || "";
      if (/rgba\(0, 0, 0, 0\)|transparent/.test(teinteGalerie)) teinteGalerie = "";
    } catch (e) { teinteGalerie = ""; }
    ecran.style.background = teinteGalerie || "var(--bg,#FDFBF9)";
    ecran.style.display = "none";
    cadre.parentElement.insertBefore(ecran, cadre);
    function hauteurEcran() {
      /* 10 px de souffle sous l'aide au cadrage avant le calage du selecteur : sans
         lui, le contenu emergent collait a la ligne « Glissez la photo... » (capture
         d'Adrien, 02/08/2026). Strictement sous la levre de 12 px : le selecteur ne
         passe jamais sous la peinture, et on reste loin du pare-soleil de 40 px. */
      return teteFixe ? basUnite() : BASE + hauteurUnite() + 10;
    }
    function poserEcran() {
      ecran.style.display = "block";
      ecran.style.position = "fixed";
      ecran.style.top = "0";
      ecran.style.left = "0";
      ecran.style.width = "100%";
      ecran.style.height = hauteurEcran() + "px";
      ecran.style.zIndex = "5";
    }
    function basUnite() {
      return BASE + hauteurUnite() + (teteFixe ? teteBloc : LIP);
    }
    function defixerTete() {
      if (!teteFixe || !tete) return;
      basculeTete = { t: performance.now(), vers: "libre" };
      teteFixe = false;
      teteBloc = 0;
      tete.classList.remove("est-calee");
      ["position", "top", "left", "width", "zIndex", "background", "boxShadow"].forEach(function (k) {
        tete.style[k] = "";
      });
      tete.parentElement.style.paddingBottom = "";
      tete.parentElement.style.position = "";
    }
    function defixer() {
      if (!fixe) return;
      basculeCadre = { t: performance.now(), vers: "libre" };
      fixe = false;
      posee = false;
      /* La largeur relevee appartient au gel qui vient de finir : gardee, elle servirait de
         reference a un prochain epinglage fait dans une autre largeur de fenetre. */
      largeurLibre = 0;
      centreLibre = 0;
      defixerTete();
      cadre.classList.remove("est-fixe");
      /* ⛔ `transform` N'EST PAS DANS CETTE LISTE, ET C'EST VOULU. L'echelle ne depend plus de
         l'epinglage mais du seul defilement : la course du menu (132 px) se termine bien AVANT
         que l'unite ne s'epingle (206 px, mesure du 15/08/2026). L'effacer au degel ferait
         retomber l'image a sa taille de depart en remontant, pour la voir regrandir a la frame
         suivante quand poserEchelle recalcule le meme etat. Un clignotement pour rien. */
      ["position", "top", "left", "width", "zIndex", "background", "boxShadow",
       "transition"].forEach(function (k) {
        cadre.style[k] = "";
      });
      cadre.parentElement.style.paddingTop = "";
      cadre.parentElement.style.position = "";
      ecran.style.display = "none";
      ["position", "top", "left", "width", "height", "zIndex", "transition"].forEach(function (k) {
        ecran.style[k] = "";
      });
    }
    /* ⛔ LA DEPOSE AU SAV EST UN PARCAGE, JAMAIS UN top PILOTE PAR FRAME : sur iOS les
       evenements de defilement sont desynchronises du compositeur et une glissade
       ecrite au scroll saute par a-coups (iPhone, 02/08/2026). Les elements restent
       hors flux (place gelee), seul leur ancrage change, du viewport vers le document,
       a l'endroit exact ou ils sont : bascule unique, sans couture. Toujours absolute,
       jamais relative (relative decale depuis la position de flux ; cinq correctifs
       rates sur cette base avant de la retirer). */
    function parquer() {
      basculeCadre = { t: performance.now(), vers: "posee" };
      posee = true;
      var galerie = cadre.parentElement;
      if (getComputedStyle(galerie).position === "static") galerie.style.position = "relative";
      var g = galerie.getBoundingClientRect();
      var r = cadre.getBoundingClientRect();
      /* ⛔ LE PARCAGE SE PLACE A LA POSITION VISEE, PAS A LA POSITION DU MOMENT :
         pendant une impulsion iOS les evenements de defilement sont rares, la
         condition se declenche en retard, et figer « la ou on est » posait l'unite
         des centaines de pixels trop bas, au-dessus de « Comment ca marche » au lieu
         de juste apres le SAV (iPhone, 02/08/2026). La cible est 12 px sous le bas du
         bloc SAV ; au franchissement exact les deux positions coincident. */
      /* ⛔ LE REPOS EST JUSTE SOUS LE BLOC SAV (Adrien, 02/08/2026, confirme deux
         fois) : au declenchement, l'unite glisse en 280 ms sous le badge, qui emerge
         au-dessus d'elle. Se poser sous lui en continuant d'epingler aurait oblige a
         suivre pendant que le badge traversait l'ecran cache sous l'image (l'effet
         « s'arrete au niveau de Comment ca marche »). */
      /* Position visee : le bas d'unite 12 px sous le bas du badge, meme si le
         declenchement a pris du retard pendant une impulsion. Au franchissement
         exact, elle coincide avec la position courante : gel sur place. */
      var repos = Math.round(cible.getBoundingClientRect().bottom + 12 - (basUnite() - BASE));
      /* L'ecran se parque avec l'unite : au repos il continue de masquer la ligne de
         livraison et le badge avales sous l'image, jusqu'aux bords de l'ecran. */
      var e = ecran.getBoundingClientRect();
      ecran.style.position = "absolute";
      ecran.style.top = Math.round(e.top - g.top) + "px";
      ecran.style.left = Math.round(e.left - g.left) + "px";
      /* En absolute, width:100% se resout contre la colonne galerie, pas contre le
         viewport : le flanc droit se decouvrait au repos (capture d'Adrien,
         02/08/2026). Largeur figee en pixels a la valeur mesuree fixee. */
      ecran.style.width = Math.round(e.width) + "px";
      cadre.style.position = "absolute";
      cadre.style.top = Math.round(r.top - g.top) + "px";
      /* ⛔ LE BORD PEINT N'EST PAS UNE COORDONNEE DE MISE EN PAGE. Adrien, 15/08/2026 : « l'image
         se decale a gauche quand on arrive au niveau de son epingle au niveau du bloc SAV ».
         Mesure dans son Chrome, iPhone XR, echelle 1,53 : largeur de mise en page 260, largeur
         peinte 398, bord gauche peint 8, bord gauche reel 77. Ecrire le bord PEINT dans `left`
         deplacait donc l'unite de 69 px vers la gauche, d'un coup, au parcage.
         L'origine de l'echelle etant a 50 %, le CENTRE est le seul point que l'echelle ne bouge
         pas : on repart de lui et de la largeur de mise en page. Meme faute que celle corrigee
         a l'epinglage ce matin, laissee ici et dans `refixer` faute d'avoir relu les voisines. */
      var cxP = (r.left + r.right) / 2;
      cadre.style.left = Math.round(cxP - (cadre.offsetWidth || r.width) / 2 - g.left) + "px";
      var zTete = null, rtTete = null;
      if (teteFixe && tete) {
        var zone = tete.parentElement;
        if (getComputedStyle(zone).position === "static") zone.style.position = "relative";
        zTete = zone.getBoundingClientRect();
        rtTete = tete.getBoundingClientRect();
        tete.style.position = "absolute";
        tete.style.top = Math.round(rtTete.top - zTete.top) + "px";
        tete.style.left = Math.round(rtTete.left - zTete.left) + "px";
      }
      requestAnimationFrame(function () {
        cadre.style.transition = "top .28s ease";
        cadre.style.top = Math.round(repos - g.top) + "px";
        ecran.style.transition = "top .28s ease";
        ecran.style.top = Math.round(repos - BASE - g.top) + "px";
        if (teteFixe && tete && zTete) {
          tete.style.transition = "top .28s ease";
          tete.style.top = Math.round(repos + hauteurUnite() + LIP - zTete.top) + "px";
        }
        setTimeout(function () {
          cadre.style.transition = "";
          ecran.style.transition = "";
          if (tete) tete.style.transition = "";
        }, 320);
      });
    }
    function refixer() {
      basculeCadre = { t: performance.now(), vers: "fixe" };
      posee = false;
      var r = cadre.getBoundingClientRect();
      var e = ecran.getBoundingClientRect();
      ecran.style.position = "fixed";
      ecran.style.top = Math.round(e.top) + "px";
      ecran.style.left = "0";
      ecran.style.width = "100%";
      cadre.style.position = "fixed";
      cadre.style.top = Math.round(r.top) + "px";
      /* Meme conversion qu'au parcage : le bord PEINT n'est pas une coordonnee de mise en page,
         seul le centre survit a l'echelle. Voir le commentaire de `parquer`. */
      cadre.style.left = Math.round((r.left + r.right) / 2 - (cadre.offsetWidth || r.width) / 2) + "px";
      if (teteFixe && tete) {
        var rt = tete.getBoundingClientRect();
        tete.style.position = "fixed";
        tete.style.top = Math.round(rt.top) + "px";
        tete.style.left = Math.round(rt.left) + "px";
      }
      /* La meme glissade que la pose, en sens inverse : l'unite remonte sur la ligne
         d'epingle pendant que le badge repasse dessous. */
      requestAnimationFrame(function () {
        cadre.style.transition = "top .28s ease";
        cadre.style.top = BASE + "px";
        ecran.style.transition = "top .28s ease";
        ecran.style.top = "0px";
        if (teteFixe && tete) {
          tete.style.transition = "top .28s ease";
          tete.style.top = (BASE + hauteurUnite() + LIP) + "px";
        }
        setTimeout(function () {
          cadre.style.transition = "";
          ecran.style.transition = "";
          if (tete) tete.style.transition = "";
        }, 320);
      });
    }
    function evaluer() {
      prevu = false;
      hMemo = 0;   /* une passe, une mesure : voir hauteurUnite */
      var galerie = cadre.parentElement;
      /* AVEC OU SANS PHOTO (Adrien, 08/08/2026) : l'epinglage s'applique des l'arrivee.
         L'ancienne porte exigeait la photo importee parce qu'a l'epoque la bande etait
         vide sans elle ; depuis les demonstrations en situation, la bande montre toujours
         quelque chose, et c'est ce visuel qui doit rester sous les yeux pendant les choix.
         Le mecanisme est strictement le meme, seule la porte a change. */
      var racine = document.querySelector(".pdp--perso");
      if (!racine || !window.matchMedia("(max-width:900px)").matches) {
        defixer();
        /* ⛔⛔ ET LA GALERIE REPREND SON EPINGLE CSS (Adrien, 20/08/2026 : « sur desktop, quand on
           clique sur un thumbnail, la galerie n'est plus epinglee au defilement »). `parquer()`
           lui pose `position:relative` EN LIGNE quand elle est statique — ce qu'elle est sur
           telephone —, et `defixer()` ne le retire qu'en passant son garde-fou `if (!fixe)
           return`. Sorti de la par n'importe quel chemin, le style en ligne survit ; en vue
           large il bat alors le `position:sticky` de la feuille, et la galerie cesse de suivre le
           defilement, definitivement. Ici on ne suppose rien : cette branche est la vue large,
           ce mecanisme n'y a rien a faire, on efface. */
        var galerieLarge = cadre.parentElement;
        if (galerieLarge && galerieLarge.style.position) galerieLarge.style.position = "";
        if (galerieLarge && galerieLarge.style.paddingTop) galerieLarge.style.paddingTop = "";
        /* En vue large l'agrandissement n'a pas lieu d'etre : la galerie a deja sa place. Une
           echelle laissee derriere une rotation de telephone vers le paysage resterait. */
        if (echelleVue > 1) {
          echelleVue = 1; hMemo = 0;
          cadre.style.transform = ""; cadre.style.transformOrigin = "";
          cadre.style.willChange = "";
          /* L'aide sort de la bande en vue large (`logerAide`) : sans ce nettoyage elle
             emporterait une echelle inverse la ou plus rien ne la compense. */
          if (aide) { aide.style.transform = ""; aide.style.transformOrigin = ""; }
        }
        return;
      }
      /* ⛔ L'ECHELLE SE POSE AVANT TOUT LE RESTE, ET DANS TOUS LES ETATS. Elle ne depend plus de
         l'epinglage mais du seul defilement : la calculer ici, en tete, garantit que tout ce qui
         suit (bas d'unite, ecran opaque, calage du selecteur) mesure la geometrie du moment et
         non celle d'avant la croissance. */
      poserEchelle();
      /* La ligne d'epingle suit le bandeau tant que rien n'est epingle : voir MARGE_HAUT. */
      if (!fixe) BASE = MARGE_HAUT + hautPromo();
      /* ⛔ LE BAS DE LA GALERIE SE FIGE JUSTE SOUS LE BADGE SAV : la ligne de
         livraison et le badge passent SOUS l'image comme tout le contenu, et l'unite
         gele sur place des que le bas du badge est avale (12 px de marge). Meme
         grammaire que le bandeau TEXTE SUR L'AFFICHE a l'entree (definition finale
         d'Adrien, 02/08/2026, apres pose-dessus, pose-dessous et cale, toutes
         fausses). 80 px apres l'arrivee du badge : aucun suivi a travers la FAQ. */
      var passe = cible.getBoundingClientRect().bottom < basUnite() - 12;
      var padHaut = parseFloat(getComputedStyle(galerie).paddingTop) || 0;
      if (!fixe) {
        var naturel = galerie.getBoundingClientRect().top + padHaut;
        if (naturel < BASE && !passe && !basculeBloquee(basculeCadre, "fixe")) {
          basculeCadre = { t: performance.now(), vers: "fixe" };
          var r = cadre.getBoundingClientRect();
          /* ⛔ LA BOITE DE MISE EN PAGE SE LIT AVANT DE PASSER EN `fixed`, ET LA MESURE L'A
             IMPOSE. Lue apres, la largeur de 76 % ne se resout plus contre la colonne galerie
             mais contre l'ECRAN : 380 px au lieu de 318, que l'echelle multipliait ensuite. Le
             releve du 15/08/2026 montrait l'echelle sauter de 1,52 a 1,78 pile a l'epinglage,
             soit une image plus large que l'ecran, alors que le plafond disait 1,52. */
          var lNat = cadre.offsetWidth || r.width;
          var hNat = cadre.offsetHeight || r.height;
          fixe = true;
          cadre.classList.add("est-fixe");
          cadre.style.position = "fixed";
          cadre.style.top = BASE + "px";
          /* ⛔ ET C'EST LA BOITE NON MISE A L'ECHELLE QU'ON GELE. `getBoundingClientRect` rend le
             rectangle PEINT, echelle comprise : figer cette largeur-la en dur ferait repartir
             l'echelle par-dessus, et l'unite doublerait de taille d'un coup a l'epinglage.
             `offsetWidth` ignore `transform`. L'origine de l'echelle etant en haut au centre,
             l'axe et le haut sont conserves : le centre peint EST le centre naturel. */
          centreLibre = (r.left + r.right) / 2;
          cadre.style.left = Math.round(centreLibre - lNat / 2) + "px";
          cadre.style.width = Math.round(lNat) + "px";
          cadre.style.zIndex = "6";
          cadre.style.background = "var(--bg,#FDFBF9)";
          poserEcran();
          /* La place gelee : sans elle, tout ce qui suit remonte d'un coup de la
             hauteur de la bande au moment ou elle quitte le flux.
             ⚠️ HAUTEUR DE MISE EN PAGE, pas hauteur peinte : c'est la place que l'unite
             occupait dans le flux qu'on remplace, et l'echelle n'en a jamais fait partie.
             Relevee AVANT le passage en `fixed`, pour la meme raison que la largeur. */
          galerie.style.paddingTop = padHaut + hNat + "px";
        }
      } else if (posee) {
        /* ⛔ RE-FIXATION EN MIROIR EXACT DU PARCAGE : quand le haut du SAV redescend
           au-dela du bas d'unite + 12, il rend la place et l'unite remonte se fixer.
           L'ancien critere (« son bord repasse la ligne d'epingle ») etait
           structurellement toujours vrai au repos sous le SAV : re-fixation spontanee
           300 ms apres la pose, unite figee en haut a jamais, image coupee sous
           l'en-tete en remontant (captures FR d'Adrien, 02/08/2026). */
        if (cible.getBoundingClientRect().bottom >= basUnite() - 12 && !basculeBloquee(basculeCadre, "fixe")) refixer();
      } else {
        /* La position qu'elle REprendrait : celle d'avant le gel, rembourrage deduit. */
        var naturelAvant = galerie.getBoundingClientRect().top + padHaut - hauteurUnite();
        if (naturelAvant >= BASE && !basculeBloquee(basculeCadre, "libre")) { defixer(); return; }
        /* Le bloc SAV vient de passer dessous : parcage, une seule bascule, la page
           emporte l'ensemble, pose juste sous lui. */
        if (passe && !basculeBloquee(basculeCadre, "posee")) parquer();
      }
      if (fixe && !posee) {
        /* ⛔ LA LIGNE D'EPINGLE SUIT LE BANDEAU MEME UNE FOIS EPINGLEE (Adrien, serie 321 :
           « j'ai toujours l'espace vide sur iPhone », capture cadre rouge, en-tete retracte).

           MESURE FR, WebKit iPhone 13, pele-mele :
             y=118  bandeau bas 40, cadre 56   ecart 16
             y=300  bandeau bas 16, cadre 46   ecart 30
           `BASE` s'etait figee a 46 alors que la ligne juste vaut 8 + 16 = 24. Elle n'etait
           recalculee que TANT QU'ON N'EST PAS EPINGLE, donc elle retenait la valeur qu'avait
           le bandeau a l'instant du basculement, en pleine retraction de l'en-tete. Le vide
           d'Adrien, c'est cet ecart-la : 30 px au lieu de 8, et rien dedans.

           ⚠️ C'EST LE MECANISME QUE J'AVAIS PROPOSE EN SERIE 318 PUIS ECARTE. Il n'etait pas la
           cause du vide de 24 px en defilement libre (c'etaient deux rembourrages empiles), il
           EST la cause de celui-ci. Ecarter une hypothese parce qu'elle n'explique pas UN cas
           ne la rend pas fausse pour les autres.

           ⚠️ LE GEL AVAIT SA RAISON, et elle tient toujours : recalculer pendant que l'en-tete
           CHANGE d'etat ferait glisser l'image. D'ou le seuil de 2 px, qui laisse passer la
           correction franche et ignore le tremblement, et `hautPromo()` qui borne deja le bas
           par la hauteur (serie 318) : pendant une retraction en cours la valeur ne peut plus
           depasser la hauteur du bandeau, donc la correction ne peut pas partir vers le haut. */
        var vise = MARGE_HAUT + hautPromo();
        if (Math.abs(vise - BASE) > 2) BASE = vise;
        var topPx = BASE + "px";
        if (cadre.style.top !== topPx) cadre.style.top = topPx;
        /* L'ecran suit la geometrie du moment : il s'etire au calage du selecteur,
           se retracte a son decrochage, et suit l'image si sa hauteur change. */
        var hEcr = hauteurEcran() + "px";
        if (ecran.style.height !== hEcr) ecran.style.height = hEcr;
      }
      /* ⛔ LE SELECTEUR SE FIGE LA OU IL ARRIVE, JAMAIS REMONTE DANS LA CARTE. Sa
         ligne d'arret est la levre de 12 px sous l'image : il reste
         un bloc de la page, pose sous la carte (Adrien, 02/08/2026). Le libelle
         « TEXTE SUR L'AFFICHE », lui, disparait sous l'image comme le reste. */
      if (fixe && !posee && tete) {
        var basPeint = BASE + hauteurUnite() + LIP;
        /* ⛔ LE SELECTEUR CALE NE PASSE JAMAIS DEVANT LE BOUTON D'ACHAT (Adrien, 23/08/2026,
           capture de `?layout=message` avec une photo importee : « y'a pas quelque chose qui te
           choque avec le CTA ? »). Mesure du meme jour dans son Chrome, ecran de 375 px : le
           selecteur cale occupait 494..521 et « Choisissez une taille » 501..551. Vingt pixels
           de recouvrement, en plein sur le libelle du bouton, sur la page qui vend.
           ⚠️ LA COMPARAISON EST ENTRE DEUX RECTANGLES MESURES, jamais entre des pixels ecrits :
           la bande du selecteur et le haut du bloc d'achat. Elle vaut donc sur tous les ecrans.
           ⚠️ ET LE MEME PREDICAT GARDE LES DEUX SENS. Decaler rend au flux le rembourrage gele,
           donc le bloc d'achat REMONTE encore : le refus reste vrai apres coup, il ne peut pas
           se dedire. Si le calage n'etait garde que dans un sens, il se reposerait aussitot,
           repousserait le bloc d'achat vers le bas, et les deux etats battraient a l'infini.
           C'est exactement la faute qui a coute deux retraits en production le 22/08. */
        var zoneAchat = racine.querySelector(".pdp-buy-actions");
        var achatDansLaBande = function (basBande) {
          if (!zoneAchat) return false;
          var ra = zoneAchat.getBoundingClientRect();
          if (!(ra.width > 0 || ra.height > 0)) return false;   /* pas de boite : rien a proteger */
          return ra.top < basBande;
        };
        var zoneTete = tete.parentElement;
        if (!teteFixe) {
          var rt = tete.getBoundingClientRect();
          if (rt.top < basPeint + 1 && !achatDansLaBande(basPeint + rt.height)
              && !basculeBloquee(basculeTete, "fixe")) {
            basculeTete = { t: performance.now(), vers: "fixe" };
            teteFixe = true;
            /* ⛔ LE REPERE DE FLUX EST UN DELTA DEPUIS LE HAUT DU PARENT, ET LA PLACE
               SE GELE EN BAS : le selecteur est le DERNIER enfant, un gel en
               paddingTop poussait le libelle dans le trou et le cachait derriere le
               selecteur fige (bande vide + polices collees, capture du 02/08/2026).
               Delta et gel se mesurent en taille NORMALE : c'est elle qui reprend sa
               place au decrochage. */
            teteDelta = rt.top - zoneTete.getBoundingClientRect().top;
            var padBas = parseFloat(getComputedStyle(zoneTete).paddingBottom) || 0;
            zoneTete.style.paddingBottom = padBas + rt.height + BAS + "px";
            /* Compact une fois cale : boutons plus bas, angles droits, bordure fondue,
               l'ecran revient a la zone de choix (Adrien, 02/08/2026). Mesure APRES la
               classe : la largeur et la hauteur figees sont celles du compact. */
            tete.classList.add("est-calee");
            var rc = tete.getBoundingClientRect();
            teteBloc = LIP + Math.round(rc.height) + BAS;
            tete.style.position = "fixed";
            tete.style.top = basPeint + "px";
            tete.style.left = Math.round(rc.left) + "px";
            tete.style.width = Math.round(rc.width) + "px";
            /* Au-dessus de l'image (z 6) au cas ou ils se frolent. */
            tete.style.zIndex = "7";
            /* BLANC, comme le bloc au repos : le creme de la page le fondait dans le
               decor et le contenu semblait visible dessous (Adrien, 02/08/2026). */
            tete.style.background = "#fff";
          }
        } else {
          /* La position qu'il REprendrait dans le flux. */
          var naturelTete = zoneTete.getBoundingClientRect().top + teteDelta;
          /* Il rend la place des que le bloc d'achat entre dans sa bande, et des qu'il
             reprendrait de lui-meme une place plus basse. */
          if ((naturelTete >= basPeint || achatDansLaBande(tete.getBoundingClientRect().bottom))
              && !basculeBloquee(basculeTete, "libre")) defixerTete();
        }
        if (teteFixe) {
          var topTete = (BASE + hauteurUnite() + LIP) + "px";
          if (tete.style.top !== topTete) tete.style.top = topTete;
        }
      } else if (!fixe) {
        defixerTete();
      }
    }
    function planifier() { if (prevu) return; prevu = true; requestAnimationFrame(evaluer); }
    /* Une cible defilee par le code doit atterrir SOUS l'unite epinglee, pas derriere
       elle : « Choisir un format » semblait defiler dans le vide, la cible cachee
       sous l'image (iOS, 02/08/2026). */
    window.__persoDefilerVers = function (el) {
      if (!el) return;
      if (!(fixe && !posee)) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      var repere = basUnite() + 12;
      var y = el.getBoundingClientRect().top + window.pageYOffset - repere;
      window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
    };
    window.addEventListener("scroll", planifier, { passive: true });
    /* Un redimensionnement change largeur et position : on depose, puis on reevalue.
       Sur mobile, la barre d'outils du navigateur retracte et etend le viewport a
       CHAQUE defilement, et ce resize deposait puis re-epinglait la bande : elle
       tremblait au lieu de rester figee (02/08/2026). Un changement de HAUTEUR seul
       ne change ni la largeur figee ni l'ecran : on ne depose que si la largeur
       bouge vraiment. */
    var derniereLargeurVue = window.innerWidth;
    window.addEventListener("resize", function () {
      if (window.innerWidth === derniereLargeurVue) { planifier(); return; }
      derniereLargeurVue = window.innerWidth;
      logerAide();
      /* Rotation ou vraie resize : la boite naturelle et le plafond d'echelle sont perimes, ils
         se reprendront au prochain passage au repos. Un changement de HAUTEUR seul n'entre pas
         ici, et c'est precisement ce qui protege du battement de la barre d'outils iOS. */
      largeurLibre = 0; hauteurLibre = 0; kMaxFige = 0; echelleVue = 0;
      cadre.style.transform = ""; cadre.style.transformOrigin = "";
      defixer(); planifier();
    });
    if (typeof ResizeObserver !== "undefined") new ResizeObserver(planifier).observe(cadre);
    planifier();
  })();

  /* ---- Achat sans photo : l'import EST le CTA (mobile) ----
     Sans photo importee, la seule action utile est d'importer : le bouton
     « Importer ma photo » (le label #pdp-upload, qui emmene son input file) prend
     la place du CTA « Choisir un format » dans la rangee d'achat, et la quantite
     disparait (Adrien, 02/08/2026, TOUS appareils, pas seulement mobile). Photo
     posee : le bouton se masque et la rangee reprend quantite + CTA. Etats poses
     en ligne, ce bloc ne depend que de lui. */
  (function () {
    if (!window.__pdpPerso) return;
    var racine = document.querySelector(".pdp--perso");
    var envoi = document.getElementById("pdp-upload");
    var rangee = document.querySelector(".pdp-buy-actions");
    var ajout = document.getElementById("pdp-add");
    var qte = document.querySelector(".pdp-buy-actions .pdp-qty-sel");
    if (!racine || !envoi || !rangee || !ajout) return;
    rangee.insertBefore(envoi, ajout);
    envoi.style.flex = "1";
    function majRangee() {
      /* ⛔ « PAS DE PHOTO » N'EST PAS « PHOTO EXIGEE ». La regle vaut pour la fiche perso et le
         pele-mele, ou le produit EST la photo du client : sans elle il n'y a rien a vendre. La
         fiche panneau porte la meme classe parce qu'elle partage ce gabarit, mais un panneau de
         bienvenue se vend avec du texte seul ; seul le type « panneau photo » attend une image.
         Le configurateur repond (`__pdpExigePhoto`), et tant qu'il ne repond pas on garde la
         regle d'origine : ici on ne devine pas a la place de la page. */
      var sansPhoto = window.__pdpExigePhoto
        ? !!window.__pdpExigePhoto()
        : !racine.classList.contains("pdp--perso-has-photo");
      /* ⛔⛔ SUR LES CONFIGURATEURS, C'EST LE CTA DE PAGE QUI DIT LE GESTE QUI MANQUE (Adrien,
         23/08/2026, capture a l'appui : « sur desktop pele mele il fallait remplacer le CTA par
         le systeme "cliquer sur une photo pour importer" que tu as mis en place uniquement dans
         la modale mobile »). Cette ligne masquait `#pdp-add` tant qu'aucune photo n'existait et
         montrait « Importer ma photo » a la place : le libelle que j'avais pose sur `#pdp-add`
         et le clignotement des cases qu'il declenche etaient donc INVISIBLES en vue large.

         ⛔ ET J'AI VERIFIE UN BOUTON MASQUE. Le 23/08 au matin j'ai mesure `#pdp-add`, lu
         « Cliquez sur une case pour importer », clique dessus par script, vu les anneaux se
         poser, et annonce que ca marchait. L'element rendait ZERO pixel : aucun client n'a
         jamais vu ce bouton. Une mesure qui ne verifie pas qu'un element a une boite ne mesure
         rien ([[mesure-aveugle-ne-prouve-rien]] est ecrit pour ce cas exact).

         ⚠️ LE PANNEAU GARDE L'ANCIEN CHEMIN : il se compose au clavier, sans fichier a fournir,
         et sa photo est une option parmi d'autres, pas la matiere du produit.
         ⚠️ ET LE SELECTEUR DE QUANTITE RESTE MASQUE : sans photo il n'y a rien a compter. */
      var parLaCase = !window.__pdpPanneau
        && (window.__pdpPeleMele || window.__pdpPerso);
      var montreDepot = sansPhoto && !parLaCase;
      envoi.style.display = montreDepot ? "" : "none";
      ajout.style.display = (sansPhoto && !parLaCase) ? "none" : "";
      /* ⛔ « "" », ET PLUS « flex » (20/08/2026). Cette ligne ecrivait « flex » EN LIGNE parce que
         le markup portait deja `display:flex` inline et qu'un retour a vide l'effacait pour de
         bon : la pastille retombait en block, boutons empiles, ovale ecrase (03/08/2026). Les
         deux causes ont disparu : `display` a quitte le style en ligne du gabarit, et
         `.pdp-qty-sel{display:flex;align-items:center}` tient le repli dans base.css depuis.
         ⛔ ET C'EST INDISPENSABLE : un `display` en ligne bat toute la feuille. Tant qu'il etait
         ecrit ici, la regle qui retire ce selecteur de la page quand la fenetre devient le chemin
         d'achat n'avait aucun effet, sans lever la moindre erreur. */
      if (qte) qte.style.display = sansPhoto ? "none" : "";
    }
    majRangee();
    /* La classe suffit a la fiche perso et au pele-mele ; le panneau change d'exigence sans que
       la classe bouge (c'est le TYPE choisi qui la porte), il rappelle donc lui-meme. */
    window.__pdpMajRangeeAchat = majRangee;
    /* ⛔ ET UNE FOIS DE PLUS APRES LES AUTRES SCRIPTS. Le premier passage a lieu pendant
       l'execution de ce fichier : si panneau-mariage.js n'a pas encore pose `__pdpExigePhoto`,
       la reponse vient du repli par la classe, et la fiche s'ouvrait sur « Importer ma photo »
       au lieu du bouton d'achat (verifie en production le 08/08/2026 : le defaut ne se voyait
       plus des qu'on cliquait un type, donc pas au premier regard). Une macrotache passe apres
       tous les scripts de la page, quel que soit leur ordre. */
    setTimeout(majRangee, 0);
    new MutationObserver(majRangee).observe(racine, { attributes: true, attributeFilter: ["class"] });
  })();

  /* ---- CRO : barre d'achat sticky ---- */
  (function () {
    /* ⚠️ `#pdp-sticky-add` N'EST PLUS LU ICI : son relais vers `#pdp-add` est parti avec le
       reste. D'autres fichiers lui ecrivent encore son libelle et son etat (`pele-mele.js`,
       `panneau-mariage.js`, `syncPersoCta`) ; sur un element masque cela ne coute rien, et les
       retirer un a un toucherait quatre configurateurs pour un gain nul. */
    var bar = $("#pdp-sticky"), anchor = $("#pdp-add");
    if (!bar || !anchor) return;
    /* ⛔⛔ LA BARRE NE S'AFFICHE PLUS (Adrien, 23/08/2026 : « vire le complètement (masque le) »).
       La feuille la masque deja ; on coupe AUSSI ici, et pas seulement la-bas, pour deux raisons
       qui ne sont pas la meme :
         - `body.pdp-sticky-on` decale la bulle de chat de la hauteur de la barre. Laisse en
           place, ce decalage s'appliquerait pour une barre que personne ne voit, et la bulle
           flotterait 61 px trop haut sur toutes les fiches.
         - `--pdp-sticky-h` sert de reserve de place a d'autres calques. Une reserve pour un
           element absent est un trou.
       ⚠️ ON SORT AVANT D'ECOUTER QUOI QUE CE SOIT : un observateur de defilement qui ne peut
       rien montrer est du travail fait a chaque image pour rien.
       ⚠️ ET `hidden` EST POSE : la feuille suffit a l'oeil, l'attribut la sort de l'arbre
       d'accessibilite, ou son bouton continuerait d'etre annonce et atteignable au clavier. */
    bar.hidden = true;
    document.body.classList.remove("pdp-sticky-on");
    document.documentElement.style.setProperty("--pdp-sticky-h", "0px");
    /* ⛔ TOUT CE QUI SUIVAIT A ETE RETIRE, PAS COMMENTE : l'observateur de defilement, les
       deux seuils, la temporisation de 320 ms et la synchro de hauteur n'existaient que pour
       montrer cette barre. Garde derriere une sortie anticipee, ce code aurait ete du code
       mort qui SE LIT comme du code vivant, et le prochain a passer par la aurait retire la
       sortie en croyant reparer une regression.
       ⚠️ LE GABARIT ET LES STYLES RESTENT : la barre existe toujours dans la page, masquee.
       `tests/barre-epinglee-retiree.test.js` verifie que les deux serrures tiennent. */
  })();

  /* ---- Upsells (cases a cocher) : cadre a la taille de l'affiche + crochet mural ----
     Les pastilles de couleur teintent l'apercu du cadre sur l'image. Les cases cochees
     sont ajoutees au panier AVEC l'affiche au clic sur "Ajouter au panier" (cf. add()). */
  (function () {
    var frameVariants = window.__pdpFrameVariants || [];
    var hook = window.__pdpHook || null;
    /* Aucune moulure choisie au départ : la valeur vide dit « pas de cadre », et c'est ce que
        lisent le prix affiché et le nom de couleur. Elle valait « Blanc », ce qui annonçait le
        prix d'un cadre que personne n'avait demandé. */
    var upColor = "";
    /* ⛔ UN POLYPTYQUE SE CADRE EN N EXEMPLAIRES DU FORMAT DE FEUILLE.
       « Polyptyque 2x2 · 50x70 » n'existe pas comme taille de cadre : frameVariantFor ne
       trouvait rien, la case restait cochee et n'ajoutait RIEN au panier. Le client repartait
       avec quatre tirages et zero cadre, en croyant les avoir commandes.
       Le cadre se cherche donc sur la FEUILLE (50X70) et se commande en QUATRE. Meme lecture
       du titre que partout ailleurs : la grille d'abord, le format ensuite, « 2x2 » n'etant
       jamais un format. */
    /* ⛔ ON LIT LES NOMBRES, PAS LE MOT.
     *
     * Cette fonction cherchait « polyptyque » par expression reguliere. Markets TRADUIT les
     * valeurs d'option : sur /nl la taille s'appelle « Polyptiek 2x2 · 50x70 ». Le motif ne
     * matchait donc pas, la fonction rendait null, et tout ce qui en depend tombait :
     *   - `posterSize()` rendait le libelle entier au lieu de « 50X70 », donc AUCUN cadre ne
     *     correspondait et l'encadrement d'un polyptyque etait impossible hors francais ;
     *   - `nbPanneaux()` rendait 1 au lieu de 4, donc UN cadre et UN jeu de crochets factures
     *     pour quatre panneaux.
     * Releve le 10/08/2026, en meme temps que la meme faute sur la couleur du cadre.
     *
     * La structure, elle, ne se traduit pas : deux nombres de panneaux, puis le format de la
     * feuille. C'est elle qu'on lit. Une taille simple (« 30X40 ») ne porte qu'un seul groupe
     * et ne matche pas, ce que le banc d'essai verifie. */
    function polyDeTaille(v) {
      var t = String(v || '');
      var g = t.match(/(\d)\s*[x\u00d7]\s*(\d)\D+(\d{2,3})\s*[x\u00d7]\s*(\d{2,3})/i);
      if (!g) return null;
      var w = Math.min(+g[3], +g[4]); var h = Math.max(+g[3], +g[4]);
      return { format: w + 'X' + h, panneaux: (+g[1]) * (+g[2]) };
    }
    function tailleChoisie() { var fi = formatGroupInfo(); return fi ? selected[fi.idx] : null; }
    /* La taille du CADRE : celle de la feuille pour un polyptyque, la taille elle-meme sinon. */
    function posterSize() {
      var v = tailleChoisie(); var poly = polyDeTaille(v);
      return poly ? poly.format : v;
    }
    /* Combien de cadres et de crochets : un par panneau. */
    function nbPanneaux() { var poly = polyDeTaille(tailleChoisie()); return poly ? poly.panneaux : 1; }
    /* Les valeurs de COULEUR du cadre, dans l'ordre du produit, deduites des variantes.
       Une taille porte un « X » entre deux nombres (21X30) et n'est pas traduite ; tout le
       reste est une couleur, et celle-la l'est. */
    function couleursDuCadre() {
      var vues = [];
      frameVariants.forEach(function (v) {
        (v.options || []).forEach(function (o) {
          if (!/^\d+X\d+$/i.test(String(o)) && vues.indexOf(o) === -1) vues.push(o);
        });
      });
      return vues;
    }
    /* ⛔ ON NE REND JAMAIS « RIEN » PARCE QU'UN MOT A CHANGE DE LANGUE.
     *
     * Le 10/08/2026, les pastilles portaient « Blanc / Noir / Chêne clair » ecrits en dur alors
     * que Markets traduit les valeurs d'option : sur /nl le cadre est « Wit / Zwart / Licht
     * eiken ». Cette fonction ne trouvait aucune variante et rendait `undefined`, donc le clic
     * sur « ajouter » n'ajoutait rien, SANS AUCUNE ERREUR. Le gabarit pose desormais la vraie
     * valeur ; ce repli existe pour que le meme oubli ne redevienne jamais un silence : si le
     * mot ne correspond a rien, on retombe sur la couleur de MEME RANG, qui, elle, ne se
     * traduit pas. Mieux vaut un cadre choisi par son rang qu'un panier qui ne bouge pas. */
    function frameVariantFor(size, color) {
      var exact = frameVariants.filter(function (v) {
        return v.available !== false && v.options.indexOf(size) > -1 && v.options.indexOf(color) > -1;
      })[0];
      if (exact) return exact;
      var couleurs = couleursDuCadre();
      var rang = ["Blanc", "Noir", "Chêne clair"].indexOf(color);
      if (rang < 0 || !couleurs[rang]) return undefined;
      return frameVariants.filter(function (v) {
        return v.available !== false && v.options.indexOf(size) > -1
          && v.options.indexOf(couleurs[rang]) > -1;
      })[0];
    }
    /* ⛔ LE « DES » SE COMPTE SUR LA TAILLE CHOISIE, PAS SUR TOUT LE CATALOGUE DE CADRES.
     * Mesure du 19/08/2026, polyptyque 2x2 en 50x70 : la fiche annoncait « des 76,00 € », soit
     * quatre fois le cadre le moins cher du produit (le 21x30 a 19 €). Or un polyptyque 50x70
     * ne peut prendre QUE des cadres 50x70 : 4 x 49 = 196 €. Le client lisait donc un prix deux
     * fois et demie trop bas, et decouvrait l'ecart au panier. Le defaut existait avant le
     * changement de prix du jour ; passer le 50x70 de 39 a 49 l'a rendu plus cher encore.
     * ⚠️ LA TAILLE SE RECONNAIT COMME AILLEURS DANS CE FICHIER : la valeur d'option qui porte un
     * « X » entre deux nombres, la seule que Markets ne traduise pas. Aucun second chemin.
     * Sans taille choisie, le minimum reste celui de tout le produit : c'est le seul moment ou
     * « des » veut dire quelque chose. */
    function frameMinPrice(size) {
      var pool = frameVariants;
      if (size) {
        var duFormat = frameVariants.filter(function (v) { return (v.options || []).indexOf(size) > -1; });
        if (duFormat.length) pool = duFormat;
      }
      var m = null;
      pool.forEach(function (v) { if (m == null || v.price < m) m = v.price; });
      return m || 0;
    }
    function refreshFramePrice() {
      var el = $("#pdp-up-frame-price"); if (!el) return;
      var size = posterSize();
      /* Tant qu'aucune moulure n'est choisie, on annonce un prix DE DÉPART, pas celui d'un
         cadre précis : sinon la fiche affiche le tarif d'un cadre blanc que le client n'a pas
         demandé, juste à côté d'un mot qui dit « cadre ». */
      var v = size && frameChecked() ? frameVariantFor(size, upColor) : null;
      /* ⛔ SUR UN POLYPTYQUE, LE PRIX ANNONCE EST CELUI DES QUATRE CADRES. Afficher le prix
         d'un seul a cote d'un bouton qui en ajoute quatre ferait un ecart de trois cadres
         entre ce qu'on lit et ce qu'on paie, decouvert au panier. */
      var n = nbPanneaux();
      /* ⛔ LE MOT SUIT LE NOMBRE (Adrien, 19/08/2026 : « pour le 100x140cm c'est ajouter les
       * cadres pas le cadre »). Un polyptyque en pose quatre : le singulier a cote d'un prix
       * qui affiche « (4) » se contredit lui-meme. Le mot ne peut pas etre choisi au rendu, la
       * taille changeant sans rechargement, et le pluriel est ecrit dans les treize langues,
       * jamais fabrique par une regle : « Rahmen » ne prend pas de marque, « κορνίζας » devient
       * « κορνιζών ». */
      var mots = window.__pdpCadreMots || {};
      var elMot = $("#pdp-up-frame-mot");
      if (elMot) {
        var mot = n > 1 ? mots.plusieurs : mots.un;
        if (mot) elMot.textContent = mot;
      }
      /* ⚠️ LE CADRE N'A PAS DE PRIX BARRE : aucune promo ne s'y applique, son prix plein est
         son prix tout court. Seule la conversion hors taxes change dans le parcours pro. */
      el.textContent = v
        ? "· " + montantTxt(v.price * n) + (n > 1 ? " (" + n + ")" : "")
        : "· " + (T.price_from || "dès") + " " + montantTxt(frameMinPrice(size) * n);
    }
    /* Teinte la moulure de l'apercu a la couleur choisie. `null` = aucun cadre retenu :
       la moulure disparait, comme l'option « Sans cadre ». La fonction sortait avant sans
       rien faire, si bien qu'une affiche deselectionnee gardait son cadre a l'ecran. */
    /* ⛔ PAS DE FORMAT, PAS DE CADRE. Un cadre se vend À LA TAILLE de l'affiche : tant que la
       taille n'est pas choisie, il n'y a rien à encadrer, et montrer une moulure sur une
       affiche sans format ne veut rien dire (Adrien, 05/08/2026).
       Le cas se produisait au RETOUR sur la fiche : le cadre restant dans le panier, la
       restauration reposait sa moulure, et l'affiche s'affichait encadrée sans qu'aucun format
       ne soit sélectionné. On ne touche pas au panier pour autant, c'est lui la vérité : on
       s'interdit seulement de PRÉTENDRE que ce cadre s'applique à ce qui est affiché. */
    function cadreAutorise() { return formatChosen(); }
    /* ⛔ UN CADRE EN RUPTURE DOIT DISPARAITRE, PAS SEULEMENT ECHOUER.
     *
     * `frameVariantFor` filtre deja sur `v.available !== false` : quand la cote choisie n'a plus
     * aucune moulure disponible, il rend `undefined`, et `add()` n'ajoute alors RIEN au panier.
     * Mais le bloc restait affiche, ses pastilles cliquables, et `frameMinPrice` annoncait
     * toujours un prix — il ne regarde pas la disponibilite. Le client choisissait une moulure,
     * lisait « des 79,00 EUR », payait son affiche, et recevait un tirage sans cadre en croyant
     * l'avoir commande. C'est mot pour mot le defaut du polyptyque du 10/08/2026, par un autre
     * chemin : ce qui est montre doit etre ce qui part au panier.
     *
     * ⚠️ ON REGARDE LA COTE, PAS LA COULEUR. Une seule teinte en rupture laisse le cadre
     * vendable dans les deux autres : c'est `frameVariantFor` qui bascule alors sur une moulure
     * disponible. Le bloc ne disparait que si la cote n'en a plus AUCUNE. */
    function cadreVendable() {
      var size = posterSize();
      if (!size) return true;               /* pas de cote choisie : c'est `cadreAutorise` qui parle */
      return frameVariants.some(function (v) {
        return v.available !== false && (v.options || []).indexOf(size) > -1;
      });
    }
    function peindreDisponibiliteCadre() {
      var ok = cadreAutorise();
      var vendable = cadreVendable();
      $$("#pdp-up-frame .pdp-up-color").forEach(function (b) {
        b.setAttribute("aria-disabled", ok ? "false" : "true");
      });
      var bloc = $("#pdp-up-frame");
      if (!bloc) return;
      bloc.setAttribute("data-attend-format", ok ? "false" : "true");
      bloc.setAttribute("data-indispo", vendable ? "false" : "true");
      /* ⛔ ET ON RELACHE LA MOULURE RETENUE. Sans ca, une pastille restee `aria-pressed` sur une
         cote devenue indisponible garde `frameChecked()` vrai : le prix de l'affiche continue de
         compter un cadre que rien n'ajoutera. Le bloc est cache, la decision doit l'etre aussi. */
      if (!vendable) {
        upColor = "";
        $$("#pdp-up-frame .pdp-up-color").forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
      }
      if (peindreDisponibiliteCrochet()) { updatePrice(); syncUpsells(); }
    }
    function applyFramePreview(sw) {
      var w = $(".pdp-gallery__wrap");
      if (!cadreAutorise()) sw = null;
      /* ⛔ SUR LA FICHE PERSO, L'APERCU EST TOUJOURS ENCADRE, ET LE CADRE N'EST PAS VENDU POUR
         AUTANT (Adrien, 08/08/2026 : « pas seulement a l'importation, meme l'image placeholder
         doit etre encadree »).
         Une feuille nue ne dit pas ce qu'on achete : posee dans une moulure chene clair, la
         meme photo se lit comme un tirage encadre, avant l'import comme apres. C'est pour ca
         que le repli vaut AUSSI quand aucun format n'est choisi, donc apres le `cadreAutorise`
         ci-dessus : le placeholder arrive bien avant le format.
         ⛔ ET IL RESTE UN APERCU. On ne touche ni a `upColor`, ni a `aria-pressed` sur les
         pastilles : `frameChecked()` et `frameVariantFor()` continuent de lire un cadre NON
         retenu, le prix ne bouge pas, rien ne part au panier. Preselectionner la pastille
         ferait payer 5 a 20 euros un cadre que personne n'a demande, exactement la faute que
         la perforation du panneau mariage vient de couter (0804380). Le client voit le beau
         rendu ; il achete le cadre s'il le coche. */
      /* ⛔ LE PELE-MELE AUSSI (Adrien, 12/08/2026 : « ajoute le cadre chene clair autour de
         l'image importee et placeholder sur la fiche pele mele comme sur la perso »). Il etait
         exclu du repli chene ; seule la fiche panneau reste nue, un support rigide ne se vend
         pas encadre. Memes garanties que la perso : rien n'est coche, rien n'est facture. */
      var persoCadreDefaut = !sw && !!document.querySelector(".pdp--perso:not(.pdp--panneau)");
      var teinte = upColor;
      if (persoCadreDefaut) { sw = FRAME_SWATCH["Chêne clair"]; teinte = "Chêne clair"; }
      /* ⛔ UN POLYPTYQUE SE MONTRE TOUJOURS ENCADRE, ET L'ECART EST LA POUR CA.
         Les 41 mm entre deux panneaux SONT le cadre : deux baguettes de 18 mm plus 5 mm de
         mur. C'est cette bande que le decoupage jette, et c'est elle qui fait que les lignes
         se rejoignent.
         J'ai d'abord rendu la moulure transparente quand aucun cadre n'etait coche : les
         cadres disparaissaient mais LEUR PLACE RESTAIT, et l'ecran montrait quatre feuilles
         separees par un vide de 41 mm que personne n'accrocherait ainsi (Adrien, 06/08/2026 :
         « il n'y a pas de cadre, pourquoi tu laisses un espace vide aussi large ? »). C'etait
         incoherent : ou les deux, ou aucun des deux. Et « aucun des deux » est impossible,
         puisque la decoupe suppose les cadres.
         La moulure est donc TOUJOURS dessinee. Sans choix, elle prend la teinte par defaut du
         cadre de la fiche, la meme que la bordure de #pdp-frame ; des qu'une moulure est
         retenue, elle prend la sienne. */
      if (w) w.style.setProperty("--poly-moulure", sw || "transparent");
      /* `data-noframe` est pose juste apres ; le redessin se fait donc en fin de fonction. */
      if (!sw) {
        if (w) { w.setAttribute("data-noframe", ""); w.removeAttribute("data-moulure"); }
        [$("#pdp-frame"), $("#pdp-mockup-poster"), $(".pdp-thumb__poster")].forEach(function (el) {
          if (el) el.style.borderWidth = "0px";
        });
        if (window.__pdpPolyRedessine) window.__pdpPolyRedessine();
        return;
      }
      if (w) w.removeAttribute("data-noframe");
      /* ⛔ LA TEINTE CHOISIE PILOTE AUSSI LA MATIERE. `data-moulure` designe l'image de bordure
         fabriquee depuis nos photos de cadre (base.css, `moulure-*.png`). La couleur reste posee
         juste apres, en repli : elle sert au BLANC, qui n'a pas encore de photo, et a tout moteur
         qui ignorerait `border-image`.
         ⚠️ ICI ET PAS DANS `updateFrame` : sur une affiche, la moulure se choisit par les
         pastilles de l'upsell, pas par une option de variante. Je l'avais posee dans
         `updateFrame`, qui ne sert qu'a la fiche du cadre : releve a l'ecran, `data-moulure`
         restait nul apres un clic sur chene comme sur noir. */
      if (w) {
        /* ⛔ LE RANG, PAS LE MOT. `teinte` vient des pastilles, donc de la langue servie : sur
           /nl c'est « Zwart » et « Licht eiken ». Compare a « Noir » et « Chêne clair », le
           test etait faux partout sauf en francais, `data-moulure` restait vide, et la mise en
           situation ne montrait AUCUNE moulure sur les douze autres marches. Le rang, lui, ne
           se traduit pas : blanc, noir, chene clair, dans cet ordre. */
        var cleT = cleCouleurFr(teinte);
        var moul = cleT === "Chêne clair" ? "chene" : (cleT === "Noir" ? "noir" : "");
        if (moul) w.setAttribute("data-moulure", moul); else w.removeAttribute("data-moulure");
      }
      if (window.__pdpPolyRedessine) window.__pdpPolyRedessine();
      [$("#pdp-frame"), $("#pdp-mockup-poster"), $(".pdp-thumb__poster")].forEach(function (el) {
        if (el) { el.style.borderWidth = ""; el.style.borderColor = sw; }
      });
    }
    /* ⛔ LA LEGENDE EST INDEXEE EN FRANCAIS. Sur /nl la pastille vaut « Licht eiken » : la
       table ne trouvait rien et la legende retombait sur la valeur brute, « Licht eiken » au
       lieu de « Licht eiken. Poster wordt ingelijst geleverd ». La phrase qui dit que
       l'affiche arrive DEJA ENCADREE disparaissait sur douze marches, et c'est un argument de
       vente, pas un ornement. Vu par Adrien a l'ecran le 10/08/2026. */
    function frameColorLabel(c) {
      var map = T.frame_colors || {};
      return map[cleCouleurFr(c)] || map[c] || c;
    }
    /* ⛔ LA PHRASE DE LIVRAISON PASSE EN GRAS, DANS LA LIGNE EXISTANTE (Adrien, 11/08/2026 :
       « mets en gras le texte deja present », apres que j'aie ajoute un doublon au lieu de
       ca). Le libelle vaut « Chêne clair. Affiche livrée déjà encadrée » dans chaque langue,
       toujours separe par un point : la teinte reste telle quelle, la promesse se met en
       evidence. Construit en DOM, jamais en innerHTML sur une chaine. Sans point, on retombe
       sur le texte brut. */
    function setColorName() {
      var el = $("#pdp-up-frame-colorname"); if (!el) return;
      var t = frameColorLabel(upColor);
      var i = t.indexOf(". ");
      el.textContent = "";
      if (i < 0) { el.textContent = t; return; }
      el.appendChild(document.createTextNode(t.slice(0, i + 2)));
      var b = document.createElement("b");
      var reste = t.slice(i + 2);
      /* ⛔ « OFFERT » DOIT SE VOIR (Adrien, 07/09/2026 : « mets OFFERT d'une autre couleur pour
       * faire ressortir »). Il etait en gras comme le reste de la phrase, donc invisible dans
       * une ligne deja en gras : c'est le seul mot de la fiche qui dit que le cadre ne coute
       * rien, et il se lisait comme la fin d'une phrase.
       * ⚠️ LE MOT SE TROUVE PAR SA PARENTHESE, PAS PAR SA LETTRE. Les treize marches ecrivent
       * (OFFERT), (FREE), (GRATIS), (ΔΩΡΕΑΝ) : chercher « offert » n'aurait teinte que la
       * France. La parenthese finale, elle, est la meme partout, et une langue qui n'en
       * mettrait pas retombe simplement sur l'ancien rendu. */
      var par = /\s*\(([^()]+)\)\s*$/.exec(reste);
      if (par) {
        b.textContent = reste.slice(0, par.index).replace(/\s+$/, "");
        el.appendChild(b);
        var g = document.createElement("span");
        g.className = "pdp-up-offert";
        g.textContent = " (" + par[1] + ")";
        el.appendChild(g);
        return;
      }
      b.textContent = reste;
      el.appendChild(b);
    }
    /* ---------- « VOIR LE CADRE » (Adrien, 06/08/2026) ----------
       ⛔ LE LIEN N'EXISTE QUE POUR UNE TEINTE QUI A DES PHOTOS. Le blanc n'est pas encore
       photographie : proposer « voir le cadre » puis ouvrir une fenetre vide, ou pire y montrer
       le chene, coute plus cher que de ne rien proposer. Le jour ou les photos du blanc
       arrivent, il suffit de les ajouter a `__pdpCadrePhotos`, rien d'autre ne bouge ici. */
    var CADRE_PHOTOS = window.__pdpCadrePhotos || {};
    /* ⛔ MEME CLE FRANCAISE, ET ELLE CACHAIT UN LIEN ENTIER. Sans normalisation, aucune teinte
       n'avait de photos hors francais : « Voir le cadre » restait masque sur douze marches, et
       la fenetre qui montre le bois ne s'ouvrait jamais. */
    function photosDeLaTeinte(c) {
      return CADRE_PHOTOS[cleCouleurFr(c)] || CADRE_PHOTOS[c] || null;
    }
    function majVoirCadre() {
      var b = $("#pdp-voircadre"); if (!b) return;
      var photos = photosDeLaTeinte(upColor);
      b.hidden = !(upColor && photos && photos.length);
    }
    function ouvrirCadre() {
      var photos = photosDeLaTeinte(upColor);
      if (!photos || !photos.length) return;
      var d = $("#pdp-cadre"), corps = $("#pdp-cadre-body"), titre = $("#pdp-cadre-titre");
      if (!d || !corps) return;
      /* ⛔ LE TITRE PREND LE NOM COURT DE LA TEINTE, PAS SON LIBELLE D'INFOBULLE. Vu a l'ecran
         apres deploiement : la fenetre s'intitulait « Noir - bois mat. Affiche livree deja
         encadree », c'est-a-dire la phrase entiere de l'attribut `title`, en capitales espacees
         et sur deux lignes. Cette phrase est faite pour etre SURVOLEE, pas pour titrer.
         Les treize langues ecrivent toutes ce libelle « <teinte> - <matiere et promesse> » : on
         garde ce qui precede le tiret, et le repli est le libelle entier si un jour l'une
         d'elles s'ecarte de la forme. Verifie sur les treize avant de s'y fier. */
      /* ⚠️ LE SEPARATEUR A CHANGE AVEC LE LIBELLE. Il etait « <teinte> - <matiere>. <promesse> » ;
         « - bois mat. » a ete retire le 06/08/2026, il reste « <teinte>. <promesse> ». On coupe
         donc au premier tiret OU au premier point suivi d'une espace, ce qui couvre les deux
         formes : si un libelle repasse un jour a l'ancienne, le titre reste juste. */
      if (titre) titre.textContent = String(frameColorLabel(upColor)).split(/\s+[-–—]\s+|\.\s+/)[0];
      corps.innerHTML = "";
      photos.forEach(function (src, i) {
        var im = document.createElement("img");
        im.src = src;
        im.alt = frameColorLabel(upColor);
        /* La premiere est celle qu'on voit en ouvrant : elle seule est prioritaire, les trois
           autres attendent le defilement. */
        im.loading = i === 0 ? "eager" : "lazy";
        im.decoding = "async";
        corps.appendChild(im);
      });
      corps.scrollTop = 0;
      d.hidden = false;
      document.documentElement.style.overflow = "hidden";
      var x = $("#pdp-cadre-close"); if (x) x.focus();
    }
    function fermerCadre() {
      var d = $("#pdp-cadre"); if (!d || d.hidden) return;
      d.hidden = true;
      document.documentElement.style.overflow = "";
      var b = $("#pdp-voircadre"); if (b && !b.hidden) b.focus();
    }
    (function brancherCadre() {
      var b = $("#pdp-voircadre"), d = $("#pdp-cadre"), x = $("#pdp-cadre-close");
      if (b) b.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); ouvrirCadre(); });
      if (x) x.addEventListener("click", fermerCadre);
      /* Cliquer le voile ferme, cliquer le panneau non : sans le test, un clic sur une photo
         refermait la fenetre qu'on venait d'ouvrir pour la regarder. */
      if (d) d.addEventListener("click", function (e) { if (e.target === d) fermerCadre(); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") fermerCadre(); });
    })();
    /* ---------- « VOIR LA QUALITE » (Adrien, 07/08/2026) ----------
       Meme fenetre que les cadres, autre contenu : la zoomee de la fiche quand elle existe
       (la vignette data-hd, celle du gros plan tire de l'upscale), puis les preuves fixes :
       qual-01, la video d'atelier, la table d'impression, qual-03. La video est MUETTE et
       sans commandes : elle montre le geste, elle n'a rien a faire entendre. */
    /* ⛔ LA FENETRE « VOIR LA QUALITE » A DEMENAGE DANS `snippets/pdp-qualite.liquid`
       (13/08/2026). Elle vit maintenant sur DEUX pages, la fiche produit et la page B2B, et
       cette derniere ne charge pas product.js : garder le code ici aurait impose soit de
       charger tout product.js sur B2B, soit d'en ecrire une seconde version. Le snippet porte
       son marquage, ses donnees ET son script, et les deux pages le rendent. */
    /* Cliquer une moulure SELECTIONNE le cadre et pose la ligne dans le panier. Recliquer la
       moulure active la retire. C'est le seul interrupteur : la case à cocher qui doublait
       cette décision a été retirée le 31/07/2026, parce qu'elle pouvait afficher « cadre »
       coché sans qu'aucune moulure soit entourée. */
    function setFrameColor(b) {
      $$("#pdp-up-frame .pdp-up-color").forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
      upColor = b.getAttribute("data-color");
      applyFramePreview(FRAME_SWATCH[cleCouleurFr(upColor)]);
      setColorName();
      majVoirCadre();
      refreshFramePrice();
      peindreDisponibiliteCrochet();
      updatePrice();
    }
    $$("#pdp-up-frame .pdp-up-color").forEach(function (b) {
      b.addEventListener("click", function () {
        /* Le clic ne fait rien tant qu'aucun format n'est choisi : le cadre se vend à la
           taille, et sans taille il n'y a pas de variante de cadre à mettre au panier. */
        if (!cadreAutorise()) { peindreDisponibiliteCadre(); return; }
        /* ⛔ NEUVIEME PORTE (Adrien, 27/08/2026 : « quand on choisit une bordure ou un cadre, la
           galerie doit revenir la 1ère image si elle était sur img de type zoom, détail ou
           papier, sinon les gens remontent pour voir le rendu et ne le voient pas »).
           Poser ou retirer une moulure change l'affiche ; une vue fixe (Papier, Detail, Zoom)
           est une photo d'atelier prise sur une AUTRE affiche, et elle ne bougera pas. Le
           client remonte, voit la meme photo, et conclut que son clic n'a rien fait.
           ⚠️ AUX DEUX BRANCHES, pas seulement a la pose : retirer le cadre change la vue tout
           autant. Le geste est donc AVANT le test, une seule fois.
           ⚠️ IL NE DEPLACE RIEN SI L'ON REGARDE DEJA L'OEUVRE : `__pdpRevenirALOeuvre` ne
           reactive la vignette que si elle n'est pas deja pressee. */
        if (window.__pdpMontrerLAffiche) window.__pdpMontrerLAffiche();
        if (b.getAttribute("aria-pressed") === "true") {
          /* Même moulure recliquée : plus de cadre. `upColor` est REMIS À VIDE, sinon
             `frameVariantFor()` continuerait de rendre une variante et le cadre reviendrait
             au premier changement de format. */
          b.setAttribute("aria-pressed", "false");
          upColor = "";
          applyFramePreview(null);
          setColorName();
          /* Plus de moulure retenue, donc plus rien a montrer : le lien disparait avec elle. */
          majVoirCadre();
          refreshFramePrice();
        } else {
          setFrameColor(b);
        }
        peindreDisponibiliteCrochet();
        updatePrice();
        syncUpsells();
      });
    });
    $$(".pdp-option").forEach(function (grp) {
      grp.addEventListener("click", function () {
        setTimeout(refreshFramePrice, 0);
        // Changer de format change la variante du cadre : la ligne du panier doit suivre.
        setTimeout(function () { if (frameChecked()) syncUpsells(); }, 0);
      });
    });
    /* Etat initial : aucune moulure n'est entouree tant que le cadre n'est pas choisi.
       En pre-selectionner une laissait croire qu'un cadre etait deja retenu. */
    $$("#pdp-up-frame .pdp-up-color").forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
    applyFramePreview(null);
    peindreDisponibiliteCrochet();
    peindreDisponibiliteCadre();
    /* Le choix d'un format rouvre le cadre : sans ce rappel, les moulures resteraient éteintes
       après la seule action qui les autorise.
       ⚠️ On écoute la PAGE, pas un sélecteur de boutons de taille : le balisage des options a
       déjà changé deux fois, et un sélecteur inventé ne casse rien de visible, il rend
       seulement le cadre inaccessible pour toujours. Un clic quelconque coûte une lecture
       d'attribut, c'est sans conséquence. */
    document.addEventListener('click', function () { setTimeout(peindreDisponibiliteCadre, 0); }, true);
    setColorName();
    refreshFramePrice();
    /* Le cadre est choisi quand une moulure est entourée. Il n'y a plus de case : elle faisait
       un second interrupteur pour la même décision, et les deux pouvaient se contredire. */
    function frameChecked() {
      return $$("#pdp-up-frame .pdp-up-color").some(function (b) {
        return b.getAttribute("aria-pressed") === "true";
      });
    }
    function crochetAutorise() {
      var size = posterSize();
      return !!(hook && hook.available !== false && cadreAutorise() && frameChecked()
        && size && frameVariantFor(size, upColor));
    }
    function peindreDisponibiliteCrochet() {
      var bloc = $("#pdp-up-hook"), c = $("#pdp-up-hook-check");
      var ok = crochetAutorise(), retire = !!(c && c.checked && !ok);
      if (bloc) bloc.hidden = !ok;
      if (c) { c.disabled = !ok; if (!ok) c.checked = false; }
      return retire;
    }
    // Le cadre d'aperçu ne suffit pas : une moulure vendable doit être sélectionnée.
    function hookChecked() { var c = $("#pdp-up-hook-check"); return !!(crochetAutorise() && c && c.checked); }
    /* ---- Les cases agissent directement sur le panier ----
       Cocher ajoute la ligne, decocher la retire, et changer de format ou de couleur
       remplace la ligne par la bonne variante. Le panier est la seule source de verite :
       on lit son contenu avant d'ecrire, ce qui rend l'operation idempotente. */
    function upsellIds() {
      var ids = frameVariants.map(function (v) { return v.id; });
      if (hook) ids.push(hook.id);
      return ids;
    }

    /* ⛔ UN ACCESSOIRE APPARTIENT À UNE AFFICHE, et la ligne de panier doit le dire.
     *
     * Sans ce lien, chaque fiche produit considérait comme SIEN tout cadre présent au panier :
     * `upsellIds()` rend toutes les variantes du produit cadre, les mêmes sur toutes les fiches.
     * Ouvrir une deuxième affiche suffisait donc à supprimer le cadre de la première, et la
     * cliente repartait avec un seul cadre, ou zéro, pour huit affiches. Relevé sur la commande
     * A1029 du 31/07/2026 : huit affiches, « cadre chêne pour chaque », aucun cadre livré.
     *
     * La propriété est masquée (préfixe `_`) : absente du panier et du mail de confirmation,
     * présente dans la commande côté administration, donc lisible par l'atelier. Elle porte le
     * HANDLE du produit, pas la variante : changer de format ne doit pas orphelin le cadre.
     *
     * Deux affiches qui prennent le même cadre donnent deux LIGNES distinctes, parce que leurs
     * propriétés diffèrent. C'est voulu : c'est ce qui permet d'en retirer un sans toucher à
     * l'autre, et l'atelier sait quel cadre va avec quelle affiche. */
    var CLE_AFFICHE = "_affiche";
    /* ⛔ LE FORMAT FAIT PARTIE DE L'IDENTITÉ DE L'ACCESSOIRE. Sans lui, un cadre est rattaché au
       HANDLE de l'affiche, donc partagé par tous ses formats : commander la même affiche en
       70X100 puis en 30X40, chacune avec son cadre, ne laissait qu'UN cadre au panier, le second
       ayant remplacé le premier (Adrien, 05/08/2026). Deux affiches payées, un seul cadre livré. */
    var CLE_FORMAT = "_format";
    var handleAffiche = (String(location.pathname).match(/\/products\/([^/?#]+)/) || [])[1] || "";
    function proprietesAccessoire() {
      var p = {};
      if (handleAffiche) p[CLE_AFFICHE] = handleAffiche;
      var taille = posterSize();
      if (taille) p[CLE_FORMAT] = taille;
      return p;
    }
    function estANous(it) {
      /* Sans handle (cas improbable), on retombe sur l'ancien comportement plutôt que de ne
         plus rien savoir gérer : mieux vaut un accessoire de trop qu'un panier qu'on ne peut
         plus corriger. Une ligne SANS la propriété est une ligne d'avant ce correctif. */
      if (!handleAffiche) return true;
      var props = it.properties || {};
      var v = props[CLE_AFFICHE];
      if (!(v === undefined || v === null || v === "" ? true : v === handleAffiche)) return false;
      /* Même affiche, mais quel format ? Un accessoire posé pour un AUTRE format appartient à
         une autre ligne du panier : on n'y touche pas. Les accessoires d'avant ce correctif
         n'ont pas la propriété et restent gérés comme avant. */
      var f = props[CLE_FORMAT];
      if (f === undefined || f === null || f === "") return true;
      var taille = posterSize();
      return !taille || f === taille;
    }
    function cartPost(url, body) {
      return fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body)
      });
    }
    var syncing = false, syncDemandee = false;
    function syncUpsells() {
      // Catalogue: commit the complete choice only when the customer adds it.
      if (window.__pdpPurchase && !PRO_HT) return Promise.resolve();
      // Un retrait de cadre pendant l'ajout du crochet doit être rejoué, pas ignoré.
      if (syncing) { syncDemandee = true; return Promise.resolve(); }
      syncing = true;
      /* ⛔ LA QUANTITE FAIT PARTIE DE CE QU'ON VEUT, PAS SEULEMENT L'IDENTIFIANT.
         `want` portait un booleen et l'ajout ecrivait `quantity: 1` en dur : un polyptyque
         partait donc au panier avec UN cadre pour quatre panneaux, et le total ne bougeait
         pas de ce qu'annoncait la fiche. Le client payait un cadre, en voyait quatre a
         l'ecran, et s'en apercevait au colis. */
      var want = {};
      var nCadres = nbPanneaux();
      if (frameChecked()) {
        var size = posterSize();
        var fv = size ? frameVariantFor(size, upColor) : null;
        if (fv) want[fv.id] = nCadres;
      }
      if (hookChecked() && hook) want[hook.id] = nCadres;
      var known = upsellIds();
      return fetch(murUrl("cart.js"), { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var chain = Promise.resolve();
          /* Les formats de CETTE affiche déjà engagés au panier. Un accessoire posé pour l'un
             d'eux est payé avec sa ligne : on ne le retire pas quand la fiche change de format.
             Un accessoire posé pour un format que le client a finalement abandonné, lui, n'a
             plus de ligne à accompagner et doit partir, sinon il resterait orphelin. */
          var formatsAuPanier = {};
          (cart.items || []).forEach(function (it) {
            if (handleAffiche && it.handle === handleAffiche) {
              (it.options_with_values || []).forEach(function (o) { formatsAuPanier[o.value] = true; });
              if (it.variant_title) String(it.variant_title).split(" / ").forEach(function (v) { formatsAuPanier[v] = true; });
            }
          });
          (cart.items || []).forEach(function (it) {
            if (known.indexOf(it.variant_id) === -1) return;   // pas un accessoire : on n'y touche pas
            var props = it.properties || {};
            var memeAffiche = !handleAffiche || !props[CLE_AFFICHE] || props[CLE_AFFICHE] === handleAffiche;
            if (!memeAffiche) return;                           // l'accessoire d'une AUTRE affiche
            if (!estANous(it)) {
              /* Même affiche, autre format. On n'y touche que s'il est orphelin. */
              var f = props[CLE_FORMAT];
              if (f && !formatsAuPanier[f]) {
                chain = chain.then(function () { return cartPost(murUrl("cart/change.js"), { id: String(it.key), quantity: 0 }); });
              }
              return;
            }
            if (want[it.variant_id]) {
              /* La ligne existe deja : il reste a corriger sa quantite. Changer de taille
                 entre une affiche seule et un polyptyque doit passer de 1 cadre a 4, ou
                 l'inverse, sans que le client ait a decocher et recocher. */
              var voulu = want[it.variant_id];
              delete want[it.variant_id];
              if (Number(it.quantity) !== voulu) {
                chain = chain.then(function () {
                  return cartPost(murUrl("cart/change.js"), { id: String(it.key), quantity: voulu });
                });
              }
              return;
            }
            chain = chain.then(function () { return cartPost(murUrl("cart/change.js"), { id: String(it.key), quantity: 0 }); });
          });
          var want0 = want;
          Object.keys(want).forEach(function (id) {
            chain = chain.then(function () {
              return cartPost(murUrl("cart/add.js"), {
                items: [{ id: Number(id), quantity: want0[id], properties: proprietesAccessoire() }]
              });
            });
          });
          return chain;
        })
        .then(function () { if (window.murRefreshCart) return window.murRefreshCart(); })
        .catch(function () {})
        .then(function () {
          syncing = false;
          if (syncDemandee) { syncDemandee = false; return syncUpsells(); }
        });
    }
    /* Etat initial : si le panier contient deja un cadre ou un crochet, les cases doivent
       le refleter, sinon un rechargement de page les decocherait sans rien retirer. */
    fetch(murUrl("cart.js"), { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var fids = frameVariants.map(function (v) { return v.id; });
        /* ⛔ « CETTE affiche », pas « une affiche ». La case se cochait dès qu'un cadre,
           n'importe lequel, se trouvait au panier : sur la deuxième fiche elle s'affichait
           cochée alors qu'aucun cadre n'avait été choisi pour cette affiche-là. La cliente
           voyait « cadre : oui » et n'y revenait pas. */
        var ligne = function (ids) {
          return (cart.items || []).filter(function (i) {
            return ids.indexOf(i.variant_id) > -1 && estANous(i);
          })[0] || null;
        };
        var hc = $("#pdp-up-hook-check");
        var lc = ligne(fids);
        if (lc) {
          /* ⛔ ET ON REMET LA MOULURE. Sans ça, `upColor` gardait sa valeur par défaut alors
             que la case s'affichait cochée : le premier changement de format rappelait
             `syncUpsells()`, qui remplaçait le cadre de la cliente par celui de la couleur par
             défaut. Mesuré le 31/07/2026 : « Chêne clair » devenu « Blanc », sans un mot. */
          var vc = frameVariants.filter(function (v) { return v.id === lc.variant_id; })[0];
          var bouton = vc && $$("#pdp-up-frame .pdp-up-color").filter(function (b) {
            return vc.options.indexOf(b.getAttribute("data-color")) > -1;
          })[0];
          /* On ne remet la moulure QUE si un format est choisi ici. Sinon le cadre du panier
             appartient à une configuration précédente, et le reposer affichait une affiche
             encadrée sans format sélectionné. */
          if (bouton && cadreAutorise()) setFrameColor(bouton);
        }
        if (hc && crochetAutorise() && ligne([hook.id])) hc.checked = true;
        peindreDisponibiliteCrochet();
        updatePrice();
      })
      .catch(function () {});

    // expose l'etat des cases pour le total du bouton (updatePrice)
    /* ⚠️ VÉRIFIER CE FICHIER EN LIGNE, PAS SEULEMENT DANS GIT. Le 05/08/2026, la synchronisation
       Shopify a appliqué le commit SUIVANT (global.js) sans jamais appliquer celui-ci : l'asset
       servi est resté deux versions en arrière pendant une demi-heure, sans erreur ni trace.
       Contrôle : lire le `?v=` servi par une fiche produit, puis chercher le code attendu dans
       https://affichely.com/cdn/shop/t/38/assets/product.js?v=… . Un commit poussé n'est pas un
       correctif livré. */
    /* ⚠️ `frameItem` ET `hookItem` NE SONT APPELÉS PAR PERSONNE. Vérifié le 05/08/2026 au soir,
       dans tout le dépôt et à l'écran : sur une fiche vidée de son panier, le cadre y entre au
       clic sur la MOULURE, pas au clic sur « Ajouter au panier ». C'est `syncUpsells()`, et lui
       seul, qui pose les accessoires ; le bouton n'ajoute que l'affiche. Le commentaire de
       `updatePrice()` le dit d'ailleurs : « le bouton annonce l'état du panier APRÈS le clic, et
       le cadre y est déjà ».
       Ces deux fonctions portent quand même `proprietesAccessoire()` : le jour où un chemin les
       appellera, il ne repartira pas sans `_affiche` ni `_format`. Mais elles n'ont rien réparé.

       ⛔ CE QUI A RÉELLEMENT CORRIGÉ LE BUG DES DEUX CADRES (A1059 / A1060, deux commandes payées
       pour une seule intention) : `_format` dans `proprietesAccessoire()`, plus le retrait devenu
       conditionnel ci-dessus. Sans le format, une ligne d'accessoire était « à nous » pour
       n'importe quel format de l'affiche, et le second passage la retirait.
       Si le correctif a paru ne pas marcher au retest, ce n'est pas qu'il manquait un chemin :
       c'est que Shopify servait encore l'ancien `product.js`. Voir l'avertissement juste au-dessus.
       La leçon est là, pas dans une seconde cause imaginaire. */
    window.__pdpUpsell = {
      extraLines: function (labels) {
        var lines = [], n = nbPanneaux();
        if (frameChecked()) {
          var size = posterSize(), variant = size && frameVariantFor(size, upColor);
          if (variant) lines.push(labels.frame + ' ' + money(variant.price * n));
        }
        if (hookChecked() && hook) {
          lines.push(labels.hook + ' ' + money((hook.price || 0) * n));
        }
        return lines;
      },
      frameItem: function (q) {
        if (!frameChecked()) return null;
        var size = posterSize(); if (!size) return null;
        var v = frameVariantFor(size, upColor);
        return v ? { id: v.id, quantity: (q || 1) * nbPanneaux(), properties: proprietesAccessoire() } : null;
      },
      hookItem: function () {
        if (!hookChecked() || !hook) return null;
        return { id: hook.id, quantity: nbPanneaux(), properties: proprietesAccessoire() };
      },
      // Montant (en centimes) a ajouter au prix de l'affiche : cadre (x qty) + crochet (x1).
      /* Un cadre et un crochet, quelle que soit la quantite d'affiches : c'est
         exactement ce que pose syncUpsells() dans le panier. Le cadre etait compte
         « x quantite » ici, ce qui aurait affiche deux cadres pour un seul facture. */
      extraTotal: function () {
        var e = 0;
        var n = nbPanneaux();
        if (frameChecked()) { var size = posterSize(); if (size) { var v = frameVariantFor(size, upColor); if (v) e += v.price * n; } }
        if (hookChecked() && hook) { e += (hook.price || 0) * n; }
        return e;
      }
    };
    // Recalcule le total du bouton quand on coche/decoche un upsell.
    // Le crochet garde sa case : il n'a rien à choisir, seulement à être pris ou non.
    var hookCheck = $("#pdp-up-hook-check");
    if (hookCheck) hookCheck.addEventListener("change", function () { updatePrice(); syncUpsells(); });
    updatePrice();
  })();

  /* ⛔ AVANT TOUT CALCUL D'ECHELLE. Les tables de taille sont indexees en francais ; cet appel
     leur ajoute la cle de la langue servie, deduite des NOMBRES du libelle. Pose ici parce que
     les pastilles doivent exister, et avant `updateFrame` qui lit deja ces tables. */
  aliasTaillesTraduites();
  updatePrice(); updateFrame();

  /* ---- Perso CRO : ?look= → H1 + filigrane exemple + _perso_look ---- */
  (function initPersoCro() {
    var root = document.querySelector("[data-perso-funnel]");
    if (!root || !window.__pdpPerso) return;
    var LOOKS = ["anniversaire", "couple", "amis", "famille", "enfant", "chat", "message", "cinema",
      "chien", "mariage", "voyage", "photo", "texte",
      "naissance", "bapteme", "bar-mitzvah", "communion"];
    /* Prereglage du bloc texte par theme : un faire-part de naissance et un portrait de
       chat ne s'ecrivent pas pareil. Applique UNIQUEMENT si le client n'a encore rien
       choisi (design, couleur et police aux valeurs d'usine) : un choix ou une session
       restauree reste maitre. */
    var LOOK_PRESETS = {
      mariage: { design: "editorial", font: "cinzel", color: "blanc" },
      famille: { design: "design", font: "classic", color: "blanc" },
      couple: { design: "arche", font: "elegant", color: "blanc" },
      enfant: { design: "design", font: "modern", color: "blanc" },
      chat: { design: "zone", font: "bold", color: "blanc" },
      chien: { design: "zone", font: "bold", color: "blanc" },
      anniversaire: { design: "design", font: "bold", color: "sable" },
      voyage: { design: "voile", font: "classic", color: "blanc" },
      cinema: { design: "design", font: "bold", color: "noir" },
      naissance: { design: "entete", font: "modern", color: "sable" },
      bapteme: { design: "entete", font: "script", color: "blanc" },
      "bar-mitzvah": { design: "editorial", font: "elegant", color: "blanc" },
      communion: { design: "entete", font: "elegant", color: "sable" }
    };
    var titleEl = $("#pdp-title") || $(".pdp-title");
    var stickyTitle = $(".pdp-sticky__title");
    var defaultH1 = root.getAttribute("data-perso-h1-default")
      || (titleEl && titleEl.getAttribute("data-perso-h1-default"))
      || (titleEl && titleEl.textContent.trim())
      || "";
    var look = "";

    function readUrl() {
      /* Contrat unifie (serie 119) : l'occasion prime le layout pour le H1 et les textes.
         layout=photo&occasion=chien titre donc sur le chien, l'annonce achetee. Les deux
         valeurs passent par la meme liste LOOKS : les cles de traduction n'ont pas bouge. */
      try {
        var p = window.__persoUrlParams ? window.__persoUrlParams() : { layout: "", occasion: "" };
        var l = p.occasion || p.layout;
        return LOOKS.indexOf(l) >= 0 ? l : "";
      } catch (e) { return ""; }
    }
    function h1ForLook(l) {
      if (!l || window.__pdpPersoMetal) return defaultH1;
      var t = root.getAttribute("data-perso-h1-" + l);
      return (t && t.trim()) || defaultH1;
    }
    /* ⛔ LE FILIGRANE NE SUIT PLUS ?look=, IL SUIT ?occasion= (Adrien, 12/08/2026, serie
       119). ?look= sert au TYPE (photo seule, message, texte) et au H1 : quand il vaut
       photo ou message, adapter la photo dessus montrait la famille perso-avant-3.jpg a un
       client venu pour tout autre chose. L'intention VISUELLE passe par le parametre des
       collections, ?occasion=, pose par le suffixe d'URL des groupes d'annonces
       d'intention. Sans lui, la photo generique reste celle que le gabarit pose en inline
       sur le fantome, la scene et les vignettes de piece : le reglage perso_example s'il
       est rempli, sinon l'asset perso-avant-3.jpg, qui EST la nature morte d'oranges de la
       commande 1084 depuis le 08/08/2026. La liste des occasions couvertes EST la liste
       des attributs data-perso-occasion-* : une valeur inconnue ne change rien. */
    function readOccasion() {
      try {
        var s = window.__persoUrlParams ? window.__persoUrlParams().occasion : "";
        return s && root.hasAttribute("data-perso-occasion-" + s) ? s : "";
      } catch (e) { return ""; }
    }
    // Remplace le filigrane (fantome + scene + vignettes de piece) selon ?occasion=,
    // sans toucher a la photo client deja importee.
    function applyOccasion() {
      var s = readOccasion();
      if (!s) return;
      var ph = $("#pdp-placeholder");
      if (ph && ph.hidden) return;
      if (photo || persoUrl) return;
      var url = root.getAttribute("data-perso-occasion-" + s) || "";
      if (!url) return;
      var bg = "url('" + String(url).replace(/'/g, "%27") + "')";
      var ghost = document.querySelector("#pdp-placeholder .pdp-placeholder__ghost");
      if (ghost) ghost.style.backgroundImage = bg;
      var mp = $("#pdp-mockup-art");
      if (mp && (mp.hasAttribute("data-example") || !mp.style.backgroundImage)) {
        mp.style.backgroundImage = bg;
        mp.setAttribute("data-example", "true");
      }
      $$(".pdp-thumb__poster[data-example]").forEach(function (el) {
        el.style.backgroundImage = bg;
      });
    }
    look = readUrl();
    window.__persoLook = look || "";
    /* ⛔ LE GRAS SE POSE PAR NOEUDS, JAMAIS PAR innerHTML (Adrien, 13/08/2026 : « il faut aussi
       mettre les mots importants en gras dans le titre »). L'expression achetee est encadree
       par ** ** dans le fichier de langue, et c'est la SEULE chose qu'une traduction peut
       decider ici : on decoupe sur ce marqueur et on cree des noeuds de texte et des <strong>.
       Rien de ce qu'ecrit un traducteur ne peut devenir une balise, ce qui est la regle du
       depot depuis les puces d'atterrissage. Un titre sans marqueur reste un simple texte.
       ⚠️ Le <title> de l'onglet, lui, reprend la version SANS les etoiles : une balise n'a
       pas de gras, et « **portrait** » s'y lirait tel quel. */
    function poserTitre(el, texte) {
      if (!el || !texte) return;
      var morceaux = String(texte).split("**");
      if (morceaux.length < 3) { el.textContent = texte; return; }
      el.textContent = "";
      morceaux.forEach(function (m, i) {
        if (!m) return;
        if (i % 2 === 1) {
          var fort = document.createElement("strong");
          fort.textContent = m;
          el.appendChild(fort);
        } else {
          el.appendChild(document.createTextNode(m));
        }
      });
    }
    function sansMarqueurs(s) { return String(s || "").split("**").join(""); }
    var h1 = h1ForLook(look);
    poserTitre(titleEl, h1);
    poserTitre(stickyTitle, h1);
    if (h1) h1 = sansMarqueurs(h1);
    /* ⛔ L'ATTERRISSAGE SUIT LE LOOK JUSQU'AU BOUT (serie 109). Le H1 changeait deja ; le
       <title> et le sous-texte restaient ceux de la fiche nue, et l'audit du 12/08/2026 a
       mesure ZERO expression achetee sur la page. Le dictionnaire __persoLookSous n'existe
       que dans les langues de campagne (fr, de, nl), pose par Liquid : ailleurs rien ne
       change, dans aucune autre langue que celle du marche. Le separateur du <title> est un
       demi-cadratin deja present dans le title rendu ; la regle du depot interdit d'ECRIRE ce
       caractere, d'ou fromCharCode. */
    if (look && h1 && !window.__pdpPersoMetal) {
      var sepTitre = " " + String.fromCharCode(8211) + " ";
      var iSepTitre = document.title.indexOf(sepTitre);
      document.title = h1 + (iSepTitre >= 0 ? document.title.slice(iSepTitre) : "");
    }
    applyOccasion();
    /* Texte d'exemple du theme : le placeholder titre/sous-titre suit ?look=. Si le mode
       texte s'est deja ouvert (look=message le fait plus haut), la valeur a ete remplie
       depuis l'ANCIEN placeholder : on la remplace aussi, mais seulement si le client n'a
       rien tape d'autre. Un attribut absent ou une cle non traduite laissent tout en place. */
    if (look) {
      [["#perso-text-title", root.getAttribute("data-perso-txt-" + look)],
       ["#perso-text-sub", root.getAttribute("data-perso-sub-" + look)]].forEach(function (pair) {
        var el = $(pair[0]), neuf = (pair[1] || "").trim();
        if (!el || !neuf || neuf.toLowerCase().indexOf("translation missing") === 0) return;
        var ancien = (el.placeholder || "").trim();
        el.placeholder = neuf;
        if (String(el.value || "").trim() === ancien && ancien) el.value = neuf;
      });
      if (typeof syncPersoTextPreview === "function") syncPersoTextPreview();
      var preset = LOOK_PRESETS[look];
      if (preset && persoTextDesign === "design" && persoTextColor === "blanc" && persoFont === "classic") {
        if (typeof setPersoTextDesign === "function") setPersoTextDesign(preset.design);
        if (typeof setPersoTextColor === "function") setPersoTextColor(preset.color);
        if (typeof setPersoFont === "function") setPersoFont(preset.font);
      }
      /* Le gabarit typographique de la bande : classes CSS pour l'ecran (que le canvas
         du panier relit), _perso_gabarit pour l'impression. */
      var GABARITS_LOOK = { mariage: "ceremonie", bapteme: "ceremonie", communion: "ceremonie",
        "bar-mitzvah": "ceremonie", naissance: "etat-civil", chat: "signature", chien: "signature",
        anniversaire: "fete" };
      persoGabarit = GABARITS_LOOK[look] || "";
      if (persoGabarit) {
        document.querySelectorAll(".pdp-textband").forEach(function (el) {
          el.classList.add("pdp-textband--" + persoGabarit);
        });
      }
    }
  })();

  /* ---- Galerie d'exemples au placeholder : les 4 rendus du look, composes par le
     moteur d'impression (snippet perso-demos-data). Desktop : colonne de rendus +
     rail de vignettes epingle au scroll, bumper sur la deuxieme. Mobile et tablette
     portrait : un rendu principal, vignettes dessous. Un clic applique la combinaison
     au configurateur. Visible UNIQUEMENT sans photo importee (CSS has-photo). ---- */
  (function galerieDemos() {
    if (!window.__pdpPerso || !window.__persoDemos) return;
    /* ⛔ UN TEXTE RETROUVE EN SESSION NE SUPPRIME PLUS LA GALERIE (Adrien, 12/08/2026 :
       « parfois ça affiche les thumbnails, parfois non »). Cette sortie (`return` sur
       __persoSessionTexte) faisait dependre les vignettes d'un essai PASSE dans le meme
       onglet : la meme URL montrait la colonne dans un onglet neuf et rien du tout dans
       celui ou un texte avait ete tape, vecu comme un rendu instable. On construit donc
       toujours, mais en etat « rendus caches » : la scene live montre le texte du client,
       et les vignettes restent des raccourcis, exactement l'etat que laisse
       __persoQuitterDemos. Le drapeau se relit EN FIN de fonction, a la pose. */
    /* Toute retouche manuelle d'option rend la scene live : la galerie ne colle plus
       aux reglages du client, elle s'efface (appele depuis les gestionnaires d'options,
       jamais depuis le clic sur une vignette de demo). */
    /* ⛔ ON CACHE LES RENDUS FIGES, PAS LES VIGNETTES (Adrien, 08/08/2026 : « pourquoi les
       vignettes disparaissent quand on clique sur un type »). Cette sortie masquait
       `#perso-demos` EN ENTIER : au premier reglage touche, la colonne de gauche se vidait
       d'un coup, raccourcis compris.
       Or les deux moities n'ont pas le meme statut. Les grands rendus sont des JPEG figes qui
       MENTENT des que le client change un reglage : ils doivent partir, le cadre live prend
       leur place. Les vignettes, elles, restent de vrais raccourcis vers les quatre
       combinaisons : rien ne les rend fausses, et les retirer prive le client du seul moyen de
       revenir a une demo apres avoir essaye quelque chose. */
    window.__persoQuitterDemos = function () {
      var d = document.getElementById("perso-demos");
      if (d) { d.hidden = false; d.setAttribute("data-rendus-caches", "1"); }
      document.documentElement.removeAttribute("data-perso-demos");
      /* Les rendus figes laissent la place au cadre live : la hauteur de la colonne change,
         donc l'arret de l'epingle aussi. */
      if (typeof window.__pdpMajBande === "function") window.__pdpMajBande();
    };
    var look = window.__persoLook || "defaut";
    /* ⛔ LE RAIL SUIT LE MODE, IL NE LE CONTREDIT PAS (Adrien, 13/08/2026 : « quand je suis
       dans avec texte et que je clique sur un thumbnail, ca se remet sur photo seule »).
       Sur `/products/affiche-personnalisee` sans parametre, `look` vaut « defaut », dont les
       quatre combinaisons sont des demos PHOTO SEULE. En mode texte, cliquer l'une d'elles
       appelait `setPersoTextMode(false)` : le client etait renvoye au mode qu'il venait de
       quitter, par une vignette qui montrait justement ce qu'il ne voulait plus.
       La regle : mode photo -> les demos photo ; mode texte -> les demos AVEC TEXTE, celles de
       l'occasion si elle en a, sinon le jeu generique. Une vignette montre toujours ce que le
       clic va produire, et le clic ne change plus le mode dans le dos du client. */
    function combosDuMode() {
      var d = window.__persoDemos || {};
      /* ⛔⛔ EN MODE PHOTO, ON NE TOUCHE A RIEN : LE JEU DE L'OCCASION RESTE LE JEU DE
         L'OCCASION. Ma premiere version filtrait aussi ce cas et rendait les demos GENERIQUES
         (les oranges) a quelqu'un qui arrivait sur `?layout=photo&occasion=chien`. Adrien,
         13/08/2026, capture a l'appui : « ca repart sur le placeholder initial ». Le H1 parlait
         bien du chien, le filigrane aussi, mais la galerie de demos COUVRE le cadre a
         l'arrivee : c'est elle que le client voit, et elle montrait des oranges sur une annonce
         achetee pour un chien. Un jeu par occasion n'existe QU'AVEC du texte : le filtrer sur
         « sans design » ne laissait rien, et le repli generique prenait la main.
         ⚠️ LA LECON : la demande portait sur le mode TEXTE (« les vignettes pour avec texte
         doivent afficher des images avec texte »). J'ai etendu la regle au mode photo, que
         personne n'avait mis en cause, et casse la page d'atterrissage la plus chere du site.
         Une regle enoncee pour un cas ne se generalise pas a l'autre sans le demander. */
      if (typeof persoTextOn !== "undefined" && persoTextOn) {
        var avecTexte = (d[look] || []).filter(function (c) { return !!c.design; });
        if (avecTexte.length) return avecTexte;
        return (d.texte || d.message || []).filter(function (c) { return !!c.design; });
      }
      return d[look] || d.defaut || [];
    }
    var combos = combosDuMode();
    if (!combos || !combos.length) combos = window.__persoDemos[look] || window.__persoDemos.defaut;
    if (!combos || !combos.length) return;
    var wrap = document.querySelector(".pdp--perso .pdp-gallery__wrap");
    if (!wrap) return;
    /* ⛔ L'INVITATION EST CREEE AVANT LA BOUCLE : le premier rendu la recoit tout de suite,
       et chaque changement de vignette la deplace sur le rendu montre.
       ⛔ ET SON CLIC OUVRE DIRECTEMENT LE SELECTEUR DE FICHIER. Il relayait sur le bouton
       `#pdp-placeholder`, qui est masque tant que la galerie de demos couvre le cadre : un
       `click()` sur un bouton cache ne declenche rien, et l'invitation ne faisait rien du
       tout (Adrien, 08/08/2026). L'input de fichier, lui, repond toujours. */
    var invitePh = document.querySelector(".pdp-placeholder__cta");
    var champFichier = document.querySelector("#pdp-upload input[type=file], input[type=file]");
    var invite = null;
    if (invitePh && champFichier) {
      invite = document.createElement("button");
      invite.type = "button";
      invite.className = "perso-demos__cta";
      /* ⛔ ON RECOPIE LE CONTENU, PAS SEULEMENT LE TEXTE (Adrien, 20/08/2026 : « verifie pourquoi
         il n'y a pas d'icone upload dans le bouton sur le placeholder »). `textContent` ne
         ramene que les mots : l'icone ajoutee le 13/08 sur `.pdp-placeholder__cta` n'a jamais
         suivi jusqu'ici, et c'est CE bouton-la que le client voit, l'autre etant couvert par la
         galerie de demos. Une copie qui prend une partie de sa source vieillit a chaque fois
         qu'on enrichit l'original, sans rien signaler. */
      Array.prototype.forEach.call(invitePh.childNodes, function (n) {
        invite.appendChild(n.cloneNode(true));
      });
      invite.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        champFichier.click();
      });
    }
    var boite = document.createElement("div");
    boite.className = "perso-demos";
    boite.id = "perso-demos";
    var rail = document.createElement("div");
    rail.className = "perso-demos__rail";
    var col = document.createElement("div");
    col.className = "perso-demos__col";
    /* ⛔ UNE SEULE BANDE, DONC UNE SEULE SELECTION. Papier et Detail sont des `.pdp-thumb`
       marquees par `aria-pressed` et une bordure posee en ligne ; les demos sont des
       `.perso-demos__mini` marquees par la classe `est-choisi`. Les deux vivent dans le MEME
       rail depuis qu'on a supprime la seconde colonne, et aucune n'effacait l'autre : le client
       voyait deux cadres a la fois, et croyait que le sien n'avait pas bouge (Adrien,
       13/08/2026 : « la bordure autour du thumbnail est autour du thumbnail precedent »).
       Ces deux fonctions sont le seul endroit qui eteint l'autre famille. */
    function eteindreVuesFixes() {
      Array.prototype.forEach.call(document.querySelectorAll(".pdp-thumb"), function (x) {
        x.setAttribute("aria-pressed", "false");
        x.style.borderColor = "#D6CAB2";
      });
      /* ⛔ ET LE BADGE PART AVEC ELLES. « Papier d'art 220 g/m² » et « Photo prise par
         l'atelier » appartiennent aux deux vues fixes ; ils restaient affiches par-dessus une
         demo, donc une legende qui decrivait une AUTRE image que celle regardee (Adrien :
         « ca affiche des badges de maniere incoherente au dessus de la mauvaise photo »). */
      if (typeof majBadgeHd === "function") majBadgeHd("");
    }
    window.__persoEteindreDemos = function () {
      Array.prototype.forEach.call(document.querySelectorAll(".perso-demos__mini.est-choisi"),
        function (x) { x.classList.remove("est-choisi"); });
    };
    function poserCombo(c, i) {
      var v = document.createElement("button");
      v.type = "button";
      v.className = "perso-demos__mini";
      v.setAttribute("aria-label", (i + 1) + " / " + combos.length);
      if (i === 1) v.setAttribute("data-bump", "1");
      v.innerHTML = '<img src="' + c.url + '" alt="" loading="lazy" width="64" height="92">';
      /* ⚠️ AVANT PAPIER ET DETAIL, PAS APRES. Les deux vues fixes ont ete DEPLACEES dans ce
         rail : un `appendChild` a la reconstruction poserait les demos derriere elles, et
         l'ordre de la bande changerait sous les yeux du client a chaque bascule de mode. */
      var premiereFixe = rail.querySelector(".pdp-thumb-item");
      if (premiereFixe) rail.insertBefore(v, premiereFixe);
      else rail.appendChild(v);
      /* ⛔ PAS D'ENVELOPPE AUTOUR DU RENDU. J'en avais ajoute une pour caler le CTA : elle a
         casse TOUS les selecteurs qui visent le rendu comme enfant direct de la colonne, d'ou
         la vignette sans effet, le paysage sans effet et un vide immense en bas de page.
         La colonne n'affiche qu'un rendu a la fois (`[data-actif]`), donc sa hauteur EST celle
         du rendu montre : un CTA centre sur la colonne est centre sur l'image, sans rien
         envelopper. */
      var grand = document.createElement("img");
      grand.className = "perso-demos__rendu";
      /* ⛔ LES DIMENSIONS AVANT LA SOURCE, SINON LA PAGE SAUTE. Mesure du 19/08/2026, six
         chargements identiques a la quatrieme decimale : CLS 0,4336 sur la fiche perso, quand
         le seuil « mauvais » est 0,25. `.perso-demos__rendu` est en `width:100%;height:auto`
         sans dimension intrinseque : le navigateur ne peut PAS reserver sa boite avant que les
         pixels arrivent. La bande passait donc de 64 a 321 px a 9,5 s, et tout ce qui est
         dessous descendait de 257 px, bloc d'achat compris. Un client qui tend le doigt vers le
         bouton le voit partir.
         ⚠️ 880x1271 N'EST PAS UN CHIFFRE ROND CHOISI AU HASARD : c'est la taille reelle des
         `perso-demo-*.jpg`, relevee sur les 68 fichiers du theme. Une dimension inventee
         reserverait la mauvaise hauteur et deplacerait le defaut au lieu de le fermer. */
      grand.width = 880;
      grand.height = 1271;
      grand.src = c.url;
      grand.alt = "";
      grand.loading = i === 0 ? "eager" : "lazy";
      if (i === 0) grand.setAttribute("data-actif", "1");
      /* Meme raison que pour les vignettes : l'invitation « Cliquer pour importer » est en
         queue de colonne, les rendus passent devant elle. */
      if (invite && invite.parentNode === col) col.insertBefore(grand, invite);
      else col.appendChild(grand);
      var appliquer = function () {
        rail.querySelectorAll("[data-bump]").forEach(function (x) { x.removeAttribute("data-bump"); });
        rail.querySelectorAll(".est-choisi").forEach(function (x) { x.classList.remove("est-choisi"); });
        v.classList.add("est-choisi");
        eteindreVuesFixes();
        col.querySelectorAll("[data-actif]").forEach(function (x) { x.removeAttribute("data-actif"); });
        grand.setAttribute("data-actif", "1");
        /* Revenir sur une demo remontre les rendus : la combinaison choisie redevient vraie,
           et l'image d'exemple reprend sa place devant la scene. */
        boite.removeAttribute("data-rendus-caches");
        var cadreRetour = document.querySelector(".pdp-gallery__wrap");
        if (cadreRetour) cadreRetour.removeAttribute("data-vue-fixe");
        document.documentElement.setAttribute("data-perso-demos", "1");
        /* Le rendu revient, le cadre repart : la hauteur de la galerie change dans l'autre sens.
           Sans ce rappel, la page gardait le padding calcule pour le cadre live et laissait un
           trou sous la fiche une fois revenu sur une demo. */
        if (typeof window.__pdpMajBande === "function") window.__pdpMajBande();
        /* Combo sans design = demo photo seule (look=photo, 08/08/2026) : bascule DIRECTE
           du mode, comme les autres setters de demos. ⛔ JAMAIS off.click() : le clic sur
           le bouton passe par le gestionnaire d'option manuelle, qui appelle
           __persoQuitterDemos et EFFACE la galerie (vignettes NL disparues, capture
           d'Adrien du 08/08/2026, une heure apres la pose).
           ⛔ ET LA BASCULE N'A LIEU QUE SI LE MODE N'EST PAS DEJA LE BON. Depuis que le rail
           suit le mode, une demo sans design ne s'affiche qu'en mode photo : appeler le setter
           ne changerait rien, mais il rejouerait tout le rendu du bloc texte pour rien. */
        if (!c.design) {
          if (typeof setPersoTextMode === "function" && typeof persoTextOn !== "undefined" && persoTextOn) {
            setPersoTextMode(false);
          }
          return;
        }
        if (typeof setPersoTextDesign === "function") setPersoTextDesign(c.design);
        if (typeof setPersoFont === "function") setPersoFont(c.police);
        if (typeof setPersoTextColor === "function") setPersoTextColor(c.couleur);
        if (typeof setPersoTextInk === "function") {
          setPersoTextInk(c.encre || "", "titre");
          setPersoTextInk(c.encreSous || "", "sous");
        }
        /* Plus de defilement vers le rendu : il n'y en a qu'un a l'ecran, la vignette le
           REMPLACE au lieu de mener a lui. */
      };
      v.addEventListener("click", appliquer);
      grand.addEventListener("click", appliquer);
    }
    combos.forEach(poserCombo);
    /* ⛔ LE RAIL SE REFAIT QUAND LE MODE CHANGE. Sans ca, la liste choisie au chargement
       resterait a l'ecran pour toute la visite : c'est elle qui montrait des demos PHOTO SEULE
       a quelqu'un qui venait de demander « Avec texte ». Appele par `setPersoTextMode`, le seul
       endroit qui connait la bascule. On ne refait rien si la liste est deja la bonne : une
       reconstruction gratuite ferait clignoter la bande. */
    window.__persoMajDemos = function () {
      var neuf = combosDuMode();
      if (!neuf || !neuf.length) return;
      var identique = neuf.length === combos.length && neuf.every(function (c, i) {
        return c && combos[i] && c.url === combos[i].url;
      });
      if (identique) return;
      combos = neuf;
      Array.prototype.forEach.call(rail.querySelectorAll(".perso-demos__mini"),
        function (x) { x.parentNode.removeChild(x); });
      Array.prototype.forEach.call(col.querySelectorAll(".perso-demos__rendu"),
        function (x) { x.parentNode.removeChild(x); });
      combos.forEach(poserCombo);
      if (typeof window.__pdpMajBande === "function") window.__pdpMajBande();
    };
    /* ⛔ L'INVITATION DOIT ETRE LA OU LE CLIENT REGARDE (Adrien, 08/08/2026 : « on ne voit pas
       le rectangle Cliquer pour importer par defaut »). Le rectangle du placeholder existe bien,
       mais la galerie de demos recouvre le cadre a l'arrivee : il etait dessous, donc invisible
       tant qu'aucune photo n'etait posee, c'est-a-dire exactement quand il sert.
       On en pose donc un second sur le grand rendu de demo. Il ne duplique pas le texte : il le
       LIT sur celui du placeholder, deja traduit par le fichier de langue. Aucune cle de plus,
       aucune traduction a tenir a jour a deux endroits.
       Le clic relaie sur le placeholder, qui est le bouton d'import : une seule porte d'entree,
       et ce bouton-ci n'a rien a savoir de la mecanique du selecteur de fichier. */
    /* ⛔ L'INVITATION DOIT ETRE LA OU LE CLIENT REGARDE (Adrien, 08/08/2026 : « on ne voit pas
       le rectangle Cliquer pour importer par defaut »). Le rectangle du placeholder existe bien,
       mais la galerie de demos recouvre le cadre a l'arrivee : il etait dessous, donc invisible
       tant qu'aucune photo n'etait posee, c'est-a-dire exactement quand il sert.
       On en pose donc un second sur le grand rendu de demo. Il ne duplique pas le texte : il le
       LIT sur celui du placeholder, deja traduit par le fichier de langue. Aucune cle de plus,
       aucune traduction a tenir a jour a deux endroits.
       ⛔ ET IL NE SE MESURE PLUS. La colonne n'affiche qu'un rendu a la fois : sa hauteur EST
       celle du rendu visible, et son centre EST le centre de l'image. Un `top:50%` de CSS suffit,
       et il reste juste quand on change de vignette. La version mesuree lisait le PREMIER rendu,
       qui devient `display:none` des qu'on en choisit un autre : elle relisait alors une hauteur
       nulle et gardait, sans le dire, la position d'une image qui n'etait plus a l'ecran. */
    if (invite) col.appendChild(invite);
    /* ⛔ UNE SEULE COLONNE DE VIGNETTES (Adrien, 08/08/2026 : « vignettes sur 2 colonnes »).
       Papier et Detail vivent dans `#pdp-thumbs`, le rail standard de la fiche ; les demos ont
       le leur. Cote a cote, ca faisait deux colonnes de vignettes pour une seule image. Les
       deux items rejoignent donc le rail des demos tant qu'il existe, et rentrent chez eux des
       que la photo du client arrive, avec le reste de la bande.
       On DEPLACE, on ne copie pas : un clone perdrait ses ecouteurs, et la vignette n'ouvrirait
       plus rien. `data-fixe` est pose par le gabarit sur l'item comme sur le bouton. */
    Array.prototype.forEach.call(
      document.querySelectorAll("#pdp-thumbs .pdp-thumb-item[data-fixe]"),
      function (it) { rail.appendChild(it); }
    );
    boite.appendChild(rail);
    boite.appendChild(col);
    if (window.__persoSessionTexte) {
      boite.setAttribute("data-rendus-caches", "1");
    } else {
      document.documentElement.setAttribute("data-perso-demos", "1");
    }
    wrap.appendChild(boite);
  })();

  /* ---- Funnel perso : arrivee, import, format, panier : un envoi par evenement,
     par page vue, avec le meme identifiant visiteur que Ma piece (af:vid). L'achat se
     lit cote Studio dans les commandes, par la propriete de ligne _perso_vid. ---- */
  (function funnelPerso() {
    if (!window.__pdpPerso) return;
    var vid = null;
    try {
      vid = localStorage.getItem("af:vid");
      if (!vid) {
        vid = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
          : "v" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
        localStorage.setItem("af:vid", vid);
      }
    } catch (e) { vid = null; }
    if (!vid) return;
    window.__persoVid = vid;
    var envoyes = {};
    /* ⛔ LE MONTANT DU PANIER, PAS UNE COCHE (Adrien, 11/08/2026). Le Studio affichait « ✓ » :
       on savait qu'un panier avait suivi, jamais ce qu'il pesait. Le total se lit sur /cart.js
       APRES l'ajout, donc c'est le panier reel. Un echec ne bloque rien : sans montant,
       l'evenement part quand meme et le Studio ecrit un tiret. */
    function totalPanierPerso() {
      /* ⚠️ AVEC LA RACINE DE LANGUE, comme tout le reste du theme depuis le 15/08/2026.
         `product.js` n'a pas la fermeture qui tient `urlPanier` : on relit la meme source,
         `window.MURMURE_RACINE`, jamais une racine devinee sur l'adresse courante. */
      var racine = String(window.MURMURE_RACINE || "/").replace(/\/$/, "");
      return fetch(racine + "/cart.js", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var t = Number(c && c.total_price);
          return isFinite(t) && t > 0 ? t / 100 : null;
        })
        .catch(function () { return null; });
    }
    /* ⛔ LE CONFIGURATEUR EST UN EVENEMENT PINTEREST A PART ENTIERE, ET IL N'EN EXISTE PAS
       D'EQUIVALENT CHEZ META. Doc Pinterest, `customize_product` : « Track people who customize
       a product using a tool on your website or app. » C'est exactement la perso, le pele-mele
       et le panneau. Une correspondance batie depuis le vocabulaire de Meta ne pouvait pas le
       trouver : il n'y a rien a traduire, il faut l'emettre.
       ⛔ SUR « import » ET « format », PAS SUR « arrivee » NI « panier ». Arriver sur la page
       n'est pas personnaliser : c'est un `page_visit`, et le compter ici rendrait l'audience
       « a personnalise » aussi large que l'audience « a vu la page », donc inutile. Le panier,
       lui, est deja un `add_to_cart`. Les deux etapes retenues sont les seules ou le client a
       REELLEMENT mis quelque chose de lui dans l'outil.
       ⚠️ UNE SEULE FOIS PAR PAGE, quelle des deux qui arrive en premier : `envoyes` dedoublonne
       chaque etape separement, or `import` et `format` mappent vers le MEME evenement Pinterest.
       Sans ce second garde, un client qui importe puis choisit son format en enverrait deux.
       ⚠️ `Shopify.analytics.publish` EST LE SEUL PONT vers le pixel personnalise : celui-ci vit
       dans un bac a sable qui ne voit ni notre DOM ni nos evenements de fenetre. Le prefixe
       « affichely: » est impose par Shopify pour ne pas heurter ses evenements standards. */
    var persoCustomizeEnvoye = false;
    function publierCustomizeProduct(url) {
      if (persoCustomizeEnvoye) return;
      persoCustomizeEnvoye = true;
      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
          Shopify.analytics.publish("affichely:customize_product", {
            url: url || location.href,
            /* Quel configurateur : le Studio et Pinterest lisent des parcours tres differents
               comme un seul sans ce champ, exactement comme le funnel de `/perso-log`. */
            outil: window.__persoLook || "",
          });
        }
      } catch (e) { /* le pixel n'est pas une raison de casser la page */ }
    }
    window.__persoFunnel = function (evenement, url) {
      if (evenement === "import" || evenement === "format") publierCustomizeProduct(url);
      if (envoyes[evenement]) return;
      envoyes[evenement] = 1;
      if (evenement === "panier") {
        /* ⛔ LE TOTAL SE LIT APRES L'AJOUT, JAMAIS AVANT (Adrien, 20/08/2026 : « dans
           statistiques > perso les paniers sont a 0 € »). Les trois configurateurs appellent ce
           funnel au DEBUT de leur geste d'ajout, pour compter l'intention meme si la ligne
           echoue ensuite. Lire `/cart.js` a cet instant donnait donc le panier d'AVANT, c'est-a-dire
           vide au premier achat : le Studio recevait un montant nul et affichait 0 €. La seule
           mesure juste est celle que `global.js` publie une fois le panier relu.
           ⚠️ ET LE COMPTE NE BOUGE PAS : l'evenement part toujours, simplement quelques centaines
           de millisecondes plus tard. Le repli le garantit meme si l'ajout echoue ou passe par
           un autre chemin, sans quoi une panne d'ajout effacerait l'etape du funnel. */
        var fait = false;
        var surPanier = function (e) {
          if (fait) return;
          fait = true;
          window.removeEventListener("af:panier", surPanier);
          var c = Number(e && e.detail && e.detail.total);
          envoiPerso(evenement, url, isFinite(c) && c > 0 ? c / 100 : null);
        };
        window.addEventListener("af:panier", surPanier);
        setTimeout(function () {
          if (fait) return;
          fait = true;
          window.removeEventListener("af:panier", surPanier);
          totalPanierPerso().then(function (m) { envoiPerso(evenement, url, m); });
        }, 4000);
        return;
      }
      envoiPerso(evenement, url, null);
    };
    function envoiPerso(evenement, url, montant) {
      try {
        fetch("https://runway.dcomdtf.app/perso-log", {
          method: "POST", headers: { "Content-Type": "application/json" },
          /* L'image deposee voyage avec l'import : le Studio doit pouvoir ouvrir ce
             que le client a envoye, pas seulement compter les imports. */
          /* ⛔ QUEL PRODUIT. Ce funnel se declenche sur le tag « Personnalisable », que
             portent la perso, le pele-mele ET le panneau : sans ce champ, le Studio lit
             des parcours tres differents comme un seul. Les DRAPEAUX de la fiche chargee
             font foi, pas __pdpRecent.handle : dans la modale plein ecran d'une fiche
             catalogue, ce handle etait celui de la fiche HOTE, refuse par la liste fermee
             du serveur, et l'evenement tombait en « produit non precise » (04/08/2026). */
          /* ⛔ L'APPAREIL, POUR LES COURBES DU STUDIO (Adrien, 13/08/2026). Classement par le
             POINTEUR et la LARGEUR, pas par le nom du navigateur : une chaine d'agent se
             maquille, et la liste des noms de tablettes n'a pas de fin. `pointer: coarse` dit
             un doigt, et c'est la seule chose qui compte ici. La tablette est le doigt sur un
             grand ecran. Trois valeurs, la meme liste fermee que celle du serveur. */
          body: JSON.stringify({ vid: vid, evenement: evenement, look: window.__persoLook || "",
            appareil: (function () {
              try {
                var doigt = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
                if (!doigt) return "desktop";
                var l = Math.min(screen.width || 0, screen.height || 0);
                return l >= 600 ? "tablette" : "mobile";
              } catch (e) { return ""; }
            })(),
            produit: window.__pdpPanneau ? "panneau-mariage"
              : window.__pdpPeleMele ? "affiche-pele-mele" : "affiche-personnalisee",
            url: url || "", montant: montant }),
          keepalive: true, mode: "cors", credentials: "omit", signal: afSignalCourt(2500)
        }).catch(function () {});
      } catch (e) {}
    }
    window.__persoFunnel("arrivee");
  })();

  var contexteInitial = thumbs && thumbs.querySelector('.pdp-thumb[data-cle="contexte"]');
  if (contexteInitial) contexteInitial.click();

  /* Récemment vues : pour le sélecteur du composeur de mur. */
  (function trackRecent() {
    if (window.__pdpPerso) return;
    var card = window.__pdpRecent;
    if (!card || !card.handle || !card.img || !window.MurRecent) return;
    if (card.handle === "cadre-pour-affiche" || card.handle === "affiche-personnalisee") return;
    var vmap = {};
    (variants || []).forEach(function (v) {
      if (!v || !v.option1) return;
      var cents = typeof v.price === "number" ? v.price : Math.round(parseFloat(v.price) * 100);
      vmap[v.option1] = { id: v.id, cents: cents, ok: v.available !== false };
    });
    window.MurRecent.push({
      handle: card.handle,
      title: card.title,
      img: card.img,
      variants: vmap
    });
    /* Compteur de vues, anonyme et agrégé : il sert à classer les listes de produits quand
       les ventes ne départagent pas. On n'envoie que le handle, ni identifiant, ni
       parcours. keepalive, parce qu'on ferme souvent une fiche aussitôt ouverte. */
    try {
      /* Une seule fois par session et par affiche. Le serveur déduplique déjà par visiteur
         et par jour, mais autant ne pas lui envoyer trente requêtes quand quelqu'un fait
         des allers-retours entre une fiche et sa collection. */
      var cle = "vue:" + card.handle;
      if (!sessionStorage.getItem(cle)) {
        sessionStorage.setItem(cle, "1");
        fetch("https://runway.dcomdtf.app/search-log/vue", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ handle: card.handle, poster_id: card.poster || "" }),
          keepalive: true, mode: "cors", credentials: "omit", signal: afSignalCourt(2500)
        }).catch(function () {});
      }
    } catch (e) {}
  })();
})();

/* Titre dynamique : ?title= dans l'URL remplace le H1 et le titre sticky des
   deux produits personnalisables (liens de campagne, annonces). Texte seul via
   textContent, jamais de HTML. Place en fin de fichier pour passer APRES le
   funnel ?look= qui pose aussi le H1 a l'init. */
(function () {
  if (!document.querySelector(".pdp--perso, .pdp--pelemele")) return;
  var brut = "";
  try { brut = new URL(window.location.href).searchParams.get("title") || ""; } catch (e) {}
  brut = brut.replace(/\s+/g, " ").trim().slice(0, 90);
  if (!brut) return;
  var h1 = document.getElementById("pdp-title") || document.querySelector(".pdp-title");
  if (h1) h1.textContent = brut;
  var sticky = document.querySelector(".pdp-sticky__title");
  if (sticky) sticky.textContent = brut;
  document.title = brut + " | Affichely";
})();

/* cro-bust-20260725234800 */

/* sync 02/08 17h06 : reappliquer les assets apres retard de la file GitHub */

/* ===========================================================================================
   CE QUE LE VISITEUR FAIT SUR LA FICHE, envoye une seule fois au depart de la page.

   ⛔ UN SEUL ENVOI, PAS UN PAR CLIC. Une requete a chaque geste aurait donne des dizaines
   d'appels par session, pour une donnee qui n'a aucun besoin d'etre en direct : on cherche des
   PARTS de visiteurs sur une periode, pas un flux. On accumule donc dans un ensemble, et on
   envoie tout quand la page part. `sendBeacon` existe pour exactement ca : il survit a la
   fermeture de l'onglet, la ou un `fetch` est tue en vol.

   ⛔ ANONYME. On envoie le poster_id, un nom de geste et un detail court. Rien d'autre : pas
   d'identifiant, pas de parcours, pas d'horaire. Le serveur calcule lui-meme un jeton du jour a
   partir de l'IP et du navigateur, comme pour les vues et les recherches, et il DEDOUBLONNE :
   dix ouvertures de la fenetre qualite par la meme personne comptent pour une.

   ⚠️ RIEN NE PART SANS poster_id. C'est l'identite de l'affiche, et le seul moyen de recoller
   les gestes a une fiche quand son titre change. Les produits sans oeuvre (personnalisee,
   pele-mele, cadre, crochets) n'en ont pas : ils ne sont donc pas mesures, ce qui est voulu,
   la demande porte sur les pages produit AFFICHE.
   =========================================================================================== */
(function statsFiche() {
  var carte = window.__pdpRecent;
  var poster = carte && carte.poster;
  var bande = document.querySelector("#pdp-thumbs");
  if (!poster || !bande) return;

  var gestes = [];
  var deja = {};
  var note = function (e, d) {
    var cle = e + "|" + (d || "");
    if (deja[cle]) return;
    deja[cle] = 1;
    if (gestes.length < 30) gestes.push({ e: e, d: d || "" });
  };

  /* ---- La galerie : quelles images ont ete VUES, et si la bande a defile ----
     ⚠️ ON OBSERVE aria-pressed, ON N'ECOUTE PAS LE CLIC. Sur mobile la vue change au
     glissement, sans qu'aucun bouton soit clique : n'ecouter que le clic aurait mesure le
     desktop et rate le geste principal du telephone, qui est justement celui qu'Adrien veut
     connaitre. L'attribut, lui, bouge dans les deux cas. */
  var vues = 0;
  /* ⛔ UNE CLE STABLE, PAS UN LIBELLE TRADUIT (Adrien, 11/08/2026). On envoyait le TEXTE de la
     vignette : « Encadrée », « Ingelijst » et « Framed » sont la meme image, et le Studio les
     comptait sur trois lignes. Une traduction change, une cle non. Le libelle reste en repli
     pour les fiches qui n'ont pas encore la cle, le temps que le theme se deploie. */
  var nomVue = function (bouton) {
    var cle = bouton.getAttribute("data-cle");
    if (cle) return cle;
    var item = bouton.closest(".pdp-thumb-item");
    var cap = item && item.querySelector(".pdp-thumb__cap");
    var t = (cap && cap.textContent.trim()) || bouton.getAttribute("aria-label") || "";
    return t.slice(0, 40);
  };

  /* ⛔ UN SLIDE EST UN GLISSEMENT, PAS UN CHANGEMENT D'IMAGE (Adrien, 11/08/2026). On emettait
     `galerie_slide` des qu'une DEUXIEME image devenait active : un clic sur une vignette
     comptait donc comme un glissement, d'ou 3,8 % de « slide » sur ordinateur, ou personne ne
     glisse. On n'emet plus que si le doigt ou le pointeur a REELLEMENT parcouru une distance
     sur la galerie, juste avant le changement. */
  var glisseJusqua = 0;
  var depart = null;
  /* ⛔⛔ `.pdp-media` N'EXISTE PAS DANS CE THEME, ET C'EST POUR CA QUE « SLIDE » ETAIT A ZERO.
     Mesure du 13/08/2026 sur une fiche reelle : `document.querySelector(".pdp-media")` rend
     null. Le repli posait donc les ecouteurs de glissement sur `bande`, c'est-a-dire la BANDE
     DE VIGNETTES. Or sur telephone on glisse LA GRANDE IMAGE ; personne ne glisse la bande de
     vignettes. `glisseJusqua` n'etait jamais arme, `galerie_slide` jamais emis : 0 % sur mobile
     pour 1 434 visiteurs, la ou le geste est justement le plus courant.
     ⚠️ ON PREND LA GALERIE ENTIERE, pas la seule image : le defilement de la bande EST un
     glissement lui aussi, et il vit dans le meme conteneur. Un selecteur absent ne doit plus
     pouvoir eteindre la mesure en silence : le banc `slide-galerie.test.js` refuse desormais
     tout selecteur qui ne se trouve pas dans le gabarit. */
  var surGalerie = document.querySelector(".pdp-gallery")
    || document.querySelector("#pdp-stage") || bande;
  var noteDepart = function (x, y) { depart = { x: x, y: y }; };
  var noteMouvement = function (x, y) {
    if (!depart) return;
    /* 24 px : au-dela d'un tremblement de doigt, en deca d'un geste volontaire rate. */
    if (Math.abs(x - depart.x) > 24 || Math.abs(y - depart.y) > 24) {
      /* La fenetre couvre l'inertie du defilement : le changement d'image suit le geste, il ne
         lui est pas simultane. */
      glisseJusqua = Date.now() + 1200;
    }
  };
  if (surGalerie) {
    surGalerie.addEventListener("touchstart", function (e) {
      var t = e.touches && e.touches[0]; if (t) noteDepart(t.clientX, t.clientY);
    }, { passive: true });
    surGalerie.addEventListener("touchmove", function (e) {
      var t = e.touches && e.touches[0]; if (t) noteMouvement(t.clientX, t.clientY);
    }, { passive: true });
    surGalerie.addEventListener("pointerdown", function (e) {
      if (e.pointerType !== "mouse" || e.buttons === 1) noteDepart(e.clientX, e.clientY);
    }, { passive: true });
    surGalerie.addEventListener("pointermove", function (e) {
      if (e.buttons === 1 || e.pointerType === "touch") noteMouvement(e.clientX, e.clientY);
    }, { passive: true });
    /* Le defilement horizontal de la bande EST un glissement, au trackpad comme au doigt. */
    surGalerie.addEventListener("scroll", function () { glisseJusqua = Date.now() + 1200; },
      { passive: true, capture: true });
  }
  var releverActive = function () {
    var on = bande.querySelector('.pdp-thumb[aria-pressed="true"]');
    if (!on) return;
    var nom = nomVue(on);
    var neuf = !deja["galerie_vue|" + nom];
    note("galerie_vue", nom);
    if (!neuf) return;
    vues += 1;
    /* ⛔ SEULEMENT SI LE DOIGT A GLISSE. La premiere image est celle d'arrivee et ne prouve
       aucun geste ; un clic sur vignette n'est pas un glissement non plus. */
    if (vues > 1 && Date.now() < glisseJusqua) note("galerie_slide", "");
  };
  releverActive();
  try {
    new MutationObserver(function () { releverActive(); })
      .observe(bande, { subtree: true, attributes: true, attributeFilter: ["aria-pressed"] });
  } catch (e) {}

  /* ---- Les gestes qui se cliquent ----
     En capture, pour etre entendu meme quand un gestionnaire arrete la propagation, ce que
     fait la modale de creation sur ses deux cartes. */
  document.addEventListener("click", function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    if (t.closest("#pdp-voirqualite")) note("qualite", "");
    if (t.closest("#pdp-up-frame .pdp-up-color")) note("pastille_couleur", "");
    var creation = t.closest(".pdp-create__card");
    if (creation) {
      var href = creation.getAttribute("href") || "";
      if (href.indexOf("/pages/composition") !== -1) note("composer_mur", "");
      if (href.indexOf("/pages/ma-piece") !== -1) note("ma_piece", "");
    }
  }, true);

  /* ---- Les sections vues a plus de la moitie ----
     ⚠️ LE SEUIL EST SUR LA SECTION, PAS SUR L'ECRAN. Un seuil de 0,5 veut dire « la moitie de
     la section est visible » ; sur une section plus haute que l'ecran, cette moitie n'arrive
     JAMAIS et le compteur resterait a zero pour toujours. On prend donc le premier des deux
     qui se produit : la moitie de la section vue, OU la section qui remplit l'ecran. */
  try {
    var ecran = window.innerHeight || 800;
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (x) {
        if (!x.isIntersecting) return;
        var h = x.boundingClientRect.height || 1;
        var vu = x.intersectionRect.height || 0;
        if (vu / h >= 0.5 || vu >= ecran * 0.9) {
          note("section_vue", x.target.id || "");
          obs.unobserve(x.target);
        }
      });
    }, { threshold: [0, 0.25, 0.5, 0.75] });
    Array.prototype.forEach.call(document.querySelectorAll("section[id]"), function (s) {
      if (s.id) obs.observe(s);
    });
  } catch (e) {}

  /* ---- L'envoi, une fois ----
     ⚠️ pagehide ET NON beforeunload : le second est ignore par Safari mobile et empeche la mise
     en cache de la page. visibilitychange rattrape l'onglet qu'on quitte sans le fermer, cas
     frequent sur telephone. Le drapeau garantit qu'on n'envoie qu'une seule fois. */
  /* ⛔⛔ UN SEUL ENVOI AU DEPART DE LA PAGE PERDAIT 90 % DES MESURES SUR ORDINATEUR.
     Constat du 13/08/2026 : `galerie_vue` de la premiere image est emis SANS CONDITION au
     chargement, donc 100 % attendus. Mesure : 100 % en tablette, 93,9 % en mobile, 9,3 % en
     desktop. Ces trois nombres ne disaient rien de la galerie, ils disaient le taux de
     LIVRAISON du beacon. Et la colonne « Visiteurs », elle, part par `fetch` AU CHARGEMENT :
     on divisait donc un numerateur qui se perd par un denominateur complet.

     ⛔ CE QUI EST CONNU AU CHARGEMENT PART AU CHARGEMENT. Un premier envoi a 2,5 s, quand la
     page est vivante et que la negociation CORS a tout son temps, emporte l'image d'arrivee et
     les sections deja vues. Le beacon garde ce qui arrive ensuite. C'est exactement le
     raisonnement qui faisait deja marcher la vue, et qui n'avait pas ete applique aux gestes.

     ⛔ ON N'ENVOIE QUE LE DELTA, ET LE SERVEUR DEDOUBLONNE DE TOUTE FACON. `envoyes` retient
     jusqu'ou on est alle ; et cote serveur l'insert est en `ON CONFLICT DO NOTHING` sur
     (poster, jour, jeton, evenement, detail). Deux envois ne peuvent donc pas compter double,
     verifie dans store.js avant d'ecrire cette ligne. */
  var envoyes = 0;
  var envoyer = function () {
    if (gestes.length <= envoyes) return;
    var lot = gestes.slice(envoyes);
    envoyes = gestes.length;
    var corps = JSON.stringify({ poster_id: poster, gestes: lot });
    try {
      /* ⚠️ UN NOM QUI NE SE CONFOND PAS. Cette adresse s'appelait `url`, comme le parametre de
         `cartPost(url, body)` quelques centaines de lignes plus haut, qui vise le PANIER Shopify :
         un banc qui resout les constantes prenait l'un pour l'autre (23/08/2026). */
      var URL_PDP = "https://runway.dcomdtf.app/search-log/pdp";
      /* ⛔ text/plain ET NON application/json, ET C'EST TOUT LE BUG (Adrien, 10/08/2026 : « on
         ne peut pas etre a 0 % pour autant de visiteurs »).
         Ce beacon part en CROSS-ORIGIN vers runway. `application/json` n'est pas un type
         autorise d'office : le navigateur doit d'abord envoyer un OPTIONS de controle. Or on
         envoie sur `pagehide`, quand la page est en train de disparaitre : le controle n'a plus
         le temps d'aboutir, et le beacon est jete SANS AUCUNE ERREUR, ni dans la console ni
         cote serveur. Resultat mesure : 3109 visiteurs, 0,5 % de galerie la ou le code emet
         `galerie_vue` sans condition au chargement, donc ~100 % attendus.
         `text/plain` fait partie des trois types qui ne declenchent aucun controle prealable :
         la requete part telle quelle. Le serveur parse ce type en plus de l'autre.
         ⚠️ LA VUE, ELLE, MARCHAIT : elle part par `fetch` AU CHARGEMENT, quand la page a tout
         son temps pour negocier. C'est cette asymetrie qui a permis au defaut de se cacher. */
      if (navigator.sendBeacon) {
        navigator.sendBeacon(URL_PDP, new Blob([corps], { type: "text/plain;charset=UTF-8" }));
      } else {
        fetch(URL_PDP, {
          method: "POST", headers: { "Content-Type": "text/plain;charset=UTF-8" },
          body: corps, keepalive: true, mode: "cors", credentials: "omit",
          signal: afSignalCourt(2500)
        }).catch(function () {});
      }
    } catch (e) {}
  };
  /* ⚠️ LE PREMIER ENVOI EST LE PLUS IMPORTANT : il porte l'image d'arrivee, la seule mesure
     qui vaut pour 100 % des visiteurs. 2,5 s laisse le temps a la galerie de se poser et aux
     premieres sections d'entrer dans l'ecran, sans attendre que la personne parte. */
  setTimeout(envoyer, 2500);
  window.addEventListener("pagehide", envoyer);
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") envoyer();
  });
})();
